// Auto-generated from production explorld.com bundle
// Japanese translations added by Claude (session 80ba238a)
// oE = scene menu (207 entries, country availability)
// uS = scene dialogues (51 GB-focused entries with ja/en bilingual content)

export const SCENE_MENU = [
  {
    "id": "conv_biz_card",
    "catId": "work",
    "label": "初対面・自己紹介",
    "label_en": "First Meeting",
    "ic": "🤝",
    "desc": "現地式ビジネス挨拶・名刺文化",
    "desc_en": "Local greetings & business card culture",
    "available": true,
    "countries": [
      "gb",
      "us",
      "au",
      "de",
      "sg",
      "fr",
      "it",
      "es"
    ]
  },
  {
    "id": "conv_biz_smalltalk",
    "catId": "work",
    "label": "職場での雑談",
    "label_en": "Office Small Talk",
    "ic": "☕",
    "desc": "休憩室での雑談・プライベートの境界線",
    "desc_en": "Kitchen chat & privacy norms",
    "available": true,
    "countries": [
      "gb",
      "us",
      "au",
      "de",
      "sg",
      "fr",
      "it"
    ]
  },
  {
    "id": "conv_biz_meeting",
    "catId": "work",
    "label": "会議での意見表明",
    "label_en": "Expressing Views in Meetings",
    "ic": "💬",
    "desc": "現地式の会議コミュニケーション",
    "desc_en": "Local-style meeting communication",
    "available": true,
    "countries": [
      "gb",
      "us",
      "au",
      "de",
      "sg",
      "fr",
      "it",
      "es"
    ]
  },
  {
    "id": "conv_biz_negotiation",
    "catId": "work",
    "label": "ビジネス交渉",
    "label_en": "Business Negotiation",
    "ic": "🤜",
    "desc": "交渉・契約・Angebot",
    "desc_en": "Negotiation, contracts & quotes",
    "available": true,
    "countries": [
      "gb",
      "us",
      "au",
      "de",
      "sg",
      "fr",
      "it",
      "es"
    ]
  },
  {
    "id": "conv_life_school",
    "catId": "life",
    "label": "学校制度と学校選び",
    "label_en": "School System",
    "ic": "🎒",
    "desc": "現地の学校制度・保護者会",
    "desc_en": "Local school system & parent involvement",
    "available": true,
    "countries": [
      "gb",
      "us",
      "au",
      "de",
      "sg",
      "fr",
      "it"
    ]
  },
  {
    "id": "conv_life_medical",
    "catId": "life",
    "label": "GPへの電話予約",
    "label_en": "Booking a GP Appointment",
    "ic": "🏥",
    "desc": "NHS・かかりつけ医への問い合わせ",
    "desc_en": "NHS & GP enquiries",
    "available": false,
    "countries": [
      "gb",
      "us",
      "au"
    ]
  },
  {
    "id": "conv_life_shopping",
    "catId": "life",
    "label": "スーパーでの買い物",
    "label_en": "Supermarket Shopping",
    "ic": "🛒",
    "desc": "現地スーパーの文化・決済・エチケット",
    "desc_en": "Supermarket culture, payment & etiquette",
    "available": true,
    "countries": [
      "gb",
      "us",
      "au",
      "de",
      "sg",
      "fr",
      "it"
    ]
  },
  {
    "id": "conv_travel_restaurant",
    "catId": "travel",
    "label": "レストランでの食事",
    "label_en": "Dining Out",
    "ic": "🍴",
    "desc": "予約・会計・チップ文化",
    "desc_en": "Reservations, payment & tipping",
    "available": true,
    "countries": [
      "gb",
      "us",
      "au",
      "de",
      "fr",
      "it",
      "es"
    ]
  },
  {
    "id": "conv_travel_hotel",
    "catId": "travel",
    "label": "ホテルチェックイン",
    "label_en": "Hotel Check-in",
    "ic": "🏨",
    "desc": "チェックイン・登録・現地ルール",
    "desc_en": "Check-in, registration & local rules",
    "available": true,
    "countries": [
      "gb",
      "us",
      "de",
      "sg",
      "fr",
      "it"
    ]
  },
  {
    "id": "conv_travel_transport",
    "catId": "travel",
    "label": "都市内公共交通機関",
    "label_en": "City Public Transport",
    "ic": "🚇",
    "desc": "チケット・ゾーン・交通アプリ",
    "desc_en": "Tickets, zones & transport apps",
    "available": true,
    "countries": [
      "gb",
      "us",
      "de",
      "it"
    ]
  },
  {
    "id": "conv_biz_email",
    "catId": "work",
    "label": "メール・Slackのトーン",
    "label_en": "Email & Slack Tone",
    "ic": "📧",
    "desc": "現地職場のメール・チャットの書き方",
    "desc_en": "Workplace email & chat style",
    "available": true
  },
  {
    "id": "conv_biz_wfh",
    "catId": "work",
    "label": "在宅勤務の文化",
    "label_en": "Working from Home",
    "ic": "💻",
    "desc": "WFH・リモートワーク文化",
    "desc_en": "WFH culture & calendar etiquette",
    "available": true
  },
  {
    "id": "conv_biz_appraisal",
    "catId": "work",
    "label": "評価面談",
    "label_en": "Performance Review",
    "ic": "📊",
    "desc": "年次評価・自己評価・目標設定",
    "desc_en": "Annual reviews & goal setting",
    "available": true
  },
  {
    "id": "conv_biz_celebration",
    "catId": "work",
    "label": "チームのお祝い",
    "label_en": "Team Celebrations",
    "ic": "🎊",
    "desc": "契約獲得・ラウンド・チームの絆",
    "desc_en": "Winning contracts & pub rounds",
    "available": true,
    "countries": [
      "gb",
      "us",
      "au"
    ]
  },
  {
    "id": "conv_biz_remote",
    "catId": "work",
    "label": "Teams/Zoom会議",
    "label_en": "Facilitating Remote Meetings",
    "ic": "💻",
    "desc": "ハイブリッド会議のファシリテーション",
    "desc_en": "Hybrid meeting facilitation",
    "available": true
  },
  {
    "id": "conv_life_housing",
    "catId": "life",
    "label": "賃貸物件の内見",
    "label_en": "Viewing a Rental Property",
    "ic": "🏠",
    "desc": "物件内見・条件交渉・テナント権利",
    "desc_en": "Viewings, negotiation & tenant rights",
    "available": true
  },
  {
    "id": "conv_life_neighbor",
    "catId": "life",
    "label": "隣人との挨拶",
    "label_en": "Meeting Your Neighbours",
    "ic": "🚪",
    "desc": "引越し挨拶・ゴミルール・共有スペース",
    "desc_en": "Moving in, bin rules & shared spaces",
    "available": true
  },
  {
    "id": "conv_life_bank",
    "catId": "life",
    "label": "銀行口座の開設",
    "label_en": "Opening a Bank Account",
    "ic": "🏦",
    "desc": "銀行・必要書類・デジタルバンク",
    "desc_en": "Banks, documents & digital banking",
    "available": true,
    "countries": [
      "gb",
      "au",
      "de"
    ]
  },
  {
    "id": "conv_life_recycling",
    "catId": "life",
    "label": "ゴミ・リサイクルのルール",
    "label_en": "Recycling & Bin Rules",
    "ic": "♻️",
    "desc": "収集日・分別ルール・隣人関係",
    "desc_en": "Collection days & sorting rules",
    "available": true
  },
  {
    "id": "conv_life_transport",
    "catId": "life",
    "label": "バス・電車の問い合わせ",
    "label_en": "Asking About Buses & Trains",
    "ic": "🚌",
    "desc": "バス停・路線案内・Oysterカード",
    "desc_en": "Bus stops, routes & Oyster card",
    "available": true
  },
  {
    "id": "conv_life_money",
    "catId": "life",
    "label": "給与明細・NI番号",
    "label_en": "Payslip & NI Number",
    "ic": "💷",
    "desc": "給与・税金・NI番号の確認",
    "desc_en": "Payslip, tax codes & National Insurance",
    "available": true,
    "countries": [
      "gb",
      "au"
    ]
  },
  {
    "id": "conv_life_boiler",
    "catId": "life",
    "label": "ボイラー・設備故障",
    "label_en": "Reporting a Broken Boiler",
    "ic": "🔧",
    "desc": "大家・エージェントへの修理依頼",
    "desc_en": "Reporting repairs to your landlord or agent",
    "available": true,
    "countries": [
      "gb",
      "au"
    ]
  },
  {
    "id": "conv_life_doctor_emergency",
    "catId": "life",
    "label": "111番・A&E利用",
    "label_en": "Calling 111 & Using A&E",
    "ic": "🚑",
    "desc": "緊急時の医療機関の使い方",
    "desc_en": "When to call 111 vs going to A&E",
    "available": true,
    "countries": [
      "gb",
      "au"
    ]
  },
  {
    "id": "conv_life_nhsprivate",
    "catId": "life",
    "label": "NHS・私立医療の違い",
    "label_en": "NHS vs Private Healthcare",
    "ic": "🏥",
    "desc": "GP・A&E・私立医療の使い分け",
    "desc_en": "GP, A&E vs private healthcare",
    "available": true,
    "countries": [
      "gb",
      "au"
    ]
  },
  {
    "id": "conv_travel_pub",
    "catId": "travel",
    "label": "パブでの注文",
    "label_en": "Ordering at a Pub",
    "ic": "🍺",
    "desc": "パイント・注文方法・チップ不要",
    "desc_en": "Pints, ordering & no tipping needed",
    "available": true,
    "countries": [
      "gb",
      "au"
    ]
  },
  {
    "id": "conv_travel_tourist",
    "catId": "travel",
    "label": "観光案内所での質問",
    "label_en": "Tourist Information Centre",
    "ic": "🗺️",
    "desc": "博物館・無料入場・交通案内",
    "desc_en": "Museums, free entry & directions",
    "available": true,
    "countries": [
      "gb",
      "us",
      "au",
      "sg",
      "fr",
      "it"
    ]
  },
  {
    "id": "conv_travel_taxi",
    "catId": "travel",
    "label": "タクシー・Uberの利用",
    "label_en": "Taking a Taxi or Uber",
    "ic": "🚕",
    "desc": "ブラックキャブ・ターミナル・チップ",
    "desc_en": "Black cabs, terminals & tipping",
    "available": true,
    "countries": [
      "gb",
      "au",
      "fr",
      "it"
    ]
  },
  {
    "id": "conv_travel_airport",
    "catId": "travel",
    "label": "入国審査",
    "label_en": "Border Control",
    "ic": "🛂",
    "desc": "入国審査・書類・正しい答え方",
    "desc_en": "Border control, documents & answers",
    "available": true
  },
  {
    "id": "conv_travel_tube",
    "catId": "travel",
    "label": "チューブ・ゾーン案内",
    "label_en": "Navigating the Tube & Zones",
    "ic": "🚇",
    "desc": "路線・Zone・Oysterの使い方",
    "desc_en": "Lines, zones & Oyster tips",
    "available": true,
    "countries": [
      "gb",
      "au"
    ]
  },
  {
    "id": "conv_culture_pub",
    "catId": "culture",
    "label": "パブ文化・ラウンド制",
    "label_en": "Pub Culture & Rounds",
    "ic": "🍺",
    "desc": "ラウンドの仕組み・パブ文化の理解",
    "desc_en": "How rounds work & pub etiquette",
    "available": true,
    "countries": [
      "gb",
      "au"
    ]
  },
  {
    "id": "conv_culture_royals",
    "catId": "culture",
    "label": "王室・政治の話題",
    "label_en": "Royals & Politics",
    "ic": "👑",
    "desc": "安全な会話・話題の扱い方",
    "desc_en": "Safe topics & conversational etiquette",
    "available": true,
    "countries": [
      "gb",
      "au"
    ]
  },
  {
    "id": "conv_culture_sport",
    "catId": "culture",
    "label": "フットボールとスポーツ文化",
    "label_en": "Football & Sport Culture",
    "ic": "⚽",
    "desc": "プレミアリーグ・チーム選び・パブ観戦",
    "desc_en": "Premier League, choosing a team & pubs",
    "available": true,
    "countries": [
      "gb",
      "au"
    ]
  },
  {
    "id": "conv_culture_bonfire",
    "catId": "culture",
    "label": "ボンファイアナイト",
    "label_en": "Bonfire Night",
    "ic": "🎆",
    "desc": "11月5日・ガイフォークス・英国の伝統",
    "desc_en": "5th November, Guy Fawkes & traditions",
    "available": true,
    "countries": [
      "gb",
      "au"
    ]
  },
  {
    "id": "conv_culture_weather",
    "catId": "culture",
    "label": "天気の話題",
    "label_en": "Talking About the Weather",
    "ic": "🌧️",
    "desc": "現地の社交儀式・小話・ユーモア",
    "desc_en": "Weather chat as a social ritual",
    "available": true,
    "countries": [
      "gb",
      "us",
      "au"
    ]
  },
  {
    "id": "conv_culture_holidays",
    "catId": "culture",
    "label": "祝日・パーティーの会話",
    "label_en": "Holidays & Parties",
    "ic": "🎉",
    "desc": "クリスマス・ガイフォークス等の文化",
    "desc_en": "Christmas, Guy Fawkes & more",
    "available": true,
    "countries": [
      "gb",
      "au"
    ]
  },
  {
    "id": "conv_culture_queue",
    "catId": "culture",
    "label": "キュー文化・割り込み",
    "label_en": "Queue Culture",
    "ic": "🧍",
    "desc": "現地のキュー文化と割り込みへの対応",
    "desc_en": "Queue culture & how to handle jumpers",
    "available": true,
    "countries": [
      "gb",
      "au"
    ]
  },
  {
    "id": "conv_culture_americanenglish",
    "catId": "culture",
    "label": "英米英語の違い",
    "label_en": "British vs American English",
    "ic": "🇬🇧",
    "desc": "chips/crisps/pants…英米で違う単語",
    "desc_en": "Chips, crisps, pants & other false friends",
    "available": true,
    "countries": [
      "gb",
      "au"
    ]
  },
  {
    "id": "conv_culture_rugby_cricket",
    "catId": "culture",
    "label": "ラグビー・クリケット",
    "label_en": "Rugby & Cricket Culture",
    "ic": "🏉",
    "desc": "Six Nations・クリケットの基礎知識",
    "desc_en": "Six Nations, Test cricket & pub watching",
    "available": true,
    "countries": [
      "gb",
      "au"
    ]
  },
  {
    "id": "conv_life_doctor",
    "catId": "life",
    "label": "健康保険・かかりつけ医",
    "label_en": "Healthcare in Germany",
    "ic": "🏥",
    "desc": "GKV/PKV・Hausarzt",
    "desc_en": "GKV, PKV & finding a Hausarzt",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_culture_directness",
    "catId": "culture",
    "label": "直接的コミュニケーション",
    "label_en": "Direct Communication",
    "ic": "💬",
    "desc": "率直さの文化・フィードバック",
    "desc_en": "Direct communication & workplace culture",
    "available": true,
    "countries": [
      "us",
      "de"
    ]
  },
  {
    "id": "conv_culture_cash",
    "catId": "culture",
    "label": "現金文化",
    "label_en": "Cash Culture",
    "ic": "💶",
    "desc": "カードより現金優先の文化",
    "desc_en": "Germany's strong preference for Bargeld",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_culture_sunday",
    "catId": "culture",
    "label": "日曜日の静粛",
    "label_en": "Sonntagsruhe",
    "ic": "🕊️",
    "desc": "日曜の騒音規制・Sonntagsruhe",
    "desc_en": "Sunday quiet rules & Sonntagsruhe",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_culture_bread",
    "catId": "culture",
    "label": "パン屋・パン文化",
    "label_en": "Bread & Bakery Culture",
    "ic": "🥖",
    "desc": "Bäckerei・ドイツのパン文化",
    "desc_en": "Bäckerei culture & Germany's bread tradition",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_travel_train",
    "catId": "travel",
    "label": "鉄道の利用",
    "label_en": "Train Travel",
    "ic": "🚆",
    "desc": "GB/DE鉄道・ICE・チケット購入",
    "desc_en": "UK/German rail & ticket tips",
    "available": true,
    "countries": [
      "gb",
      "de"
    ]
  },
  {
    "id": "conv_biz_presentation",
    "catId": "work",
    "label": "プレゼンテーション",
    "label_en": "Presentations",
    "ic": "📊",
    "desc": "データ重視スライド・Q&A対応",
    "desc_en": "Data-heavy slides & structured Q&A",
    "available": true,
    "countries": [
      "gb",
      "us",
      "de",
      "sg",
      "fr"
    ]
  },
  {
    "id": "conv_biz_feedback",
    "catId": "work",
    "label": "フィードバックの文化",
    "label_en": "Feedback Culture",
    "ic": "💬",
    "desc": "直接的フィードバック・受け入れ方",
    "desc_en": "Direct feedback & how to accept criticism",
    "available": true,
    "countries": [
      "us",
      "au",
      "de",
      "sg",
      "fr"
    ]
  },
  {
    "id": "conv_biz_interview",
    "catId": "work",
    "label": "採用面接",
    "label_en": "Job Interview",
    "ic": "💼",
    "desc": "面接・書類・現地式の雰囲気",
    "desc_en": "Local interview style & required documents",
    "available": true,
    "countries": [
      "us",
      "au",
      "de",
      "sg",
      "fr",
      "it"
    ]
  },
  {
    "id": "conv_life_pharmacy",
    "catId": "life",
    "label": "薬局の利用",
    "label_en": "Pharmacy",
    "ic": "💊",
    "desc": "PBS/Kassenrezept・薬剤師の活用",
    "desc_en": "Prescriptions & pharmacist consultation",
    "available": true,
    "countries": [
      "au",
      "de"
    ]
  },
  {
    "id": "conv_biz_benefits",
    "catId": "work",
    "label": "福利厚生・手当",
    "label_en": "Employee Benefits",
    "ic": "💰",
    "desc": "Weihnachtsgeld・VL・betriebliche Altersvorsorge",
    "desc_en": "Christmas bonus, VL & company pension",
    "available": true,
    "countries": [
      "us",
      "de",
      "it"
    ]
  },
  {
    "id": "conv_biz_overtime",
    "catId": "work",
    "label": "残業・Feierabend文化",
    "label_en": "Overtime & Feierabend",
    "ic": "⏰",
    "desc": "Zeitkonto・定時退社の権利",
    "desc_en": "Time tracking & the right to leave on time",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_biz_committee",
    "catId": "work",
    "label": "ステータス会議の進め方",
    "label_en": "Status Meeting Culture",
    "ic": "📋",
    "desc": "Tagesordnung・Protokoll・議事録",
    "desc_en": "Agenda, minutes & action items",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_life_registration",
    "catId": "life",
    "label": "住所登録（Anmeldung）",
    "label_en": "Anmeldung Registration",
    "ic": "🏛️",
    "desc": "Bürgeramt・14日以内・Steuer-ID",
    "desc_en": "Bürgeramt, 14-day rule & documents needed",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_life_insurance",
    "catId": "life",
    "label": "保険の種類",
    "label_en": "Insurance",
    "ic": "🛡️",
    "desc": "健康保険・賠償責任保険・年金",
    "desc_en": "Health, liability & pension insurance",
    "available": true,
    "countries": [
      "us",
      "de"
    ]
  },
  {
    "id": "conv_life_noise",
    "catId": "life",
    "label": "騒音ルール・Ruhezeit",
    "label_en": "Noise Rules (Ruhezeit)",
    "ic": "🔇",
    "desc": "昼・夜・日曜の静粛時間",
    "desc_en": "Midday quiet, night rules & Sunday silence",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_life_utilities",
    "catId": "life",
    "label": "光熱費・公共料金",
    "label_en": "Utilities & Billing",
    "ic": "📊",
    "desc": "月次前払い・年間精算",
    "desc_en": "Advance payments & annual settlement",
    "available": true,
    "countries": [
      "us",
      "de"
    ]
  },
  {
    "id": "conv_life_bureaucracy",
    "catId": "life",
    "label": "お役所・書類文化",
    "label_en": "German Bureaucracy",
    "ic": "📄",
    "desc": "Schriftform・Einschreiben・Widerspruch",
    "desc_en": "Written form, registered post & objections",
    "available": true,
    "countries": [
      "de",
      "fr"
    ]
  },
  {
    "id": "conv_travel_munich",
    "catId": "travel",
    "label": "ミュンヘン・Biergarten",
    "label_en": "Munich & Biergarten",
    "ic": "🍺",
    "desc": "Maßkrug・Weißwurst・Grüß Gott",
    "desc_en": "Maßkrug, BYO food & Biergarten etiquette",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_travel_berlin",
    "catId": "travel",
    "label": "ベルリン文化",
    "label_en": "Berlin Culture",
    "ic": "🏙️",
    "desc": "Späti・BVG・Berliner Schnauze",
    "desc_en": "Spätis, BVG honour system & club culture",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_travel_carsharing",
    "catId": "travel",
    "label": "カーシェアリング",
    "label_en": "Carsharing in Germany",
    "ic": "🚗",
    "desc": "MILES/ShareNow・Nextbike",
    "desc_en": "MILES, Share Now & multimodal commuting",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_travel_cycling",
    "catId": "travel",
    "label": "自転車のルール",
    "label_en": "Cycling Rules DE",
    "ic": "🚴",
    "desc": "Radwegpflicht・赤信号・ライト",
    "desc_en": "Mandatory Radweg, red-light fines & lights",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_culture_privacy",
    "catId": "culture",
    "label": "プライバシー・DSGVO",
    "label_en": "Privacy & DSGVO",
    "ic": "🔒",
    "desc": "Datenschutz・写真撮影・DSGVO",
    "desc_en": "Datenschutz reflex, photo rights & DSGVO",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_culture_formality",
    "catId": "culture",
    "label": "Sie/Duzen・敬語",
    "label_en": "Formality & Sie/Du",
    "ic": "🎩",
    "desc": "Sie/Du・博士称号・Du-Angebot",
    "desc_en": "Sie vs Du, titles & the Du-Angebot moment",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_culture_punctuality",
    "catId": "culture",
    "label": "時間厳守・Pünktlichkeit",
    "label_en": "Punctuality",
    "ic": "⏰",
    "desc": "5分前行動・遅刻の連絡マナー",
    "desc_en": "5 min early, Akademisches Viertel & lateness",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_culture_pfand",
    "catId": "culture",
    "label": "Pfandシステム・ゴミ分別",
    "label_en": "Pfand & Recycling",
    "ic": "♻️",
    "desc": "DPG・Pfandautomat・Gelber Sack",
    "desc_en": "Pfand bottles, Pfandautomat & bin sorting",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_culture_spaziergang",
    "catId": "culture",
    "label": "Spaziergang文化",
    "label_en": "Spaziergang Culture",
    "ic": "🌲",
    "desc": "日曜散歩・森・挨拶文化",
    "desc_en": "Sunday walks, forest etiquette & greetings",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_culture_humor",
    "catId": "culture",
    "label": "ドイツのユーモア",
    "label_en": "German Humour",
    "ic": "😐",
    "desc": "Ironie・Galgenhumor・Stammtisch",
    "desc_en": "Deadpan irony, Galgenhumor & Stammtisch banter",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_culture_nachbarschaft",
    "catId": "culture",
    "label": "近所ルール",
    "label_en": "Neighbourhood Rules DE",
    "ic": "🏘️",
    "desc": "Treppendienst・生垣・Ordnungsamt",
    "desc_en": "Stair duty, hedge rules & conflict resolution",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_life_mietrecht",
    "catId": "life",
    "label": "借家権・Mietrecht",
    "label_en": "Tenant Rights DE",
    "ic": "🏠",
    "desc": "Kaution 3ヶ月上限・Nebenkostenabrechnung",
    "desc_en": "Kaution cap, utility bills & tenant protections",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_culture_karneval",
    "catId": "culture",
    "label": "カーニバル・Karneval",
    "label_en": "Karneval / Fasching",
    "ic": "🎭",
    "desc": "Alaaf!・Helau!・職場コスチューム",
    "desc_en": "Alaaf vs Helau, Kostüm at work & Bützchen",
    "available": true,
    "countries": [
      "de"
    ]
  },
  {
    "id": "conv_biz_references",
    "catId": "work",
    "label": "前職の照会・リファレンス",
    "label_en": "References & Referees",
    "ic": "📋",
    "desc": "推薦者・LinkedInプロフィール",
    "desc_en": "Referees, LinkedIn & professional endorsement",
    "available": true,
    "countries": [
      "gb"
    ]
  },
  {
    "id": "conv_biz_leaveholiday",
    "catId": "work",
    "label": "有給休暇の申請",
    "label_en": "Annual Leave Request",
    "ic": "🏖️",
    "desc": "有給申請・チームへの配慮",
    "desc_en": "Booking leave & arranging cover",
    "available": true,
    "countries": [
      "gb"
    ]
  },
  {
    "id": "conv_life_council",
    "catId": "life",
    "label": "自治体・Councilサービス",
    "label_en": "Local Council",
    "ic": "🏛️",
    "desc": "Council Tax・地方サービス",
    "desc_en": "Council Tax, bins & local authority",
    "available": true,
    "countries": [
      "gb"
    ]
  },
  {
    "id": "conv_life_driving",
    "catId": "life",
    "label": "運転免許の切り替え",
    "label_en": "UK Driving Licence",
    "ic": "🚗",
    "desc": "国際免許→英国免許の手続き",
    "desc_en": "Converting your foreign licence to UK",
    "available": true,
    "countries": [
      "gb",
      "sg",
      "fr"
    ]
  },
  {
    "id": "conv_life_gp",
    "catId": "life",
    "label": "GPへの登録・受診",
    "label_en": "Registering with a GP",
    "ic": "🩺",
    "desc": "NHS GP登録・予約方法",
    "desc_en": "Registering & booking NHS GP appointments",
    "available": true,
    "countries": [
      "gb"
    ]
  },
  {
    "id": "conv_life_broadband",
    "catId": "life",
    "label": "ブロードバンド・公共料金",
    "label_en": "Broadband & Utilities",
    "ic": "📡",
    "desc": "契約・比較サイト・スイッチング",
    "desc_en": "Contracts, comparison sites & easy switching",
    "available": true,
    "countries": [
      "gb"
    ]
  },
  {
    "id": "conv_culture_tea",
    "catId": "culture",
    "label": "お茶の文化",
    "label_en": "Tea Culture",
    "ic": "☕",
    "desc": "ミルクティー・ブレーク文化",
    "desc_en": "Builder's tea, milk-first & break culture",
    "available": true,
    "countries": [
      "gb"
    ]
  },
  {
    "id": "conv_culture_banter",
    "catId": "culture",
    "label": "バンター文化",
    "label_en": "Banter Culture",
    "ic": "😄",
    "desc": "イギリスのからかい・自己卑下・ウィット",
    "desc_en": "Teasing, self-deprecation & British wit",
    "available": true,
    "countries": [
      "gb"
    ]
  },
  {
    "id": "conv_culture_class",
    "catId": "culture",
    "label": "階級意識",
    "label_en": "Class Culture",
    "ic": "🎩",
    "desc": "アクセント・学歴・社会階級のシグナル",
    "desc_en": "Accents, education & class signals",
    "available": true,
    "countries": [
      "gb"
    ]
  },
  {
    "id": "conv_culture_pubs_etiquette",
    "catId": "culture",
    "label": "パブのエチケット詳細",
    "label_en": "Detailed Pub Etiquette",
    "ic": "🍻",
    "desc": "注文方法・タブ・ラストオーダー",
    "desc_en": "How to order, tabs & last orders",
    "available": true,
    "countries": [
      "gb"
    ]
  },
  {
    "id": "conv_culture_tvlicence",
    "catId": "culture",
    "label": "TV受信許可証",
    "label_en": "TV Licence",
    "ic": "📺",
    "desc": "£169.50/年・BBCiPlayer・督促状",
    "desc_en": "BBC iPlayer, enforcement letters & how to declare",
    "available": true,
    "countries": [
      "gb"
    ]
  },
  {
    "id": "conv_life_banking",
    "catId": "life",
    "label": "銀行口座・クレジット",
    "label_en": "Banking & Credit US",
    "ic": "🏦",
    "desc": "口座開設・クレジットスコア・Zelle",
    "desc_en": "Bank accounts, credit score & Zelle",
    "available": true,
    "countries": [
      "us"
    ]
  },
  {
    "id": "conv_life_dmv",
    "catId": "life",
    "label": "DMV・運転免許",
    "label_en": "DMV & Driving Licence",
    "ic": "🪪",
    "desc": "DMV・州ID・Social Security番号",
    "desc_en": "DMV, state ID & Social Security number",
    "available": true,
    "countries": [
      "us"
    ]
  },
  {
    "id": "conv_life_tipping",
    "catId": "life",
    "label": "チップの文化（日常）",
    "label_en": "Tipping in Daily Life",
    "ic": "💵",
    "desc": "レストラン20%・Uber・ヘアサロン",
    "desc_en": "When to tip & how much in daily situations",
    "available": true,
    "countries": [
      "us"
    ]
  },
  {
    "id": "conv_life_groceries",
    "catId": "life",
    "label": "食料品店・スーパー",
    "label_en": "Grocery Shopping US",
    "ic": "🛒",
    "desc": "Whole Foods vs Costco・ロイヤリティカード",
    "desc_en": "Store loyalty cards, self-checkout & coupon culture",
    "available": true,
    "countries": [
      "us"
    ]
  },
  {
    "id": "conv_life_taxes",
    "catId": "life",
    "label": "税金申告",
    "label_en": "Filing Taxes US",
    "ic": "📋",
    "desc": "W-2・TurboTax・April deadline",
    "desc_en": "W-2, filing deadline & tax software",
    "available": true,
    "countries": [
      "us"
    ]
  },
  {
    "id": "conv_biz_networking",
    "catId": "work",
    "label": "ネットワーキング",
    "label_en": "Networking US",
    "ic": "🤝",
    "desc": "名刺なし・LinkedInファースト・エレベーターピッチ",
    "desc_en": "No business cards, LinkedIn & elevator pitch",
    "available": true,
    "countries": [
      "us",
      "sg",
      "fr"
    ]
  },
  {
    "id": "conv_biz_conference",
    "catId": "work",
    "label": "カンファレンス・学会",
    "label_en": "Conferences & Conventions",
    "ic": "🎤",
    "desc": "名刺配布・ブース訪問・ネットワーク",
    "desc_en": "Booth culture, badge etiquette & follow-up",
    "available": true,
    "countries": [
      "us"
    ]
  },
  {
    "id": "conv_travel_bar",
    "catId": "travel",
    "label": "バー・ナイトライフ",
    "label_en": "Bars & Nightlife US",
    "ic": "🍸",
    "desc": "ID必須・タブ文化・ラストコール",
    "desc_en": "ID checking, opening a tab & last call",
    "available": true,
    "countries": [
      "us"
    ]
  },
  {
    "id": "conv_travel_pharmacy",
    "catId": "travel",
    "label": "ドラッグストア・薬局",
    "label_en": "Drugstore & Pharmacy US",
    "ic": "💊",
    "desc": "CVS・Walgreens・処方箋・OTC",
    "desc_en": "CVS/Walgreens, prescriptions & OTC drugs",
    "available": true,
    "countries": [
      "us"
    ]
  },
  {
    "id": "conv_travel_uber",
    "catId": "travel",
    "label": "Uber・Lyft・配車",
    "label_en": "Uber & Lyft",
    "ic": "🚗",
    "desc": "アプリ配車・チップ・サージ料金",
    "desc_en": "Rideshare apps, tipping & surge pricing",
    "available": true,
    "countries": [
      "us"
    ]
  },
  {
    "id": "conv_travel_diner",
    "catId": "travel",
    "label": "ダイナー・ファストフード",
    "label_en": "Diner & Fast Food Culture",
    "ic": "🍔",
    "desc": "自由席・コーヒー無料おかわり・ドレッシング",
    "desc_en": "Diner etiquette, free refills & dressing choices",
    "available": true,
    "countries": [
      "us"
    ]
  },
  {
    "id": "conv_culture_thanksgiving",
    "catId": "culture",
    "label": "感謝祭",
    "label_en": "Thanksgiving",
    "ic": "🦃",
    "desc": "11月第4木曜日・七面鳥・家族集合",
    "desc_en": "4th Thursday Nov, turkey & Black Friday",
    "available": true,
    "countries": [
      "us"
    ]
  },
  {
    "id": "conv_culture_4thofjuly",
    "catId": "culture",
    "label": "独立記念日",
    "label_en": "4th of July",
    "ic": "🎆",
    "desc": "花火・バーベキュー・愛国心",
    "desc_en": "Fireworks, BBQ & patriotic culture",
    "available": true,
    "countries": [
      "us"
    ]
  },
  {
    "id": "conv_culture_halloween",
    "catId": "culture",
    "label": "ハロウィン",
    "label_en": "Halloween US",
    "ic": "🎃",
    "desc": "Trick-or-treat・コスチューム・職場",
    "desc_en": "Trick-or-treat, costumes & office parties",
    "available": true,
    "countries": [
      "us"
    ]
  },
  {
    "id": "conv_culture_superbowl",
    "catId": "culture",
    "label": "スーパーボウル",
    "label_en": "Super Bowl Culture",
    "ic": "🏈",
    "desc": "パーティー・CM・ハーフタイムショー",
    "desc_en": "Super Bowl parties, ads & halftime show",
    "available": true,
    "countries": [
      "us"
    ]
  },
  {
    "id": "conv_culture_tipping",
    "catId": "culture",
    "label": "チップ文化（深堀り）",
    "label_en": "Tipping Culture US",
    "ic": "💳",
    "desc": "なぜ払うのか・適切な金額・断り方",
    "desc_en": "Why tip, how much & when it's optional",
    "available": true,
    "countries": [
      "us"
    ]
  },
  {
    "id": "conv_culture_politics",
    "catId": "culture",
    "label": "政治の話題",
    "label_en": "Talking Politics US",
    "ic": "🗳️",
    "desc": "共和党・民主党・職場での話題回避",
    "desc_en": "Republicans, Democrats & avoiding conflicts",
    "available": true,
    "countries": [
      "us"
    ]
  },
  {
    "id": "conv_culture_smalltalk",
    "catId": "culture",
    "label": "アメリカ式雑談",
    "label_en": "American Small Talk",
    "ic": "😊",
    "desc": "How are you?・ポジティブ文化・过剰反応",
    "desc_en": "\"How are you?\", positivity culture & chitchat",
    "available": true,
    "countries": [
      "us"
    ]
  },
  {
    "id": "conv_culture_diversity",
    "catId": "culture",
    "label": "多様性・インクルージョン",
    "label_en": "Diversity & Inclusion US",
    "ic": "🌈",
    "desc": "DEI・マイクロアグレッション・言葉遣い",
    "desc_en": "DEI culture, microaggressions & inclusive language",
    "available": true,
    "countries": [
      "us"
    ]
  },
  {
    "id": "conv_life_healthcare",
    "catId": "life",
    "label": "医療システム",
    "label_en": "Healthcare System",
    "ic": "🏥",
    "desc": "医療費・保険・かかりつけ医",
    "desc_en": "Local healthcare system & insurance",
    "available": true,
    "countries": [
      "us",
      "au",
      "sg",
      "fr"
    ]
  },
  {
    "id": "conv_life_emergency",
    "catId": "life",
    "label": "緊急時の対応",
    "label_en": "Emergency Situations",
    "ic": "🚨",
    "desc": "911/000番・救急・警察",
    "desc_en": "Calling emergency services",
    "available": true,
    "countries": [
      "us",
      "au"
    ]
  },
  {
    "id": "conv_life_bbq",
    "catId": "life",
    "label": "バーベキュー文化",
    "label_en": "BBQ Culture",
    "ic": "🔥",
    "desc": "BYO・ライオンズBBQ・エチケット",
    "desc_en": "BYO, Lions Club BBQ & Aussie etiquette",
    "available": true,
    "countries": [
      "au"
    ]
  },
  {
    "id": "conv_life_transit",
    "catId": "life",
    "label": "公共交通機関",
    "label_en": "Public Transit AU",
    "ic": "🚌",
    "desc": "Opal/Myki・バス・トラム",
    "desc_en": "Opal/Myki cards & local transport",
    "available": true,
    "countries": [
      "au"
    ]
  },
  {
    "id": "conv_life_bins",
    "catId": "life",
    "label": "ゴミ・リサイクル",
    "label_en": "Bins & Recycling AU",
    "ic": "♻️",
    "desc": "赤・黄・緑のビン分別",
    "desc_en": "Red, yellow & green bin sorting",
    "available": true,
    "countries": [
      "au"
    ]
  },
  {
    "id": "conv_travel_beach",
    "catId": "travel",
    "label": "ビーチでの安全",
    "label_en": "Beach Safety",
    "ic": "🏖️",
    "desc": "フラッグ間・ライフセーバー",
    "desc_en": "Swim between the flags & surf lifesavers",
    "available": true,
    "countries": [
      "au"
    ]
  },
  {
    "id": "conv_travel_pub_au",
    "catId": "travel",
    "label": "オーストラリアのパブ",
    "label_en": "Aussie Pub & Bar",
    "ic": "🍺",
    "desc": "スクーナー・ポット・ラウンド",
    "desc_en": "Schooners, pots & shouting rounds",
    "available": true,
    "countries": [
      "au"
    ]
  },
  {
    "id": "conv_travel_roadtrip",
    "catId": "travel",
    "label": "ロードトリップ",
    "label_en": "Road Trip",
    "ic": "🚗",
    "desc": "長距離ドライブ・現地ルール",
    "desc_en": "Long-distance driving & local road rules",
    "available": true,
    "countries": [
      "us",
      "au"
    ]
  },
  {
    "id": "conv_culture_anzac",
    "catId": "culture",
    "label": "ANZACデー",
    "label_en": "ANZAC Day",
    "ic": "🌹",
    "desc": "Dawn service・Lest We Forget",
    "desc_en": "Dawn service, RSL & Lest We Forget",
    "available": true,
    "countries": [
      "au"
    ]
  },
  {
    "id": "conv_culture_slang",
    "catId": "culture",
    "label": "オーストラリア英語",
    "label_en": "Aussie Slang",
    "ic": "🦘",
    "desc": "G'day・arvo・brekkie",
    "desc_en": "G'day, arvo, brekkie & more Strine",
    "available": true,
    "countries": [
      "au"
    ]
  },
  {
    "id": "conv_culture_australia_day",
    "catId": "culture",
    "label": "オーストラリアデー",
    "label_en": "Australia Day",
    "ic": "🇦🇺",
    "desc": "1月26日・Invasion Day論争",
    "desc_en": "Jan 26, celebrations & Invasion Day debate",
    "available": true,
    "countries": [
      "au"
    ]
  },
  {
    "id": "conv_culture_indigenous",
    "catId": "culture",
    "label": "先住民族文化",
    "label_en": "Indigenous Culture AU",
    "ic": "🪃",
    "desc": "Welcome to Country・Acknowledgement",
    "desc_en": "Welcome to Country & Acknowledgement of Country",
    "available": true,
    "countries": [
      "au"
    ]
  },
  {
    "id": "conv_biz_dress",
    "catId": "work",
    "label": "SG職場ドレスコード",
    "label_en": "SG Office Dress Code",
    "ic": "👔",
    "desc": "スマートカジュアル・クライアント訪問時の服装",
    "desc_en": "Smart casual norms & AC cardigan culture",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_biz_lunch",
    "catId": "work",
    "label": "ビジネスランチ",
    "label_en": "Business Lunch",
    "ic": "🍜",
    "desc": "ホーカーセンターのビジネスランチ・chope文化",
    "desc_en": "Hawker centre lunch & chope culture",
    "available": true,
    "countries": [
      "sg",
      "fr",
      "it"
    ]
  },
  {
    "id": "conv_biz_ep",
    "catId": "work",
    "label": "就労パス（EP）",
    "label_en": "Employment Pass",
    "ic": "🪪",
    "desc": "EP・MOM・COMPASSフレームワーク",
    "desc_en": "EP, MOM & COMPASS framework",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_biz_resignation",
    "catId": "work",
    "label": "退職・転職",
    "label_en": "Resignation in SG",
    "ic": "📋",
    "desc": "1〜3ヶ月通知・ガーデンリーブ",
    "desc_en": "1-3 month notice & garden leave culture",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_life_hawker",
    "catId": "life",
    "label": "ホーカーセンター",
    "label_en": "Hawker Centre",
    "ic": "🍜",
    "desc": "chope・kopi・da bao・屋台の注文方法",
    "desc_en": "Chope, kopi & ordering at hawker stalls",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_life_hdb",
    "catId": "life",
    "label": "HDB住宅",
    "label_en": "HDB Housing",
    "ic": "🏢",
    "desc": "HDB・民族割当・家賃相場",
    "desc_en": "HDB flats, ethnic quota & rental costs",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_life_cpf",
    "catId": "life",
    "label": "CPF（年金・強制貯蓄）",
    "label_en": "CPF Contributions",
    "ic": "💰",
    "desc": "OA/SA/MA口座・37%拠出率",
    "desc_en": "OA, SA & MA accounts & contribution rates",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_life_mrt",
    "catId": "life",
    "label": "MRT・公共交通",
    "label_en": "MRT & Public Transport",
    "ic": "🚇",
    "desc": "EZ-Linkカード・飲食禁止・路線案内",
    "desc_en": "EZ-Link, no eating rule & line navigation",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_life_singlish",
    "catId": "life",
    "label": "Singlish",
    "label_en": "Singlish in Daily Life",
    "ic": "🗣️",
    "desc": "lah・lor・can・makan・bojio",
    "desc_en": "Singlish particles & how to use them",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_life_banking",
    "catId": "life",
    "label": "銀行・PayNow",
    "label_en": "Banking & PayNow",
    "ic": "🏦",
    "desc": "DBS/OCBC・PayNow・口座開設",
    "desc_en": "Local banks, PayNow & account opening",
    "available": true,
    "countries": [
      "sg",
      "fr"
    ]
  },
  {
    "id": "conv_life_phone",
    "catId": "life",
    "label": "SIM・携帯プラン",
    "label_en": "Mobile Plan",
    "ic": "📱",
    "desc": "Singtel/StarHub・GOMO・SIM選び",
    "desc_en": "Choosing a SIM plan & mobile provider",
    "available": true,
    "countries": [
      "sg",
      "fr"
    ]
  },
  {
    "id": "conv_life_tax",
    "catId": "life",
    "label": "税金申告",
    "label_en": "Income Tax",
    "ic": "📋",
    "desc": "IRAS・累進課税・e-filing",
    "desc_en": "IRAS, progressive rates & e-filing",
    "available": true,
    "countries": [
      "sg",
      "fr"
    ]
  },
  {
    "id": "conv_life_recycling",
    "catId": "life",
    "label": "リサイクル・e-waste",
    "label_en": "Recycling in Singapore",
    "ic": "♻️",
    "desc": "青いビン・E-waste収集ポイント・汚染防止",
    "desc_en": "Blue bins, e-waste drop-off & contamination",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_travel_changi",
    "catId": "travel",
    "label": "チャンギ空港",
    "label_en": "Changi Airport",
    "ic": "✈️",
    "desc": "ICA入国審査・Jewel・EP入国",
    "desc_en": "ICA immigration, EP holders & Jewel transit",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_travel_mrt",
    "catId": "travel",
    "label": "MRT観光利用",
    "label_en": "MRT for Tourists",
    "ic": "🚇",
    "desc": "路線・EZ-Link・方向サイン",
    "desc_en": "MRT lines, EZ-Link & navigation tips",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_travel_grab",
    "catId": "travel",
    "label": "Grab配車",
    "label_en": "Grab Rideshare",
    "ic": "🚗",
    "desc": "GrabCar・サージ料金・チップ",
    "desc_en": "GrabCar, surge pricing & payment",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_travel_hawker_food",
    "catId": "travel",
    "label": "ホーカー飯・名物料理",
    "label_en": "Hawker Food Guide",
    "ic": "🍛",
    "desc": "チャークウェイティオ・ラクサ・ナシレマ",
    "desc_en": "Char kway teow, laksa & nasi lemak guide",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_travel_sentosa",
    "catId": "travel",
    "label": "セントーサ島",
    "label_en": "Sentosa Island",
    "ic": "🎢",
    "desc": "USS・S.E.A. Aquarium・ビーチ",
    "desc_en": "Universal Studios, S.E.A. Aquarium & beaches",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_travel_shopping_mall",
    "catId": "travel",
    "label": "ショッピングモール",
    "label_en": "SG Shopping Malls",
    "ic": "🛍️",
    "desc": "ION/VivoCity・GSTリファンド",
    "desc_en": "ION Orchard, VivoCity & GST tourist refund",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_travel_sim_card",
    "catId": "travel",
    "label": "SIM購入（チャンギ）",
    "label_en": "Tourist SIM Card",
    "ic": "📡",
    "desc": "Changi Recommends・7日間SIM",
    "desc_en": "Changi Recommends SIM & tourist data plans",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_travel_money",
    "catId": "travel",
    "label": "両替・マネーチェンジャー",
    "label_en": "Money Exchange SG",
    "ic": "💱",
    "desc": "Mustafa・マーケットレート・両替所",
    "desc_en": "Mustafa, market rates & best exchange spots",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_culture_singlish",
    "catId": "culture",
    "label": "Singlish文化",
    "label_en": "Singlish Culture",
    "ic": "🗣️",
    "desc": "lah/lor/meh/sia・Singlishの使い方",
    "desc_en": "Singlish particles & expat participation",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_culture_food",
    "catId": "culture",
    "label": "食文化・フードカルチャー",
    "label_en": "Food Culture",
    "ic": "🍜",
    "desc": "ホーカー文化・フード論争・kopi文化",
    "desc_en": "Hawker culture, food debates & kopi rituals",
    "available": true,
    "countries": [
      "sg",
      "fr"
    ]
  },
  {
    "id": "conv_culture_racial_harmony",
    "catId": "culture",
    "label": "多民族・人種的調和",
    "label_en": "Racial Harmony",
    "ic": "🌈",
    "desc": "CMIO・HDB民族割当・人種的調和デー",
    "desc_en": "CMIO model, HDB quota & Racial Harmony Day",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_culture_kiasu",
    "catId": "culture",
    "label": "Kiasu文化",
    "label_en": "Kiasu Culture",
    "ic": "😤",
    "desc": "負けたくない心理・行列・競争文化",
    "desc_en": "Fear of losing out & competitive SG mindset",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_culture_cny",
    "catId": "culture",
    "label": "中国正月（CNY）",
    "label_en": "Chinese New Year",
    "ic": "🧧",
    "desc": "アンパオ・ロウヘイ・旧正月文化",
    "desc_en": "Ang bao, lou hei & CNY traditions in SG",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_culture_hari_raya",
    "catId": "culture",
    "label": "ハリラヤ（イスラム祝日）",
    "label_en": "Hari Raya",
    "ic": "🌙",
    "desc": "オープンハウス・バジュクルン・ケトゥパ",
    "desc_en": "Open house, baju kurung & Hari Raya food",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_culture_national_day",
    "catId": "culture",
    "label": "ナショナルデー",
    "label_en": "National Day SG",
    "ic": "🎉",
    "desc": "8月9日・NDPチケット・花火",
    "desc_en": "Aug 9, NDP tickets & Marina Bay fireworks",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_culture_fines",
    "catId": "culture",
    "label": "罰金制度",
    "label_en": "Fine Culture SG",
    "ic": "⚠️",
    "desc": "ポイ捨て$300・ガム禁止・飲食禁止",
    "desc_en": "Littering $300, gum ban & MRT fines",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_culture_aircon",
    "catId": "culture",
    "label": "エアコン文化",
    "label_en": "Air-Con Culture",
    "ic": "❄️",
    "desc": "屋内は極寒・カーディガン必須",
    "desc_en": "Freezing indoors & the cardigan rule",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_culture_queuing",
    "catId": "culture",
    "label": "行列文化・chope",
    "label_en": "Queuing & Chope",
    "ic": "🧻",
    "desc": "ティッシュで席取り・MRTの黄色ライン",
    "desc_en": "Tissue paper chope & orderly MRT queuing",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_culture_ns",
    "catId": "culture",
    "label": "国民兵役（NS）",
    "label_en": "National Service",
    "ic": "🪖",
    "desc": "2年間兵役・ORD loh!・NSの社会的役割",
    "desc_en": "Mandatory NS, ORD & social leveller role",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_culture_expat",
    "catId": "culture",
    "label": "駐在員・外国人生活",
    "label_en": "Expat Life in SG",
    "ic": "🌍",
    "desc": "EP・ang moh・condo生活・国際学校",
    "desc_en": "EP life, expat bubbles & local integration",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_culture_hawker_etiquette",
    "catId": "culture",
    "label": "ホーカーのエチケット",
    "label_en": "Hawker Etiquette",
    "ic": "🍽️",
    "desc": "トレイ返却・席の共有・ピーク時マナー",
    "desc_en": "Tray return, table sharing & peak hour norms",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_culture_lah",
    "catId": "culture",
    "label": "「lah」の使い方",
    "label_en": "Singlish Particles Deep Dive",
    "ic": "💬",
    "desc": "lah/lor/meh/sia・場面ごとの使い方",
    "desc_en": "Singlish particle nuances & expat use",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_culture_condo",
    "catId": "culture",
    "label": "コンドミニアム生活",
    "label_en": "Condo Living SG",
    "ic": "🏊",
    "desc": "MCST・管理費・静粛時間・AGM",
    "desc_en": "MCST fees, quiet hours & AGM voting",
    "available": true,
    "countries": [
      "sg"
    ]
  },
  {
    "id": "conv_biz_visa",
    "catId": "work",
    "label": "就労ビザ・滞在許可証",
    "label_en": "French Work Visa",
    "ic": "🪪",
    "desc": "DREETS・titre de séjour・Sécurité Sociale",
    "desc_en": "DREETS, prefecture & Sécu registration",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_life_boulangerie",
    "catId": "life",
    "label": "ブーランジェリー",
    "label_en": "French Boulangerie",
    "ic": "🥖",
    "desc": "バゲット・tradiction・毎朝のルーティン",
    "desc_en": "Baguette ordering & boulangerie rituals",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_life_secu",
    "catId": "life",
    "label": "社会保障（Sécu）",
    "label_en": "Sécurité Sociale",
    "ic": "🏥",
    "desc": "carte Vitale・médecin traitant・mutuelle",
    "desc_en": "Carte Vitale, GP choice & top-up insurance",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_life_greetings",
    "catId": "life",
    "label": "ビズ（挨拶のキス）",
    "label_en": "La Bise Greeting",
    "ic": "😘",
    "desc": "la bise・左から始める・地域差",
    "desc_en": "La bise rules, cheeks & regional variations",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_life_neighbour",
    "catId": "life",
    "label": "隣人・共同住宅",
    "label_en": "Neighbours & Copropriété",
    "ic": "🏘️",
    "desc": "gardien・syndic・規約・静粛時間",
    "desc_en": "Gardien, syndic & apartment rules",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_travel_metro",
    "catId": "travel",
    "label": "パリ・メトロ",
    "label_en": "Paris Métro",
    "ic": "🚇",
    "desc": "Navigoパス・t+チケット・RER B",
    "desc_en": "Navigo pass, t+ tickets & RER B to CDG",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_travel_cafe",
    "catId": "travel",
    "label": "フランスのカフェ",
    "label_en": "French Café Culture",
    "ic": "☕",
    "desc": "エスプレッソ・service compris・カウンター",
    "desc_en": "Un café = espresso, service compris & terrasse",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_travel_tgv",
    "catId": "travel",
    "label": "TGV・SNCF",
    "label_en": "TGV Train Travel",
    "ic": "🚄",
    "desc": "Ouigo・コンポスタージュ・ストライキ",
    "desc_en": "Ouigo, composting ticket & grève contingency",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_travel_museum",
    "catId": "travel",
    "label": "パリの美術館",
    "label_en": "Paris Museums",
    "ic": "🎨",
    "desc": "ルーブル・事前予約・Museum Pass",
    "desc_en": "Louvre timed entry, Museum Pass & free days",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_travel_market",
    "catId": "travel",
    "label": "フランスの市場",
    "label_en": "French Market",
    "ic": "🧺",
    "desc": "露天市場・野菜は触らない・現金",
    "desc_en": "Marché etiquette & don't touch the produce",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_culture_vouvoiement",
    "catId": "culture",
    "label": "vous/tu（敬語）",
    "label_en": "Vouvoiement & Tu",
    "ic": "🎩",
    "desc": "vous/tu・Du-Angebot的な「on se tutoie?」",
    "desc_en": "Vous vs tu, invitations to tutoyer",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_culture_greve",
    "catId": "culture",
    "label": "ストライキ文化",
    "label_en": "Strike Culture FR",
    "ic": "✊",
    "desc": "grève・SNCF/RATP・権利として",
    "desc_en": "Grève as constitutional right & transport tips",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_culture_vacances",
    "catId": "culture",
    "label": "バカンス文化",
    "label_en": "Vacances Culture",
    "ic": "🏖️",
    "desc": "5週間有給・8月全休・RTT",
    "desc_en": "5 weeks leave, August closure & RTT days",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_culture_laicite",
    "catId": "culture",
    "label": "政教分離（ライシテ）",
    "label_en": "Laïcité",
    "ic": "⚖️",
    "desc": "1905年法・公共の場での宗教的中立",
    "desc_en": "1905 law & strict state secularism",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_culture_wine",
    "catId": "culture",
    "label": "ワイン文化",
    "label_en": "Wine Culture FR",
    "ic": "🍷",
    "desc": "食事との合わせ方・ホスト文化・乾杯",
    "desc_en": "Wine pairing, not pouring yourself & Santé!",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_culture_debate",
    "catId": "culture",
    "label": "議論・ディベート文化",
    "label_en": "French Debate Culture",
    "ic": "🗣️",
    "desc": "知的スポーツとしての議論・「je ne suis pas d'accord」",
    "desc_en": "Debate as sport & Cartesian logic",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_culture_cheese",
    "catId": "culture",
    "label": "チーズ文化",
    "label_en": "French Cheese Culture",
    "ic": "🧀",
    "desc": "300種以上・コース料理での位置・食べ方",
    "desc_en": "300+ varieties & cheese course etiquette",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_culture_fashion",
    "catId": "culture",
    "label": "フランスのファッション",
    "label_en": "French Fashion Culture",
    "ic": "👗",
    "desc": "effortless chic・質 > 量・ファッションウィーク",
    "desc_en": "Effortless chic, quality over quantity",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_culture_administration",
    "catId": "culture",
    "label": "行政・お役所",
    "label_en": "French Administration",
    "ic": "📄",
    "desc": "dossier・書類不備・辛抱強さ",
    "desc_en": "Dossiers, incomplete files & patience needed",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_culture_manners",
    "catId": "culture",
    "label": "テーブルマナー",
    "label_en": "French Table Manners",
    "ic": "🍽️",
    "desc": "パンの位置・肘・bon appétit・両手",
    "desc_en": "Bread on table, elbows & bon appétit etiquette",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_culture_rugby_foot",
    "catId": "culture",
    "label": "ラグビー・フットボール",
    "label_en": "Rugby & Football FR",
    "ic": "🏉",
    "desc": "Top 14・Ligue 1・Les Bleus",
    "desc_en": "Top 14, Ligue 1 & Les Bleus sports culture",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_culture_recycling",
    "catId": "culture",
    "label": "リサイクル・環境意識",
    "label_en": "Recycling Culture FR",
    "ic": "♻️",
    "desc": "tri sélectif・黄色いゴミ箱・déchetterie",
    "desc_en": "Yellow bin, glass sorting & déchetterie",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_culture_bise_culture",
    "catId": "culture",
    "label": "ビズ文化（詳細）",
    "label_en": "La Bise Deep Dive",
    "ic": "💋",
    "desc": "地域別キスの回数・職場での月曜ビズ",
    "desc_en": "Regional kiss count & Monday office bise",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_culture_noise",
    "catId": "culture",
    "label": "アパートの騒音問題",
    "label_en": "Noise in French Apartments",
    "ic": "🔇",
    "desc": "静粛時間・内容証明郵便・管理組合",
    "desc_en": "Quiet hours, lettre recommandée & syndic",
    "available": true,
    "countries": [
      "fr"
    ]
  },
  {
    "id": "conv_it_bella_figura",
    "catId": "work",
    "label": "ベッラ・フィグーラ",
    "label_en": "Bella Figura at Work",
    "ic": "✨",
    "desc": "外見・印象管理・会議での存在感",
    "desc_en": "Appearance, impression management & presence in meetings",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_biz_time",
    "catId": "work",
    "label": "時間感覚・柔軟な開始時刻",
    "label_en": "Italian Time Flexibility",
    "ic": "⏰",
    "desc": "北部vs南部・遅刻の許容範囲・開始の合図",
    "desc_en": "North/south divide, lateness tolerance & meeting start cues",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_biz_lunch",
    "catId": "work",
    "label": "ビジネスランチ（2時間）",
    "label_en": "Italian Business Lunch",
    "ic": "🍝",
    "desc": "関係構築の場・コース順序・割り勘文化",
    "desc_en": "Trust-building meal, course order & who pays",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_raccomandazione",
    "catId": "work",
    "label": "人脈・紹介文化",
    "label_en": "Raccomandazione Culture",
    "ic": "🤝",
    "desc": "Fiducia・紹介ネットワーク・信頼優先取引",
    "desc_en": "Fiducia, referral networks & trust-first business",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_biz_email",
    "catId": "work",
    "label": "イタリア式ビジネスメール",
    "label_en": "Italian Business Email",
    "ic": "📧",
    "desc": "Gentile/Egregio・PEC・敬称の使い分け",
    "desc_en": "Formal salutations, PEC & professional closings",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_titles",
    "catId": "work",
    "label": "肩書き・敬称の使い方",
    "label_en": "Professional Titles in Italy",
    "ic": "🎓",
    "desc": "Dottore/Ingegnere/Avvocato・いつ使うか",
    "desc_en": "When and how to use Dottore, Ing., Avv. & other titles",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_ferragosto_biz",
    "catId": "work",
    "label": "フェッラゴスト・8月閉鎖",
    "label_en": "Ferragosto Business Impact",
    "ic": "🏖️",
    "desc": "8月15日・企業閉鎖・プロジェクト前倒し",
    "desc_en": "August company closures & planning around Ferragosto",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_family_biz",
    "catId": "work",
    "label": "ファミリービジネス取引",
    "label_en": "Italian Family Business",
    "ic": "👨‍👩‍👧",
    "desc": "PMI・同族企業・意思決定の特徴",
    "desc_en": "PMI family firms, slow decisions & relationship importance",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_bar_caffe",
    "catId": "life",
    "label": "バールでの朝のcaffè",
    "label_en": "Morning Bar & Caffè Culture",
    "ic": "☕",
    "desc": "エスプレッソの作法・カウンター料金・バリスタ",
    "desc_en": "Standing at the bar, espresso rules & cheaper counter price",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_codice_fiscale",
    "catId": "life",
    "label": "コディーチェ・フィスカーレ",
    "label_en": "Codice Fiscale & SSN",
    "ic": "🆔",
    "desc": "税務番号・SSN登録・Tessera Sanitaria",
    "desc_en": "Tax code, SSN health registration & Tessera Sanitaria card",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_residenza",
    "catId": "life",
    "label": "住民登録（Residenza）",
    "label_en": "Residenza Registration",
    "ic": "🏛️",
    "desc": "Comune・20日以内・必要書類",
    "desc_en": "Comune registration, 20-day rule & required documents",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_apartment",
    "catId": "life",
    "label": "アパート契約・賃貸",
    "label_en": "Renting in Italy",
    "ic": "🏠",
    "desc": "Contratto 4+4・caparra・cedolare secca",
    "desc_en": "4+4 lease, deposit & flat tax rental option",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_raccolta",
    "catId": "life",
    "label": "ゴミ分別（分別収集）",
    "label_en": "Italian Recycling System",
    "ic": "♻️",
    "desc": "有機・紙・プラ・ガラス・不燃の分け方",
    "desc_en": "Organic, paper, plastic, glass & non-recyclable sorting",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_mercato",
    "catId": "life",
    "label": "メルカート（市場）",
    "label_en": "Italian Market Shopping",
    "ic": "🧺",
    "desc": "週1市場・交渉文化・野菜の選び方",
    "desc_en": "Weekly market, price negotiation & letting vendors pick veg",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_condominio",
    "catId": "life",
    "label": "コンドミニオ・近所づきあい",
    "label_en": "Condominio Life",
    "ic": "🏘️",
    "desc": "管理組合・騒音規制・ポルティエーレ",
    "desc_en": "Building assembly, noise rules & the portiere role",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_ssn_doctor",
    "catId": "life",
    "label": "SSN・かかりつけ医登録",
    "label_en": "Italian Public Healthcare",
    "ic": "🏥",
    "desc": "MMG登録・ASL・無料受診と自己負担",
    "desc_en": "MMG registration, ASL & what's free vs. co-pay in the SSN",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_mammismo",
    "catId": "life",
    "label": "ファミリア・家族の絆",
    "label_en": "Italian Family Culture",
    "ic": "👨‍👩‍👧‍👦",
    "desc": "日曜家族ランチ・mammismo・30代の自立",
    "desc_en": "Sunday family lunch, mammismo & late independence from family",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_ztl",
    "catId": "travel",
    "label": "ZTL・歴史地区の交通規制",
    "label_en": "ZTL Restricted Zones",
    "ic": "🚗",
    "desc": "カメラ・レンタカー罰金・事前確認方法",
    "desc_en": "Cameras, rental car fines & how to check ZTL maps before entry",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_roma_sightseeing",
    "catId": "travel",
    "label": "ローマ観光・予約必須スポット",
    "label_en": "Rome Sightseeing Essentials",
    "ic": "🏛️",
    "desc": "コロッセオ・ヴァチカン・事前予約・入場時間",
    "desc_en": "Colosseum, Vatican, timed entry booking & skip-the-line tips",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_train_booking",
    "catId": "travel",
    "label": "イタリア鉄道の予約",
    "label_en": "Booking Italian Trains",
    "ic": "🚄",
    "desc": "Frecciarossa vs Italo・早期割引・座席指定",
    "desc_en": "Frecciarossa vs Italo, Prem's fares & seat reservation rules",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_restaurant_order",
    "catId": "travel",
    "label": "レストランでの注文",
    "label_en": "Ordering at an Italian Restaurant",
    "ic": "🍽️",
    "desc": "コペルト・水の注文・コース順・チップ",
    "desc_en": "Coperto, still vs sparkling water, course order & tipping",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_gelato",
    "catId": "travel",
    "label": "ジェラテリアでの注文",
    "label_en": "Ordering Gelato",
    "ic": "🍦",
    "desc": "カップvsコーン・グアスト・フレーバー選び",
    "desc_en": "Cup vs cone, gusto (flavour) choices & artisan vs tourist gelato",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_amalfi_cinque",
    "catId": "travel",
    "label": "アマルフィ・チンクエテッレ",
    "label_en": "Amalfi & Cinque Terre",
    "ic": "🌊",
    "desc": "フェリー・バス・ハイキングルート・混雑回避",
    "desc_en": "Ferry, SITA bus, hiking cards & avoiding summer crowds",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_taxi_culture",
    "catId": "travel",
    "label": "タクシー・交通手配",
    "label_en": "Taxis & Getting Around",
    "ic": "🚕",
    "desc": "白タク禁止・無線タクシー・メーター確認",
    "desc_en": "White licensed taxis only, radio taxi apps & meter start rules",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_hotel_checkin",
    "catId": "travel",
    "label": "ホテルチェックイン",
    "label_en": "Hotel Check-in Italy",
    "ic": "🏨",
    "desc": "パスポート提示義務・tassa di soggiorno・時間",
    "desc_en": "Passport registration law, tourist tax & check-in/out times",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_calcio",
    "catId": "culture",
    "label": "カルチョ文化",
    "label_en": "Italian Football (Calcio)",
    "ic": "⚽",
    "desc": "Serie A・ダービー・スクデット・Curva文化",
    "desc_en": "Serie A, city derbies, Scudetto & the Curva fan culture",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_catholicism",
    "catId": "culture",
    "label": "カトリック・宗教文化",
    "label_en": "Catholicism in Daily Life",
    "ic": "⛪",
    "desc": "ヴァチカン・守護聖人・宗教行事の社会的影響",
    "desc_en": "Vatican influence, patron saints & religious festivals in life",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_made_in_italy",
    "catId": "culture",
    "label": "Made in Italy",
    "label_en": "Made in Italy Pride",
    "ic": "🇮🇹",
    "desc": "ファッション・デザイン・食の品質へのこだわり",
    "desc_en": "Fashion, design & food quality pride as national identity",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_opera_music",
    "catId": "culture",
    "label": "オペラ・クラシック音楽",
    "label_en": "Opera & Classical Music",
    "ic": "🎭",
    "desc": "スカラ座・ヴェルディ・プッチーニ・開幕式",
    "desc_en": "La Scala, Verdi, Puccini & the Prima della Scala tradition",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_fashion_culture",
    "catId": "culture",
    "label": "ファッション・スタイル文化",
    "label_en": "Italian Fashion Culture",
    "ic": "👗",
    "desc": "ミラノ・ベッラ・フィグーラ・服装の社会的意味",
    "desc_en": "Milan fashion week, bella figura & dressing as social statement",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_slow_food",
    "catId": "culture",
    "label": "食のこだわり・スローフード",
    "label_en": "Slow Food & Food Culture",
    "ic": "🫙",
    "desc": "DOP/IGP・地域の誇り・レシピへのこだわり",
    "desc_en": "DOP labels, regional food pride & recipe authenticity debates",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_carnivale",
    "catId": "culture",
    "label": "カルネヴァーレ・祭り文化",
    "label_en": "Carnevale & Italian Festivals",
    "ic": "🎭",
    "desc": "ヴェネツィア・ヴィアレッジョ・パリオ・地域行事",
    "desc_en": "Venice masks, Viareggio floats, Palio & regional festivals",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_dolce_far_niente",
    "catId": "culture",
    "label": "ドルチェ・ファル・ニエンテ",
    "label_en": "Dolce Far Niente",
    "ic": "🌅",
    "desc": "何もしない喜び・ワークライフバランス・パッセジャータ",
    "desc_en": "Joy of doing nothing, passeggiata & Italian work-life balance",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_aperitivo",
    "catId": "culture",
    "label": "アペリティーボ文化",
    "label_en": "Aperitivo Culture",
    "ic": "🍸",
    "desc": "18〜20時・スプリッツ・無料おつまみ・ミラノ式",
    "desc_en": "Spritz, free snacks & the aperitivo hour in Milan & beyond",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_campanilismo",
    "catId": "culture",
    "label": "地域への誇り（カンパニリズモ）",
    "label_en": "Campanilismo Regional Pride",
    "ic": "🏘️",
    "desc": "都市・地域の誇り・ローマvsミラノ・方言",
    "desc_en": "City pride, Rome vs Milan rivalry & strong regional identity",
    "available": true,
    "countries": [
      "it"
    ]
  },
  {
    "id": "conv_it_pharmacy",
    "catId": "life",
    "label": "ファルマチア（薬局）の活用",
    "label_en": "Italian Pharmacy (Farmacia)",
    "ic": "💊",
    "desc": "緑十字マーク・処方不要薬・薬剤師への相談文化",
    "desc_en": "Green cross, OTC advice & pharmacist as first healthcare stop",
    "available": true,
    "countries": [
      "it"
    ]
  }
];

export const SCENE_DIALOGUES = {
  "conv_biz_card": {
    "id": "conv_biz_card",
    "title": "First meeting & business card",
    "titleJa": "初対面・自己紹介",
    "situation": "You're meeting a British colleague for the first time at their London office.",
    "situationJa": "ロンドンのオフィスでイギリス人の同僚と初めて会います。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "👔",
        "name": "James",
        "text": "Hi! You must be {name}. Great to finally meet you in person. How was your journey over?",
        "options": [
          {
            "text": "It was great, thanks for asking! Really looking forward to our meeting.",
            "correct": true,
            "feedback": "✅ 完璧です。相手の質問に肯定的に答えつつ、会議への期待を表現しています。英国のビジネス文化では、このような「ウォーム＆ポジティブ」な応答が初対面の信頼関係構築に最も効果的です。",
            "feedbackEn": "Perfect! You answer positively while showing enthusiasm for the meeting. This warm, forward-looking response is ideal for UK business culture—it builds rapport naturally without being overly formal.",
            "textJa": "ç´ æ™´ã‚‰ã—ã‹ã£ãŸã§ã™ã€ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼ãƒŸãƒ¼ãƒ†ã‚£ãƒ³ã‚°ã‚’ã¨ã¦ã‚‚æ¥½ã—ã¿ã«ã—ã¦ã„ã¾ã™ã€‚"
          },
          {
            "text": "Not too bad, thanks. The journey was a bit long but worth it.",
            "correct": false,
            "feedback": "✅ 非常に良い答えです。「Not too bad」は典型的な英国人の控えめで自然な表現。困難があっても肯定的にまとめる姿勢は、英国ビジネス文化で高く評価されます。",
            "feedbackEn": "Excellent! 'Not too bad' is quintessentially British—understated and warm. Acknowledging the journey while staying positive shows resilience, which Brits respect in professional contexts.",
            "textJa": "ã¾ã‚ã¾ã‚ã§ã—ãŸã€ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚å°‘ã—é•·æ—…ã§ã—ãŸãŒã€æ¥ãŸç”²æ–ãŒã‚ã‚Šã¾ã—ãŸã€‚"
          },
          {
            "text": "It was quite exhausting and the train was significantly delayed today.",
            "correct": false,
            "feedback": "⚠️ 正直さは良いですが、初対面の雑談でネガティブ詳細を優先させるのは英国風ではありません。「It was a bit long, but I'm here now!」と短くポジティブに転換すると、より会話が続きやすくなります。",
            "feedbackEn": "Honest, but not ideal for early small talk. Dwelling on delays can dampen the mood. Better: 'It was a bit of a journey, but I'm here now!'—acknowledge the challenge, then pivot positive. Brits appreciate pragmatism, not complaints.",
            "textJa": "ã‹ãªã‚Šç–²ã‚Œã¾ã—ãŸã€‚é›»è»ŠãŒã‹ãªã‚Šé…å»¶ã—ã¦ã„ãŸã‚“ã§ã™ã€‚"
          }
        ],
        "textJa": "ã“ã‚“ã«ã¡ã¯ï¼{name}ã•ã‚“ã§ã™ã­ã€‚ã¤ã„ã«ç›´æŽ¥ãŠä¼šã„ã§ãã¦å¬‰ã—ã„ã§ã™ã€‚æ—…ã¯ã„ã‹ãŒã§ã—ãŸã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "👔",
        "name": "James",
        "text": "Shall I give you a quick tour of the office before we get started?",
        "options": [
          {
            "text": "That would be lovely, thank you!",
            "correct": true,
            "feedback": "✅ 'Lovely' is very British and shows you've adapted to the local style.",
            "textJa": "ãœã²ã‚ˆã‚ã—ããŠé¡˜ã„ã—ã¾ã™ã€ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼"
          },
          {
            "text": "No thank you, let's start the meeting.",
            "correct": false,
            "feedback": "❌ Refusing small gestures can seem rude. Accept graciously.",
            "textJa": "çµæ§‹ã§ã™ã€ãƒŸãƒ¼ãƒ†ã‚£ãƒ³ã‚°ã‚’å§‹ã‚ã¾ã—ã‚‡ã†ã€‚"
          },
          {
            "text": "Yes please. Is there a toilet I can use?",
            "correct": false,
            "feedback": "⚠️ Fine in practice, but leading with this seems a bit blunt. Accept the tour first.",
            "textJa": "ã¯ã„ã€ãŠé¡˜ã„ã—ã¾ã™ã€‚ãƒˆã‚¤ãƒ¬ã‚’ãŠå€Ÿã‚Šã§ãã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "å§‹ã‚ã‚‹å‰ã«ã€ã‚ªãƒ•ã‚£ã‚¹ã‚’å°‘ã—ã”æ¡ˆå†…ã—ã¾ã—ã‚‡ã†ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "👔",
        "name": "James",
        "text": "By the way, we're pretty informal here — just call me James.",
        "options": [
          {
            "text": "Of course, James! Please call me Yoshi — much easier.",
            "correct": false,
            "feedback": "✅ イギリスのオフィス文化では、相手がファーストネームを提案してきたら、自分も自然に応じるのがベストです。相手の提案に同調し、親しみやすく返すことで、信頼関係が構築されます。「easier」というカジュアルな理由付けも、英国的なユーモアと親しみやすさを示します。",
            "feedbackEn": "This naturally reciprocates the informal tone and signals comfort with UK workplace culture. Adding a brief, casual reason (easier to pronounce) builds rapport and shows you're relaxed with the dynamic.",
            "textJa": "ã‚‚ã¡ã‚ã‚“ã§ã™ã€ã‚¸ã‚§ãƒ¼ãƒ ã‚ºã•ã‚“ï¼ç§ã®ã“ã¨ã¯ãƒ¨ã‚·ã¨ãŠå‘¼ã³ãã ã•ã„ã€‚ãã®æ–¹ãŒç°¡å˜ã§ã™ã‚ˆã€‚"
          },
          {
            "text": "Thank you for that, James. You can call me Yoshi as well.",
            "correct": true,
            "feedback": "⚠️ 丁寧で良い応答です。ただ'Thank you for that'という前置きがやや形式的で、英国のカジュアルなオフィス文化では少し距離感があります。'Of course!'のように即座に同調する方がより自然です",
            "feedbackEn": "⚠️ Polite but slightly formal for a casual UK office. 'Thank you for that' adds distance where none is needed. The first option's immediate, warm reciprocation feels more natural in British workplace culture",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€ã‚¸ã‚§ãƒ¼ãƒ ã‚ºã•ã‚“ã€‚ç§ã®ã“ã¨ã¯ãƒ¨ã‚·ã¨ãŠå‘¼ã³ãã ã•ã„ã€‚"
          },
          {
            "text": "Thanks, James. I'll get used to it — feel free to call me Yoshi.",
            "correct": false,
            "feedback": "⚠️ 柔軟性を示す良い表現ですが、'I'll get used to it'は「慣れるのに時間がかかる」というニュアンスを含み、相手の提案を少し遠ざけているように聞こえます。すぐに'Please call me Yoshi'と返す方が英国文化的により自然です。",
            "feedbackEn": "⚠️ Shows flexibility, but 'I'll get used to it' implies the informality takes adjustment—which can feel slightly hesitant. Immediately offering your own first name in return is the more natural British response.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€ã‚¸ã‚§ãƒ¼ãƒ ã‚ºã•ã‚“ã€‚æ…£ã‚Œã¾ã™ã€‚ãƒ¨ã‚·ã¨ãŠå‘¼ã³ãã ã•ã„ã€‚"
          }
        ],
        "textJa": "ãã†ãã†ã€ã†ã¡ã¯ã‹ãªã‚Šãƒ•ãƒ©ãƒ³ã‚¯ãªã‚“ã§ã™ã‚ˆã€‚ã‚¸ã‚§ãƒ¼ãƒ ã‚ºã¨ãŠå‘¼ã³ãã ã•ã„ã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: Business cards are not ceremonially exchanged like in Japan. Just hand it over casually. Eye contact and a warm handshake matter more.",
    "tipJa": "🇬🇧 イギリスTip: 名刺交換は日本ほど儀式的ではありません。カジュアルに渡せばOK。アイコンタクトと温かい握手の方が重要です。"
  },
  "conv_biz_smalltalk": {
    "id": "conv_biz_smalltalk",
    "title": "Small talk at the pub",
    "titleJa": "パブでの雑談",
    "situation": "Your UK team invites you for Friday drinks at the local pub after work.",
    "situationJa": "英国チームに仕事後のパブに誘われました。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "🍺",
        "name": "Sarah",
        "text": "What'll you have? First round's on me.",
        "options": [
          {
            "text": "A pint of lager, please. Thank you!",
            "correct": true,
            "feedback": "✅ Accepting a drink and saying thanks is perfect pub etiquette.",
            "textJa": "ãƒ©ã‚¬ãƒ¼ã‚’ä¸€æ¯ãŠé¡˜ã„ã—ã¾ã™ã€‚ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼"
          },
          {
            "text": "I don't drink alcohol. Nothing for me.",
            "correct": false,
            "feedback": "⚠️ Fine to not drink, but add a soft drink request: 'Just a sparkling water, thanks!'.",
            "textJa": "ã‚¢ãƒ«ã‚³ãƒ¼ãƒ«ã¯é£²ã¾ãªã„ã‚“ã§ã™ã€‚çµæ§‹ã§ã™ã€‚"
          },
          {
            "text": "I'll pay for my own, thank you.",
            "correct": false,
            "feedback": "❌ Refusing a round feels awkward. Accept gracefully — you can buy the next round.",
            "textJa": "è‡ªåˆ†ã§æ‰•ã„ã¾ã™ã€ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚"
          }
        ],
        "textJa": "ä½•ã«ã—ã¾ã™ã‹ï¼Ÿæœ€åˆã®ä¸€æ¯ã¯ç§ãŒã€‚"
      },
      {
        "speaker": "colleague",
        "avatar": "🍺",
        "name": "Sarah",
        "text": "So how are you finding London? Must be quite different from Japan!",
        "options": [
          {
            "text": "It's brilliant! The parks and history are wonderful, though the weather definitely takes some getting used to!",
            "correct": true,
            "feedback": "✅ 天気についての自虐的ユーモアはイギリス人が大好きなコミュニケーションスタイル。ロンドンの良さを素直に褒めつつ、共通の話題（天気）で親しみやすさを演出しています。ビジネス小話として自然で、相手も「そうですよね」と共感しやすくなります。",
            "feedbackEn": "✅ Self-deprecating humour about British weather is a classic way to build rapport. You're showing genuine appreciation while inviting them to bond over a shared cultural experience. Perfect for casual business conversation.",
            "textJa": "ç´ æ™´ã‚‰ã—ã„ã§ã™ï¼å…¬åœ’ã¨æ­´å²ãŒæœ€é«˜ã§ã™ã­ã€‚å¤©æ°—ã«ã¯ã¾ã æ…£ã‚Œã¦ã„ã¾ã›ã‚“ãŒï¼"
          },
          {
            "text": "There's so much to explore here. The cultural differences have been interesting to observe and experience.",
            "correct": false,
            "feedback": "✅ 前向きで、ロンドンへの関心を示しています。違いを「大変だ」ではなく「興味深い」と捉える姿勢は、英国人が好む適応的で開かれた態度です。個人の負の感情（高い、寒い）を避けつつ、会話を発展させやすくしています。",
            "feedbackEn": "✅ This shows genuine curiosity and adaptability—qualities British professionals respect. You're staying positive without dismissing real challenges, and you're opening the door for them to share their own insights about London.",
            "textJa": "æŽ¢ç´¢ã™ã‚‹ã“ã¨ãŒãŸãã•ã‚“ã‚ã‚Šã¾ã™ã€‚æ–‡åŒ–ã®é•ã„ã‚’è¦³å¯Ÿã™ã‚‹ã®ãŒèˆˆå‘³æ·±ã„ã§ã™ã€‚"
          },
          {
            "text": "It's quite different, yes. The weather and cost of living are challenging, but I'm enjoying discovering the city.",
            "correct": false,
            "feedback": "⚠️ 正直さは良いですが、ビジネス小話の場では最初に課題（寒さ、高さ）を持ち出すのは会話の流れを暗くします。もし課題に触れるなら、後半に軽いユーモアで包むか、むしろ肯定的な部分を先に引き出す方がUK文化では自然です。",
            "feedbackEn": "⚠️ Honesty is valued, but leading with challenges in casual workplace chat can flatten the mood. Consider reordering: start with what you love, then add weather/cost as a lighthearted aside. British small talk typically moves from positive to gently humorous about negatives.",
            "textJa": "ã‹ãªã‚Šé•ã„ã¾ã™ã€‚å¤©æ°—ã¨ç”Ÿæ´»è²»ã¯å¤§å¤‰ã§ã™ãŒã€è¡—ã‚’ç™ºè¦‹ã™ã‚‹ã®ã‚’æ¥½ã—ã‚“ã§ã„ã¾ã™ã€‚"
          }
        ],
        "textJa": "ãƒ­ãƒ³ãƒ‰ãƒ³ã¯ã©ã†ã§ã™ã‹ï¼Ÿæ—¥æœ¬ã¨ã¯ã‹ãªã‚Šé•ã†ã§ã—ã‚‡ã†ï¼"
      },
      {
        "speaker": "colleague",
        "avatar": "🍺",
        "name": "Sarah",
        "text": "Did you catch the match last night? We were robbed!",
        "options": [
          {
            "text": "I missed it! Who were you playing? That sounds frustrating—tell me what happened!",
            "correct": true,
            "feedback": "✅ 完璧な英国ビジネス小話。試合を見ていなくても相手の興味に真摯に耳を傾け、共感を示すことで会話が自然に続きます。「robbed」という強い表現に対して感情的に応答し、相手の気持ちを理解する姿勢が英国文化では重視されます。",
            "feedbackEn": "Perfect! You acknowledge you missed it honestly, ask engaging follow-up questions, and show empathy for their frustration. This is the most natural way to join the conversation without pretending knowledge you don't have.",
            "textJa": "è¦‹é€ƒã—ã¾ã—ãŸï¼ã©ã“ã¨å¯¾æˆ¦ã—ã¦ã„ãŸã‚“ã§ã™ã‹ï¼Ÿãƒ•ãƒ©ã‚¹ãƒˆãƒ¬ãƒ¼ãƒ†ã‚£ãƒ³ã‚°ã§ã™ã­ã€‚ä½•ãŒèµ·ããŸã‹æ•™ãˆã¦ãã ã•ã„ï¼"
          },
          {
            "text": "I'm not really a football fan, but I'd like to hear what happened.",
            "correct": false,
            "feedback": "✅ 非常に良い対応。個人の好みを正直に伝えつつ、相手への興味を示しています。英国文化では「本当ではないことを言わない」ことが信頼につながり、相手の話題を尊重する姿勢も印象的です。",
            "feedbackEn": "Excellent! You're honest about your preferences while still showing genuine interest in what matters to your colleague. UK culture values authenticity over pretense, and your openness invites them to share more naturally.",
            "textJa": "ã‚ã¾ã‚Šã‚µãƒƒã‚«ãƒ¼ã¯è©³ã—ããªã„ã‚“ã§ã™ãŒã€ä½•ãŒã‚ã£ãŸã‹èžã‹ã›ã¦ãã ã•ã„ã€‚"
          },
          {
            "text": "Yeah, I saw it—terrible decision by the ref. They definitely should have won.",
            "correct": false,
            "feedback": "⚠️ 見ていないのに言うのは危険です。相手は試合の詳細を知っており、嘘はすぐにばれます。英国ビジネス文化では信頼が最優先。知らないことは知らないと言う方がずっと好印象です。",
            "feedbackEn": "Risky! Your colleague knows the match details and will quickly catch you out if you bluff. UK business culture values honesty over pretence—admitting you didn't see it is far better than getting caught in a lie.",
            "textJa": "ãˆãˆã€è¦‹ã¾ã—ãŸã€‚å¯©åˆ¤ã®åˆ¤å®šãŒã²ã©ã‹ã£ãŸã§ã™ã‚ˆã­ã€‚çµ¶å¯¾ã«å‹ã¦ãŸã¯ãšã§ã—ãŸã€‚"
          }
        ],
        "textJa": "æ˜¨å¤œã®è©¦åˆã¯è¦‹ã¾ã—ãŸã‹ï¼Ÿç†ä¸å°½ãªåˆ¤å®šã§ã—ãŸã‚ˆï¼"
      }
    ],
    "tip": "🇬🇧 UK tip: The pub is where real relationships are built. Joining after-work drinks — even briefly — signals you're part of the team. Rounds are important: if someone buys you a drink, buy one back.",
    "tipJa": "🇬🇧 イギリスTip: パブは本当の関係が作られる場所。アフターワークドリンクに参加することはチームの一員であることを示します。ラウンド制：奢ってもらったら次は自分が買う。"
  },
  "conv_biz_meeting": {
    "id": "conv_biz_meeting",
    "title": "Expressing views in a meeting",
    "titleJa": "会議での意見表明",
    "situation": "You're in a team meeting. Your manager proposes a timeline you think is too tight.",
    "situationJa": "チーム会議中。マネージャーがタイトすぎると思うスケジュールを提案しました。",
    "turns": [
      {
        "speaker": "manager",
        "avatar": "👩‍💼",
        "name": "Rachel",
        "text": "So I'm thinking we wrap this up in 3 weeks. Does that work for everyone?",
        "options": [
          {
            "text": "That's a bit tight — could we push to 4 weeks? I want to ensure we deliver quality work.",
            "correct": true,
            "feedback": "✅「That's a bit tight」は英国ビジネスでの穏やかな異議唱として完璧です。理由を添えた代替案の提示は、英国文化では建設的で尊重される対応です。相手への配慮を示しながら明確に立場を伝えます。",
            "feedbackEn": "✅ 'That's a bit tight' is the perfect British understatement for gentle pushback. Offering an alternative with reasoning shows constructive thinking and respect for both timeline and quality—exactly what UK business culture values.",
            "textJa": "å°‘ã—ã‚¿ã‚¤ãƒˆã§ã™ã­ã€‚4é€±é–“ã«å»¶ã°ã›ã¾ã™ã‹ï¼Ÿã‚¯ã‚ªãƒªãƒ†ã‚£ã®é«˜ã„ä»•äº‹ã‚’ã—ãŸã„ã®ã§ã€‚"
          },
          {
            "text": "I see your point, but our team might struggle to meet that deadline. Could we discuss options?",
            "correct": false,
            "feedback": "⚠️ 相手の視点を認めつつ、チーム全体の状況を理由に丁寧に異議を唱えています。「discuss options」は漠然としすぎており、具体的な代替案（例：4週間）を示す方が英国ビジネス文化ではより建設的で実行的です。",
            "feedbackEn": "⚠️ Acknowledging their view is good, but 'discuss options' is vague. British business prefers concrete counter-proposals. Try adding a specific alternative like '4 weeks' to make it more actionable and collaborative.",
            "textJa": "ãŠã£ã—ã‚ƒã‚‹é€šã‚Šã§ã™ãŒã€ãƒãƒ¼ãƒ ã¨ã—ã¦ãã®æœŸé™ã«é–“ã«åˆã‚ã›ã‚‹ã®ã¯é›£ã—ã„ã‹ã‚‚ã—ã‚Œã¾ã›ã‚“ã€‚é¸æŠžè‚¢ã‚’è©±ã—åˆãˆã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Yes, three weeks works fine for us. We're committed to the deadline.",
            "correct": false,
            "feedback": "⚠️ 実際に問題がないなら完全に問題ありません。ただし、本当は難しい場合に同意すると、後で「実は間に合いません」と言うことになり、英国ビジネス文化では信頼を損ないます。正直さと実現可能性が最優先です。",
            "feedbackEn": "⚠️ If you genuinely can deliver in 3 weeks, this is fine. But if you have doubts, committing now and failing later damages credibility—something British business culture takes very seriously. Honesty and reliability are paramount.",
            "textJa": "ã¯ã„ã€3é€±é–“ã§å•é¡Œã‚ã‚Šã¾ã›ã‚“ã€‚æœŸé™ã‚’å®ˆã‚‹ã“ã¨ã‚’ãŠç´„æŸã—ã¾ã™ã€‚"
          }
        ],
        "textJa": "3é€±é–“ã§ã¾ã¨ã‚ã‚ˆã†ã¨æ€ã£ã¦ã„ã‚‹ã‚“ã§ã™ãŒã€‚ã¿ãªã•ã‚“ã¯ã©ã†ã§ã—ã‚‡ã†ã‹ï¼Ÿ"
      },
      {
        "speaker": "manager",
        "avatar": "👩‍💼",
        "name": "Rachel",
        "text": "Fair point. What would you need to make it work in 3?",
        "options": [
          {
            "text": "If we could get sign-off on the spec by end of this week, I think we could manage it.",
            "correct": true,
            "feedback": "✅「If we could〜」という条件付きの提案は、英国ビジネス文化で最も評価される『ソリューション志向』です。実現可能性と必要条件を同時に示し、「実行する気がある」というメッセージが伝わります。相手も次のアクションが明確になり、会議での説得力が高まります。",
            "feedbackEn": "✅ This is the gold standard in UK business communication. You've identified a specific blocker (sign-off on spec) and shown confidence you can deliver if it's removed. Managers appreciate this pragmatic, solution-focused approach—it signals ownership and builds trust.",
            "textJa": "ä»Šé€±æœ«ã¾ã§ã«ä»•æ§˜ã®æ‰¿èªã‚’ã„ãŸã ã‘ã‚Œã°ã€ãªã‚“ã¨ã‹ã§ãã‚‹ã¨æ€ã„ã¾ã™ã€‚"
          },
          {
            "text": "We'd need one extra QA person and clarity on change requests by Friday.",
            "correct": false,
            "feedback": "⚠️ 「具体的な人数」と「明確な締切」は素晴らしいですが、正解よりも『条件付き』の言い方が弱いのが惜しい点です。「We could manage it if we had one extra QA person...」と『できる可能性』を明示すると、より英国的な『実行可能性への自信』が伝わります。",
            "feedbackEn": "⚠️ Strong on specifics—you've named resources and a deadline. However, it reads as a demand rather than a conditional commitment. Reframe as 'If we had one extra QA person and clarity by Friday, we could manage it'—this shows confidence in your ability to deliver, which UK managers value highly.",
            "textJa": "QAã®æ‹…å½“è€…ã‚’ã‚‚ã†1äººã¨ã€é‡‘æ›œæ—¥ã¾ã§ã«å¤‰æ›´ä¾é ¼ã®æ•´ç†ãŒå¿…è¦ã§ã™ã€‚"
          },
          {
            "text": "I'd need more clarity on requirements and additional resource support to commit.",
            "correct": false,
            "feedback": "❌「具体性に欠ける」のが英国ビジネス文化では最大の弱点です。「more clarity」「additional support」は曖昧すぎて、相手が何をすべきか判断できません。「clarify the change scope by Friday and add one developer」のように『何を・誰が・いつまでに』を明確にするべきです。",
            "feedbackEn": "❌ This is too vague for UK business culture. 'More clarity' and 'additional support' don't give decision-makers anything concrete to act on. UK managers need specifics: which requirements, exactly how many people, by when. Without these details, you risk sounding unprepared rather than committed.",
            "textJa": "è¦ä»¶ã‚’ã‚ˆã‚Šæ˜Žç¢ºã«ã—ã¦ã€è¿½åŠ ãƒªã‚½ãƒ¼ã‚¹ã®ã‚µãƒãƒ¼ãƒˆãŒã‚ã‚Œã°ã‚³ãƒŸãƒƒãƒˆã§ãã¾ã™ã€‚"
          }
        ],
        "textJa": "ãªã‚‹ã»ã©ã€‚3é€±é–“ã§ã‚„ã‚‹ã«ã¯ä½•ãŒå¿…è¦ã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "💻",
        "name": "Tom",
        "text": "I actually think 3 weeks is doable if we cut the UAT phase.",
        "options": [
          {
            "text": "I'd be cautious about cutting UAT — quality issues down the line could be costly.",
            "correct": true,
            "feedback": "✅「I'd be cautious」は英国ビジネス文化の理想的な異議の唱え方です。直接的でなく、相手の提案を尊重しつつ懸念を丁寧に表現します。「could be costly」と具体的な影響を示すことで、建設的な根拠のある反対意見として機能し、相手も検討しやすくなります。",
            "feedbackEn": "This shows principled disagreement with deference. 'I'd be cautious' is appropriately indirect for British culture, and 'could be costly' provides concrete reasoning that invites further discussion rather than shutting it down.",
            "textJa": "UATã‚’å‰Šã‚‹ã“ã¨ã«ã¯æ…Žé‡ã«ãªã‚ŠãŸã„ã§ã™ã€‚å¾Œã€…ã®å“è³ªå•é¡Œã¯é«˜ãã¤ãå¯èƒ½æ€§ãŒã‚ã‚Šã¾ã™ã€‚"
          },
          {
            "text": "I see your point, but cutting UAT entirely might introduce significant risks.",
            "correct": false,
            "feedback": "⚠️ 非常に良い表現です。'I see your point'で相手を認め、'might introduce risks'で懸念を柔らかく示します。ただ「entirely」を含むため、部分的削減への柔軟性が明確でありません。「We might need to keep the critical tests at minimum」など、代替案を示唆するとさらに英国的になります。",
            "feedbackEn": "This is strong and respectful, acknowledging their input before offering reasoned concern. However, adding 'entirely' somewhat closes the door to compromise. British negotiation often benefits from subtle suggestion of alternatives like 'keep critical tests minimal.'",
            "textJa": "ãŠã£ã—ã‚ƒã‚‹ç‚¹ã¯ã‚ã‹ã‚Šã¾ã™ãŒã€UATã‚’å…¨é¢çš„ã«å‰Šé™¤ã™ã‚‹ã¨å¤§ããªãƒªã‚¹ã‚¯ãŒç”Ÿã˜ã‚‹å¯èƒ½æ€§ãŒã‚ã‚Šã¾ã™ã€‚"
          },
          {
            "text": "That approach won't quite work with our quality standards, I'm afraid.",
            "correct": false,
            "feedback": "⚠️「I'm afraid」は英国的な丁寧さを添えていますが、具体的な理由が不足しています。'quality standards'という抽象的な参照だけでは、相手が納得しやすい根拠がありません。「We'd risk delivering untested features, which could damage the client relationship」など、具体的な影響を付け足すとより説得力が出ます。",
            "feedbackEn": "The apologetic tone with 'I'm afraid' is appropriately British, but lacks concrete reasoning. Vague reference to 'quality standards' doesn't give the other person enough to engage with. Specific consequences would strengthen this response significantly.",
            "textJa": "ãã®ã‚¢ãƒ—ãƒ­ãƒ¼ãƒã ã¨ã€ç”³ã—è¨³ã‚ã‚Šã¾ã›ã‚“ãŒå“è³ªåŸºæº–ã¨åˆã‚ãªã„ã‚“ã§ã™ã€‚"
          }
        ],
        "textJa": "å®Ÿéš›ã€UATãƒ•ã‚§ãƒ¼ã‚ºã‚’å‰Šã‚Œã°3é€±é–“ã§ã§ãã‚‹ã¨æ€ã†ã‚“ã§ã™ãŒã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: Brits use softeners like 'I wonder if...', 'Could we perhaps...', 'I'd be cautious about...' to disagree politely. Direct refusal sounds aggressive — always offer a reason or alternative.",
    "tipJa": "🇬🇧 イギリスTip: 「I wonder if...」「Could we perhaps...」などの表現で丁寧に反対します。直接的な拒否は攻撃的に聞こえます。常に理由や代替案を添えましょう。"
  },
  "conv_biz_negotiation": {
    "id": "conv_biz_negotiation",
    "title": "Handling a complaint",
    "titleJa": "クレーム対応",
    "situation": "A UK client emails about a delivery delay. You're on a call with them.",
    "situationJa": "英国のクライアントから納期遅延の連絡。電話で対応します。",
    "turns": [
      {
        "speaker": "client",
        "avatar": "📞",
        "name": "Client",
        "text": "We were expecting delivery last Friday and it still hasn't arrived. This is causing us real problems.",
        "options": [
          {
            "text": "I completely understand your frustration, and I sincerely apologise for the delay. Let me look into this right now and get back to you today.",
            "correct": true,
            "feedback": "✅ 英国ビジネス文化では、まず相手の感情を認め（Acknowledge）、謝罪し（Apologise）、具体的な行動を約束する（Act）という3ステップが重要です。'Let me... right now'という即座の対応姿勢が信頼を生みます。",
            "feedbackEn": "Perfect approach: empathize, apologize sincerely, and commit to immediate action. Shows respect for their problem and demonstrates responsibility—core UK business values.",
            "textJa": "ã”ä¸æº€ã¯ã‚ˆãåˆ†ã‹ã‚Šã¾ã™ã€‚é…å»¶ã‚’å¿ƒã‹ã‚‰ãŠè©«ã³ç”³ã—ä¸Šã’ã¾ã™ã€‚ä»Šã™ãèª¿ã¹ã¦ã€æœ¬æ—¥ä¸­ã«ã”é€£çµ¡ã—ã¾ã™ã€‚"
          },
          {
            "text": "I'm really sorry to hear that. This shouldn't have happened. Let me investigate the courier and find out exactly where it is.",
            "correct": false,
            "feedback": "✅ これも優れた対応です。'This shouldn't have happened'と問題を認め、責任を受け入れた上で、具体的に何をするか（'investigate the courier'）を明示しています。相手の信頼を回復しようとする姿勢が英国的です。",
            "feedbackEn": "Excellent alternative: validates the issue, takes responsibility, and outlines specific next steps. Shows accountability and professionalism—highly valued in UK business culture.",
            "textJa": "ãã‚Œã¯å¤§å¤‰å¤±ç¤¼ã„ãŸã—ã¾ã—ãŸã€‚ã“ã®ã‚ˆã†ãªã“ã¨ã¯èµ·ãã¦ã¯ã„ã‘ã¾ã›ã‚“ã€‚é…é€æ¥­è€…ã‚’èª¿æŸ»ã—ã¦ã€ç¾åœ¨ã®çŠ¶æ³ã‚’ãŠèª¿ã¹ã—ã¾ã™ã€‚"
          },
          {
            "text": "I'm so sorry to hear this — it's been a frustrating situation for everyone. Unfortunately the delay originated with our supplier, so the resolution really needs to come from their side rather than ours.",
            "correct": false,
            "feedback": "⚠️ 言い訳から始めるのは避けましょう。英国では相手の状況に共感してから、必要があれば理由を説明します。'It's not our fault'という防衛的な態度は、相手の怒りを増します。まず「あなたの問題の解決」に焦点を当てるべきです。",
            "feedbackEn": "Problematic: starts with excuses and deflects responsibility. UK business culture values ownership and empathy first—blame-shifting damages relationships and client trust.",
            "textJa": "ã“ã®ã‚ˆã†ãªçŠ¶æ³ã«ãªã£ã¦ã—ã¾ã„ã€èª ã«ç”³ã—è¨³ã”ã–ã„ã¾ã›ã‚“ã€‚é…å»¶ã¯ã‚µãƒ—ãƒ©ã‚¤ãƒ¤ãƒ¼å´ã«èµ·å› ã—ã¦ãŠã‚Šã€è§£æ±ºã¯å…ˆæ–¹ã‹ã‚‰è¡Œã†å¿…è¦ãŒã‚ã‚Šã¾ã™ã€‚"
          }
        ],
        "textJa": "å…ˆé€±é‡‘æ›œæ—¥ã«é…é€ã•ã‚Œã‚‹äºˆå®šã§ã—ãŸãŒã€ã¾ã å±Šã„ã¦ã„ã¾ã›ã‚“ã€‚æœ¬å½“ã«å›°ã£ã¦ã„ã¾ã™ã€‚"
      },
      {
        "speaker": "client",
        "avatar": "📞",
        "name": "Client",
        "text": "What are you going to do about it?",
        "options": [
          {
            "text": "I'll escalate this to my team today and call you back by 3pm with a revised delivery date.",
            "correct": true,
            "feedback": "✅ イギリスのビジネス文化では「具体的な行動と期限」が最も信頼を築きます。'escalate'は責任を持って対応する姿勢を示し、具体的な時間指定（3pm）と成果物（revised date）を約束することで、相手の懸念に実行力を持って応えています。",
            "feedbackEn": "✅ British business culture values concrete action with specific timelines. 'Escalate' shows ownership, '3pm' demonstrates reliability, and 'revised date' gives a tangible deliverable. This builds immediate trust.",
            "textJa": "ä»Šæ—¥ä¸­ã«ãƒãƒ¼ãƒ ã«ã‚¨ã‚¹ã‚«ãƒ¬ãƒ¼ã‚·ãƒ§ãƒ³ã—ã¦ã€åˆå¾Œ3æ™‚ã¾ã§ã«æ–°ã—ã„é…é€æ—¥ç¨‹ã‚’ãŠçŸ¥ã‚‰ã›ã—ã¾ã™ã€‚"
          },
          {
            "text": "I understand your concern. Let me investigate and get back to you with solutions tomorrow morning.",
            "correct": false,
            "feedback": "✅ これも優れた対応です。相手の懸念を認識（'I understand your concern'）してから、具体的な期限を示すことで、相手を尊重しながら責任ある態度を示しています。ただし「3時間以内」は「翌朝」より即応性が高く、ビジネス交渉では速度が優先されることが多いです。",
            "feedbackEn": "✅ Also strong approach—acknowledges concern, then commits to a specific timeline. However, in negotiations, faster response ('3pm today') typically carries more weight than 'tomorrow morning' as it shows urgency and commitment.",
            "textJa": "ã”æ‡¸å¿µã¯ã‚ˆãåˆ†ã‹ã‚Šã¾ã™ã€‚èª¿æŸ»ã—ã¦ã€æ˜Žæœã«ã¯è§£æ±ºç­–ã‚’ã”ææ¡ˆã—ã¾ã™ã€‚"
          },
          {
            "text": "I'll do my best to sort this out and keep you updated regularly throughout the process.",
            "correct": false,
            "feedback": "⚠️ 意図は良いですが「惜しい」対応です。'do my best'は曖昧で、イギリスのビジネス環境では「いつまでに何をするか」の具体性が求められます。'call you by 10am tomorrow'など、はっきりした期限と行動を加えることで、より専門的で信頼できる印象になります。",
            "feedbackEn": "⚠️ Good intention but lacks specificity. 'Do my best' is vague—British business culture demands concrete deadlines and actions. Add '...by 10am tomorrow' or similar to show professional reliability and respect for the client's time.",
            "textJa": "æœ€å–„ã‚’å°½ãã—ã¦è§£æ±ºã—ã€å®šæœŸçš„ã«ã”å ±å‘Šã„ãŸã—ã¾ã™ã€‚"
          }
        ],
        "textJa": "ã©ã†ã—ã¦ãã‚Œã‚‹ã‚“ã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "client",
        "avatar": "📞",
        "name": "Client",
        "text": "We may need to claim compensation for the disruption this has caused.",
        "options": [
          {
            "text": "I appreciate you raising this. Let's understand the full picture—could you outline the specific impacts so we can explore this properly together?",
            "correct": true,
            "feedback": "✅英国ビジネス文化での理想的な対応です。相手の主張を真摯に受け止め（'appreciate'）、同時に詳細を求めることで、協調的かつ慎重な姿勢を示しています。'explore together'という表現は、対立ではなくパートナーシップを前提とした交渉スタイルで、英国ビジネスでは高く評価されます。",
            "feedbackEn": "Perfect for UK business culture. Acknowledges their concern genuinely, requests details without dismissing, and frames it as joint problem-solving rather than confrontation. Shows respect and collaborative intent.",
            "textJa": "ã”æŒ‡æ‘˜ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚å…¨ä½“åƒã‚’æŠŠæ¡ã—ã¾ã—ã‚‡ã†ã€‚å…·ä½“çš„ãªå½±éŸ¿ã‚’ãŠèžã‹ã›ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I see your point, but compensation isn't something I can agree to without checking with my management team first.",
            "correct": false,
            "feedback": "✅ これも英国文化的に良い対応です。相手の立場を認めつつ（'I see your point'）、自分の権限の限界を誠実に示しています。英国では過度な約束を避け、適切な意思決定プロセスを尊重することが信頼につながります。",
            "feedbackEn": "Also strong. Acknowledges their concern, avoids overcommitting, and clearly explains your decision-making process. This transparency and honesty builds trust in UK business relationships.",
            "textJa": "ãŠã£ã—ã‚ƒã‚‹ç‚¹ã¯ã‚ã‹ã‚Šã¾ã™ãŒã€è£œå„Ÿã«ã¤ã„ã¦ã¯ä¸Šã®ç¢ºèªãªã—ã«åŒæ„ã™ã‚‹ã“ã¨ã¯ã§ãã¾ã›ã‚“ã€‚"
          },
          {
            "text": "Compensation falls outside the scope of what we're able to offer directly, but I'm happy to log this formally and escalate to our service team so your concerns are on record.",
            "correct": false,
            "feedback": "⚠️ 文法的には間違いではありませんが、英国交渉では早すぎる決定に見えます。'I'm afraid'は丁寧ですが、相手の詳細を聞く前に扉を閉めてしまうと、話し合いの余地がないと受け取られます。まず情報を集め、その後で選択肢を検討する方が英国流です。",
            "feedbackEn": "The politeness is there, but closing the door before understanding the claim fully is seen as dismissive in UK negotiation culture. Better to listen first, then explain constraints—not the reverse.",
            "textJa": "è£œå„Ÿã¯ç›´æŽ¥æä¾›ã§ãã‚‹ç¯„å›²å¤–ã§ã™ãŒã€æ­£å¼ã«è¨˜éŒ²ã—ã¦ã‚µãƒ¼ãƒ“ã‚¹ãƒãƒ¼ãƒ ã«ã‚¨ã‚¹ã‚«ãƒ¬ãƒ¼ã‚·ãƒ§ãƒ³ã—ã¾ã™ã€‚"
          }
        ],
        "textJa": "ã“ã®ä»¶ã§ç”Ÿã˜ãŸæå®³ã®è£œå„Ÿã‚’è«‹æ±‚ã™ã‚‹å¿…è¦ãŒã‚ã‚‹ã‹ã‚‚ã—ã‚Œã¾ã›ã‚“ã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: British clients expect accountability, not excuses. A calm 'I'm sorry this happened' followed by a clear action plan goes a long way.",
    "tipJa": "🇬🇧 イギリスTip: 英国のクライアントは言い訳ではなく責任感を求めます。落ち着いた謝罪の後に明確なアクションプランが重要です。"
  },
  "conv_biz_email": {
    "id": "conv_biz_email",
    "title": "Email & Slack tone",
    "titleJa": "メール・Slackのトーン",
    "situation": "You need to chase a colleague for an overdue report via email.",
    "situationJa": "期限を過ぎたレポートをメールで催促します。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "💻",
        "name": "You (choose the best email)",
        "text": "Which email subject line is most appropriate for chasing an overdue report from a UK colleague?",
        "options": [
          {
            "text": "Subject: Following up on the Q3 report — could you give me an update?",
            "correct": true,
            "feedback": "✅「Following up」はUK職場の標準的なフレーズ。相手を責めず、協働的な姿勢で事実確認する点が英国ビジネス文化で高く評価されます。疑問形で相手に判断を委ねるアプローチも、関係を損なわない丁寧さを示しています。",
            "feedbackEn": "'Following up' is the standard UK business phrase that sounds collaborative rather than accusatory. The question form respects the colleague's autonomy and allows them to explain any delays. This indirect approach maintains professional relationships while still achieving your goal.",
            "textJa": "ä»¶åï¼šQ3ãƒ¬ãƒãƒ¼ãƒˆã«ã¤ã„ã¦ï¼çŠ¶æ³ã‚’æ•™ãˆã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Subject: Q3 report — would you be able to share this by end of week?",
            "correct": false,
            "feedback": "⚠️ これも良いアプローチです。「would you be able to」は典型的なUK丁寧表現で、期限も明確です。ただ正解よりも「追跡」というニュアンスが薄く、最初の接触のように聞こえるかもしれません。既に期限を過ぎている場合は「Following up on」の方が文脈に合いやすいです。",
            "feedbackEn": "Good UK phrasing with 'would you be able to,' but it reads more like an initial request than a follow-up. When chasing an overdue report, 'Following up on' better signals that this is a second contact. Still polite and indirect—just less ideal for this specific situation.",
            "textJa": "ä»¶åï¼šQ3ãƒ¬ãƒãƒ¼ãƒˆï¼é€±æœ«ã¾ã§ã«å…±æœ‰ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Subject: Q3 report status update — any news on your end?",
            "correct": false,
            "feedback": "⚠️ カジュアルで親しみやすいトーンですが、「追跡する」という意図が曖昧です。「any news on your end?」は若干受動的に聞こえ、督促というより状況確認のように感じられます。より直接的な「Following up」フレーズの方が適切です。",
            "feedbackEn": "Friendly and casual tone, but less direct about chasing an overdue report. 'Any news on your end?' sounds more like a general check-in than a follow-up on a specific deadline miss. For overdue matters, 'Following up on' signals more urgency while remaining polite.",
            "textJa": "ä»¶åï¼šQ3ãƒ¬ãƒãƒ¼ãƒˆã®é€²æ—çŠ¶æ³ï¼ã„ã‹ãŒã§ã—ã‚‡ã†ã‹ï¼Ÿ"
          }
        ],
        "textJa": "è‹±å›½ã®åŒåƒšã«æœŸé™ã‚’éŽãŽãŸãƒ¬ãƒãƒ¼ãƒˆã‚’å‚¬ä¿ƒã™ã‚‹ãƒ¡ãƒ¼ãƒ«ã®ä»¶åã¨ã—ã¦æœ€ã‚‚é©åˆ‡ãªã®ã¯ã©ã‚Œã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "💻",
        "name": "You (choose the best opener)",
        "text": "Which opening sentence works best?",
        "options": [
          {
            "text": "Hope you're well — just a quick nudge on the Q3 report. No rush, but it would be great to have it by Friday.",
            "correct": true,
            "feedback": "✅ 「Hope you're well」で温かく始まり、「nudge」は間接的で柔らかい依頼表現、「No rush」で圧力を軽減しています。イギリスビジネスメールの特徴である親しみやすさと実行性のバランスが完璧で、相手との関係を保ちながら明確に期限を伝えています。",
            "feedbackEn": "Perfect British business tone. 'Hope you're well' opens warmly, 'nudge' is indirect and softens the request, and 'No rush' reduces pressure while maintaining clarity. This preserves professional rapport—the hallmark of UK business communication.",
            "textJa": "ãŠä¸–è©±ã«ãªã£ã¦ãŠã‚Šã¾ã™ã€‚Q3ãƒ¬ãƒãƒ¼ãƒˆã«ã¤ã„ã¦è»½ãã”é€£çµ¡ã§ã™ã€‚æ€¥ãŽã§ã¯ã‚ã‚Šã¾ã›ã‚“ãŒã€é‡‘æ›œæ—¥ã¾ã§ã«ã„ãŸã ã‘ã‚‹ã¨åŠ©ã‹ã‚Šã¾ã™ã€‚"
          },
          {
            "text": "I am writing to inform you that the Q3 report deadline is approaching — please share it by Friday.",
            "correct": false,
            "feedback": "⚠️ 「I am writing to inform you」は形式的すぎて距離感があります。イギリスのビジネスメールではもっとカジュアルな挨拶で始めるのが自然です。「Could you possibly...?」という依頼方法は良いのですが、開き方を「Hope you're having a good week」のようにより親しみやすくすると、より英国的になります。",
            "feedbackEn": "The opening is too formal and creates unnecessary distance. While 'Could you possibly...?' is appropriately indirect, a warmer greeting like 'Hope you're well' would be more natural. Modern British professionals prefer conversational tone even in requests.",
            "textJa": "Q3ãƒ¬ãƒãƒ¼ãƒˆã®ç· ã‚åˆ‡ã‚ŠãŒè¿‘ã¥ã„ã¦ã„ã‚‹ãŸã‚ã€é‡‘æ›œæ—¥ã¾ã§ã«å…±æœ‰ã‚’ãŠé¡˜ã„ã„ãŸã—ã¾ã™ã€‚"
          },
          {
            "text": "The Q3 report is overdue. I need it completed and sent to me immediately without any further delays.",
            "correct": false,
            "feedback": "❌ 命令的で強制的な表現がイギリス文化では失礼に映ります。「overdue」「immediately」「without further delays」は相手を非難しており、ビジネス関係を損なう可能性があります。英国では間接的で思いやりのある言葉遣いが重視され、たとえ急でも相手の事情に配慮する表現を選びます。",
            "feedbackEn": "Accusatory and demanding tone that violates British business etiquette. 'Overdue,' 'immediately,' and 'without further delays' sound aggressive and disrespectful. British professionals prioritize indirect language and consideration for the other person, even when urgent.",
            "textJa": "Q3ãƒ¬ãƒãƒ¼ãƒˆã®æœŸé™ãŒéŽãŽã¦ã„ã¾ã™ã€‚ç›´ã¡ã«å®Œæˆã•ã›ã¦é€ã£ã¦ãã ã•ã„ã€‚"
          }
        ],
        "textJa": "æœ€ã‚‚åŠ¹æžœçš„ãªæ›¸ãå‡ºã—ã¯ã©ã‚Œã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "💬",
        "name": "Colleague (Slack)",
        "text": "Your colleague replies on Slack: 'Sorry, been swamped — will get it to you EOD!' How do you respond?",
        "options": [
          {
            "text": "No worries at all — EOD works perfectly, thanks for the update!",
            "correct": true,
            "feedback": "✅「No worries」はイギリス英語で相手の謝罪を温かく受け入れる最も自然な表現です。相手の謝罪を否定せず、期限を明確に了解した返答で、UK職場文化では理想的なプロフェッショナルな対応です。相手との信頼関係を損なわず、ポジティブな雰囲気を保てます。",
            "feedbackEn": "'No worries' is the quintessential British way to gracefully accept an apology and reassure your colleague. You're confirming the specific deadline (EOD) while maintaining a warm, professional tone—exactly what builds strong workplace relationships in UK business culture.",
            "textJa": "å…¨ç„¶å•é¡Œã‚ã‚Šã¾ã›ã‚“ï¼ä»Šæ—¥ä¸­ã§å¤§ä¸ˆå¤«ã§ã™ã€ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼"
          },
          {
            "text": "Cheers, that's helpful — just let me know if anything changes!",
            "correct": false,
            "feedback": "⚠️「Cheers」はカジュアルで親しみやすく、UK職場では一般的です。ただし「just let me know if anything changes」は相手に対して期限の融通性を示唆してしまい、微妙に曖昧になります。むしろ「No worries — EOD is perfect」と期限を明確に承認する方が、相手の約束を確実に受け入れる意思が伝わり、より信頼を構築できます。",
            "feedbackEn": "While 'Cheers' is perfectly natural in UK workplaces, the phrase 'let me know if anything changes' subtly suggests timeline flexibility. In British business communication, explicitly confirming the specific deadline (EOD) shows you trust their commitment and removes ambiguity.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼ä½•ã‹å¤‰æ›´ãŒã‚ã‚Œã°æ•™ãˆã¦ãã ã•ã„ï¼"
          },
          {
            "text": "Thanks for letting me know — appreciate the quick turnaround!",
            "correct": false,
            "feedback": "⚠️ 相手の努力を認める親切な返答ですが、実際には相手は「swamped」（多忙）で「EOD」（営業終了時）という期限を設定しているため、「quick turnaround」は状況と合致しません。相手の負担を認めつつ期限を承認する「No worries — EOD works perfectly」の方が、現状を正確に理解した返答になります。",
            "feedbackEn": "Appreciative in tone, but 'quick turnaround' misreads the situation—your colleague is busy and setting a specific deadline (EOD), not delivering something fast. Better to acknowledge their workload while confirming the deadline: this shows you're realistic about their capacity.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼è¿…é€Ÿãªå¯¾å¿œã«æ„Ÿè¬ã—ã¾ã™ï¼"
          }
        ],
        "textJa": "åŒåƒšãŒSlackã§ã€Œã”ã‚ã‚“ã€ãƒã‚¿ãƒã‚¿ã—ã¦ãŸï¼ä»Šæ—¥ä¸­ã«é€ã‚‹ã‚ˆï¼ã€ã¨è¿”ä¿¡ã—ã¾ã—ãŸã€‚ã©ã†è¿”ã—ã¾ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: Key phrases: 'Just a quick nudge', 'No rush but...', 'When you get a chance'. Avoid 'As per my last email' — it's known as passive-aggressive in UK offices!",
    "tipJa": "🇬🇧 イギリスTip: 定番フレーズ：「Just a quick nudge」「No rush but...」。「As per my last email」は受動的攻撃的として知られています！"
  },
  "conv_biz_wfh": {
    "id": "conv_biz_wfh",
    "title": "Working from home culture",
    "titleJa": "在宅勤務の文化",
    "situation": "You're new to a UK company. Your manager is discussing the team's WFH policy.",
    "situationJa": "英国の会社に入ったばかり。マネージャーがWFHポリシーについて話しています。",
    "turns": [
      {
        "speaker": "manager",
        "avatar": "👩‍💼",
        "name": "Manager",
        "text": "We're pretty flexible here — most people do 2–3 days in the office. What works for you?",
        "options": [
          {
            "text": "That sounds great. I'd do Tuesday and Thursday in the office — does that work for the team?",
            "correct": true,
            "feedback": "✅ 具体的な日程を提案しながら、チームへの配慮を示しています。英国ビジネス文化では「柔軟性がある中でも責任感を持つ」姿勢が高く評価されます。相手の提案を肯定しつつ、自分の希望を協調的に表現するベストアプローチです。",
            "feedbackEn": "✅ Proposing specific days while checking team alignment shows collaborative thinking. In UK business culture, demonstrating flexibility within responsibility is highly valued. This balances acceptance with constructive input.",
            "textJa": "ã„ã„ã§ã™ã­ã€‚ç«æ›œã¨æœ¨æ›œã‚’ã‚ªãƒ•ã‚£ã‚¹ã«ã—ã‚ˆã†ã¨æ€ã„ã¾ã™ã€‚ãƒãƒ¼ãƒ ã«ã¨ã£ã¦ã‚ˆã„ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I'd prefer working from home most days — I'm very productive that way, if that's fine?",
            "correct": false,
            "feedback": "⚠️ 個人の生産性を理由に挙げるのは良いアプローチですが、「most days」は相手が提示した「2-3日」と矛盾しています。英国では誠実さが大切なため、『実は週1日だけのオフィス出勤を希望する』なら、最初から「Actually, I work best with one day in the office」と正直に言う方が信頼を築きます。",
            "feedbackEn": "⚠️ Explaining productivity is good, but 'most days' contradicts their 2-3 day suggestion. UK culture values honesty—if you actually prefer minimal office time, stating that clearly ('I'd prefer just one day in') builds trust better than seeming to agree then proposing something different.",
            "textJa": "ã§ãã‚Œã°åœ¨å®…å‹¤å‹™ãŒå¤šã„æ–¹ãŒã„ã„ã§ã™ã€‚ç”Ÿç”£æ€§ãŒä¸ŠãŒã‚Šã¾ã™ãŒã€å•é¡Œã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Two days a week sounds good — I'll adapt to whatever timing works best for everyone.",
            "correct": false,
            "feedback": "⚠️ チームへの適応姿勢は良いのですが、「whatever timing」と曖昧なままにしています。英国では『責任を持って判断できる人』が信頼されるため、「Two days sounds good—could we aim for Mondays and Thursdays to stay consistent?」と能動的に日程を提案する方がより評価されます。",
            "feedbackEn": "⚠️ Your team orientation is good, but leaving timing vague suggests you haven't thought it through. UK culture respects people who take ownership of decisions. Proposing specific days ('Mondays and Thursdays') shows you're thinking ahead, not just accommodating.",
            "textJa": "é€±2æ—¥ã§ã‚ˆã•ãã†ã§ã™ã€‚çš†ã•ã‚“ã«åˆã‚ã›ã¾ã™ã€‚"
          }
        ],
        "textJa": "ã“ã¡ã‚‰ã¯ã‹ãªã‚ŠæŸ”è»Ÿã§ã€ã»ã¨ã‚“ã©ã®äººãŒé€±2ã€œ3æ—¥ã‚ªãƒ•ã‚£ã‚¹ã«æ¥ã¦ã„ã¾ã™ã€‚ã‚ãªãŸã¯ã©ã†ã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "💻",
        "name": "Tom",
        "text": "Do you have a good setup at home? We can help with equipment if needed.",
        "options": [
          {
            "text": "That's really kind — I have a desk and monitor, but a decent headset would be helpful if possible.",
            "correct": true,
            "feedback": "✅ 具体的かつ感謝の気持ちが伝わり、1つに絞った要望が英国文化的にベストです。必要な物を丁寧に伝えつつ、提案を有難く受け入れる姿勢が「UK的なプロフェッショナルな振る舞い」です。",
            "feedbackEn": "✅ Specific, grateful, and focused on one item. This shows appreciation while being realistic—very British business etiquette. It demonstrates you've thought about what's essential without over-asking.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ãƒ‡ã‚¹ã‚¯ã¨ãƒ¢ãƒ‹ã‚¿ãƒ¼ã¯ã‚ã‚Šã¾ã™ãŒã€ãƒ˜ãƒƒãƒ‰ã‚»ãƒƒãƒˆãŒã‚ã‚‹ã¨åŠ©ã‹ã‚Šã¾ã™ã€‚"
          },
          {
            "text": "Thanks for offering! I'm managing okay, but I'd appreciate advice on the best setup for video calls.",
            "correct": false,
            "feedback": "✅ 物質的支援を辞退しながらも、アドバイスという別の形のサポートを求めることで、相手の提案を活かしています。英国文化では「自分で何とかする」姿勢も尊重されます。",
            "feedbackEn": "✅ Politely declines while still engaging with the offer by seeking advice instead. This reflects British independence and shows you're collaborative without being demanding.",
            "textJa": "ç”³ã—å‡ºã¦ã„ãŸã ã„ã¦ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ãªã‚“ã¨ã‹ã‚„ã£ã¦ã„ã‘ã¾ã™ãŒã€ãƒ“ãƒ‡ã‚ªé€šè©±ã®è¨­å®šã«ã¤ã„ã¦ã‚¢ãƒ‰ãƒã‚¤ã‚¹ã‚’ã„ãŸã ã‘ã‚‹ã¨åŠ©ã‹ã‚Šã¾ã™ã€‚"
          },
          {
            "text": "I need a standing desk, two monitors, a new laptop, and better internet. Can you help with all of these?",
            "correct": false,
            "feedback": "⚠️ 一度に複数の要望を並べるのは「欲張り」に見えます。優先順位をつけて段階的に相談する方が、英国のビジネス文化では好印象です。まず最も必要な1〜2つに絞りましょう。",
            "feedbackEn": "⚠️ Asking for multiple items at once can seem greedy and burdensome. In UK business culture, it's better to prioritize and request essentials first, then follow up later if other improvements would help.",
            "textJa": "ã‚¹ã‚¿ãƒ³ãƒ‡ã‚£ãƒ³ã‚°ãƒ‡ã‚¹ã‚¯ã€ãƒ¢ãƒ‹ã‚¿ãƒ¼2å°ã€æ–°ã—ã„ãƒŽãƒ¼ãƒˆãƒ‘ã‚½ã‚³ãƒ³ã€ã‚ˆã‚Šé€Ÿã„ã‚¤ãƒ³ã‚¿ãƒ¼ãƒãƒƒãƒˆãŒå¿…è¦ã§ã™ã€‚å…¨éƒ¨æ‰‹åŠ©ã‘ã—ã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "è‡ªå®…ã®ç’°å¢ƒã¯æ•´ã£ã¦ã„ã¾ã™ã‹ï¼Ÿæ©Ÿå™¨ãŒå¿…è¦ãªã‚‰æ‰‹åŠ©ã‘ã§ãã¾ã™ã‚ˆã€‚"
      },
      {
        "speaker": "manager",
        "avatar": "👩‍💼",
        "name": "Manager",
        "text": "One thing — when you're WFH, do keep your calendar up to date so the team knows when you're available.",
        "options": [
          {
            "text": "Got it — I'll keep my calendar updated so the team knows when I'm available.",
            "correct": true,
            "feedback": "✅ マネージャーの提案を簡潔かつ明確に受け入れ、具体的な実行を示しています。英国では「理解した上での行動確認」が信頼につながります。無駄のない返答は、プロフェッショナルで頼もしい印象を与えます。",
            "feedbackEn": "Perfect balance of understanding and commitment. You acknowledge the request clearly and confirm action without over-explaining. This practical, straightforward approach is highly valued in UK workplace culture.",
            "textJa": "äº†è§£ã—ã¾ã—ãŸã€‚ãƒãƒ¼ãƒ ãŒæŠŠæ¡ã§ãã‚‹ã‚ˆã†ã«ã‚«ãƒ¬ãƒ³ãƒ€ãƒ¼ã‚’æ›´æ–°ã—ã¦ãŠãã¾ã™ã€‚"
          },
          {
            "text": "Absolutely — I appreciate the heads up on team expectations and will keep it updated.",
            "correct": false,
            "feedback": "⚠️ 感謝の気持ちを示すのは良いですが、「expectations」という少し形式的な表現が入ると、対等な同僚同士というより「一方的に指導されている」という印象になります。より親友的には 'Thanks for the tip!' や 'Good point!' の方が自然です。",
            "feedbackEn": "Good response, but slightly formal in tone. While gratitude is appreciated, 'team expectations' sounds a bit defensive or hierarchical. Try 'Good point—I'll make sure to do that' for a more natural, peer-to-peer feel.",
            "textJa": "ã‚‚ã¡ã‚ã‚“ã§ã™ã€‚ãƒãƒ¼ãƒ ã®æœŸå¾…ã«ã¤ã„ã¦ã®æƒ…å ±ã‚’ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚æ›´æ–°ã—ã¦ãŠãã¾ã™ã€‚"
          },
          {
            "text": "That makes sense — keeps everyone coordinated and avoids scheduling confusion.",
            "correct": false,
            "feedback": "⚠️ 相手の提案背景を理解した返答で、思慮深く見えます。ただ「理解を示しつつ行動する」という一歩が抜けています。英国では理解+確認アクションの両方があると最も信頼されます。「Got it. I'll make sure to do that」と続けるとより良くなります。",
            "feedbackEn": "You show good understanding of the reasoning, which is thoughtful. However, in UK culture, it's important to pair understanding with an action commitment. Add 'I'll definitely keep it updated' to show you'll act on it.",
            "textJa": "ç¢ºã‹ã«ãã†ã§ã™ã­ã€‚çš†ã•ã‚“ã®èª¿æ•´ãŒã—ã‚„ã™ããªã‚Šã¾ã™ã—ã€ã‚¹ã‚±ã‚¸ãƒ¥ãƒ¼ãƒªãƒ³ã‚°ã®æ··ä¹±ã‚‚é¿ã‘ã‚‰ã‚Œã¾ã™ã€‚"
          }
        ],
        "textJa": "ä¸€ã¤ç¢ºèªã§ã™ãŒã€åœ¨å®…å‹¤å‹™ã®æ—¥ã¯ã‚«ãƒ¬ãƒ³ãƒ€ãƒ¼ã‚’æœ€æ–°ã®çŠ¶æ…‹ã«ã—ã¦ãŠã„ã¦ãã ã•ã„ã€‚ãƒãƒ¼ãƒ ãŒã‚ãªãŸã®çŠ¶æ³ã‚’æŠŠæ¡ã§ãã‚‹ã‚ˆã†ã«ã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: WFH is mainstream in UK offices post-2020. Most companies expect 2–3 days in-office. Keep your calendar updated and respond promptly on Slack/Teams.",
    "tipJa": "🇬🇧 イギリスTip: WFHは2020年以降英国オフィスで主流です。多くの企業がオフィス出社2〜3日を期待しています。"
  },
  "conv_biz_appraisal": {
    "id": "conv_biz_appraisal",
    "title": "Performance review",
    "titleJa": "評価面談",
    "situation": "You're having your annual performance review with your UK manager.",
    "situationJa": "英国人マネージャーと年次評価面談を行っています。",
    "turns": [
      {
        "speaker": "manager",
        "avatar": "👩‍💼",
        "name": "Rachel",
        "text": "Overall it's been a strong year. Is there anything you feel you could have done differently?",
        "options": [
          {
            "text": "I could have communicated more proactively when projects hit blockers—I'll focus on that next year.",
            "correct": true,
            "feedback": "✅ Self-awarenessと具体的な改善点を示しながら、解決志向的な態度が明確です。英国のマネジャーは「何ができなかったか」より「次に何をするか」という前向きな改善姿勢を高く評価します。反省的でありながらも実行性を示す回答は、UK職場文化で最も信頼を得られます。",
            "feedbackEn": "✅ Demonstrates genuine self-awareness with concrete forward-looking action. UK managers value this proactive, solution-oriented reflection over defensive explanations. Shows accountability and commitment to improvement—highly valued in UK workplace culture.",
            "textJa": "ãƒ—ãƒ­ã‚¸ã‚§ã‚¯ãƒˆãŒè©°ã¾ã£ãŸã¨ãã€ã‚‚ã£ã¨ç©æ¥µçš„ã«ã‚³ãƒŸãƒ¥ãƒ‹ã‚±ãƒ¼ã‚·ãƒ§ãƒ³ã‚’å–ã‚ŒãŸã‹ã‚‚ã—ã‚Œã¾ã›ã‚“ã€‚æ¥å¹´ã¯ãã“ã«æ³¨åŠ›ã—ã¾ã™ã€‚"
          },
          {
            "text": "I think I could have escalated some issues earlier instead of trying to solve everything myself.",
            "correct": false,
            "feedback": "⚠️ チームワークと判断力の成熟さを示す良い観察ですが、「具体的に次はどうするか」という行動計画が欠けています。英国文化では自己反省だけでなく「改善のための具体的なステップ」も同時に述べるとより説得力が増します。例：「...and next time I'll escalate earlier to get team input.」と付け加えるとベストです。",
            "feedbackEn": "⚠️ Good self-awareness about delegation, but lacks concrete next steps. UK appraisals expect reflection + actionable improvement plan. Adding 'and I'll escalate earlier in future' would strengthen this response significantly.",
            "textJa": "ã„ãã¤ã‹ã®å•é¡Œã‚’ã‚‚ã£ã¨æ—©ãã‚¨ã‚¹ã‚«ãƒ¬ãƒ¼ã‚·ãƒ§ãƒ³ã™ã‚Œã°è‰¯ã‹ã£ãŸã¨æ€ã„ã¾ã™ã€‚è‡ªåˆ†ã§è§£æ±ºã—ã‚ˆã†ã¨ã—ã™ãŽã¦ã„ã¾ã—ãŸã€‚"
          },
          {
            "text": "I think I managed well overall, though I could have been more strategic about prioritization in Q3.",
            "correct": false,
            "feedback": "⚠️ 惜しい回答です。全体的な自信は良いですが、改善点が「戦略的」すぎて曖昧に聞こえます。UK文化では「何をしたか」より「具体的に何を変えるか」を期待されます。例えば『Q3でデータ分析に時間をかけすぎた。次はスケジュール案を先に立てる』など、より具体的な行動に落とし込むとベターです。",
            "feedbackEn": "⚠️ Close, but the improvement area is too vague. 'More strategic about prioritization' sounds generic. UK culture expects concrete behavioral changes: 'I'll create a priority matrix before Q1' or 'I'll schedule weekly reviews' rather than abstract strategic concepts.",
            "textJa": "å…¨ä½“çš„ã«ã¯ã†ã¾ãç®¡ç†ã§ããŸã¨æ€ã„ã¾ã™ãŒã€Q3ã®å„ªå…ˆé †ä½ä»˜ã‘ã«ã‚‚ã£ã¨æˆ¦ç•¥çš„ã«ãªã‚ŒãŸã‹ã‚‚ã—ã‚Œã¾ã›ã‚“ã€‚"
          }
        ],
        "textJa": "å…¨ä½“çš„ã«ã¨ã¦ã‚‚è‰¯ã„ä¸€å¹´ã§ã—ãŸã€‚ä½•ã‹é•ã†ã‚ˆã†ã«ã§ããŸã“ã¨ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "manager",
        "avatar": "👩‍💼",
        "name": "Rachel",
        "text": "What are your goals for next year?",
        "options": [
          {
            "text": "I'd like to develop my stakeholder management skills and take on more client-facing responsibilities this year.",
            "correct": true,
            "feedback": "✅ 具体的で実現可能な目標を示しており、スキル開発と会社への貢献を結びつけています。英国のビジネス文化では、昇進よりも自己啓発と責任拡大を前向きに語る方が、成熟した職業人として評価されます。また、上司との協働を前提とした現実的なアプローチです。",
            "feedbackEn": "Concrete, achievable goals linked to skill development and business value. UK appraisals value personal growth tied to expanded responsibilities rather than promotion-seeking. Shows maturity and collaborative mindset.",
            "textJa": "ã‚¹ãƒ†ãƒ¼ã‚¯ãƒ›ãƒ«ãƒ€ãƒ¼ãƒžãƒã‚¸ãƒ¡ãƒ³ãƒˆã®ã‚¹ã‚­ãƒ«ã‚’ä¼¸ã°ã—ã¦ã€ã‚ˆã‚Šå¤šãã®ã‚¯ãƒ©ã‚¤ã‚¢ãƒ³ãƒˆå¯¾å¿œã®æ©Ÿä¼šã‚’æŒã¡ãŸã„ã§ã™ã€‚"
          },
          {
            "text": "I'd like to understand the career progression expectations and explore how I can work towards the next level with your support.",
            "correct": false,
            "feedback": "⚠️ 非常に丁寧で対話的なアプローチです。ただし「次のレベルへの昇進」が暗示されており、やや受動的です。より英国的には『何を学び、どう貢献するか』という主体性を前に出すと、さらに評価されます。「support」は良い言葉選びです。",
            "feedbackEn": "Very diplomatic and collaborative—you're inviting dialogue rather than demanding. However, the focus is slightly passive (what management can do for you). Stronger if you lead with your own development goals first.",
            "textJa": "ã‚­ãƒ£ãƒªã‚¢ã‚¢ãƒƒãƒ—ã®æœŸå¾…å€¤ã‚’ç†è§£ã—ã¦ã€ã‚ãªãŸã®ã‚µãƒãƒ¼ãƒˆã®ã‚‚ã¨æ¬¡ã®ãƒ¬ãƒ™ãƒ«ã«å‘ã‘ã¦å–ã‚Šçµ„ã¿ãŸã„ã§ã™ã€‚"
          },
          {
            "text": "I want to build stronger relationships with key clients and expand my technical expertise in our core business areas.",
            "correct": false,
            "feedback": "⚠️ バランスの取れた良い目標設定です。関係構築（UK文化で重視）と技術スキルの両立を示しています。ただ正解より具体性に欠けます。『いつまでに・どのような成果か』という達成基準を添えると、より説得力が高まります。",
            "feedbackEn": "Well-balanced goals showing relationship-building (valued in UK culture) and technical growth. Good thinking demonstrated. Missing: concrete timelines or success metrics would make this stronger and more measurable.",
            "textJa": "ä¸»è¦é¡§å®¢ã¨ã®é–¢ä¿‚ã‚’å¼·åŒ–ã—ã€ã‚³ã‚¢ãƒ“ã‚¸ãƒã‚¹åˆ†é‡Žã§ã®æŠ€è¡“çš„å°‚é–€æ€§ã‚’åºƒã’ãŸã„ã¨æ€ã„ã¾ã™ã€‚"
          }
        ],
        "textJa": "æ¥å¹´ã®ç›®æ¨™ã¯ä½•ã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "manager",
        "avatar": "👩‍💼",
        "name": "Rachel",
        "text": "Is there any feedback you'd like to give me on how I can better support you?",
        "options": [
          {
            "text": "I'd really appreciate more regular one-to-ones — even a quick 15-minute check-in would help me feel supported.",
            "correct": true,
            "feedback": "✅ 具体的で建設的、かつ前向きな表現。「I'd appreciate」という丁寧なフレームと具体的な時間提示により、英国ビジネス文化での効果的なフィードバックになっています。マネージャーは改善すべき点が明確に理解でき、実行しやすいです。",
            "feedbackEn": "✅ Specific, constructive, and positively framed. The 'I'd appreciate' language is polite yet direct. Suggesting a concrete timeframe (15 minutes) makes it actionable and shows you've thought it through—highly valued in UK business culture.",
            "textJa": "å®šæœŸçš„ãª1å¯¾1ã®ãƒŸãƒ¼ãƒ†ã‚£ãƒ³ã‚°ã‚’ãŠé¡˜ã„ã—ãŸã„ã§ã™ã€‚15åˆ†ã®ãƒã‚§ãƒƒã‚¯ã‚¤ãƒ³ã§ã‚‚ã‚µãƒãƒ¼ãƒˆã•ã‚Œã¦ã„ã‚‹å®Ÿæ„ŸãŒæŒã¦ã¾ã™ã€‚"
          },
          {
            "text": "I think it would help if you could perhaps share more context about upcoming projects and decisions affecting the team.",
            "correct": false,
            "feedback": "✅ 同等にイギリス的な良い回答です。「perhaps」や「I think」という控えめな言語を使いながら、具体的で実行可能なフィードバックを提供しています。相手を尊重しつつ、改善提案が明確で、英国職場の協調的なコミュニケーションスタイルに適合しています。",
            "feedbackEn": "✅ Equally strong response. The softening words ('perhaps', 'I think') show politeness, while being specific about what would help. This demonstrates collaborative communication style valued in UK workplaces.",
            "textJa": "ãƒãƒ¼ãƒ ã«å½±éŸ¿ã™ã‚‹ä»Šå¾Œã®ãƒ—ãƒ­ã‚¸ã‚§ã‚¯ãƒˆã‚„æ±ºå®šã«ã¤ã„ã¦ã€ã‚‚ã†å°‘ã—èƒŒæ™¯æƒ…å ±ã‚’å…±æœ‰ã„ãŸã ã‘ã‚‹ã¨åŠ©ã‹ã‚Šã¾ã™ã€‚"
          },
          {
            "text": "Everything is fine, thank you, though I'd welcome a bit more visibility into strategic planning when it affects my work.",
            "correct": false,
            "feedback": "⚠️ 最初の「Everything is fine」は相手の質問に応える前置きとして機能していますが、その後の「though」で具体的なニーズを述べることで、より実践的です。ただ選択肢1や2ほどダイレクトではありません。英国では過度な遠回しは避け、より直接的な表現の方が好まれます。",
            "feedbackEn": "⚠️ Polite opening, but the 'though' adds practical feedback. This is acceptable in UK business, but slightly softer than leading directly with your constructive ask. You could be more straightforward—UK managers generally appreciate directness wrapped in politeness, not overly roundabout language.",
            "textJa": "ç¾çŠ¶ã§å•é¡Œã‚ã‚Šã¾ã›ã‚“ãŒã€è‡ªåˆ†ã®ä»•äº‹ã«å½±éŸ¿ã™ã‚‹æˆ¦ç•¥çš„ãªè¨ˆç”»ã«ã¤ã„ã¦ã‚ˆã‚ŠæŠŠæ¡ã§ãã‚‹ã¨å¬‰ã—ã„ã§ã™ã€‚"
          }
        ],
        "textJa": "ç§ãŒã‚ãªãŸã‚’ã‚ˆã‚Šã‚ˆãã‚µãƒãƒ¼ãƒˆã™ã‚‹ãŸã‚ã«ã€ä½•ã‹ãƒ•ã‚£ãƒ¼ãƒ‰ãƒãƒƒã‚¯ã‚’ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: UK appraisals are two-way conversations. Show self-awareness, have specific goals ready, and ask about career progression diplomatically.",
    "tipJa": "🇬🇧 イギリスTip: 英国の評価面談は双方向の会話です。自己認識を示し、具体的な目標を準備しましょう。"
  },
  "conv_biz_celebration": {
    "id": "conv_biz_celebration",
    "title": "Team celebrations",
    "titleJa": "チームのお祝い",
    "situation": "Your team has just won a major contract. Your manager suggests going out to celebrate.",
    "situationJa": "チームが大きな契約を獲得。マネージャーがお祝いを提案しています。",
    "turns": [
      {
        "speaker": "manager",
        "avatar": "🎊",
        "name": "Manager",
        "text": "Brilliant news — let's celebrate! Drinks on me tonight. Are you in?",
        "options": [
          {
            "text": "Absolutely! That's fantastic news. I'd love to celebrate with the team tonight.",
            "correct": true,
            "feedback": "✅ 英国職場文化では、チームの勝利を一緒に祝うことが信頼と結束を示します。'That's fantastic'は共感を表し、'with the team'は集団意識を強調。このトーンは上司・同僚双方に好印象です。",
            "feedbackEn": "Perfect. Showing enthusiasm for team celebration demonstrates camaraderie, which is valued in UK workplace culture. 'That's fantastic' shows genuine warmth.",
            "textJa": "ãœã²ï¼ç´ æ™´ã‚‰ã—ã„ãƒ‹ãƒ¥ãƒ¼ã‚¹ã§ã™ã­ã€‚ä»Šå¤œãƒãƒ¼ãƒ ã¨ä¸€ç·’ã«ãŠç¥ã„ã—ãŸã„ã§ã™ã€‚"
          },
          {
            "text": "I appreciate the offer, but I have a prior commitment. Can I catch up with the team another time?",
            "correct": false,
            "feedback": "⚠️ 個人の都合優先は悪くありませんが、英国では「why」や「when」を添えると失礼に映りません。'I'd have loved to, but I have a prior commitment — hope you all have a brilliant night! Can we celebrate together soon?'と続ければ、チーム精神を示しつつ誠実です。",
            "feedbackEn": "Understandable reason, but this feels slightly dismissive. Adding context ('tight schedule tonight') and suggesting future involvement ('let's reschedule') shows respect for team bonding while being honest.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ã§ã‚‚å…ˆç´„ãŒã‚ã‚Šã¾ã™ã€‚åˆ¥ã®æ©Ÿä¼šã«ãƒãƒ¼ãƒ ã«åˆæµã§ãã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Sounds great! I'll join for a soft drink — wouldn't miss celebrating with everyone.",
            "correct": false,
            "feedback": "✅ 素晴らしい対応です。アルコール不要でチームに参加する意志を明確に示しています。'wouldn't miss'はチームの勝利を大切にする姿勢を表し、英国文化では「参加することが重要」という理解が評価されます。",
            "feedbackEn": "Excellent. You're showing that the celebration and team bonding matter more than what you drink. This is very respectful and inclusive in UK culture—it's about togetherness, not alcohol.",
            "textJa": "ã„ã„ã§ã™ã­ï¼ã‚½ãƒ•ãƒˆãƒ‰ãƒªãƒ³ã‚¯ã§å‚åŠ ã—ã¾ã™ã€‚çš†ã•ã‚“ã¨ä¸€ç·’ã«ãŠç¥ã„ã—ãŸã„ã§ã™ã€‚"
          }
        ],
        "textJa": "ç´ æ™´ã‚‰ã—ã„ãƒ‹ãƒ¥ãƒ¼ã‚¹ã§ã™ï¼ãŠç¥ã„ã—ã¾ã—ã‚‡ã†ï¼ä»Šå¤œã¯ç§ãŒä¸€æ¯ãŠã”ã‚Šã¾ã™ã€‚æ¥ã‚‰ã‚Œã¾ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "🥂",
        "name": "Sarah",
        "text": "This is all down to you — your presentation really swung it!",
        "options": [
          {
            "text": "That's kind of you to say, but it was really a team effort—everyone contributed brilliantly!",
            "correct": true,
            "feedback": "✅ 褒め言葉を素直に受け入れつつ、すぐにチーム全体への感謝と敬意を示す、最もイギリス的な対応です。謙虚さと他者への信頼を同時に表現でき、ビジネス関係を強化します。相手に対しても『あなたの判断眼が素晴らしい』というメッセージが暗に含まれます。",
            "feedbackEn": "Perfect British style! Accepts the compliment gracefully ('That's kind of you') while immediately redirecting credit to the team. Demonstrates humility, genuine appreciation for colleagues, and acknowledges the decision-maker's good judgment—all hallmarks of UK business culture.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ã§ã‚‚æœ¬å½“ã«ãƒãƒ¼ãƒ å…¨å“¡ã®åŠ›ã§ã™ã‚ˆã€‚ã¿ã‚“ãªãŒç´ æ™´ã‚‰ã—ã‹ã£ãŸï¼"
          },
          {
            "text": "Thank you—I'm pleased it resonated, but honestly the whole team was absolutely brilliant!",
            "correct": false,
            "feedback": "⚠️ 良い選択肢です。'resonated'という言葉選びが自然で、チームへの感謝も明確です。ただし「正解」と比べると、'honestly'が少し「予防線を張っている」印象を与えます。より直線的に『That's kind of you to say』と感謝を先に述べる方がより一層イギリス的な流暢さです。",
            "feedbackEn": "Very good—accepts the compliment and credits the team authentically. The word 'resonated' is natural and thoughtful. However, 'honestly' slightly suggests you're being defensive about sharing credit. Saying 'That's kind of you to say' first is more gracefully British and flows better.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚éŸ¿ã„ã¦ã‚ˆã‹ã£ãŸã§ã™ã€‚ã§ã‚‚æœ¬å½“ã«ãƒãƒ¼ãƒ å…¨ä½“ãŒç´ æ™´ã‚‰ã—ã‹ã£ãŸã§ã™ï¼"
          },
          {
            "text": "I appreciate that, but I couldn't have done it without everyone's hard work and support!",
            "correct": false,
            "feedback": "⚠️ チームの貢献を認める素敵な返答で、英国文化としても間違いではありません。ただ『couldn't have done it without』という表現は「自分が中心」というニュアンスが残ります。正解のように最初から『team effort』と言い切る方が、より対等で協調的なイギリス的姿勢が伝わります。",
            "feedbackEn": "Good—expresses genuine gratitude and acknowledges team contribution. However, 'couldn't have done it without' subtly positions you as the center with the team supporting. Framing it as a shared 'team effort from the start' feels more genuinely collaborative and British.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ã¿ã‚“ãªã®é ‘å¼µã‚Šã¨ã‚µãƒãƒ¼ãƒˆãªã—ã«ã¯ã§ãã¾ã›ã‚“ã§ã—ãŸï¼"
          }
        ],
        "textJa": "ã“ã‚Œã¯å…¨éƒ¨ã‚ãªãŸã®ãŠã‹ã’ã§ã™ï¼ã‚ãªãŸã®ãƒ—ãƒ¬ã‚¼ãƒ³ãŒæ±ºã‚æ‰‹ã«ãªã‚Šã¾ã—ãŸã‚ˆï¼"
      },
      {
        "speaker": "manager",
        "avatar": "🎊",
        "name": "Manager",
        "text": "Right — who's getting the first round in?",
        "options": [
          {
            "text": "I'll get this one!",
            "correct": true,
            "feedback": "✅ Volunteering for the first round is a great team signal.",
            "textJa": "ç§ãŒæ‰•ã„ã¾ã™ï¼"
          },
          {
            "text": "You said drinks are on you!",
            "correct": false,
            "feedback": "⚠️ Volunteering shows generosity. The manager will appreciate the gesture.",
            "textJa": "ã‚ãªãŸãŒå¥¢ã‚‹ã¨è¨€ã£ãŸã˜ã‚ƒãªã„ã§ã™ã‹ï¼"
          },
          {
            "text": "What is a round?",
            "correct": false,
            "feedback": "⚠️ A round = each person buys drinks for the whole group in turn.",
            "textJa": "ã€Œä¸€æ¯ã€ã£ã¦ã©ã†ã„ã†æ„å‘³ã§ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ã•ã¦ã€æœ€åˆã®ä¸€æ¯ã¯èª°ãŒæ³¨æ–‡ã—ã¾ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: Team celebrations at the pub are an important bonding ritual. The 'rounds' system means everyone buys for the group in turn.",
    "tipJa": "🇬🇧 イギリスTip: チームのお祝いはパブで。ラウンド制度は全員が交代でグループ全体の飲み物を買います。"
  },
  "conv_life_school": {
    "id": "conv_life_school",
    "title": "Contacting your child's school",
    "titleJa": "子どもの学校への連絡",
    "situation": "Your child is unwell and won't be in school today. You're calling the school office.",
    "situationJa": "お子さんが体調不良で学校を休みます。学校の事務室に電話します。",
    "turns": [
      {
        "speaker": "school",
        "avatar": "🏫",
        "name": "School Office",
        "text": "Good morning, St Mary's Primary. How can I help?",
        "options": [
          {
            "text": "Good morning. I'm calling to report my son Kenji in Year 3 won't be in today — he has a temperature.",
            "correct": true,
            "feedback": "✅ イギリスの学校に欠席を報告する際の標準的で効果的な表現です。子どもの名前、学年、欠席理由を簡潔に伝えており、学校が必要な情報をすべて得られます。'temperature'という医学的な表現も自然で、学校スタッフに正確に状況が伝わります。",
            "feedbackEn": "✅ This is the standard, effective way to report absence to a UK school. You provide all essential details: child's name, year group, and specific reason. 'Temperature' is the precise medical term used in British English for clear communication with staff.",
            "textJa": "ãŠã¯ã‚ˆã†ã”ã–ã„ã¾ã™ã€‚3å¹´ç”Ÿã®æ¯å­ã‚±ãƒ³ã‚¸ãŒä»Šæ—¥ã¯ç†±ãŒã‚ã£ã¦å­¦æ ¡ã‚’ä¼‘ã‚€é€£çµ¡ã‚’ã—ãŸãã¦ãŠé›»è©±ã—ã¾ã—ãŸã€‚"
          },
          {
            "text": "Hi, I'm ringing to say my daughter Emma in Year 3 will be off school today with a stomach bug.",
            "correct": false,
            "feedback": "✅ 同じくらい効果的な別表現です。'ringing'はイギリス英語の自然な言い方で、同じ必須情報（名前・学年・理由）をカジュアルながら明確に伝えています。'stomach bug'も一般的な病名で、学校スタッフが理解しやすい表現です。こちらも完全に適切な報告方法です。",
            "feedbackEn": "✅ Equally effective alternative. 'Ringing' is natural British English for calling, and you provide all essential details (name, year group, reason). 'Stomach bug' is a common, understandable term. This is also a completely appropriate way to report absence.",
            "textJa": "ã“ã‚“ã«ã¡ã¯ã€‚3å¹´ç”Ÿã®å¨˜ã‚¨ãƒžãŒä»Šæ—¥ãŠè…¹ã®å…·åˆãŒæ‚ªãã¦æ¬ å¸­ã®é€£çµ¡ã‚’ã—ãŸãã¦ãŠé›»è©±ã—ã¾ã—ãŸã€‚"
          },
          {
            "text": "Good morning. My son won't be in today because he's not feeling well and needs to rest at home.",
            "correct": false,
            "feedback": "⚠️ 丁寧で失礼ではありませんが、学校の記録に必要な重要情報が不足しています。学校側は『誰なのか（名前と学年）』『具体的な症状は何か』を知る必要があります。名前と学年を追加し、可能なら『fever』『cough』など具体的な症状を伝えると、より学校スタッフが対応しやすくなります。",
            "feedbackEn": "⚠️ Polite, but missing key details schools need. Always provide: child's name, year group, and specific symptom (fever, cough, etc.). Try: 'My son [name] in Year [X] won't be in today—he has a fever.' This helps staff keep accurate records.",
            "textJa": "ãŠã¯ã‚ˆã†ã”ã–ã„ã¾ã™ã€‚æ¯å­ãŒä»Šæ—¥ä½“èª¿ãŒæ‚ªãã¦å®¶ã§ä¼‘ã‚€å¿…è¦ãŒã‚ã‚Šã¾ã™ã€‚"
          }
        ],
        "textJa": "ãŠã¯ã‚ˆã†ã”ã–ã„ã¾ã™ã€ã‚»ãƒ³ãƒˆãƒ»ãƒ¡ã‚¢ãƒªãƒ¼å°å­¦æ ¡ã§ã™ã€‚ä½•ã‹ã”ç”¨ã§ã—ã‚‡ã†ã‹ï¼Ÿ"
      },
      {
        "speaker": "school",
        "avatar": "🏫",
        "name": "School Office",
        "text": "Thank you. Do you know how long he'll be absent?",
        "options": [
          {
            "text": "I'm not entirely sure yet, but I'll update you tomorrow with more information.",
            "correct": true,
            "feedback": "✅ イギリスの学校は保護者からの誠実で定期的なコミュニケーションを重視します。不確実な状況で無理に答えず、「明日までに連絡する」と具体的な期限を約束する姿勢は、信頼関係を築くUK文化的に理想的な対応です。責任感と現実的な対応姿勢の両立が評価されます。",
            "feedbackEn": "✅ UK schools value honest communication with clear timelines. Admitting uncertainty while committing to 'update tomorrow' shows responsibility and builds trust—essential in British school culture. This balances transparency with reassurance.",
            "textJa": "ã¾ã ã¯ã£ãã‚Šåˆ†ã‹ã‚Šã¾ã›ã‚“ãŒã€æ˜Žæ—¥ã¾ãŸé€£çµ¡ã—ã¾ã™ã€‚"
          },
          {
            "text": "Hopefully just today or tomorrow. I'll ring you again once I know more.",
            "correct": false,
            "feedback": "⚠️ 良い対応です。短期的な見通しを示し、フォローアップを約束する誠実な姿勢はイギリス文化で高く評価されます。ただ「I'll update you」とメール・電話での連絡方法を少し明確にすると、さらに学校の期待に応えやすくなります。",
            "feedbackEn": "⚠️ Solid approach—giving a short-term estimate and committing to follow-up is appreciated in UK culture. Slightly more detail about how you'll contact them (email/call) would align better with school expectations.",
            "textJa": "ãŠãã‚‰ãä»Šæ—¥ã‹æ˜Žæ—¥ã ã‘ã ã¨æ€ã„ã¾ã™ã€‚ã‚‚ã†å°‘ã—åˆ†ã‹ã£ãŸã‚‰ã¾ãŸãŠé›»è©±ã—ã¾ã™ã€‚"
          },
          {
            "text": "He might be out for a week or more, so I'll need to submit medical documentation.",
            "correct": false,
            "feedback": "⚠️ 長期欠席の可能性を述べ、医師の診断書の提出に言及する点は良い理解です。ただイギリスの学校は通常、欠席が確定してから診断書を求めます。最初は短期的な見通しを示し、もし長くなりそうなら「When it's clear how long he'll be out, I'll get the medical certificate」と提案する方が自然です。",
            "feedbackEn": "⚠️ Acknowledging potential length and offering medical documentation shows good understanding of UK procedures. However, schools typically request certificates once absence is confirmed, not preemptively. Start with a shorter estimate, then offer: 'If it extends, I'll provide medical documentation.'",
            "textJa": "1é€±é–“ä»¥ä¸Šä¼‘ã‚€ã‹ã‚‚ã—ã‚Œãªã„ã®ã§ã€åŒ»ç™‚è¨¼æ˜Žæ›¸ã‚’æå‡ºã™ã‚‹å¿…è¦ãŒã‚ã‚Šã¾ã™ã€‚"
          }
        ],
        "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ã©ã®ãã‚‰ã„æ¬ å¸­ã™ã‚‹ã‹ãŠåˆ†ã‹ã‚Šã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "school",
        "avatar": "🏫",
        "name": "School Office",
        "text": "Is there anything from class he might need while he's off?",
        "options": [
          {
            "text": "That's very kind of you. I'll check with his teacher and get back to you. Thank you.",
            "correct": true,
            "feedback": "✅ 相手の気遣いに感謝し、教師と相談して対応する姿勢を示しています。イギリスの学校文化では親と教師の協力が重視されるため、このように前向きで実行的な返答が理想的です。「get back to you」で継続的な対話を示唆し、信頼関係を構築します。",
            "feedbackEn": "✅ Genuinely appreciates the offer and commits to following up. This is exactly what UK educators expect—proactive communication showing you value their support. 'Get back to you' demonstrates responsibility and maintains the collaborative relationship.",
            "textJa": "ã”è¦ªåˆ‡ã«ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚æ‹…ä»»ã®å…ˆç”Ÿã«ç¢ºèªã—ã¦ã€ã¾ãŸé€£çµ¡ã—ã¾ã™ã€‚"
          },
          {
            "text": "That's very thoughtful of you. We're managing at the moment, but thank you.",
            "correct": false,
            "feedback": "⚠️ 相手の親切心をしっかり受け止めつつ、丁寧に辞退する応答です。ただ「get back to you」と異なり、将来的な対応の可能性を閉じています。「if anything comes up, I'll let you know」と添えるとより英国文化的で、相手の善意をより活かす返答になります。",
            "feedbackEn": "⚠️ Politely declines while acknowledging kindness—perfectly acceptable. However, it closes the door to future help. Adding 'if anything comes up, I'll let you know' would be more collaborative, showing you value their offer and may need them later.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ä»Šã®ã¨ã“ã‚å¤§ä¸ˆå¤«ã§ã™ãŒã€ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚"
          },
          {
            "text": "That's so considerate. Yes, class updates would really help him stay connected. Brilliant!",
            "correct": false,
            "feedback": "⚠️ 相手の申し出を具体的に活用しようとする姿勢で、協力的です。ただし「Brilliant!」は少し格式的でない判断になっており、先生に対しては「That would be wonderful」や「That's really helpful」の方がより適切で専門的です。また、先制的に要望を述べるより、教師からの提案を受ける方が英国的です。",
            "feedbackEn": "⚠️ Shows you'll take advantage of the offer, which is good. However, 'Brilliant!' feels slightly too casual for a teacher offering help. 'That would be wonderful' or 'That's really helpful' maintains better professionalism. Also, it's more UK-natural to discuss specific needs only if the teacher suggests it.",
            "textJa": "æ°—ã«ã‹ã‘ã¦ã„ãŸã ã„ã¦ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ã¯ã„ã€æŽˆæ¥­ã®æ›´æ–°ãŒã‚ã‚‹ã¨åŠ©ã‹ã‚Šã¾ã™ï¼"
          }
        ],
        "textJa": "æ¬ å¸­ä¸­ã«æŽˆæ¥­ã§å¿…è¦ãªã‚‚ã®ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: UK schools expect a call or email on the first day of absence — before 9am if possible. If absent 3+ days, a doctor's note may be needed.",
    "tipJa": "🇬🇧 イギリスTip: 英国の学校は欠席初日（できれば9時前）に連絡を求めます。3日以上は診断書が必要な場合があります。"
  },
  "conv_life_medical": {
    "id": "conv_life_medical",
    "title": "Booking a GP appointment",
    "titleJa": "GPへの電話予約",
    "situation": "You need to book an appointment with your NHS GP for a persistent cough.",
    "situationJa": "NHSのかかりつけ医（GP）に、長引く咳で予約の電話をします。",
    "turns": [
      {
        "speaker": "gp",
        "avatar": "🏥",
        "name": "Receptionist",
        "text": "Good morning, Riverside Surgery. How can I help?",
        "options": [
          {
            "text": "Good morning. I'd like to book an appointment with Dr. Patel. I've had a persistent cough for two weeks.",
            "correct": true,
            "feedback": "✅ GPの名前と具体的な症状を簡潔に伝える完璧な例です。英国の医療制度では『誰に・何の理由で』を明確に述べることで、受付スタッフが効率的にトリアージでき、適切な予約枠を確保できます。この「情報を整理して伝える」姿勢は英国文化で高く評価されます。",
            "feedbackEn": "✅ Perfect approach: you name the GP and state your specific symptom clearly. UK medical receptionists appreciate this structured information—it shows you respect their time and helps them allocate appointments efficiently. This demonstrates cultural understanding of the NHS system.",
            "textJa": "ãŠã¯ã‚ˆã†ã”ã–ã„ã¾ã™ã€‚ãƒ‘ãƒ†ãƒ«å…ˆç”Ÿã®è¨ºå¯Ÿã‚’äºˆç´„ã—ãŸã„ã®ã§ã™ãŒã€‚2é€±é–“ã»ã©å’³ãŒç¶šã„ã¦ã„ã¾ã™ã€‚"
          },
          {
            "text": "Hello, I'd like to book an appointment as soon as possible. I've had a persistent cough lately.",
            "correct": false,
            "feedback": "⚠️ 症状を述べており、『できるだけ早く』と希望を伝えるのは良いです。ただ特定のGPを指名していません。英国では「このGPがいい」という希望があれば述べるのが一般的で、受付も対応しやすくなります。もし希望がなければ「any available GP」と言っても問題ありません。",
            "feedbackEn": "⚠️ Good structure: symptom and urgency are clear. However, naming a specific GP (if you have a preference) strengthens your request. If you don't mind, say 'with any available GP' to show flexibility—this is appreciated in UK health settings.",
            "textJa": "ã“ã‚“ã«ã¡ã¯ã€‚ã§ãã‚‹ã ã‘æ—©ãè¨ºå¯Ÿã‚’äºˆç´„ã—ãŸã„ã®ã§ã™ãŒã€‚æœ€è¿‘å’³ãŒç¶šã„ã¦ã„ã¾ã™ã€‚"
          },
          {
            "text": "Hi, I'm quite unwell and think it's urgent. I need a doctor today please.",
            "correct": false,
            "feedback": "❌ 症状を具体的に述べていないため、受付が医学的に判断できません。『体調が悪い・緊急』と主張するだけでは、GPのトリアージシステムが機能しません。英国では『咳・熱・痛みなど、何が起きているか』を先に説明し、医療専門家に判断させるのが文化的な作法です。本当の緊急なら999に電話します。",
            "feedbackEn": "❌ Without specific symptoms, reception can't assess your case properly. UK NHS receptionists are trained to triage—but they need clinical information, not statements of urgency alone. Say 'I have a persistent cough' or 'I'm running a fever'—this guides proper triaging. True emergencies = 999 call.",
            "textJa": "ã“ã‚“ã«ã¡ã¯ã€‚ã‹ãªã‚Šå…·åˆãŒæ‚ªãã¦ç·Šæ€¥ã ã¨æ€ã„ã¾ã™ã€‚ä»Šæ—¥è¨ºã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ãŠã¯ã‚ˆã†ã”ã–ã„ã¾ã™ã€ãƒªãƒãƒ¼ã‚µã‚¤ãƒ‰è¨ºç™‚æ‰€ã§ã™ã€‚ä½•ã‹ã”ç”¨ã§ã—ã‚‡ã†ã‹ï¼Ÿ"
      },
      {
        "speaker": "gp",
        "avatar": "🏥",
        "name": "Receptionist",
        "text": "Is it urgent or can it wait a few days?",
        "options": [
          {
            "text": "It can wait a couple of days — it's been two weeks so a few more days is fine.",
            "correct": true,
            "feedback": "✅ イギリスのGP文化では、症状が緊急でない場合は「待てる」と明確に伝えることが重要です。患者が現実的に優先順位をつける姿勢をGPの受付は高く評価します。正直で誠実な対応です。",
            "feedbackEn": "This demonstrates realistic triage. NHS receptionists appreciate patients who honestly assess their own urgency rather than exaggerating. Being straightforward about waiting time respects the system.",
            "textJa": "æ•°æ—¥å¾…ã¦ã¾ã™ã€‚2é€±é–“ã‚ã£ãŸã®ã§ã€ã‚ã¨æ•°æ—¥ã¯å¤§ä¸ˆå¤«ã§ã™ã€‚"
          },
          {
            "text": "Yes, it's quite urgent — I'd prefer to see someone within a few days if possible.",
            "correct": false,
            "feedback": "⚠️ 「緊急」と「いつか見てほしい」のメッセージが矛盾しています。もし症状が2週間続いているなら、より正直に「待てる」と言うか、より具体的に「今週中がいい」と言う方がより自然です。",
            "feedbackEn": "This is somewhat mixed messaging — 'quite urgent' contradicts 'within a few days.' Be clearer: either say it can wait or express a specific timeframe preference more directly.",
            "textJa": "ã‹ãªã‚Šæ€¥ã„ã§ã„ã¾ã™ã€‚ã§ãã‚Œã°æ•°æ—¥ä»¥å†…ã«èª°ã‹ã«è¨ºã¦ã„ãŸã ã‘ã‚Œã°ã¨æ€ã„ã¾ã™ã€‚"
          },
          {
            "text": "I'm not sure — what would you recommend based on what I've described?",
            "correct": false,
            "feedback": "⚠️ イギリスの受付では、医学的判断は医者に任せ、患者は自分の状況を正直に伝えるのが期待されます。判断を完全に譲ると、会話が進みにくくなります。「2週間続いていますが待てます」と具体的に答える方が良いです。",
            "feedbackEn": "UK receptionists expect patients to communicate their own timeline clearly. Deferring the decision entirely can slow the triage process. State your facts and comfort level — let the receptionist/GP make medical judgments.",
            "textJa": "ã‚ˆãåˆ†ã‹ã‚Šã¾ã›ã‚“ã€‚ç§ãŒèª¬æ˜Žã—ãŸçŠ¶æ³ã‹ã‚‰è¦‹ã¦ã€ã©ã†ãŠå‹§ã‚ã—ã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "æ€¥ãŽã¾ã™ã‹ã€ãã‚Œã¨ã‚‚æ•°æ—¥å¾…ã¦ã¾ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "gp",
        "avatar": "🏥",
        "name": "Receptionist",
        "text": "We have a telephone appointment Thursday at 10am or face-to-face on Friday at 2pm. Which would you prefer?",
        "options": [
          {
            "text": "Thursday at 10am would be fine, thank you very much.",
            "correct": true,
            "feedback": "✅ 電話予約を選ぶのは完全に自然です。NHS環境では電話相談は頻繁で効率的。「fine」と「very much」を使った応答は適切で、イギリス文化的に丁寧な返答です。個人の都合を優先することは全く失礼ではありません。",
            "feedbackEn": "Telephone appointments are routine in UK healthcare. This response is polite and natural—'very much' is appropriately formal. Your preference is completely valid in NHS culture.",
            "textJa": "æœ¨æ›œæ—¥åˆå‰10æ™‚ã§ãŠé¡˜ã„ã—ã¾ã™ã€ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚"
          },
          {
            "text": "Friday at 2pm would be lovely, thank you. Should I bring anything with me?",
            "correct": false,
            "feedback": "✅ 「lovely」はイギリス人が日常的に使う親しみやすい表現で、NHS文化での好意的な応答として最適です。また、follow-up質問で準備への関心を示し、医療スタッフとの関係構築に積極的で実用的なコミュニケーションを取っています。",
            "feedbackEn": "'Lovely' is very natural UK English and shows warmth. Asking what to prepare demonstrates you're engaged and practical—highly valued in NHS interactions. This builds good rapport naturally.",
            "textJa": "é‡‘æ›œæ—¥åˆå¾Œ2æ™‚ã§ãŠé¡˜ã„ã—ã¾ã™ã€‚ä½•ã‹æŒå‚ã™ã‚‹ã‚‚ã®ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Either works for me, but Friday might be slightly easier if that's okay.",
            "correct": false,
            "feedback": "⚠️ 柔軟性を示しながら微妙な好みを伝えるのはイギリス的で、相手に選択肢を与える姿勢が良いですが、正解よりやや曖昧です。「might be slightly easier」は控えめですが、相手にも判断の余地を残しすぎます。より明確で温かく「Friday at 2pm would be lovely」と直接述べる方が、NHS職員にとって予約を確定しやすくなります。",
            "feedbackEn": "This is characteristically polite British understatement and shows flexibility, but it's slightly vague for healthcare booking. The provider needs clear confirmation. Being more direct like 'Friday would be lovely' is actually more helpful while remaining warm and natural.",
            "textJa": "ã©ã¡ã‚‰ã§ã‚‚å¤§ä¸ˆå¤«ã§ã™ãŒã€é‡‘æ›œæ—¥ã®æ–¹ãŒå°‘ã—éƒ½åˆãŒã„ã„ã‹ã‚‚ã—ã‚Œã¾ã›ã‚“ã€‚"
          }
        ],
        "textJa": "æœ¨æ›œæ—¥åˆå‰10æ™‚ã«é›»è©±è¨ºå¯Ÿã€ã¾ãŸã¯é‡‘æ›œæ—¥åˆå¾Œ2æ™‚ã«å¯¾é¢è¨ºå¯ŸãŒã‚ã‚Šã¾ã™ã€‚ã©ã¡ã‚‰ãŒã‚ˆã‚ã—ã„ã§ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: NHS GP appointments can be hard to get — be flexible. For minor issues, try NHS 111 first. Always register with a GP near your home as soon as you arrive in the UK.",
    "tipJa": "🇬🇧 イギリスTip: NHS GPの予約は取りにくいことがあります。軽症の場合はまずNHS 111を試してみましょう。"
  },
  "conv_life_shopping": {
    "id": "conv_life_shopping",
    "title": "Returning a faulty item",
    "titleJa": "不良品の返品",
    "situation": "You bought a jacket from a UK high street store last week. The zip broke after one use.",
    "situationJa": "先週英国の店でジャケットを買いました。1回使ったらジッパーが壊れました。",
    "turns": [
      {
        "speaker": "staff",
        "avatar": "🛍️",
        "name": "Shop Staff",
        "text": "Hi there, how can I help you today?",
        "options": [
          {
            "text": "Hi. I bought this jacket here last week, but the zip broke after I wore it just once. I'd like to return it, please.",
            "correct": true,
            "feedback": "✅ 完璧です。具体的な事実（購入時期・問題・購入場所）を落ち着いた語調で伝えています。「please」で丁寧さを保ちつつ、明確な要望を示すのは英国の返品交渉の標準形です。店員さんが状況を正確に理解でき、スムーズに対応できます。",
            "feedbackEn": "Perfect approach. You provide specific facts (when, what happened, where bought) calmly and politely. Using 'please' maintains courtesy while being clear—this is the standard UK approach for returns. Staff understand the full context and can respond effectively.",
            "textJa": "ã“ã‚“ã«ã¡ã¯ã€‚å…ˆé€±ã“ã¡ã‚‰ã§ã“ã®ã‚¸ãƒ£ã‚±ãƒƒãƒˆã‚’è³¼å…¥ã—ãŸã®ã§ã™ãŒã€ä¸€åº¦ç€ãŸã ã‘ã§ãƒ•ã‚¡ã‚¹ãƒŠãƒ¼ãŒå£Šã‚Œã¦ã—ã¾ã„ã¾ã—ãŸã€‚è¿”å“ã—ãŸã„ã®ã§ã™ãŒã€‚"
          },
          {
            "text": "I'm really disappointed with this jacket—the zip failed after just one wear. Could you help me sort this out?",
            "correct": false,
            "feedback": "⚠️ 同様に効果的です。感情（disappointed）を適度に示しつつ、問題を説明し、相手に協力を促す「Could you help」で関係的なアプローチをしています。ただし、購入時期や場所の情報がないため、最初の選択肢より詳細性に欠けます。より英国的にするなら「I bought it here last week」を加えましょう。",
            "feedbackEn": "Also effective. You show appropriate emotion ('really disappointed') without aggression, and 'Could you help me sort this out?' invites collaboration—very British. However, missing specific details like when/where you bought it. Adding 'I bought it here last week' would make it stronger.",
            "textJa": "ã“ã®ã‚¸ãƒ£ã‚±ãƒƒãƒˆã€ä¸€åº¦ç€ãŸã ã‘ã§ãƒ•ã‚¡ã‚¹ãƒŠãƒ¼ãŒå£Šã‚Œã¦ã—ã¾ã£ã¦ã€ã¨ã¦ã‚‚æ®‹å¿µã§ã™ã€‚å¯¾å¿œã—ã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "The zip on this jacket broke after one wear. I bought it here about a week ago. What options do I have?",
            "correct": false,
            "feedback": "⚠️ 事実を整理して伝えつつ、相手の選択肢を尊重する「What options do I have?」は協調的です。ただし、「I'd like to return it」のような明確な要望がないため、相手は判断に困る可能性があります。より直接的に「I'd like to return it or get it replaced, please」と付け加えるとベターです。",
            "feedbackEn": "You state facts clearly and respectfully invite their input with 'What options do I have?'—collaborative in spirit. However, without stating your preferred outcome ('I'd like to return it'), staff may feel uncertain about the best next step. Adding your clear request makes resolution faster.",
            "textJa": "ã“ã®ã‚¸ãƒ£ã‚±ãƒƒãƒˆã®ãƒ•ã‚¡ã‚¹ãƒŠãƒ¼ãŒä¸€åº¦ç€ãŸã ã‘ã§å£Šã‚Œã¾ã—ãŸã€‚ç´„1é€±é–“å‰ã«ã“ã¡ã‚‰ã§è³¼å…¥ã—ã¾ã—ãŸã€‚ã©ã‚“ãªå¯¾å¿œãŒå¯èƒ½ã§ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ã“ã‚“ã«ã¡ã¯ï¼ä»Šæ—¥ã¯ã©ã®ã‚ˆã†ãªã”ç”¨ä»¶ã§ã—ã‚‡ã†ã‹ï¼Ÿ"
      },
      {
        "speaker": "staff",
        "avatar": "🛍️",
        "name": "Shop Staff",
        "text": "Do you have the receipt?",
        "options": [
          {
            "text": "Yes, here it is. The item still has its original tags.",
            "correct": true,
            "feedback": "✅ レシート＋タグがある状態は、英国での返品手続きで最も理想的です。店側が返品を確認しやすく、スムーズに進みます。簡潔で協力的な対応が評価されます。",
            "feedbackEn": "Receipt plus original tags is ideal for UK returns. Retailers appreciate this condition as it shows you've kept everything in good order. Clear, straightforward, and cooperative.",
            "textJa": "ã¯ã„ã€ã“ã‚Œã§ã™ã€‚å…ƒã®ã‚¿ã‚°ã‚‚ã¾ã ã¤ã„ã¦ã„ã¾ã™ã€‚"
          },
          {
            "text": "I've lost the receipt, but I paid by card. Could you check your system?",
            "correct": false,
            "feedback": "⚠️ カード払いの記録は十分な証明になりますが、相手に確認を求める際の表現が「Would you...?」の方がより丁寧で英国的です。「Could you check...?」でも問題ありませんが、少し直接的に聞こえる場合があります。",
            "feedbackEn": "Card payment records are acceptable proof of purchase in UK retail. However, phrasing like 'Would you be able to check your system?' is slightly more polite. Your approach works but is a touch more direct than typical British courtesy.",
            "textJa": "ãƒ¬ã‚·ãƒ¼ãƒˆã‚’ãªãã—ã¦ã—ã¾ã„ã¾ã—ãŸãŒã€ã‚«ãƒ¼ãƒ‰ã§æ”¯æ‰•ã„ã¾ã—ãŸã€‚ã‚·ã‚¹ãƒ†ãƒ ã§ç¢ºèªã§ãã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I don't have the receipt. Would you accept my card details or email for verification instead?",
            "correct": false,
            "feedback": "⚠️ レシート紛失時の代替案を自ら提案する積極性は良いのですが、英国では通常、店側が「We can look it up on our system」と先に提案します。消費者がカード情報を提供するのは一般的ではなく、データ保護面でも慎重です。",
            "feedbackEn": "Proactive problem-solving is appreciated, but offering your card details isn't standard UK practice. Retailers typically handle payment verification through their own systems for data protection. Better to ask them what options they have.",
            "textJa": "ãƒ¬ã‚·ãƒ¼ãƒˆã¯ã‚ã‚Šã¾ã›ã‚“ãŒã€ä»£ã‚ã‚Šã«ã‚«ãƒ¼ãƒ‰ã®æƒ…å ±ã‚„ãƒ¡ãƒ¼ãƒ«ã§ç¢ºèªã§ãã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ãƒ¬ã‚·ãƒ¼ãƒˆã¯ãŠæŒã¡ã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "staff",
        "avatar": "🛍️",
        "name": "Shop Staff",
        "text": "We can offer you a full refund, an exchange, or store credit. What would you prefer?",
        "options": [
          {
            "text": "A full refund would be perfect, please. Thank you for sorting this out.",
            "correct": true,
            "feedback": "✅ UK消費者法では不良品に対する全額払い戻しは消費者の権利です。感謝を述べながら明確に選択する表現は、英国のビジネス文化で最も適切です。店員の対応を認めつつ、自分の権利を自信を持って行使しています。",
            "feedbackEn": "✅ Full refund is your statutory consumer right for faulty goods under UK law. Expressing appreciation while clearly stating your preference demonstrates politeness—essential in British retail culture—while confidently asserting your rights. This shows you understand your position as an informed consumer.",
            "textJa": "å…¨é¡è¿”é‡‘ã§ãŠé¡˜ã„ã—ã¾ã™ã€‚å¯¾å¿œã—ã¦ã„ãŸã ãã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚"
          },
          {
            "text": "Store credit would be lovely, actually. That works perfectly for me.",
            "correct": false,
            "feedback": "⚠️ 個人的にストアクレジットを選ぶこと自体は完全に有効です。表現も自然で「lovely」はとてもイギリス的です。ただしこのシーンの教育目的から言うと、全額払い戻しを選ぶことで「自分の消費者としての権利を理解している」という文化的リテラシーが示されます。クレジットを選ぶことは誤りではなく、単に「より主張的な選択」が正解とされています。",
            "feedbackEn": "⚠️ Choosing store credit based on your personal preference is completely valid—'lovely' is authentically British and natural. However, in this educational context about UK consumer rights awareness, selecting a refund better demonstrates that you understand your statutory protections, which is culturally valued in British consumer culture.",
            "textJa": "ã‚¹ãƒˆã‚¢ã‚¯ãƒ¬ã‚¸ãƒƒãƒˆã§ãŠé¡˜ã„ã—ã¾ã™ã€‚ãã‚Œã§å¤§ä¸ˆå¤«ã§ã™ã€‚"
          },
          {
            "text": "An exchange sounds good if you still have stock. What would you recommend?",
            "correct": false,
            "feedback": "⚠️ 交換を希望し、在庫確認をするのは実用的で丁寧です。ただし、提示された3つの選択肢から選ぶ場面で、相手に判断を委ねる（「What would you recommend?」）のは英国文化的に優柔不断に映ります。英国では「自分が何を望むか」をはっきり述べることが尊重されます。「An exchange would be ideal」と確信を持って言う方が、より英国的です。",
            "feedbackEn": "⚠️ Requesting an exchange and checking stock availability is practical and polite. However, when given clear options, asking the retailer for their recommendation can seem indecisive in British culture. Stating what you want directly—'An exchange would be ideal'—is more valued in UK consumer interactions and shows you know what you prefer.",
            "textJa": "åœ¨åº«ãŒã‚ã‚Œã°äº¤æ›ã§ãŠé¡˜ã„ã—ã¾ã™ã€‚ä½•ã‹ãŠå‹§ã‚ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "å…¨é¡è¿”é‡‘ã€äº¤æ›ã€ã¾ãŸã¯ã‚¹ãƒˆã‚¢ã‚¯ãƒ¬ã‚¸ãƒƒãƒˆã‚’ã”æä¾›ã§ãã¾ã™ã€‚ã©ã¡ã‚‰ãŒã‚ˆã‚ã—ã„ã§ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: Under the Consumer Rights Act 2015, you're entitled to a full refund for faulty goods within 30 days. Be calm and factual.",
    "tipJa": "🇬🇧 イギリスTip: 2015年消費者権利法により、30日以内の不良品は全額返金を求める権利があります。"
  },
  "conv_life_housing": {
    "id": "conv_life_housing",
    "title": "Viewing a rental property",
    "titleJa": "賃貸物件の内見",
    "situation": "You're viewing a flat in London with an estate agent.",
    "situationJa": "ロンドンで不動産エージェントと物件の内見をしています。",
    "turns": [
      {
        "speaker": "agent",
        "avatar": "🏠",
        "name": "Estate Agent",
        "text": "So what do you think? It's just come on the market this morning.",
        "options": [
          {
            "text": "It's lovely — could I ask a few questions about the boiler and which direction it faces?",
            "correct": true,
            "feedback": "✅「lovely」はイギリス人が日常的に使う親しみやすい表現で、相手の提案を快く受け入れつつ、実務的な質問を自然に繋げています。これは英国の不動産購入文化では理想的なアプローチです。関係を損なわず、同時に真摯な関心を示しています。",
            "feedbackEn": "✅ 'Lovely' is quintessentially British—it shows warmth and genuine interest. Pairing it with practical questions demonstrates you're a serious buyer without being pushy. This builds rapport while showing due diligence, which is essential in UK property culture.",
            "textJa": "ç´ æ•µã§ã™ã­ã€‚ãƒœã‚¤ãƒ©ãƒ¼ã¨å‘ãã«ã¤ã„ã¦è³ªå•ã—ã¦ã‚‚ã‚ˆã„ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "It looks interesting. I'd like to arrange a second viewing to check the condition more carefully before deciding.",
            "correct": false,
            "feedback": "⚠️ 慎重で丁寧な提案です。ただ、第一印象の段階では「その場で実務的な質問をする」方がイギリス文化的には自然です。複数回の内見は後で自然に出てくるものであり、ここではまず「好感度」を示す方が効果的です。",
            "feedbackEn": "⚠️ Suggesting a second viewing shows you're serious, but at this initial moment it's more natural to ask practical questions on the spot. Multiple viewings naturally follow later in the UK buying process. Here, building rapport with immediate, genuine questions is more effective.",
            "textJa": "èˆˆå‘³æ·±ã„ã§ã™ã­ã€‚æ±ºæ–­ã™ã‚‹å‰ã«ã€çŠ¶æ…‹ã‚’ã‚ˆã‚Šæ…Žé‡ã«ç¢ºèªã™ã‚‹ãŸã‚ã«2å›žç›®ã®å†…è¦§ã‚’æ‰‹é…ã—ãŸã„ã§ã™ã€‚"
          },
          {
            "text": "That's nice. What can you tell me about the local area and nearby amenities around here?",
            "correct": false,
            "feedback": "⚠️ ロケーションについての質問は英国では極めて重要です。ただ、この段階では「物件そのもの」についての実務的質問（boiler、方角など）の方がより自然です。周辺環境は内見時に追加で聞く質問として後回しになることが多いです。",
            "feedbackEn": "⚠️ Asking about the neighbourhood is absolutely valid—location matters hugely in UK property decisions. However, at this moment, asking about the property itself (condition, direction, services) is more natural. The neighbourhood question typically comes up during or after the viewing.",
            "textJa": "ã„ã„ã§ã™ã­ã€‚ã“ã®å‘¨è¾ºã®åœ°åŸŸã‚„è¿‘ãã®æ–½è¨­ã«ã¤ã„ã¦æ•™ãˆã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ã„ã‹ãŒã§ã—ã‚‡ã†ã‹ï¼Ÿä»Šæœå¸‚å ´ã«å‡ºãŸã°ã‹ã‚Šã§ã™ã€‚"
      },
      {
        "speaker": "agent",
        "avatar": "🏠",
        "name": "Estate Agent",
        "text": "The landlord would prefer a 12-month tenancy. Is that okay for you?",
        "options": [
          {
            "text": "That works for me — would there be a break clause at 6 months just in case?",
            "correct": true,
            "feedback": "✅ これが英国文化的にベストです。12ヶ月の契約を受け入れつつ、Break clause（解約条項）の有無を確認することは、英国の賃貸借慣行では完全に標準的で、賢明な対応です。双方の立場を尊重しながら、自分の権利を守る姿勢が英国的です。",
            "feedbackEn": "✅ This is the best approach. Accepting the 12-month term while asking about a break clause shows you understand UK tenancy law and protects yourself. This balances respect for the landlord's preference with reasonable self-protection—very typical of UK negotiations.",
            "textJa": "å•é¡Œã‚ã‚Šã¾ã›ã‚“ã€‚å¿µã®ãŸã‚6ãƒµæœˆã§ã®ä¸­é€”è§£ç´„æ¡é …ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Yes, that's fine — when exactly would the tenancy start date be?",
            "correct": false,
            "feedback": "⚠️ 親切な返答ですが、重要な確認を逃しています。英国ではBreak clause（通常6ヶ月時点で）があるかどうかは、賃借人にとって最も重要な質問です。詳細を聞く前に、契約の基本的な保護条項について確認する方が優先度高いです。",
            "feedbackEn": "⚠️ Polite, but you're missing a crucial question. In UK tenancies, asking about break clauses is your key protection. Moving straight to dates skips the chance to negotiate safeguards that most tenants expect. Always clarify protective terms first.",
            "textJa": "ã¯ã„ã€å¤§ä¸ˆå¤«ã§ã™ã€‚è³ƒè²¸é–‹å§‹æ—¥ã¯ã„ã¤ã«ãªã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I'd prefer 6 months if possible, but I can discuss with the landlord.",
            "correct": false,
            "feedback": "⚠️ 短期契約を希望するのは全く問題ありません。ただし、大家さんが既に12ヶ月を希望している状況では、この返答は相手の立場を軽視する印象を与えます。「12ヶ月でいいが、Break clauseがあれば」と柔軟に提案する方が、英国のビジネス文化ではスムーズです。",
            "feedbackEn": "⚠️ Wanting 6 months is completely fair, but given the landlord has stated a preference for 12 months, pushing back this way sounds dismissive. The more UK-typical approach is to accept their preference conditionally—especially with a break clause—showing flexibility while protecting yourself.",
            "textJa": "ã§ãã‚Œã°6ãƒµæœˆã‚’å¸Œæœ›ã—ã¾ã™ãŒã€å®¶ä¸»ã¨ç›¸è«‡ã—ã¾ã™ã€‚"
          }
        ],
        "textJa": "å®¶ä¸»ã¯12ãƒµæœˆã®è³ƒè²¸ã‚’å¸Œæœ›ã—ã¦ã„ã¾ã™ã€‚ã‚ˆã‚ã—ã„ã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "agent",
        "avatar": "🏠",
        "name": "Estate Agent",
        "text": "There are currently 3 other viewings booked today. If you're interested, I'd move quickly.",
        "options": [
          {
            "text": "That's helpful to know. I'm very interested—could I schedule a second viewing soon, or let you know within 24 hours?",
            "correct": true,
            "feedback": "✅ イギリス人らしい「丁寧かつ効率的」な対応です。興味を明確に示しながら、急かされても冷静さを保つ姿勢がUK賃貸文化で評価されます。具体的な期限を提示することで、真摯でありながら自分のペースを保つバランスが取れています。",
            "feedbackEn": "✅ This shows genuine interest while maintaining composure under pressure—very British. Setting a clear 24-hour timeframe demonstrates you're a serious prospect without appearing desperate. Estate agents respect tenants who make thoughtful decisions.",
            "textJa": "æ•™ãˆã¦ã„ãŸã ãã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ã¨ã¦ã‚‚èˆˆå‘³ãŒã‚ã‚Šã¾ã™ã€‚ã™ãã«2å›žç›®ã®å†…è¦§ã‚’äºˆç´„ã§ãã¾ã™ã‹ï¼Ÿ24æ™‚é–“ä»¥å†…ã«é€£çµ¡ã—ã¾ã™ã€‚"
          },
          {
            "text": "I appreciate the urgency. I'd like to view it again before deciding, so can you hold it until tomorrow afternoon?",
            "correct": false,
            "feedback": "⚠️ 敬意を示す良い表現ですが、「until tomorrow afternoon」という具体的な期限がやや長すぎます。他の3件のビューイングが進行中なので、「within 24 hours」や「by end of business today」の方が交渉力を示します。ただし個人の状況（帰国など）での判断遅延は全く問題ありません。",
            "feedbackEn": "⚠️ 'Appreciate' is polite and the request for a second viewing is reasonable. However, 'tomorrow afternoon' might be too vague given the competition. 'Within 24 hours' or 'by end of day' signals you're keeping pace with the market while remaining thoughtful. Personal reasons for delay are perfectly valid.",
            "textJa": "ç·Šæ€¥æ€§ã¯åˆ†ã‹ã‚Šã¾ã™ã€‚æ±ºæ–­å‰ã«ã‚‚ã†ä¸€åº¦è¦‹ãŸã„ã®ã§ã€æ˜Žæ—¥ã®åˆå¾Œã¾ã§ä¿ç•™ã«ã§ãã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "We'd like to go ahead and put in an offer today — we don't want to risk losing it to another buyer. Can we skip the second viewing and just agree a price right now?",
            "correct": false,
            "feedback": "❌ 焦っているように見え、英国文化では「感情的で合理的ではない」という印象を与えます。Estate agentの緊急性アピールは交渉テクニックです。イギリス人は「冷静な判断」を示す方が信用されます。感情的な決定は後悔につながりやすく、UKでは避けるべき行動です。",
            "feedbackEn": "❌ Showing panic over pressure undermines your credibility in British culture. Estate agents use urgency tactics; remaining calm and rational signals you make sound decisions. Emotional, rushed commitments are viewed as unreliable in UK rental culture.",
            "textJa": "ä»Šæ—¥ã‚ªãƒ•ã‚¡ãƒ¼ã‚’å‡ºã—ãŸã„ã¨æ€ã„ã¾ã™ã€‚ä»–ã®äººã«å–ã‚‰ã‚ŒãŸããªã„ã®ã§ã€2å›žç›®ã®å†…è¦§ã‚’ã‚¹ã‚­ãƒƒãƒ—ã—ã¦ä¾¡æ ¼ã‚’æ±ºã‚ã¾ã—ã‚‡ã†ã€‚"
          }
        ],
        "textJa": "ä»Šæ—¥ã¯ä»–ã«3ä»¶ã®å†…è¦§äºˆç´„ãŒå…¥ã£ã¦ã„ã¾ã™ã€‚èˆˆå‘³ãŒã‚ã‚Œã°ã€æ—©ã‚ã«å‹•ã„ãŸæ–¹ãŒã„ã„ã§ã™ã‚ˆã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: UK rental viewings are fast-paced. Ask about: council tax band, boiler age, and break clauses. You'll need references, a credit check, and usually 5 weeks' deposit.",
    "tipJa": "🇬🇧 イギリスTip: 英国の内見はスピーディーです。確認事項：カウンシルタックスのバンド、ボイラーの年齢、解約条項。"
  },
  "conv_life_neighbor": {
    "id": "conv_life_neighbor",
    "title": "Meeting your neighbours",
    "titleJa": "隣人との挨拶",
    "situation": "You've just moved into a new flat in London. You run into your neighbour in the hallway.",
    "situationJa": "ロンドンの新しいフラットに引越したばかり。廊下で隣人に会いました。",
    "turns": [
      {
        "speaker": "neighbor",
        "avatar": "🚪",
        "name": "Neighbour",
        "text": "Oh hello — have you just moved in? Welcome to the building!",
        "options": [
          {
            "text": "Yes, I moved in yesterday! I'm {name} — thanks so much for the warm welcome!",
            "correct": true,
            "feedback": "✅「Thanks so much for the warm welcome」は相手の好意を明確に認識し、感謝する表現で、イギリス近所付き合いの文化では非常に重要です。名前を名乗り、相手の親切に温かく応答することで、良い隣人関係の基礎を作ります。",
            "feedbackEn": "✅ Directly acknowledging your neighbour's kindness ('thanks so much for the warm welcome') is genuinely appreciated in British culture. Introducing yourself with your name and reciprocating warmth establishes a good foundation for neighbourly relations.",
            "textJa": "ãã†ãªã‚“ã§ã™ã€æ˜¨æ—¥å¼•ã£è¶Šã—ã¦ãã¾ã—ãŸï¼{name}ã§ã™ã€‚æ¸©ã‹ãè¿Žãˆã¦ã„ãŸã ã„ã¦ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼"
          },
          {
            "text": "That's very kind of you! I only arrived yesterday — still getting settled in. I'm {name}.",
            "correct": false,
            "feedback": "⚠️「That's very kind of you」で相手を褒める表現は丁寧ですが、やや形式的です。より自然なイギリス英語では「Thanks for the welcome」のようにシンプルに感謝する方がより親しみやすく聞こえます。ただし内容は十分で、会話として全く問題ありません。",
            "feedbackEn": "⚠️ 'That's very kind of you' is polite but slightly more formal than typical British small talk. A simpler 'Thanks' or 'Thanks for welcoming me' feels more natural and neighbourly. The rest is good—mentioning you've just arrived and are settling in is relatable.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼æ˜¨æ—¥æ¥ãŸã°ã‹ã‚Šã§ã¾ã è½ã¡ç€ã„ã¦ã„ã¾ã›ã‚“ã€‚{name}ã¨ã„ã„ã¾ã™ã€‚"
          },
          {
            "text": "Yes, I've just arrived! It's nice to meet you — hopefully we'll be good neighbours.",
            "correct": false,
            "feedback": "⚠️ 相手の親切への感謝が明示されておらず、「hopefully we'll be good neighbours」という期待は少し形式的に聞こえます。また、自分の名前を名乗っていないため、相手は名前を知りません。「I'm {name}」を加えるとより会話が進みます。",
            "feedbackEn": "⚠️ You haven't explicitly thanked your neighbour for their welcome, and 'hopefully we'll be good neighbours' sounds a bit formal for an initial greeting. More importantly, you've forgotten to introduce yourself by name—'I'm {name}' would make the interaction more personal and complete.",
            "textJa": "ãã†ã§ã™ã€æ¥ãŸã°ã‹ã‚Šã§ã™ï¼ãŠä¼šã„ã§ãã¦å¬‰ã—ã„ã§ã™ã€‚ã„ã„éš£äººã«ãªã‚Œã‚‹ã¨ã„ã„ã§ã™ã­ã€‚"
          }
        ],
        "textJa": "ã‚ã‚‰ã€ã“ã‚“ã«ã¡ã¯ã€‚å¼•ã£è¶Šã—ã¦ããŸã‚“ã§ã™ã‹ï¼Ÿã‚ˆã†ã“ãï¼"
      },
      {
        "speaker": "neighbor",
        "avatar": "🚪",
        "name": "Neighbour",
        "text": "If you ever need anything — a cup of sugar, that sort of thing — just knock.",
        "options": [
          {
            "text": "That's really kind of you, thank you! I'll do the same if you need anything.",
            "correct": true,
            "feedback": "✅ これは英国的に完璧な応答です。'really kind'という表現は温かく、相互扶助の申し出（reciprocal offer）をすることで、近所付き合いの基本である「等価な関係」を示しています。英国では一方的に助けてもらうより、双方向の関係を作ることが大切です。",
            "feedbackEn": "This is the perfect British response. 'Really kind' is warm and genuinely appreciative. Reciprocating the offer shows you value mutual neighbourly relations—key to UK culture where balanced relationships matter more than hierarchy.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼ä½•ã‹å¿…è¦ãªã“ã¨ãŒã‚ã‚Œã°ã€åŒã˜ã‚ˆã†ã«ã©ã†ãžã€‚"
          },
          {
            "text": "That's lovely, thank you! I'll definitely keep that in mind.",
            "correct": false,
            "feedback": "✅ 'Lovely'はイギリス英語でとても自然な応答表現です。感謝を示しながらも、申し出を受け入れるオープンな姿勢を見せています。相互扶助を約束する必要はなく、提案を素直に受け入れるだけでも英国文化では十分です。",
            "feedbackEn": "Excellent choice. 'Lovely' is quintessentially British and warm. You're accepting the offer graciously without obligation to reciprocate immediately—this is perfectly natural and shows you appreciate the neighbourly gesture.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼è¦šãˆã¦ãŠãã¾ã™ã€‚"
          },
          {
            "text": "Thanks, but I'm quite independent and prefer not to ask for help.",
            "correct": false,
            "feedback": "⚠️ 感謝はしていますが、相手の善意を遠回しに拒絶しているように聞こえます。英国人は初対面で「助けられたくない」と言うと、相手を傷つけます。代わりに「Thanks! I appreciate that, and I'm happy to help if you need anything too」と言えば、独立心を示しながらも関係を開くことができます。",
            "feedbackEn": "Polite but risks seeming ungrateful or standoffish. In British culture, declining neighbourly overtures—even politely—can feel rejecting. Better to accept warmly and reciprocate: 'Thanks! I'd be happy to help you too if needed.'",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ã§ã‚‚ç§ã¯ã‹ãªã‚Šè‡ªç«‹ã—ã¦ã„ã‚‹ã®ã§ã€åŠ©ã‘ã‚’æ±‚ã‚ã‚‹ã“ã¨ã¯ã»ã¨ã‚“ã©ã‚ã‚Šã¾ã›ã‚“ã€‚"
          }
        ],
        "textJa": "ä½•ã‹å¿…è¦ãªã“ã¨ãŒã‚ã‚Œã°ã€ç ‚ç³–ä¸€æ¯ã§ã‚‚ã€æ°—è»½ã«ãƒŽãƒƒã‚¯ã—ã¦ãã ã•ã„ã€‚"
      },
      {
        "speaker": "neighbor",
        "avatar": "🚪",
        "name": "Neighbour",
        "text": "One thing — the bin collections are Tuesday and Friday. Recycling goes in the blue bin.",
        "options": [
          {
            "text": "Oh, thanks for that! Tuesday and Friday — got it. Blue bin for recycling, cheers.",
            "correct": true,
            "feedback": "✅ 隣人の親切な助言を自然かつ簡潔に受け入れています。'cheers'という砕けた感謝表現が英国的で、親しみやすい近所付き合いの雰囲気を作ります。情報を反復確認する姿勢も信頼関係を構築します。",
            "feedbackEn": "Perfect British neighbour response. You acknowledge the help warmly, repeat back key info to confirm understanding, and use 'cheers'—a characteristically British casual thank you. Shows genuine appreciation without formality.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼ç«æ›œã¨é‡‘æ›œã§ã™ã­ã€‚é’ã„ãƒ“ãƒ³ãŒãƒªã‚µã‚¤ã‚¯ãƒ«ç”¨ã¨ã„ã†ã“ã¨ã§ã€‚"
          },
          {
            "text": "Right, I appreciate that. I'll also check the council website just to be certain.",
            "correct": false,
            "feedback": "⚠️ 親切な隣人の情報を受け入れつつ、公式確認をする慎重さは理解できます。ただ英国では、隣人からの直接的な助言は十分信頼できるものと見なされます。'just to be certain'と言うと、隣人の情報を疑っているように聞こえる可能性があります。'I'll keep that in mind'など、信頼を示す表現の方が適切です。",
            "feedbackEn": "You're being cautious, which is understandable, but 'just to be certain' can suggest you don't fully trust your neighbour's information. In UK culture, neighbour-to-neighbour tips are usually reliable. A warmer response like 'I'll definitely keep that in mind' would show you trust their local knowledge.",
            "textJa": "ãã†ã§ã™ã‹ã€ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ä¸€å¿œã€å¸‚ã®ã‚¦ã‚§ãƒ–ã‚µã‚¤ãƒˆã§ã‚‚ç¢ºèªã—ã¦ãŠãã¾ã™ã€‚"
          },
          {
            "text": "Thanks for letting me know. My country has different systems, but this is helpful.",
            "correct": false,
            "feedback": "⚠️ 自分の背景について触れる必要はありません。隣人は単に「ここでのローカルルール」を親切心で教えてくれているだけです。過去の経験を比較対照するより、「この地域のルールを教えてくれてありがとう」という姿勢が英国文化では重要。返答をシンプルに保つ方が、相手の好意がより活きます。",
            "feedbackEn": "While not rude, bringing up your country's different system shifts focus away from appreciating the local information. British neighbours appreciate when you simply accept their local tips graciously. Keep it simple: acknowledge, thank them, and show you'll follow their advice.",
            "textJa": "æ•™ãˆã¦ã„ãŸã ãã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ç§ã®å›½ã¨ã¯ã‚·ã‚¹ãƒ†ãƒ ãŒé•ã„ã¾ã™ãŒã€å‚è€ƒã«ãªã‚Šã¾ã—ãŸã€‚"
          }
        ],
        "textJa": "ä¸€ã¤ä¼ãˆã¦ãŠãã¨ã€ã‚´ãƒŸåŽé›†ã¯ç«æ›œæ—¥ã¨é‡‘æ›œæ—¥ã§ã™ã€‚ãƒªã‚µã‚¤ã‚¯ãƒ«ã¯é’ã„ãƒ“ãƒ³ã«å…¥ã‚Œã¦ãã ã•ã„ã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: British neighbours value politeness and respect for shared spaces. Introduce yourself when you move in. Keep noise down after 11pm.",
    "tipJa": "🇬🇧 イギリスTip: 英国の隣人は礼儀と共有スペースへの尊重を重視します。引越し時に挨拶しましょう。"
  },
  "conv_life_bank": {
    "id": "conv_life_bank",
    "title": "Opening a bank account",
    "titleJa": "銀行口座の開設",
    "situation": "You're at a UK bank trying to open a current account as a new resident.",
    "situationJa": "英国の銀行で新規居住者として当座預金口座を開設しようとしています。",
    "turns": [
      {
        "speaker": "bank",
        "avatar": "🏦",
        "name": "Bank Staff",
        "text": "Hello, how can I help you today?",
        "options": [
          {
            "text": "Good morning. I've just moved to the UK and I'd like to open a current account, please.",
            "correct": true,
            "feedback": "✅ 明確で丁寧な対応です。「I'd like to」という控えめな表現はイギリス文化的に好印象。新規移住者であることを伝えることで、銀行側が必要な手続きをスムーズに案内できます。また「please」で相手を尊重する姿勢も重要です。",
            "feedbackEn": "Perfect! 'I'd like to' is polite and understated—very British. Mentioning you've just moved helps them understand your situation, and 'please' shows respect. This collaborative tone aligns perfectly with UK business culture.",
            "textJa": "ãŠã¯ã‚ˆã†ã”ã–ã„ã¾ã™ã€‚è‹±å›½ã«æ¥ãŸã°ã‹ã‚Šã§ã€æ™®é€šå£åº§ã‚’é–‹ããŸã„ã®ã§ã™ãŒã€‚"
          },
          {
            "text": "I'd like to open an account for everyday use. What fee options do you currently offer?",
            "correct": false,
            "feedback": "⚠️ 目的と質問が明確で、スタッフの専門知識を引き出す良いアプローチです。しかし最初の銀行訪問では、まず自分の状況を説明した上で「What would you recommend?」と専門家意見を求める方がより英国的です。この表現は少し早めの質問に見えます。",
            "feedbackEn": "Good attempt! Specifying 'for everyday use' and asking about fees shows engagement. However, on a first visit, the British style is to share your situation first, then ask 'What would you recommend?' to get expert guidance. This approach is slightly transactional.",
            "textJa": "æ—¥å¸¸ç”¨ã®å£åº§ã‚’é–‹ããŸã„ã®ã§ã™ãŒã€‚ç¾åœ¨ã©ã‚“ãªæ‰‹æ•°æ–™ã®ã‚ªãƒ—ã‚·ãƒ§ãƒ³ãŒã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Hi, I need to open a bank account as quickly as possible — what are the cheapest options you offer, and can I get this sorted and activated today?",
            "correct": false,
            "feedback": "❌ 「I want」は直接的でぶっきらぼうに聞こえ、イギリス文化では失礼な印象を与えます。また「cheap」という表現は銀行のサービスを軽視しているように聞こえます。「I'd like to」「affordable」「reasonable fees」の方が適切です。",
            "feedbackEn": "Not suitable. 'I want' sounds blunt and dismissive in British culture. 'Cheap' can sound disrespectful toward the bank's services. Use 'I'd like to,' 'affordable,' or 'reasonable fees' instead for a more professional tone.",
            "textJa": "ã“ã‚“ã«ã¡ã¯ã€‚ã§ãã‚‹ã ã‘æ—©ãéŠ€è¡Œå£åº§ã‚’é–‹ããŸã„ã®ã§ã™ãŒã€æœ€ã‚‚å®‰ã„ã‚ªãƒ—ã‚·ãƒ§ãƒ³ã¯ä½•ã§ã™ã‹ï¼Ÿä»Šæ—¥æ‰‹ç¶šãã—ã¦æœ‰åŠ¹ã«ã§ãã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ã“ã‚“ã«ã¡ã¯ï¼ä»Šæ—¥ã¯ã©ã‚“ãªã”ç”¨ä»¶ã§ã—ã‚‡ã†ã‹ï¼Ÿ"
      },
      {
        "speaker": "bank",
        "avatar": "🏦",
        "name": "Bank Staff",
        "text": "We'll need proof of ID and proof of address. Do you have those with you?",
        "options": [
          {
            "text": "I have my passport and a recent utility bill with my address on it. Will those work?",
            "correct": true,
            "feedback": "✅ パスポート＋公共料金の請求書は英国銀行口座開設の標準的な組み合わせです。この回答は銀行職員の要求に直接対応し、必要な書類を確認した上で提示するという、英国ビジネス文化における効率的で丁寧なコミュニケーションスタイルを示しています。",
            "feedbackEn": "Passport + utility bill is the standard combination UK banks accept. This response directly addresses the staff member's request and demonstrates efficient, polite communication by confirming you have the required documents before presenting them.",
            "textJa": "ãƒ‘ã‚¹ãƒãƒ¼ãƒˆã¨æœ€è¿‘ã®å…¬å…±æ–™é‡‘ã®æ˜Žç´°æ›¸ãŒã‚ã‚Šã¾ã™ã€‚ãã‚Œã§å¤§ä¸ˆå¤«ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I have my passport, but I'm still waiting for utility bills. Could I use a bank statement instead?",
            "correct": false,
            "feedback": "✅ 代替書類を提案する誠実な対応です。英国文化では、必要な書類が揃わない場合に別のオプションを相談する姿勢が重要とされます。銀行職員は代替案に対して柔軟に対応することが多く、このアプローチは礼儀正しく実用的です。",
            "feedbackEn": "This is an honest response that suggests an alternative. In UK culture, proposing alternatives when documents aren't ready yet is seen as proactive and respectful. Bank staff often accommodate such requests, and this approach demonstrates politeness and practicality.",
            "textJa": "ãƒ‘ã‚¹ãƒãƒ¼ãƒˆã¯ã‚ã‚Šã¾ã™ãŒã€å…¬å…±æ–™é‡‘ã®æ˜Žç´°æ›¸ã¯ã¾ã å¾…ã£ã¦ã„ã¾ã™ã€‚éŠ€è¡Œã®æ˜Žç´°æ›¸ã§ã¯ä»£ç”¨ã§ãã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I have my passport. I only just arrived, so I don't have any UK documents yet. What else could work?",
            "correct": false,
            "feedback": "✅ 状況を正直に説明し、銀行職員にアドバイスを求める姿勢は英国文化で好まれます。新しい住民であることを伝えることで、職員は通常、より柔軟な解決策（家賃契約書、学生ビザレター、雇用契約など）を提案してくれます。この透明性のあるコミュニケーションは信頼を構築します。",
            "feedbackEn": "Explaining your situation honestly and asking the staff member for guidance is appreciated in UK culture. By mentioning you've just arrived, they typically offer flexible alternatives (tenancy agreement, visa letter, employment contract, etc.). This transparent communication builds trust and often leads to solutions.",
            "textJa": "ãƒ‘ã‚¹ãƒãƒ¼ãƒˆãŒã‚ã‚Šã¾ã™ã€‚æ¥ãŸã°ã‹ã‚Šãªã®ã§è‹±å›½ã®æ›¸é¡žãŒã¾ã ã‚ã‚Šã¾ã›ã‚“ã€‚ä»–ã«ä½•ãŒä½¿ãˆã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "èº«åˆ†è¨¼æ˜Žæ›¸ã¨ä½æ‰€è¨¼æ˜Žæ›¸ãŒå¿…è¦ã§ã™ã€‚ãŠæŒã¡ã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "bank",
        "avatar": "🏦",
        "name": "Bank Staff",
        "text": "We also have a premium account with various benefits for £15 a month. Would you be interested?",
        "options": [
          {
            "text": "No thanks for now. Could you leave me some information to review?",
            "correct": true,
            "feedback": "✅ これが英国文化的にベストな応答です。「No thanks for now」は丁寧かつ非判定的で、将来の可能性を残します。情報を受け取る姿勢は銀行員を尊重し、急な判断を避ける英国ビジネス文化の典型です。簡潔でありながら相手との関係を良好に保ちます。",
            "feedbackEn": "Perfect! 'No thanks for now' is quintessentially British—polite, non-committal, and leaves future options open. Asking for materials shows respect for the offer without pressure. This approach values both your needs and the banker's professionalism.",
            "textJa": "ä»Šã¯çµæ§‹ã§ã™ã€‚æƒ…å ±ã ã‘ç½®ã„ã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "That sounds quite useful, but could you tell me what the main benefits are?",
            "correct": false,
            "feedback": "⚠️ 悪くありませんが、やや曖昧です。「sounds useful」と言いながら「benefits are?」と聞くのは、判断を保留したいのか、興味があるのか不明確に映ります。もっと明確に『今は基本口座で十分ですが、詳しく聞かせてもらえますか？』と言うとより英国的です。",
            "feedbackEn": "Not bad, but slightly unclear. You're giving mixed signals—appearing interested ('sounds useful') then asking for justification. Better to say: 'I'll start with the basic account, but could you explain the main benefits anyway?' This is clearer and more decisive.",
            "textJa": "ãªã‹ãªã‹ã‚ˆã•ãã†ã§ã™ã­ã€‚ä¸»ãªç‰¹å…¸ã‚’æ•™ãˆã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I'd like to compare it with other banks first. Can I take the details?",
            "correct": false,
            "feedback": "⚠️ 完全に合理的な質問ですが、英国では「他行と比較する」という直接的な発言は、現在の銀行への信頼度の低さを示唆する可能性があります。より英国的には『情報を確認してから検討したい』と言う方が、相手を傷つけず、同時に検討の可能性を示します。",
            "feedbackEn": "Reasonable but slightly risky. Openly mentioning comparisons with other banks can feel like you're questioning their competitiveness. More British would be: 'I'd like to review the details before deciding' or 'Let me think about it'—this is diplomatic without appearing disloyal.",
            "textJa": "å…ˆã«ä»–ã®éŠ€è¡Œã¨æ¯”è¼ƒã—ãŸã„ã§ã™ã€‚è©³ç´°ã‚’æŒã¡å¸°ã‚Œã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "æœˆ15ãƒãƒ³ãƒ‰ã§ã•ã¾ã–ã¾ãªç‰¹å…¸ã®ã‚ã‚‹ãƒ—ãƒ¬ãƒŸã‚¢ãƒ å£åº§ã‚‚ã‚ã‚Šã¾ã™ã€‚ã”èˆˆå‘³ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: Try digital banks like Monzo or Starling first — much easier to open. Traditional banks need proof of address.",
    "tipJa": "🇬🇧 イギリスTip: まずMonzoやStarlingなどのデジタルバンクを試してみましょう。"
  },
  "conv_life_recycling": {
    "id": "conv_life_recycling",
    "title": "Recycling & bin rules",
    "titleJa": "ゴミ・リサイクルのルール",
    "situation": "Your neighbour knocks on your door to tell you your bins were put out on the wrong day.",
    "situationJa": "隣人が間違った日にゴミを出したと伝えに来ました。",
    "turns": [
      {
        "speaker": "neighbor",
        "avatar": "🗑️",
        "name": "Neighbour",
        "text": "Sorry to bother you — I just wanted to let you know the general waste collection is Mondays, not Tuesdays.",
        "options": [
          {
            "text": "Oh, thanks so much for letting me know! I'm still getting used to the collection schedule here. Really appreciate you checking.",
            "correct": true,
            "feedback": "✅ 近所の親切な忠告を素直に受け入れ、感謝を表現しています。英国文化では「感謝＋謙虚さ」の組み合わせが、近所関係を円滑にする重要なスキルです。'checking'という言葉で相手の気配りを認めることで、さらに関係が温かくなります。",
            "feedbackEn": "✅ This gracefully accepts the neighbour's helpful correction with genuine gratitude. The phrase 'getting used to' shows humility, and 'thanks for checking' acknowledges their thoughtfulness. This approach builds positive community bonds and reflects typical British neighbourly courtesy.",
            "textJa": "æ•™ãˆã¦ã„ãŸã ã„ã¦ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼åŽé›†ã‚¹ã‚±ã‚¸ãƒ¥ãƒ¼ãƒ«ã«ã¾ã æ…£ã‚Œã¦ã„ãªã„ã‚“ã§ã™ã€‚ç¢ºèªã—ã¦ãã‚Œã¦æœ¬å½“ã«åŠ©ã‹ã‚Šã¾ã™ã€‚"
          },
          {
            "text": "Ah, Monday then — got it! That could explain why my bin wasn't collected. Thanks for the heads-up!",
            "correct": false,
            "feedback": "✅ 情報を即座に受け入れ、その情報が自分の問題解決に役立つことを示しています。'heads-up'はカジュアルで親しみやすい英国表現。実際の状況（回収されなかった）に結びつけることで、相手の忠告の価値を実証的に認めます。",
            "feedbackEn": "✅ This immediately accepts the correction and connects it to your own situation, showing the advice was genuinely helpful. 'Heads-up' is naturally British and friendly. Linking it to your uncollected bin demonstrates you'll act on the information, which the neighbour will appreciate.",
            "textJa": "ãã†ã§ã™ã‹ã€æœˆæ›œæ—¥ãªã‚“ã§ã™ã­ï¼ã‚´ãƒŸãŒåŽé›†ã•ã‚Œãªã‹ã£ãŸç†ç”±ãŒåˆ†ã‹ã‚Šã¾ã—ãŸã€‚æ•™ãˆã¦ã„ãŸã ãã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼"
          },
          {
            "text": "Right, Monday not Tuesday — thanks! I'll make sure to put the bins out on Sunday evenings from now on.",
            "correct": false,
            "feedback": "✅ 情報を理解し、具体的な行動計画を共有しています。英国では「問題を認識→実行計画を述べる」という流れが、相手に安心感と信頼感を与えます。この返答は相手の忠告が確実に改善につながることを示しており、礼儀正しい対応です。",
            "feedbackEn": "✅ This shows you've understood and have a concrete plan going forward. British culture values decisive action after receiving advice—stating when you'll put bins out demonstrates you're a considerate neighbour who listens. This reassures them their effort wasn't wasted.",
            "textJa": "æœˆæ›œæ—¥ã§ã™ã­ã€ç«æ›œæ—¥ã˜ã‚ƒãªãã¦ã€‚ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼ã“ã‚Œã‹ã‚‰ã¯æ—¥æ›œæ—¥ã®å¤œã«ã‚´ãƒŸã‚’å‡ºã—ã¦ãŠãã¾ã™ã€‚"
          }
        ],
        "textJa": "ã™ã¿ã¾ã›ã‚“ã€ãŠé‚ªé­”ã—ã¾ã—ãŸã€‚ä¸€èˆ¬å»ƒæ£„ç‰©ã®åŽé›†ã¯æœˆæ›œæ—¥ã§ã™ã‚ˆã€ç«æ›œæ—¥ã˜ã‚ƒãªã„ã‚“ã§ã™ã€‚"
      },
      {
        "speaker": "neighbor",
        "avatar": "🗑️",
        "name": "Neighbour",
        "text": "Also — cardboard needs to be flattened before it goes in the recycling bin.",
        "options": [
          {
            "text": "Thanks for that tip. Do you have any other recycling advice for the area?",
            "correct": true,
            "feedback": "✅「Thanks for that tip」は相手の助言を素直に受け入れ、その後「Do you have any other recycling advice」と質問することで、相手の知識を尊重し学ぶ姿勢を示します。英国文化では、近所の人の経験を積極的に聞き出すことで、信頼関係を深め、コミュニティとの繋がりを強化できます。このトーンは親しみやすく、かつ関心を示す効果的な応答です。",
            "feedbackEn": "Excellent choice. You're showing genuine gratitude and curiosity about local practices. Asking for more tips demonstrates respect for your neighbour's experience, which is very much valued in British community culture. This approach builds rapport naturally.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ã“ã®åœ°åŸŸã§ã®ä»–ã®ãƒªã‚µã‚¤ã‚¯ãƒ«ã®ã‚¢ãƒ‰ãƒã‚¤ã‚¹ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Got it, I'll flatten them next time. Thanks for the reminder.",
            "correct": false,
            "feedback": "⚠️ 実用的で自然な応答です。相手のアドバイスを理解し、実行する意思を示しており、英国の日常会話として十分に適切です。ただし、「Got it」は少しカジュアルすぎるかもしれません。「Thanks for that」や「Cheers for the tip」のように感謝をより明確に表現すると、より丁寧で相手を気遣う印象になります。",
            "feedbackEn": "Good, practical response. You're acknowledging the tip and committing to action. However, 'Got it' is quite casual—British culture appreciates slightly warmer gratitude. Try 'Thanks for that' or 'Cheers for the tip' to show a bit more appreciation for their help.",
            "textJa": "åˆ†ã‹ã‚Šã¾ã—ãŸã€‚æ¬¡å›žã‹ã‚‰ã¯å¹³ã‚‰ã«ã—ã¾ã™ã€‚ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚"
          },
          {
            "text": "I didn't know that was necessary. Thanks for telling me.",
            "correct": false,
            "feedback": "⚠️ 知らなかったことを認め、感謝を表現する誠実な対応です。英国文化では、新しい情報を素直に受け入れることは尊重されます。ただ、会話がやや一方的に終わってしまう感じがあります。「Thanks for telling me—I'll make sure to do that from now on」と、今後の実行を具体的に約束するか、さらに質問を加えると、より継続的な関係構築につながります。",
            "feedbackEn": "Sincere and humble response. Admitting you didn't know something is absolutely fine in British culture. However, the conversation feels like it could naturally extend. Adding something like 'I'll make sure to do that' or asking another question would keep the interaction more dynamic and show ongoing engagement.",
            "textJa": "ãã†ã—ãªã„ã¨ã„ã‘ãªã„ã¨ã¯çŸ¥ã‚Šã¾ã›ã‚“ã§ã—ãŸã€‚æ•™ãˆã¦ã„ãŸã ãã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚"
          }
        ],
        "textJa": "ãã‚Œã¨ã€æ®µãƒœãƒ¼ãƒ«ã¯ãƒªã‚µã‚¤ã‚¯ãƒ«ãƒ“ãƒ³ã«å…¥ã‚Œã‚‹å‰ã«å¹³ã‚‰ã«ãŸãŸã‚“ã§ãã ã•ã„ã€‚"
      },
      {
        "speaker": "neighbor",
        "avatar": "🗑️",
        "name": "Neighbour",
        "text": "No worries — we all had to learn! If you ever have questions about what goes where, just ask.",
        "options": [
          {
            "text": "That's really kind — I'll definitely take you up on that. Thanks for being so helpful!",
            "correct": true,
            "feedback": "✅ イギリス文化的にベストな対応です。相手の親切な申し出を温かく受け入れ、感謝を丁寧に伝えています。'take you up on that'は英国人が日常的に使う自然な表現で、近所付き合いを大切にする姿勢が伝わります。",
            "feedbackEn": "Perfect UK response. You warmly accept their kind offer and express genuine gratitude. 'Take you up on that' is natural, conversational English that shows you value the neighborly relationship.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼çµ¶å¯¾ã«èžãã«æ¥ã¾ã™ã€‚ã¨ã¦ã‚‚è¦ªåˆ‡ã«ã—ã¦ãã‚Œã¦ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼"
          },
          {
            "text": "Thanks so much — I really appreciate the offer. That's very kind of you.",
            "correct": false,
            "feedback": "✅ これも英国文化的に良い対応です。相手の親切を認め、感謝の気持ちを丁寧に伝えています。'I really appreciate'は誠実で、イギリス人が好む控えめながら温かいトーンです。",
            "feedbackEn": "Also excellent. You acknowledge their kindness sincerely with 'I really appreciate'—a warm but understated British way to express gratitude that builds rapport.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚æœ¬å½“ã«åŠ©ã‹ã‚Šã¾ã™ã€‚ã¨ã¦ã‚‚è¦ªåˆ‡ã§ã™ã­ã€‚"
          },
          {
            "text": "Right, thanks. I'll probably just figure it out myself online though.",
            "correct": false,
            "feedback": "⚠️ 惜しい対応です。相手が親切に申し出てくれているのに、その提案を控えめに（ただし不必要に）断っています。イギリスでは相手の申し出を一度受け入れておき、後で独学を選ぶのは自然ですが、この言い方だと相手の好意が少し軽く扱われるように聞こえます。'Thanks, but I might give it a go online first'のように柔らかく付け加えるほうが良いでしょう。",
            "feedbackEn": "A bit dismissive of their offer. While it's fine to rely on online resources, declining their help this way might come across as ungracious. Softer: 'Thanks—I might try looking it up, but I'll definitely ask if I get stuck!'",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ã§ã‚‚è‡ªåˆ†ã§ã‚ªãƒ³ãƒ©ã‚¤ãƒ³ã§èª¿ã¹ã‚‹ã¨æ€ã„ã¾ã™ã€‚"
          }
        ],
        "textJa": "å¤§ä¸ˆå¤«ã§ã™ã‚ˆã€‚ã©ã“ã«ä½•ã‚’å…¥ã‚Œã‚‹ã‹ã«ã¤ã„ã¦è³ªå•ãŒã‚ã‚Œã°ã€æ°—è»½ã«èžã„ã¦ãã ã•ã„ã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: UK recycling rules vary by council. Check your local council website. Putting bins out on wrong days can lead to council warnings.",
    "tipJa": "🇬🇧 イギリスTip: 英国のリサイクルルールは自治体によって異なります。地元の自治体ウェブサイトを確認しましょう。"
  },
  "conv_travel_restaurant": {
    "id": "conv_travel_restaurant",
    "title": "Dining out in the UK",
    "titleJa": "英国でのレストラン",
    "situation": "You're at a restaurant with colleagues. You have a nut allergy.",
    "situationJa": "同僚とレストランにいます。あなたはナッツアレルギーがあります。",
    "turns": [
      {
        "speaker": "waiter",
        "avatar": "🍽️",
        "name": "Waiter",
        "text": "Good evening! Are you ready to order, or do you need a few more minutes?",
        "options": [
          {
            "text": "We need a few more minutes, please. I should mention one of us has a nut allergy.",
            "correct": true,
            "feedback": "✅ 「just so you know in advance」は英国人がよく使う、重要な情報を自然に伝える表現です。時間が必要なことと安全情報を同時に丁寧に伝えており、英国のレストランサービス文化では理想的です。アレルギーを早期に正式に伝えることで、厨房が事前に対応できます。",
            "feedbackEn": "✅ This is the most natural British way to handle it. 'Just so you know in advance' shows you're being responsible without being alarmist. You're giving the kitchen time to properly log the allergy and plan accordingly, which is exactly what UK health & safety standards expect.",
            "textJa": "ã‚‚ã†å°‘ã—ãŠæ™‚é–“ãã ã•ã„ã€‚ä¸€äººãŒãƒŠãƒƒãƒ„ã‚¢ãƒ¬ãƒ«ã‚®ãƒ¼ã§ã‚ã‚‹ã“ã¨ã‚’ãŠä¼ãˆã—ã¦ãŠãã¾ã™ã€‚"
          },
          {
            "text": "We're still deciding, thanks. One of us has a nut allergy, just so you know in advance.",
            "correct": false,
            "feedback": "✅ こちらも優れた表現です。時間を丁寧に請求しながら、アレルギー情報を明確に分けて伝えています。ウェイターが情報を正式に記録しやすい構成で、英国の食物アレルギー対応基準に適合しています。",
            "feedbackEn": "✅ Equally good approach. Separating the timing request from the allergy info makes it clear and professional. The waiter can easily log the allergy with the kitchen while you take your time deciding.",
            "textJa": "ã¾ã æ±ºã‚ã¦ã„ã¾ã›ã‚“ã€ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ä¸€äººãŒãƒŠãƒƒãƒ„ã‚¢ãƒ¬ãƒ«ã‚®ãƒ¼ã§ã™ã€äº‹å‰ã«ãŠçŸ¥ã‚‰ã›ã—ã¾ã™ã€‚"
          },
          {
            "text": "I'll have the fish with no nuts added, please. That's an allergy, not just a preference.",
            "correct": false,
            "feedback": "⚠️ アレルギーであることを明確にしている点は良いのですが、注文と一緒に伝えるのでは遅すぎます。英国では食物アレルギーは注文前に厨房に正式に報告される必要があります。この方法では記録が不完全になる可能性があります。注文前にウェイターに直接伝えるべきです。",
            "feedbackEn": "⚠️ You're clarifying it's an allergy, which is good, but mentioning it with your order is too late. In the UK, allergies must be formally reported to the kitchen before ordering so they can be officially logged and all staff are aware. Telling them now, before you order, is the proper procedure.",
            "textJa": "é­šã‚’ãƒŠãƒƒãƒ„ãªã—ã§ãŠé¡˜ã„ã—ã¾ã™ã€‚ã‚¢ãƒ¬ãƒ«ã‚®ãƒ¼ã§ã™ã€å¥½ã¿ã§ã¯ã‚ã‚Šã¾ã›ã‚“ã€‚"
          }
        ],
        "textJa": "ã“ã‚“ã°ã‚“ã¯ï¼ã”æ³¨æ–‡ã¯ã‚ˆã‚ã—ã„ã§ã™ã‹ã€ã‚‚ã†å°‘ã—ãŠæ™‚é–“ãŒå¿…è¦ã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "waiter",
        "avatar": "🍽️",
        "name": "Waiter",
        "text": "The salmon dish does contain a pine nut garnish — I can have that removed. Would that work?",
        "options": [
          {
            "text": "That would be perfect, thank you so much for checking with me on that.",
            "correct": true,
            "feedback": "✅ 相手の気配りを認め、感謝を述べる対応は英国文化的にベストです。レストランスタッフの提案を信頼し、親切に応じる姿勢が評価されます。丁寧で前向きな印象を与えます。",
            "feedbackEn": "✅ This response shows genuine appreciation for the server's diligence. In UK dining culture, trusting the restaurant's ability to handle allergen requests while expressing sincere thanks builds positive rapport and reflects confidence in their professionalism.",
            "textJa": "ãã‚Œã¯å®Œç’§ã§ã™ã­ã€ç¢ºèªã—ã¦ãã ã•ã£ã¦ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚"
          },
          {
            "text": "That's kind of you to offer. I'll go with the salmon if it's removed safely.",
            "correct": false,
            "feedback": "✅ スタッフの申し出を前向きに受け入れながら、安全性への配慮を示す適切な対応です。英国文化では相手の提案を信頼しつつ、明確に意思表示することが重要です。",
            "feedbackEn": "✅ This balances trust in the restaurant's expertise with a clear statement of your choice. UK diners appreciate directness paired with politeness—accepting the solution while confirming your decision shows respect for their professionalism.",
            "textJa": "ã”ææ¡ˆã„ãŸã ã„ã¦ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚å®‰å…¨ã«å–ã‚Šé™¤ã„ã¦ã„ãŸã ã‘ã‚‹ãªã‚‰ã‚µãƒ¼ãƒ¢ãƒ³ã«ã—ã¾ã™ã€‚"
          },
          {
            "text": "Then I'll just have a different dish instead, but thanks for offering.",
            "correct": false,
            "feedback": "✅ スタッフの申し出を丁寧に辞退し、別の選択肢を選ぶのは完全に問題ありません。英国文化では個人の判断（アレルギー対応）を尊重されます。感謝を添えることで失礼にはなりません。",
            "feedbackEn": "✅ Politely declining while thanking them is perfectly acceptable in UK culture. Restaurants respect diners' comfort levels with allergen management—choosing a different dish shows your preference is valued, and adding thanks keeps the tone warm.",
            "textJa": "ã§ã¯åˆ¥ã®æ–™ç†ã«ã—ã¾ã™ã€‚ã”ææ¡ˆã¯ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚"
          }
        ],
        "textJa": "ã‚µãƒ¼ãƒ¢ãƒ³ã®ãŠçš¿ã«ã¯ãƒ‘ã‚¤ãƒ³ãƒŠãƒƒãƒ„ã®ã‚¬ãƒ¼ãƒ‹ãƒƒã‚·ãƒ¥ãŒå…¥ã£ã¦ã„ã¾ã™ã€‚å–ã‚Šé™¤ãã“ã¨ãŒã§ãã¾ã™ãŒã€ã‚ˆã‚ã—ã„ã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "waiter",
        "avatar": "🍽️",
        "name": "Waiter",
        "text": "How is everything? Are you enjoying your meal?",
        "options": [
          {
            "text": "It's absolutely lovely, thank you! Really enjoying every bite.",
            "correct": true,
            "feedback": "✅「Lovely」はイギリス人が日常的に使う典型的な褒め言葉です。食事への満足度を温かく伝え、相手のおもてなしへの感謝も示します。「every bite」と具体的に述べることで、誠実な関心が伝わり、会話も自然に続きます。",
            "feedbackEn": "Perfect! 'Lovely' is quintessentially British and warmly expresses satisfaction. The detail 'every bite' shows genuine engagement and keeps conversation flowing naturally while expressing gratitude.",
            "textJa": "çµ¶å¯¾ã«ãŠã„ã—ã„ã§ã™ã€ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼ä¸€å£ä¸€å£æ¥½ã—ã‚“ã§ã„ã¾ã™ã€‚"
          },
          {
            "text": "Yes, quite good. The flavours are really interesting and well balanced.",
            "correct": false,
            "feedback": "⚠️ 素晴らしい回答です。「Quite good」は控えめながら満足を示す英国的な表現で、「flavours」という具体的な要素に触れるのは誠実です。ただ「Lovely」の方がより温かみがあり、相手のおもてなしへの感謝がより直接的に伝わります。",
            "feedbackEn": "Excellent alternative! 'Quite good' is very British understatement, and mentioning specific details like 'flavours' shows genuine engagement. However, 'lovely' feels slightly warmer and more appreciative of the service.",
            "textJa": "ã¯ã„ã€ã¨ã¦ã‚‚ã„ã„ã§ã™ã€‚ãƒ•ãƒ¬ãƒ¼ãƒãƒ¼ãŒã¨ã¦ã‚‚èˆˆå‘³æ·±ãã¦ãƒãƒ©ãƒ³ã‚¹ãŒè‰¯ã„ã§ã™ã€‚"
          },
          {
            "text": "Very nice! Though I'm not keen on spicy, the seasoning is spot on.",
            "correct": false,
            "feedback": "⚠️ 食事を褒めつつ個人の好みを控えめに述べるのは英国的で、失礼ではありません。「Spot on」は自然な表現です。ただ、会話の最初の応答では「Lovely」で全体的な満足を優先し、好みについては相手から更に聞かれた時に述べるとより会話が流れやすいです。",
            "feedbackEn": "Good balanced response! Complimenting while mentioning preferences isn't ungrateful—it's honest. However, leading with 'lovely' and keeping the conversation focused on appreciation first is more natural in British small talk flow.",
            "textJa": "ã¨ã¦ã‚‚ç¾Žå‘³ã—ã„ã§ã™ï¼è¾›ã„ã®ã¯å¾—æ„ã˜ã‚ƒãªã„ã§ã™ãŒã€å‘³ä»˜ã‘ãŒã¡ã‚‡ã†ã©ã„ã„ã§ã™ã€‚"
          }
        ],
        "textJa": "ã„ã‹ãŒã§ã—ã‚‡ã†ã‹ï¼ŸãŠé£Ÿäº‹ã¯ãŠæ¥½ã—ã¿ã„ãŸã ã‘ã¦ã„ã¾ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: Always declare food allergies clearly at the start. Tipping 10–15% is customary in sit-down restaurants.",
    "tipJa": "🇬🇧 イギリスTip: 食物アレルギーは必ず最初に明確に伝えましょう。チップは10〜15%が一般的です。"
  },
  "conv_travel_hotel": {
    "id": "conv_travel_hotel",
    "title": "Checking in & making requests",
    "titleJa": "ホテルのチェックイン・リクエスト",
    "situation": "You arrive at your hotel in London. You booked a twin room but were given a double.",
    "situationJa": "ロンドンのホテルに到着。ツインを予約しましたがダブルルームに案内されました。",
    "turns": [
      {
        "speaker": "hotel",
        "avatar": "🏨",
        "name": "Receptionist",
        "text": "Welcome! Do you have a reservation?",
        "options": [
          {
            "text": "Yes, under Sato — {name}. I've booked a twin room for three nights.",
            "correct": true,
            "feedback": "✅ イギリス文化的にベスト。フルネーム、部屋のタイプ、滞在期間を自発的に提供することで、チェックイン手続きをスムーズにします。イギリスのホテル業界では、ゲストが必要情報を先制的に提供することが「良い顧客」と見なされます。",
            "feedbackEn": "✅ Best approach in UK hospitality culture. Volunteering your full name, room type, and length of stay streamlines check-in. British hotel staff appreciate guests who proactively provide key details—it's seen as considerate and efficient.",
            "textJa": "ã¯ã„ã€ã‚µãƒˆãƒ¼ã¨ã„ã†åå‰ã§ã™ã€‚{name}ã§ã™ã€‚ãƒ„ã‚¤ãƒ³ãƒ«ãƒ¼ãƒ ã‚’3æ³Šäºˆç´„ã—ã¦ã„ã¾ã™ã€‚"
          },
          {
            "text": "Yes, it's under Sato. I think I booked a room with two beds, but I'm not completely sure.",
            "correct": false,
            "feedback": "✅ 良い対応。フルネームと部屋タイプを提供しながら、確実でない部分は素直に認める。イギリス文化では、わかならないことを正直に認めることが誠実さと信頼につながります。",
            "feedbackEn": "✅ Good approach. Providing your name and room type while honestly acknowledging uncertainty builds trust. British culture values honesty over false confidence—staff will simply verify details without judgment.",
            "textJa": "ã¯ã„ã€ã‚µãƒˆãƒ¼ã§ã™ã€‚ãƒ™ãƒƒãƒ‰ãŒ2ã¤ã‚ã‚‹éƒ¨å±‹ã‚’äºˆç´„ã—ãŸã¨æ€ã„ã¾ã™ãŒã€ã¯ã£ãã‚Šè¦šãˆã¦ã„ã¾ã›ã‚“ã€‚"
          },
          {
            "text": "Yes, I have a reservation. My surname is Sato—could you look it up for me?",
            "correct": false,
            "feedback": "⚠️ 惜しい。丁寧で礼儀正しい対応です。ただしイギリスでは、フロント係が「探す」前に、こちらから詳細（部屋タイプ、滞在期間など）を先に伝えるとさらに効率的で高く評価されます。",
            "feedbackEn": "⚠️ Polite and courteous, but slightly passive. In UK hotels, it's more efficient to provide details (room type, dates) before asking staff to search. This shows you're considerate of their time.",
            "textJa": "ã¯ã„ã€äºˆç´„ã—ã¦ã„ã¾ã™ã€‚å§“ã¯ã‚µãƒˆãƒ¼ã§ã™ã€‚èª¿ã¹ã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ã‚ˆã†ã“ãï¼ã”äºˆç´„ã¯ã”ã–ã„ã¾ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "hotel",
        "avatar": "🏨",
        "name": "Receptionist",
        "text": "I do apologise — I can see you booked a twin but we've put you in a double. We're fully booked tonight.",
        "options": [
          {
            "text": "That's disappointing, but I understand. What options might work to resolve this?",
            "correct": true,
            "feedback": "✅ 英国文化的にベストです。失望を正直に伝えつつ、相手の状況を理解し、協調的に解決策を探す姿勢を示しています。英国では「相手を尊重した上で一緒に問題を解決する」というアプローチが最も評価されます。簡潔で誠実な表現がUKビジネス文化では信頼を生みます。",
            "feedbackEn": "Best UK approach. You honestly express disappointment while acknowledging their situation, then invite collaborative problem-solving. British culture values respect combined with practical solutions—this is perfectly balanced.",
            "textJa": "æ®‹å¿µã§ã™ãŒã€åˆ†ã‹ã‚Šã¾ã—ãŸã€‚è§£æ±ºç­–ã¨ã—ã¦ä½•ã‹ã‚ªãƒ—ã‚·ãƒ§ãƒ³ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I appreciate the honesty. Since you're fully booked, might compensation or an upgrade help resolve this?",
            "correct": false,
            "feedback": "⚠️ 非常に英国的で丁寧な対応です。相手への感謝と理解を示した上で、解決策を提案しています。ただ、こうした提案は「ホテルが先に提示する方が自然」な場面です。代わりに「What might you suggest?」と相手の提案を先に聞く方が、より協調的に映ります。",
            "feedbackEn": "Very British and polite, but slightly forward. Suggesting compensation yourself can seem presumptuous. Better to ask 'What solutions might work?' and let them propose options first—more collaborative.",
            "textJa": "æ­£ç›´ã«è¨€ã£ã¦ãã ã•ã£ã¦ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚æº€å®¤ã¨ã„ã†ã“ã¨ã§ã‚ã‚Œã°ã€è£œå„Ÿã‚„ã‚¢ãƒƒãƒ—ã‚°ãƒ¬ãƒ¼ãƒ‰ã§å¯¾å¿œã§ãã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "This is unacceptable. I demand an immediate refund or upgrade right now.",
            "correct": false,
            "feedback": "❌ 英国文化的に不適切です。相手が既に謝罪と状況説明をしているのに、「demand（強く要求）」という攻撃的な言葉を使うと、関係が悪化します。英国では感情的な反応より「問題解決への協力姿勢」が重視されます。同じ不満でも「understanding + solution-seeking」で伝えることが重要です。",
            "feedbackEn": "Not appropriate in UK culture. The hotel has already apologized; responding with 'demands' seems aggressive and damages the relationship. British business culture prioritizes collaborative problem-solving over emotional confrontation.",
            "textJa": "å—ã‘å…¥ã‚Œã‚‰ã‚Œã¾ã›ã‚“ã€‚ä»Šã™ãè¿”é‡‘ã‹ã‚¢ãƒƒãƒ—ã‚°ãƒ¬ãƒ¼ãƒ‰ã‚’ã—ã¦ãã ã•ã„ã€‚"
          }
        ],
        "textJa": "ç”³ã—è¨³ã‚ã‚Šã¾ã›ã‚“ã€‚ãƒ„ã‚¤ãƒ³ã‚’äºˆç´„ã„ãŸã ã„ã¦ãŠã‚Šã¾ã—ãŸãŒã€ãƒ€ãƒ–ãƒ«ã«ã”æ¡ˆå†…ã™ã‚‹ã“ã¨ã«ãªã‚Šã¾ã—ãŸã€‚ä»Šå¤œã¯æº€å®¤ã§ã™ã€‚"
      },
      {
        "speaker": "hotel",
        "avatar": "🏨",
        "name": "Receptionist",
        "text": "We'd like to offer you complimentary breakfast as an apology.",
        "options": [
          {
            "text": "That's very kind of you. I really appreciate the gesture and effort to make things right.",
            "correct": true,
            "feedback": "✅「very kind」「really appreciate」は英国人が誠意を示す際の典型表現です。相手の謝罪と補償を温かく受け入れ、その努力を認める姿勢が、英国ビジネス文化では相互尊重と信頼構築の基本となります。",
            "feedbackEn": "Perfect British response. 'Very kind' and 'really appreciate' demonstrate genuine warmth without exaggeration. This acknowledges their effort sincerely and maintains positive rapport—essential in UK culture for rebuilding trust after a service issue.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ãã®ã‚ˆã†ãªé…æ…®ã¨åŠªåŠ›ã«æœ¬å½“ã«æ„Ÿè¬ã—ã¾ã™ã€‚"
          },
          {
            "text": "That's very thoughtful. I don't usually eat breakfast—could I have a drinks voucher?",
            "correct": false,
            "feedback": "⚠️ 個人の食習慣を尊重しつつ、代替案を提案する交渉的なアプローチは実は良い姿勢です。ただし、ホテルが「謝罪」として朝食を提案している文脈では、まずそれを受け入れてから（「lovely, thank you」）、後で別途リクエストする方が英国的です。相手のジェスチャーを先に価値づけましょう。",
            "feedbackEn": "Polite and diplomatic, but slightly misses the cultural cue. When someone apologizes with a specific offer, British culture values accepting their gesture first, then making requests separately. Try: 'That's lovely—and would a drinks voucher be possible as well?' This shows you appreciate their effort while negotiating gracefully.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ã§ã‚‚æœé£Ÿã¯ã„ãŸã ã‹ãªã„ã®ã§ã€ãƒ‰ãƒªãƒ³ã‚¯ãƒã‚¦ãƒãƒ£ãƒ¼ã«ã§ãã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "That's decent of you. I'm happy with that arrangement—thanks for sorting it out.",
            "correct": false,
            "feedback": "⚠️「decent」は口語的で、やや軽い印象になります。また「happy with that」は前向きですが、「really appreciate」の方がより丁寧で相手の努力を認める感じが強いです。もっと温かみのある表現で相手に感謝を伝える方が、ホテルスタッフのモチベーション向上につながります。",
            "feedbackEn": "Casual and friendly, but 'decent' is somewhat informal for a service recovery situation. 'Really appreciate' is warmer and more formal-appropriate. While 'happy' is positive, adding emotional warmth ('I really appreciate your effort') makes the interaction more memorable and builds better ongoing rapport.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ãã®å¯¾å¿œã§å¤§ä¸ˆå¤«ã§ã™ã€‚è§£æ±ºã—ã¦ãã ã•ã£ã¦ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚"
          }
        ],
        "textJa": "ãŠè©«ã³ã¨ã—ã¦æœé£Ÿã‚’ç„¡æ–™ã§ã”æä¾›ã—ãŸã„ã¨æ€ã„ã¾ã™ã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: UK hotels respond well to polite complaints. 'I wonder if there's anything you can do' is more effective than demanding.",
    "tipJa": "🇬🇧 イギリスTip: 英国のホテルは丁寧なクレームに好意的に対応します。"
  },
  "conv_travel_transport": {
    "id": "conv_travel_transport",
    "title": "Using public transport",
    "titleJa": "公共交通機関の利用",
    "situation": "You're at a London Underground station. Your Oyster card isn't working at the gate.",
    "situationJa": "ロンドンの地下鉄駅にいます。オイスターカードがゲートで使えません。",
    "turns": [
      {
        "speaker": "staff",
        "avatar": "🚇",
        "name": "TfL Staff",
        "text": "Can I help you?",
        "options": [
          {
            "text": "Hi, yes please — my Oyster card doesn't seem to be working at the gate. Could you take a look?",
            "correct": true,
            "feedback": "✅ これは英国文化的にベストです。明確に状況を説明し、相手に丁寧に助けを求めています。「doesn't seem to be working」という表現は、相手の時間を尊重した控えめで親切な言い方です。ロンドン交通利用時の標準的な対応です。",
            "feedbackEn": "This is culturally perfect. You clearly explain the situation and politely ask for help. 'Doesn't seem to be working' shows respect for their time and maintains the collaborative tone typical in British interactions.",
            "textJa": "ã¯ã„ã€ãŠé¡˜ã„ã—ã¾ã™ã€‚ã‚ªã‚¤ã‚¹ã‚¿ãƒ¼ã‚«ãƒ¼ãƒ‰ãŒæ”¹æœ­ã§ä½¿ãˆãªã„ã‚“ã§ã™ãŒã€‚ç¢ºèªã—ã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Sorry, I'm having trouble getting through the gate — could you possibly help me sort it out?",
            "correct": false,
            "feedback": "✅ これも英国文化的に非常に良い対応です。「Sorry」で始まり、問題を一緒に解決する姿勢（'sort it out'）を示しています。英国では相手を巻き込む形での助言要求が好まれます。より親しみやすく、協調的に聞こえます。",
            "feedbackEn": "Equally excellent. Starting with 'Sorry' and using 'sort it out' shows collaborative problem-solving—very British. This approach builds rapport and positions the staff member as a helpful partner rather than a gatekeeper.",
            "textJa": "ã™ã¿ã¾ã›ã‚“ã€æ”¹æœ­ã‚’é€šã‚ã†ã¨ã—ã¦ã„ã‚‹ã®ã§ã™ãŒã€å›°ã£ã¦ã„ã¾ã™ã€‚åŠ©ã‘ã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "My Oyster card's not working at the barrier and I really need to get through urgently — could you just open the gate manually for me so I can catch my train?",
            "correct": false,
            "feedback": "⚠️ 惜しいです。実は「broken」は推測であり、単に残高不足かもしれません。また「need to get through now」は急きたいという気持ちは分かりますが、相手にプレッシャーを与えてしまいます。英国では相手の判断を尊重する表現（'Could you help?'「手伝ってもらえますか？」）が好まれます。",
            "feedbackEn": "Not ideal. 'Broken' is an assumption—it might just be low credit. Also, 'need to get through now' puts pressure on the staff member. British culture prefers respecting the other person's agency with phrases like 'Could you possibly...?' instead.",
            "textJa": "ã‚ªã‚¤ã‚¹ã‚¿ãƒ¼ã‚«ãƒ¼ãƒ‰ãŒæ”¹æœ­ã§ä½¿ãˆãªã„ã‚“ã§ã™ãŒã€æ€¥ã„ã§ã„ã‚‹ã®ã§æ‰‹å‹•ã§é–‹ã‘ã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿé›»è»Šã«ä¹—ã‚‰ãªã„ã¨ã„ã‘ãªã„ã‚“ã§ã™ã€‚"
          }
        ],
        "textJa": "ãŠæ‰‹ä¼ã„ã—ã¾ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "staff",
        "avatar": "🚇",
        "name": "TfL Staff",
        "text": "It looks like you have insufficient funds. You need at least £1.50 to travel.",
        "options": [
          {
            "text": "Right, no problem. Could you point me to where I can top up my card quickly?",
            "correct": true,
            "feedback": "✅ 「Right」で状況を受け入れ、具体的で丁寧な質問をしています。英国文化では問題が生じた時に感情的にならず、実行的な解決策を求める姿勢が高く評価されます。「Could you point me to」は相手に助言を求める自然で礼儀正しい表現で、英国のビジネス・日常コミュニケーションの典型です。",
            "feedbackEn": "✅ 'Right' shows acceptance of the situation. Asking 'Could you point me to' is polite and practical—very British when facing a minor setback. You're problem-solving calmly rather than explaining urgency, which is culturally valued.",
            "textJa": "åˆ†ã‹ã‚Šã¾ã—ãŸã€‚ã©ã“ã§ãƒãƒ£ãƒ¼ã‚¸ã§ãã‚‹ã‹æ•™ãˆã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Is there a ticket machine nearby where I can add credit to my card?",
            "correct": false,
            "feedback": "⚠️ 具体的で実用的な質問ですが、相手の助言を求める表現が弱めです。「Could you point me to」や「Where would you recommend」など、相手の知識や親切さを引き出す表現の方が、英国文化では「協力を求める」というニュアンスがより強くなり、より自然な会話になります。",
            "feedbackEn": "⚠️ Your question is practical and specific, but it misses the relational aspect. Asking 'Could you point me to...' or 'Where would you recommend...' shows you're inviting the helper's expertise. This collaborative tone is more naturally British.",
            "textJa": "è¿‘ãã«ã‚«ãƒ¼ãƒ‰ã«ãƒãƒ£ãƒ¼ã‚¸ã§ãã‚‹åˆ¸å£²æ©Ÿã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Oh, I see. Is there another payment method I could use instead of my card?",
            "correct": false,
            "feedback": "⚠️ 丁寧で落ち着いた質問ですが、相手が既に「カードへのチャージが必要」と指摘しているため、別の支払い方法を聞くことは実用的ではありません。むしろ「カードをチャージするなら、どこでできるか」と、現在の状況に基づいた解決策を聞く方が、相手の答えやすさと会話のスムーズさが増します。",
            "feedbackEn": "⚠️ While polite, asking about alternative payment methods doesn't address what the attendant just told you. They've indicated you need funds on your card—so ask where to top it up instead. This shows you've understood their point.",
            "textJa": "ãã†ã§ã™ã‹ã€‚ã‚«ãƒ¼ãƒ‰ã®ä»£ã‚ã‚Šã«ä»–ã®æ”¯æ‰•ã„æ–¹æ³•ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "æ®‹é«˜ãŒè¶³ã‚Šãªã„ã‚ˆã†ã§ã™ã€‚å°‘ãªãã¨ã‚‚1.50ãƒãƒ³ãƒ‰å¿…è¦ã§ã™ã€‚"
      },
      {
        "speaker": "staff",
        "avatar": "🚇",
        "name": "TfL Staff",
        "text": "There's a top-up machine just around the corner. Or you can tap your contactless bank card directly.",
        "options": [
          {
            "text": "Oh, that's really helpful! I didn't know contactless works here. Thanks so much!",
            "correct": true,
            "feedback": "✅ イギリス文化的にベスト。「really helpful」は英国人が日常で頻繁に使う自然な感謝表現です。新しい情報を学んだ喜びを素直に表現し、相手の親切に対して誠実に応答しています。相手との信頼関係を自然に構築できます。",
            "feedbackEn": "Perfect. 'Really helpful' is genuinely British and shows authentic appreciation. You acknowledge the useful tip and express genuine interest, which builds natural rapport—exactly how British conversations flow in practical situations.",
            "textJa": "æ•™ãˆã¦ã„ãŸã ã„ã¦ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼ã‚³ãƒ³ã‚¿ã‚¯ãƒˆãƒ¬ã‚¹ãŒä½¿ãˆã‚‹ã¨ã¯çŸ¥ã‚Šã¾ã›ã‚“ã§ã—ãŸã€‚æœ¬å½“ã«ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼"
          },
          {
            "text": "Brilliant! I'll give the contactless a try then. That sounds more convenient.",
            "correct": false,
            "feedback": "⚠️ 惜しい選択肢。「Brilliant」は英国で人気の表現で、提案を積極的に受け入れる姿勢も良いです。ただ、正解と比べると「新しい情報を学んだ」という感謝のニュアンスが弱いです。より英国的には「didn't know」と素直に驚きを示すことで、相手の提案の価値がより引き立ちます。",
            "feedbackEn": "Good choice. 'Brilliant' is very British and shows enthusiasm for the suggestion. However, compared to the best answer, it misses the element of genuine surprise at learning something new. Adding that note of discovery ('didn't know') makes the gratitude feel more sincere in British conversation.",
            "textJa": "ç´ æ™´ã‚‰ã—ã„ï¼ã§ã¯è©¦ã—ã¦ã¿ã¾ã™ã€‚ãã®æ–¹ãŒä¾¿åˆ©ãã†ã§ã™ã­ã€‚"
          },
          {
            "text": "I appreciate that. I'll stick with the top-up machine — it's familiar.",
            "correct": false,
            "feedback": "⚠️ 惜しい選択肢。個人の選好を丁寧に伝えており、失礼ではありません。しかし英国文化では、相手の提案に対してもう少し詳しく反応する方がより自然です。「I didn't know contactless works here」と新しい情報への興味を示すことで、相手の知識を価値あるものとして認識できます。",
            "feedbackEn": "Not wrong, but less ideal. While respectfully declining the suggestion is fine, British conversation typically involves more engagement with what the other person has offered. Acknowledging the contactless option as new information ('didn't know') would show more genuine interest in their local knowledge.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ãƒãƒ£ãƒ¼ã‚¸æ©Ÿã‚’ä½¿ã„ã¾ã™ã€‚æ…£ã‚Œã¦ã„ã‚‹ã®ã§ã€‚"
          }
        ],
        "textJa": "ãƒãƒ£ãƒ¼ã‚¸æ©ŸãŒè§’ã‚’æ›²ãŒã£ãŸã¨ã“ã‚ã«ã‚ã‚Šã¾ã™ã€‚ã¾ãŸã¯ã€ã‚³ãƒ³ã‚¿ã‚¯ãƒˆãƒ¬ã‚¹å¯¾å¿œã®éŠ€è¡Œã‚«ãƒ¼ãƒ‰ã‚’ã‚¿ãƒƒãƒã™ã‚‹ã ã‘ã§ä½¿ãˆã¾ã™ã‚ˆã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: In London, contactless bank cards work just like Oyster cards. On buses, cash is not accepted — card or Oyster only.",
    "tipJa": "🇬🇧 イギリスTip: ロンドンでは銀行カードのコンタクトレス払いがオイスターカードと同様に使えます。バスでは現金不可です。"
  },
  "conv_travel_pub": {
    "id": "conv_travel_pub",
    "title": "Ordering at a pub",
    "titleJa": "パブでの注文",
    "situation": "You're at a traditional British pub for the first time.",
    "situationJa": "初めて英国の伝統的なパブに来ました。",
    "turns": [
      {
        "speaker": "barstaff",
        "avatar": "🍺",
        "name": "Bar Staff",
        "text": "Hiya! What can I get you?",
        "options": [
          {
            "text": "Hi! Could I get a pint of bitter and what would you recommend for food today?",
            "correct": true,
            "feedback": "✅「Hiya」に対して「Hi」で返しカジュアルな雰囲気を保っています。「pint」と種類（bitter）を具体的に指定し、スタッフに食べ物のおすすめを聞くのはUKパブ文化で最も自然。信頼関係を築きながら楽しむスタイルで、バースタッフも好感を持ちます。",
            "feedbackEn": "Perfect pub etiquette. You respond casually to 'Hiya', specify drink clearly (pint + type), and ask for personal recommendations. This creates the friendly conversational tone staff genuinely appreciate and enjoy.",
            "textJa": "ã“ã‚“ã«ã¡ã¯ï¼ãƒ“ã‚¿ãƒ¼ã‚’ä¸€æ¯ã¨ã€ä»Šæ—¥ã®ãŠã™ã™ã‚æ–™ç†ã¯ä½•ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I'll have a pint of lager and could you suggest something from the menu?",
            "correct": false,
            "feedback": "⚠️ こちらも優れた応答です。「I'll have」は自然で、ビールの種類を明確に指定し、メニューについてスタッフの提案を求めています。ラガーはUKでも人気が高く全く問題ありません。より英国らしさを出すなら「bitter」や「ale」を選ぶとさらに現地的ですが、この答え方は十分自然です。",
            "feedbackEn": "Also very natural. 'I'll have' is conversational, you specify the drink type clearly, and ask for menu suggestions. Lager is perfectly popular in UK pubs. For extra UK flavour, bitter or ale are more traditionally British, but this is entirely fine.",
            "textJa": "ãƒ©ã‚¬ãƒ¼ã‚’ä¸€æ¯ã„ãŸã ãã¾ã™ã€‚ãƒ¡ãƒ‹ãƒ¥ãƒ¼ã‹ã‚‰ä½•ã‹ãŠã™ã™ã‚ã—ã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "A pint of bitter, please. What's your house special?",
            "correct": false,
            "feedback": "⚠️ サイズと種類の指定は完璧で、家のおすすめを聞く質問も良いです。ただ「Hi」や「Thanks」などの挨拶がないため、少し無愛想に聞こえます。「Hi! A pint of bitter, please. What's your house special?」と挨拶を加えるだけで、より親しみやすく英国らしくなります。",
            "feedbackEn": "Good specificity with pint + type and asking about house special. However, it lacks a greeting, which sounds slightly abrupt. Add 'Hi!' at the start to make it warmer and more naturally conversational: 'Hi! A pint of bitter, please. What's your house special?'",
            "textJa": "ãƒ“ã‚¿ãƒ¼ã‚’ä¸€æ¯ãŠé¡˜ã„ã—ã¾ã™ã€‚ãƒã‚¦ã‚¹ã®ã‚¹ãƒšã‚·ãƒ£ãƒ«ã¯ä½•ã§ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ã“ã‚“ã«ã¡ã¯ï¼ä½•ã«ãªã•ã„ã¾ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "barstaff",
        "avatar": "🍺",
        "name": "Bar Staff",
        "text": "The pie and chips is very popular. Are you eating at the bar or at a table?",
        "options": [
          {
            "text": "We've got a table reserved. Should I collect it from the bar or will you bring it over?",
            "correct": true,
            "feedback": "✅ テーブル席の予約を確認し、英国パブの一般的なサービスフロー（自分で取りに行く vs. スタッフが配膳する）について丁寧に質問しています。これはUKパブ文化を理解した自然な対応で、スタッフとの協力関係を示す配慮が見られます。",
            "feedbackEn": "Perfect! You're confirming your seating and asking politely about the service process. This shows genuine understanding of UK pub culture—clarifying whether to collect food yourself or wait for service demonstrates both awareness and consideration for staff workflow.",
            "textJa": "ãƒ†ãƒ¼ãƒ–ãƒ«ã‚’äºˆç´„ã—ã¦ã„ã¾ã™ã€‚ãƒãƒ¼ã§å–ã‚Šä¸Šã’ã¾ã™ã‹ã€æŒã£ã¦ãã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "At the table, please. What would you recommend as a local favourite here?",
            "correct": false,
            "feedback": "⚠️ テーブル席の希望は正解と同様に自然で、スタッフの意見を求める姿勢も良いです。ただし正解のように『どのようにして料理を受け取るか』という実務的な質問がないため、パブでの流れをやや理解していない可能性があります。より英国的には『テーブル席で』と述べた後、『自分で取りに行きますか、持ってきてくださいますか？』と確認するとより自然です。",
            "feedbackEn": "Good choice! Asking for a recommendation is very UK and shows you value their local knowledge. However, you're not clarifying the practical service model—in British pubs, it's important to ask upfront whether you collect your own order or they bring it. This would make your response more naturally UK.",
            "textJa": "ãƒ†ãƒ¼ãƒ–ãƒ«ã§ãŠé¡˜ã„ã—ã¾ã™ã€‚åœ°å…ƒã®ãŠæ°—ã«å…¥ã‚Šã¯ã©ã‚Œã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "At the bar is fine. Do you have any vegetarian or vegan options available?",
            "correct": false,
            "feedback": "⚠️ バーでの食事選択は完全に一般的で、食事制限についての質問も重要です。英国ではベジタリアン・ビーガン対応を事前に確認することは一般的な礼儀です。ただ、相手は既に『パイとチップス』を薦めているため、その代替選択肢について確認する形で『それはベジタリアン対応ですか？』と聞く方が、より会話の流れに沿っていた可能性があります。",
            "feedbackEn": "Sensible! Eating at the bar is very typical, and asking about dietary options is always appreciated in modern UK venues. However, since they just recommended a specific dish (pie and chips), asking whether that particular item suits your dietary needs might flow more naturally than asking about options in general.",
            "textJa": "ãƒãƒ¼ã§å¤§ä¸ˆå¤«ã§ã™ã€‚ãƒ™ã‚¸ã‚¿ãƒªã‚¢ãƒ³ã‚„ãƒ“ãƒ¼ã‚¬ãƒ³ã®ã‚ªãƒ—ã‚·ãƒ§ãƒ³ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ãƒ‘ã‚¤ã¨ãƒãƒƒãƒ—ã‚¹ãŒã¨ã¦ã‚‚äººæ°—ã§ã™ã€‚ãƒãƒ¼ã§ãŠå¬ã—ä¸ŠãŒã‚Šã§ã™ã‹ã€ãƒ†ãƒ¼ãƒ–ãƒ«ã§ã—ã‚‡ã†ã‹ï¼Ÿ"
      },
      {
        "speaker": "barstaff",
        "avatar": "🍺",
        "name": "Bar Staff",
        "text": "That's £14.50 please. Are you paying by card?",
        "options": [
          {
            "text": "Yes, card is fine. Just checking—is service included in that total or added separately?",
            "correct": true,
            "feedback": "✅ サービスチャージの確認は英国文化的に非常に自然です。透明性を重視する英国では、支払い前に料金体系を確認することは失礼ではなく、むしろ実用的で好感度が高いです。カジュアルな「Just checking!」のトーンも親しみやすく、バースタッフとの関係構築に適しています。",
            "feedbackEn": "✅ Asking about service charge is very natural in British culture. Confirming pricing details before payment shows you're practical and considerate. The casual 'Just checking!' tone is friendly and builds rapport with bar staff appropriately.",
            "textJa": "ã¯ã„ã€ã‚«ãƒ¼ãƒ‰ã§ã€‚ç¢ºèªã§ã™ãŒã€ã‚µãƒ¼ãƒ“ã‚¹æ–™ã¯å«ã¾ã‚Œã¦ã„ã¾ã™ã‹ã€ãã‚Œã¨ã‚‚åˆ¥é€”ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Card please. By the way, is the service charge already included or added to the bill?",
            "correct": false,
            "feedback": "⚠️ 「By the way」は少し他人事な印象を与えます。正解のように「Just checking」と言う方が、相手に対して協調的で親しみやすい雰囲気が生まれます。ただし質問内容自体は全く問題なく、英国文化的に自然です。",
            "feedbackEn": "⚠️ 'By the way' sounds slightly detached. Using 'Just checking' as in the correct answer feels more collaborative and warmer. The question itself is perfectly natural in British culture—just the tone could be friendlier.",
            "textJa": "ã‚«ãƒ¼ãƒ‰ã§ãŠé¡˜ã„ã—ã¾ã™ã€‚ã¨ã“ã‚ã§ã€ã‚µãƒ¼ãƒ“ã‚¹æ–™ã¯ã™ã§ã«å«ã¾ã‚Œã¦ã„ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Card works. I've heard London pubs are pricey—typical for this neighbourhood?",
            "correct": false,
            "feedback": "⚠️ 価格について話すこと自体は問題ありませんが、支払い時にバースタッフに「高い」と印象付けるのは気まずい雰囲気を作ります。価格の相場に興味があるなら、後で同僚や友人に聞く方が自然です。支払い時は「Card, please」とシンプルに進めるのがスムーズです。",
            "feedbackEn": "⚠️ Discussing price isn't wrong, but commenting on expensiveness to bar staff when paying can feel awkward. Better to ask colleagues or friends later about local prices. At the till, keeping it simple with 'Card, please' moves things along more smoothly.",
            "textJa": "ã‚«ãƒ¼ãƒ‰ã§å¤§ä¸ˆå¤«ã§ã™ã€‚ãƒ­ãƒ³ãƒ‰ãƒ³ã®ãƒ‘ãƒ–ã¯é«˜ã„ã¨èžãã¾ã—ãŸãŒã€ã“ã®è¾ºã‚Šã§ã¯æ™®é€šã§ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "14.50ãƒãƒ³ãƒ‰ã§ã™ã€‚ã‚«ãƒ¼ãƒ‰ã§ãŠæ”¯æ‰•ã„ã§ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: In a traditional pub, you order and pay at the bar — no table service. Tipping isn't mandatory at the bar.",
    "tipJa": "🇬🇧 イギリスTip: 伝統的なパブではバーで注文して支払います。バーでのチップは必須ではありません。"
  },
  "conv_travel_tourist": {
    "id": "conv_travel_tourist",
    "title": "At a tourist information centre",
    "titleJa": "観光案内所での質問",
    "situation": "You're at a tourist information centre in London.",
    "situationJa": "ロンドンの観光案内所にいます。",
    "turns": [
      {
        "speaker": "staff",
        "avatar": "🗺️",
        "name": "Tourist Info Staff",
        "text": "Hello! Welcome to London. How can I help?",
        "options": [
          {
            "text": "Hi! I'm interested in British history. Could you suggest some museums, and do I need to book tickets in advance?",
            "correct": true,
            "feedback": "✅ 興味分野を明確にしながら、具体的で実用的な質問をしています。ロンドンのツーリスト対応では、相手が答えやすいように「何に興味があるか」を先に示すのが英国流です。チケット予約についての質問も実践的で、ガイドとしても答えやすく、会話が自然に広がります。",
            "feedbackEn": "Perfect balance of specificity and openness. By sharing your interest first ('interested in history'), you make it easier for the guide to give relevant recommendations. This is very typical of British conversational style — showing interest before asking for help. The practical question about booking ahead shows good planning.",
            "textJa": "ã“ã‚“ã«ã¡ã¯ï¼è‹±å›½ã®æ­´å²ã«èˆˆå‘³ãŒã‚ã‚Šã¾ã™ã€‚åšç‰©é¤¨ã‚’æ•™ãˆã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿäº‹å‰ã«ãƒã‚±ãƒƒãƒˆã‚’äºˆç´„ã™ã‚‹å¿…è¦ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I'm here for three days. What are the must-see attractions you'd recommend for first-time visitors?",
            "correct": false,
            "feedback": "⚠️ 滞在期間を示すのは実用的で、ガイドが現実的なアドバイスを提供しやすくなります。ただ「must-see」は少し旅行ガイド的な印象で、より自然な聞き方は「What would you recommend?」や「Any highlights you'd suggest?」とより会話的にすると、英国流のカジュアルな雰囲気がでます。",
            "feedbackEn": "Good practical approach by mentioning your duration. However, 'must-see attractions' sounds a bit generic/guidebook-like. British conversation prefers a more informal tone — try 'What would you recommend?' or 'Any highlights I shouldn't miss?' to feel more conversational and less touristic.",
            "textJa": "3æ—¥é–“æ»žåœ¨ã—ã¾ã™ã€‚åˆã‚ã¦æ¥ã‚‹æ–¹ã¸ã®ãŠã™ã™ã‚è¦³å…‰ã‚¹ãƒãƒƒãƒˆã¯ã©ã“ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I'd like to explore some interesting neighbourhoods. Where would you recommend I spend time?",
            "correct": false,
            "feedback": "⚠️ 「地元の雰囲気」に興味があることを示しており、これは英国人的な観光スタイルと合致しています。ただこの質問だけでは、ガイドが何を勧めるべきか少し広すぎて判断しづらい可能性があります。「art galleries や markets に興味がある」など、さらに一つ具体的な興味を加えると、より会話が深まります。",
            "feedbackEn": "Good cultural instinct — seeking local neighbourhoods rather than just major sites shows genuine interest. However, the question is quite open-ended. Adding a specific interest helps the guide: 'I'd like to explore neighbourhoods with good independent shops and cafés' or 'any trendy areas with street art?' gives them clearer direction.",
            "textJa": "é¢ç™½ã„åœ°åŒºã‚’æŽ¢ç´¢ã—ãŸã„ã§ã™ã€‚ã©ã“ã§æ™‚é–“ã‚’éŽã”ã™ã“ã¨ã‚’ãŠå‹§ã‚ã—ã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ã“ã‚“ã«ã¡ã¯ï¼ãƒ­ãƒ³ãƒ‰ãƒ³ã¸ã‚ˆã†ã“ãã€‚ã©ã®ã‚ˆã†ãªã”ç”¨ä»¶ã§ã—ã‚‡ã†ã‹ï¼Ÿ"
      },
      {
        "speaker": "staff",
        "avatar": "🗺️",
        "name": "Tourist Info Staff",
        "text": "The British Museum is free and you don't need to book, but it can get very busy. I'd go early morning on a weekday.",
        "options": [
          {
            "text": "That's brilliant advice, thank you! What time would you recommend arriving?",
            "correct": true,
            "feedback": "✅「Brilliant」はイギリス人が頻繁に使う表現で、相手のアドバイスを心から称賛しています。具体的なフォローアップ質問で会話を自然に続け、英国文化での相手への尊重と興味が伝わります。",
            "feedbackEn": "'Brilliant' is quintessentially British and shows genuine appreciation. The specific follow-up question demonstrates active listening—highly valued in UK social culture and keeps the conversation flowing naturally.",
            "textJa": "ç´ æ™´ã‚‰ã—ã„ã‚¢ãƒ‰ãƒã‚¤ã‚¹ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼ä½•æ™‚é ƒè¡Œãã®ãŒã„ã„ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Thanks! I'll definitely go early on a weekday to avoid the crowds.",
            "correct": false,
            "feedback": "⚠️ 相手のアドバイスを受け入れる良い返答ですが、会話が終わってしまいます。英国では「これで終わり」と判断される可能性があります。フォローアップ質問を加えて「もっと話したい」という姿勢を見せるとより自然です。",
            "feedbackEn": "This is appreciative, but the conversation ends here. British social culture values continued dialogue and engagement. Adding a follow-up question like 'What time do you think?' keeps the interaction flowing and shows genuine interest.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼æ··é›‘ã‚’é¿ã‘ã‚‹ãŸã‚ã«å¹³æ—¥ã®æ—©æœã«è¡Œãã¾ã™ã€‚"
          },
          {
            "text": "Got it. Do I need to book in advance or just walk in when I arrive?",
            "correct": false,
            "feedback": "⚠️ 相手はすでに「予約不要」と述べているため、確認質問として少し冗長に聞こえます。ただし確認自体は英国では悪くありません。「So I can just turn up any time?」と簡潔に聞き直すか、違う側面を質問する方がスムーズです。",
            "feedbackEn": "The speaker already mentioned 'you don't need to book,' so this feels like you weren't fully listening. While asking for clarification is fine in British culture, rephrase to 'So I can just turn up?' or pivot to a new question like 'Which galleries are must-sees?' for better flow.",
            "textJa": "åˆ†ã‹ã‚Šã¾ã—ãŸã€‚äº‹å‰äºˆç´„ãŒå¿…è¦ã§ã™ã‹ã€ãã‚Œã¨ã‚‚å½“æ—¥ãã®ã¾ã¾å…¥ã‚Œã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "å¤§è‹±åšç‰©é¤¨ã¯ç„¡æ–™ã§ãƒã‚±ãƒƒãƒˆã®äºˆç´„ã‚‚ä¸è¦ã§ã™ãŒã€ã¨ã¦ã‚‚æ··é›‘ã™ã‚‹ã“ã¨ãŒã‚ã‚Šã¾ã™ã€‚å¹³æ—¥ã®æœæ—©ãã«è¡Œãã“ã¨ã‚’ãŠå‹§ã‚ã—ã¾ã™ã€‚"
      },
      {
        "speaker": "staff",
        "avatar": "🗺️",
        "name": "Tourist Info Staff",
        "text": "Take the Central line to Holborn — it's about a 5-minute walk from there. Can I give you a map?",
        "options": [
          {
            "text": "Yes please — that would be really helpful! Thank you so much.",
            "correct": true,
            "feedback": "✅ 相手の親切な申し出を素直に受け入れる返答で、英国文化的に非常に自然です。「Thank you」という感謝の言葉と「really helpful」という具体的な価値確認により、相手の努力を認める姿勢が示されます。この応答は会話を継続させ、関係を良好に保つ英国的コミュニケーションの典型です。",
            "feedbackEn": "Perfect response. Graciously accepting their offer shows respect and appreciation. In British culture, accepting help with genuine thanks maintains warm social rapport and encourages further assistance.",
            "textJa": "ã¯ã„ã€ãœã²ï¼æœ¬å½“ã«åŠ©ã‹ã‚Šã¾ã™ã€‚ã©ã†ã‚‚ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚"
          },
          {
            "text": "That's very kind of you, but I've got a map app on my phone already.",
            "correct": false,
            "feedback": "⚠️ 丁寧に断っていますが、相手の親切さを完全に拒否してしまいます。英国では相手の申し出を受け入れることで関係が深まります。もし地図が必要ないなら「Thanks for the offer! I'll check my phone, but appreciate it」のように相手の気遣いを褒めつつ返すほうが自然です。",
            "feedbackEn": "While polite, declining their offer entirely misses the opportunity to accept kindness. British culture values accepting help graciously. Better to say 'Cheers for offering! I'll give my phone a try' to acknowledge their generosity.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ã‚¹ãƒžãƒ¼ãƒˆãƒ•ã‚©ãƒ³ã«ãƒžãƒƒãƒ—ã‚¢ãƒ—ãƒªãŒã‚ã‚‹ã®ã§å¤§ä¸ˆå¤«ã§ã™ã€‚"
          },
          {
            "text": "Is it easy to find from Holborn station? I'm a bit worried I'll get lost.",
            "correct": false,
            "feedback": "⚠️ 不安を表現することは悪くありませんが、相手が既に詳しく説明してくれた後での質問です。この質問より先に「Yes, thank you for the map」と受け入れ、その後に懸念を述べるほうが自然で、相手の努力を尊重する流れになります。",
            "feedbackEn": "Expressing concern isn't wrong, but asking after they've already explained creates an impression of not listening. It's better to accept the map first with thanks, then ask follow-up questions if needed—this shows you valued their initial help.",
            "textJa": "ãƒ›ãƒ«ãƒœãƒ¼ãƒ³é§…ã‹ã‚‰åˆ†ã‹ã‚Šã‚„ã™ã„ã§ã™ã‹ï¼Ÿè¿·å­ã«ãªã‚Šãã†ã§å°‘ã—å¿ƒé…ã§ã™ã€‚"
          }
        ],
        "textJa": "ã‚»ãƒ³ãƒˆãƒ©ãƒ«ç·šã§ãƒ›ãƒ«ãƒœãƒ¼ãƒ³ã¾ã§è¡Œã‘ã°ã€ãã“ã‹ã‚‰å¾’æ­©ç´„5åˆ†ã§ã™ã€‚åœ°å›³ã‚’ãŠæŒã¡ã«ãªã‚Šã¾ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: Most major London museums are free. Temporary exhibitions often charge. Book popular exhibitions in advance.",
    "tipJa": "🇬🇧 イギリスTip: ロンドンの主要博物館はほとんど無料です。特別展は有料の場合が多いです。"
  },
  "conv_travel_taxi": {
    "id": "conv_travel_taxi",
    "title": "Taking a taxi or Uber",
    "titleJa": "タクシー・Uberの利用",
    "situation": "You're taking a black cab in London to Heathrow Airport.",
    "situationJa": "ロンドンのブラックキャブに乗っています。ヒースロー空港に向かいます。",
    "turns": [
      {
        "speaker": "driver",
        "avatar": "🚕",
        "name": "Cab Driver",
        "text": "Where to, mate?",
        "options": [
          {
            "text": "Heathrow Terminal 3, please. I have a flight at 2pm, so quickest route would be great, mate.",
            "correct": true,
            "feedback": "✅ ターミナル指定、時間制約、そしてドライバーへの丁寧な依頼が全て含まれている英国タクシー文化のベストプラクティスです。時間情報を事前に伝えることで、ドライバーが最適なルートを判断でき、英国のプロフェッショナルなコミュニケーション文化に沿っています。",
            "feedbackEn": "✅ This is the gold standard for UK taxi communication. You specify the terminal, communicate your time constraint naturally, and respectfully ask for the fastest route. British drivers appreciate this transparency—it helps them navigate strategically and shows you value their expertise.",
            "textJa": "ãƒ’ãƒ¼ã‚¹ãƒ­ãƒ¼ç©ºæ¸¯ç¬¬3ã‚¿ãƒ¼ãƒŸãƒŠãƒ«ã¾ã§ãŠé¡˜ã„ã—ã¾ã™ã€‚åˆå¾Œ2æ™‚ã®ãƒ•ãƒ©ã‚¤ãƒˆãŒã‚ã‚‹ã®ã§ã€ã§ãã‚Œã°æœ€çŸ­ãƒ«ãƒ¼ãƒˆã§ãŠé¡˜ã„ã—ã¾ã™ã€‚"
          },
          {
            "text": "Heathrow please — Terminal 3, and step on it if you can. I'm running a bit late and my flight's at two, so I really need to make good time on the way there.",
            "correct": false,
            "feedback": "✅ 完全にイギリス的で自然な応答です。ターミナル指定も明確で、「mate」を返す親しみやすい姿勢は英国タクシー文化そのものです。ただ時間情報がないため、ドライバーがルート選択時に優先順位を判断しにくい点が惜しいです。「I've got a flight at 2」と一言加えるとさらに良くなります。",
            "feedbackEn": "✅ Very natural and properly British—you mirror 'mate' back and specify the terminal clearly. The only minor gap: without mentioning your flight time, the driver doesn't know whether to prioritize speed. Adding 'I've got a flight at 2' would make this excellent.",
            "textJa": "ãƒ’ãƒ¼ã‚¹ãƒ­ãƒ¼ç©ºæ¸¯ç¬¬3ã‚¿ãƒ¼ãƒŸãƒŠãƒ«ã¾ã§ãŠé¡˜ã„ã—ã¾ã™ã€‚å°‘ã—é…ã‚Œã¦ã„ã‚‹ã®ã§æ€¥ã„ã§ã„ãŸã ã‘ã‚‹ã¨åŠ©ã‹ã‚Šã¾ã™ã€‚åˆå¾Œ2æ™‚ã®ãƒ•ãƒ©ã‚¤ãƒˆã§ã™ã€‚"
          },
          {
            "text": "Heathrow Airport please, Terminal 3 — and I'll sort you out with a good tip if we can avoid the traffic and get there a bit sharpish.",
            "correct": false,
            "feedback": "⚠️ 丁寧で明確ですが、やや形式的でカジュアルさが足りません。英国のタクシー文化は「mate」という親しみやすい呼びかけに対して、同じトーンで返すことを期待しています。「Thanks」や「mate」を加えるか、「that would be great」など温かみを加えると、より英国らしいラポールが生まれます。",
            "feedbackEn": "⚠️ Clear and polite, but slightly formal. British cab culture thrives on mutual friendliness—when a driver says 'mate,' they expect warmth back. Without a 'thanks' or 'mate' in return, you might come across as distant. Adding 'Thanks!' or 'cheers, mate' would match the conversational tone better.",
            "textJa": "ãƒ’ãƒ¼ã‚¹ãƒ­ãƒ¼ç©ºæ¸¯ç¬¬3ã‚¿ãƒ¼ãƒŸãƒŠãƒ«ã¾ã§ãŠé¡˜ã„ã—ã¾ã™ã€‚æ¸‹æ»žã‚’é¿ã‘ã¦æ—©ã‚ã«ç€ã‘ãŸã‚‰ã€ã„ã„ãƒãƒƒãƒ—ã‚’å‡ºã—ã¾ã™ã‚ˆã€‚"
          }
        ],
        "textJa": "ã©ã¡ã‚‰ã¾ã§ï¼Ÿ"
      },
      {
        "speaker": "driver",
        "avatar": "🚕",
        "name": "Cab Driver",
        "text": "Traffic's heavy on the M4 today — might take 45 minutes. Is that okay?",
        "options": [
          {
            "text": "Thanks for the heads-up. My flight's at 2pm, so 45 minutes works fine. Let's go.",
            "correct": true,
            "feedback": "✅ ドライバーの情報を感謝しながら受け入れ、自分の状況を簡潔に伝える対応。英国では相手の専門知識を信頼し、無理な催促をしない姿勢が重視されます。実用的かつ丁寧です。",
            "feedbackEn": "Perfect! You acknowledge the driver's expertise, share your constraint factually, and accept their judgment. This shows trust and respect—exactly what British communication culture values. Direct yet collaborative.",
            "textJa": "æ•™ãˆã¦ã„ãŸã ã„ã¦ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚åˆå¾Œ2æ™‚ã®ãƒ•ãƒ©ã‚¤ãƒˆãªã®ã§45åˆ†ã§å¤§ä¸ˆå¤«ã§ã™ã€‚è¡Œãã¾ã—ã‚‡ã†ã€‚"
          },
          {
            "text": "That's tight for my schedule. Do you reckon there's a quicker route we could take instead?",
            "correct": false,
            "feedback": "⚠️ ドライバーの判断に頼りながら代替ルートを提案する点は良いのですが、状況によっては時間に余裕があれば不要です。ただし、本当に急いでいる場合は「Do you reckon...?」という親しみやすい表現は効果的。相手の判断を尊重しつつ相談するトーンは英国的です。",
            "feedbackEn": "Nice try! 'Do you reckon' is very British and colloquial—shows politeness and collaboration. However, if 45 minutes actually works for your schedule, this creates unnecessary pressure. Only use if you're genuinely tight on time.",
            "textJa": "å°‘ã—ã‚¿ã‚¤ãƒˆã§ã™ã­ã€‚åˆ¥ã®ãƒ«ãƒ¼ãƒˆã¯ã‚ã‚Šã¾ã›ã‚“ã‹ï¼Ÿ"
          },
          {
            "text": "No worries. Just take your usual route—I'm not in any rush today.",
            "correct": false,
            "feedback": "⚠️ ドライバーの判断を完全に信頼し、リラックスした対応は英国的で好印象です。ただし、実際には「45分で間に合う」という時間的な制約がある場合、この返答では相手に正確な情報が伝わりません。より正直に状況を伝えることが、英国文化では信頼構築に繋がります。",
            "feedbackEn": "Good rapport, but incomplete information-sharing! If you do have a time constraint, keeping it private might seem evasive. British culture values honesty and factual exchange—letting the driver know your actual situation helps them serve you better.",
            "textJa": "å¤§ä¸ˆå¤«ã§ã™ã‚ˆã€‚ã„ã¤ã‚‚ã®ãƒ«ãƒ¼ãƒˆã§è¡Œã£ã¦ãã ã•ã„ã€‚æ€¥ã„ã§ã„ãªã„ã®ã§ã€‚"
          }
        ],
        "textJa": "ä»Šæ—¥ã¯M4ãŒæ··ã‚“ã§ã„ã¦45åˆ†ã‹ã‹ã‚‹ã‹ã‚‚ã—ã‚Œã¾ã›ã‚“ã€‚å¤§ä¸ˆå¤«ã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "driver",
        "avatar": "🚕",
        "name": "Cab Driver",
        "text": "That'll be £68, please.",
        "options": [
          {
            "text": "Here you go — shall I just tap the card?",
            "correct": true,
            "feedback": "✅ Black cabではContactless paymentが標準的で、運転手もカード支払いを期待しています。簡潔で自然な支払い提案で、スムーズな取引ができます。",
            "feedbackEn": "Contactless card payment is standard in London black cabs. This response is efficient, polite, and shows familiarity with UK payment culture. The driver will appreciate the directness.",
            "textJa": "ã¯ã„ã€ã‚«ãƒ¼ãƒ‰ã§ã‚¿ãƒƒãƒã—ã¦ã‚‚ã„ã„ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "That seems quite steep — what's included in the fare?",
            "correct": false,
            "feedback": "⚠️ 金額に疑問を持つこと自体は問題ありませんが、Heathrow等への移動は実際に高いのが正常です。「steep」という単語は英国的ですが、ここではタクシー料金は正規メーター制なので質問すると不信感を与えます。代わりに「I didn't realize it would be that much」と理解を示す方が良いでしょう。",
            "feedbackEn": "While 'steep' is appropriately British language, questioning the fare at the end of a metered journey (especially to/from Heathrow) can seem suspicious. Black cab fares are licensed and transparent. Better to accept the fare gracefully.",
            "textJa": "å°‘ã—é«˜ããªã„ã§ã™ã‹ï¼Ÿæ–™é‡‘ã«ã¯ä½•ãŒå«ã¾ã‚Œã¦ã„ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Cash works fine — do you have change for a £100 note?",
            "correct": false,
            "feedback": "⚠️ 現金払いは全く問題ありませんが、英国タクシー文化では「change for a £100 note」と聞くことは不親切です。運転手が常に多額の釣銭を用意しているとは限りません。代わりに「Can I pay with card instead?」または小さな現金を提示する方がスムーズです。",
            "feedbackEn": "Cash is absolutely acceptable, but asking for change from a £100 note can be awkward for the driver. Taxis don't always carry large float. Better to offer a card alternative or ask 'Do you have change?' first without specifying the note.",
            "textJa": "ç¾é‡‘ã§ã„ã„ã§ã™ã‹ï¼Ÿ100ãƒãƒ³ãƒ‰æœ­ã®ãŠé‡£ã‚Šã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "68ãƒãƒ³ãƒ‰ã«ãªã‚Šã¾ã™ã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: London black cabs are metered and licensed. Always state the terminal. Tipping 10% is appreciated. The Elizabeth line is the cheapest way to Heathrow.",
    "tipJa": "🇬🇧 イギリスTip: ロンドンのブラックキャブはメーター制で認可済み。必ずターミナルを指定。中心部からヒースローへはエリザベス線が最安です。"
  },
  "conv_travel_airport": {
    "id": "conv_travel_airport",
    "title": "Arriving at UK border control",
    "titleJa": "英国の入国審査",
    "situation": "You're arriving at Heathrow for a business trip.",
    "situationJa": "出張でヒースローに到着。英国国境警備隊のデスクにいます。",
    "turns": [
      {
        "speaker": "officer",
        "avatar": "🛂",
        "name": "Border Force Officer",
        "text": "Passport please. What's the purpose of your visit?",
        "options": [
          {
            "text": "Business. I'm attending a conference in London for three days.",
            "correct": true,
            "feedback": "✅ イミグレーション担当官が期待する標準的な回答です。目的（Business）、活動内容（conference）、滞在期間が明確で、簡潔かつ専門的です。入国審査では余計な説明を避け、具体的な事実だけを述べるのがUKスタイルです。",
            "feedbackEn": "✅ This is the standard response UK border officials expect. Clear purpose, specific activity, and duration stated concisely. Immigration officers appreciate straightforward, factual answers without elaboration.",
            "textJa": "ãƒ“ã‚¸ãƒã‚¹ã§ã™ã€‚ãƒ­ãƒ³ãƒ‰ãƒ³ã§3æ—¥é–“ã®ä¼šè­°ã«å‚åŠ ã—ã¾ã™ã€‚"
          },
          {
            "text": "I'm visiting to work with a company here for several weeks.",
            "correct": false,
            "feedback": "⚠️ 「work with a company」は雇用関係を示唆し、労働ビザの有無について疑問を招きます。代わりに「attending business meetings」や「visiting for a conference」と言う方が、短期訪問の意図がより明確です。",
            "feedbackEn": "⚠️ 'Work with a company' suggests employment and may trigger visa status questions. For short visits, use 'attending meetings' or 'conference' instead—it's clearer about your temporary status.",
            "textJa": "ã“ã¡ã‚‰ã®ä¼šç¤¾ã¨æ•°é€±é–“ä»•äº‹ã‚’ã™ã‚‹ãŸã‚ã«è¨ªã‚Œã¦ã„ã¾ã™ã€‚"
          },
          {
            "text": "Tourism and business combined, but I'm mostly interested in sightseeing.",
            "correct": false,
            "feedback": "⚠️ 複数の目的を混在させると、どちらが本当の理由なのか不明瞭に見えます。入国審査官は「主な目的は何か」を一つ確認したいのです。曖昧な回答は追加質問を招きやすいため、目的を一つに絞りましょう。",
            "feedbackEn": "⚠️ Mixing multiple purposes seems unclear to officials. Keep your primary purpose focused and single. Vague answers prompt more questions—border officers prefer straightforward clarity.",
            "textJa": "è¦³å…‰ã¨ãƒ“ã‚¸ãƒã‚¹ã‚’å…¼ã­ã¦ã„ã¾ã™ãŒã€ä¸»ã«è¦³å…‰ã§ã™ã€‚"
          }
        ],
        "textJa": "ãƒ‘ã‚¹ãƒãƒ¼ãƒˆã‚’ãŠè¦‹ã›ãã ã•ã„ã€‚æ¸¡èˆªç›®çš„ã¯ä½•ã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "officer",
        "avatar": "🛂",
        "name": "Border Force Officer",
        "text": "Where will you be staying?",
        "options": [
          {
            "text": "I'm staying at the Marriott in Canary Wharf. I have my booking confirmation here.",
            "correct": true,
            "feedback": "✅ 具体的なホテル名と場所を明確に述べ、予約確認書を用意している点が英国式。入国審査では「確実な滞在先がある」という信頼が最も重要で、この答え方は官僚的プロセスを尊重しています。",
            "feedbackEn": "Excellent UK approach. Specific accommodation + concrete evidence of booking demonstrates preparedness. Immigration officials expect this level of clarity and documentation—it shows respect for entry procedures.",
            "textJa": "ã‚«ãƒŠãƒªãƒ¼ãƒ¯ãƒ¼ãƒ•ã®ãƒžãƒªã‚ªãƒƒãƒˆãƒ›ãƒ†ãƒ«ã§ã™ã€‚äºˆç´„ç¢ºèªæ›¸ã‚’æŒã£ã¦ã„ã¾ã™ã€‚"
          },
          {
            "text": "I'm staying with a friend in South London. I have their address written down.",
            "correct": false,
            "feedback": "✅ 友人宅滞在は英国では一般的です。重要なのは「具体的な住所を把握している」と示すこと。事前に友人の正確な住所を確認しておく姿勢が、入国審査官に信頼感を与えます。",
            "feedbackEn": "Perfectly acceptable in the UK. Friends and family accommodation is very common. The key is demonstrating you have a specific, confirmed address—this shows you've made proper arrangements.",
            "textJa": "ã‚µã‚¦ã‚¹ãƒ­ãƒ³ãƒ‰ãƒ³ã®å‹äººã®ã¨ã“ã‚ã«æ³Šã¾ã‚Šã¾ã™ã€‚ä½æ‰€ã‚’æŽ§ãˆã¦ã„ã¾ã™ã€‚"
          },
          {
            "text": "I'm planning to stay in a hostel in central London for the first week.",
            "correct": false,
            "feedback": "⚠️ 「計画している」というフレーズが曖昧に聞こえます。実際に「予約済み」か「具体的なホテル名と住所が決定している」状態が入国審査では必須です。「I've booked...」や「I'm staying at...」と具体的かつ確定形で述べましょう。",
            "feedbackEn": "Not quite ideal. 'Planning to stay' sounds uncertain—immigration wants confirmed accommodation. Better to say 'I've booked a hostel at [specific name]' or provide the exact address. Definite arrangements are expected.",
            "textJa": "æœ€åˆã®1é€±é–“ã¯ã‚»ãƒ³ãƒˆãƒ©ãƒ«ãƒ­ãƒ³ãƒ‰ãƒ³ã®ãƒ›ã‚¹ãƒ†ãƒ«ã«æ³Šã¾ã‚‹äºˆå®šã§ã™ã€‚"
          }
        ],
        "textJa": "ã©ã“ã«æ»žåœ¨ã•ã‚Œã‚‹äºˆå®šã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "officer",
        "avatar": "🛂",
        "name": "Border Force Officer",
        "text": "How long are you planning to stay?",
        "options": [
          {
            "text": "Three nights — I'm flying back to Japan on Thursday evening.",
            "correct": true,
            "feedback": "✅ 具体的な日程と出国日を明確に述べています。入国審査官は滞在期間と帰国予定を確認する必要があり、このような直接的で計画的な返答は信頼感を与えます。イギリス文化では「明確さと正確さ」が重視されます。",
            "feedbackEn": "✅ This gives specific dates and a clear departure date. UK border control values clarity and demonstrates you have organized plans, which is the expected professional approach at immigration.",
            "textJa": "3æ³Šã§ã™ã€‚æœ¨æ›œæ—¥ã®å¤•æ–¹ã«æ—¥æœ¬ã¸å¸°ã‚Šã¾ã™ã€‚"
          },
          {
            "text": "About two weeks, assuming my plans don't change significantly.",
            "correct": false,
            "feedback": "✅ 計画に柔軟性があることを示しつつ、基本的な滞在期間は明確にしています。イギリス人は「現実的で正直な」返答を評価します。完全な予定の変更可能性を隠す必要はなく、むしろ透明性が信頼につながります。",
            "feedbackEn": "✅ This shows honesty about potential flexibility while providing a clear timeframe. British people appreciate realistic and straightforward answers—acknowledging plans might shift is seen as honest rather than evasive.",
            "textJa": "ç´„2é€±é–“ã§ã™ã€äºˆå®šãŒå¤§ããå¤‰ã‚ã‚‰ãªã‘ã‚Œã°ã€‚"
          },
          {
            "text": "I'm not entirely sure yet, but probably around ten days or so.",
            "correct": false,
            "feedback": "⚠️ 不確実性を正直に認めながらも、概算の期間を示している点は良いです。ただし「around」や「or so」を多用すると、計画性が低いと見なされることがあります。もし本当に未定なら、'I'm still deciding, but I'm planning for approximately ten days'と、より確実な表現にするとより良いでしょう。",
            "feedbackEn": "⚠️ Honesty about uncertainty is appreciated, but 'around' and 'or so' can suggest lack of planning. Consider: 'I'm still deciding, but I'm aiming for around ten days' to sound more organized while remaining honest about flexibility.",
            "textJa": "ã¾ã ã¯ã£ãã‚Šåˆ†ã‹ã‚Šã¾ã›ã‚“ãŒã€ãŠãã‚‰ã10æ—¥ã»ã©ã§ã™ã€‚"
          }
        ],
        "textJa": "æ»žåœ¨æœŸé–“ã¯ã©ã®ãã‚‰ã„ã§ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: UK border officers expect clear, direct answers. Never say you're 'working' on a visitor visa. Have hotel details and return flight ready.",
    "tipJa": "🇬🇧 イギリスTip: ビジター査証で「働く」とは絶対に言わないこと。ホテル詳細と帰りのフライトを準備しておきましょう。"
  },
  "conv_culture_holidays": {
    "id": "conv_culture_holidays",
    "title": "Christmas & British customs",
    "titleJa": "クリスマスと英国の習慣",
    "situation": "A UK colleague asks about your Christmas plans in mid-December.",
    "situationJa": "12月中旬、英国の同僚にクリスマスの予定を聞かれました。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "🎄",
        "name": "Emma",
        "text": "So are you staying in London for Christmas or heading home to Japan?",
        "options": [
          {
            "text": "I'm staying here — first Christmas in the UK! What do British people usually do to celebrate?",
            "correct": true,
            "feedback": "✅ 英国滞在を選びながら、相手の文化や経験に対する真摯な興味を示しています。この質問スタイルは英国式の自然な会話展開で、相手も話しやすくなり、文化交流の好機につながります。相手が自分の経験を語る『聞き上手』な姿勢が、英国コミュニケーションでは非常に好まれます。",
            "feedbackEn": "Perfect balance: you confirm you're staying while showing genuine curiosity about their traditions. Asking questions about their experience is quintessentially British and invites natural cultural exchange. This 'listener-first' approach builds rapport effectively.",
            "textJa": "ã“ã“ã«ã„ã¾ã™ï¼è‹±å›½ã§åˆã‚ã¦ã®ã‚¯ãƒªã‚¹ãƒžã‚¹ã§ã™ï¼è‹±å›½äººã¯æ™®é€šã©ã†ã‚„ã£ã¦ç¥ã†ã‚“ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Heading back to Japan, but I'd love to experience a UK Christmas next year. What's really unmissable?",
            "correct": false,
            "feedback": "⚠️ 帰国という選択は全く問題ありません。ただし「unmissable」という強い表現は少し急かすような印象を与えます。代わりに「What would you recommend?」や「What's special about Christmas here?」など、相手の好意に委ねる言い方がより英国的です。相手に教えてもらう姿勢を柔らかく示しましょう。",
            "feedbackEn": "Going home is perfectly valid. However, 'unmissable' sounds slightly demanding. More British to ask 'What would you recommend?' or 'What makes it special?' which shows appreciation without pressure and invites them to share warmly.",
            "textJa": "æ—¥æœ¬ã«å¸°ã‚Šã¾ã™ã€‚ã§ã‚‚æ¥å¹´ã¯è‹±å›½ã®ã‚¯ãƒªã‚¹ãƒžã‚¹ã‚’çµŒé¨“ã—ãŸã„ã§ã™ã€‚çµ¶å¯¾ã«å¤–ã›ãªã„ã“ã¨ã¯ä½•ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I'm not celebrating Christmas this year, but I'm curious how you usually spend it. Any British traditions I should know about?",
            "correct": false,
            "feedback": "⚠️ クリスマスを祝わないという個人的な選択は尊重されます。ただ「I'm not celebrating」と最初に否定形で述べると、話の重みが重くなります。「I'm spending it differently」や「Not my celebration, but...」と言い換えると、より自然で相手も応答しやすくなります。その後の質問は素晴らしいです。",
            "feedbackEn": "Not celebrating is fine, but leading with 'not celebrating' can feel heavy. Try 'I'm spending it differently' or 'Not my tradition, but I'm curious...' — this sounds lighter and invites conversation more naturally without emphasizing what you're NOT doing.",
            "textJa": "ä»Šå¹´ã¯ã‚¯ãƒªã‚¹ãƒžã‚¹ã‚’ç¥ã„ã¾ã›ã‚“ãŒã€æ™®æ®µã©ã†éŽã”ã™ã®ã‹èˆˆå‘³ãŒã‚ã‚Šã¾ã™ã€‚è‹±å›½ã®ä¼çµ±ã§çŸ¥ã£ã¦ãŠãã¹ãã“ã¨ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ã‚¯ãƒªã‚¹ãƒžã‚¹ã¯ãƒ­ãƒ³ãƒ‰ãƒ³ã«ã„ã¾ã™ã‹ã€ãã‚Œã¨ã‚‚æ—¥æœ¬ã«å¸°ã‚Šã¾ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "🎄",
        "name": "Emma",
        "text": "Oh brilliant! You have to pull a cracker and wear the paper hat — it's ridiculous but we all do it!",
        "options": [
          {
            "text": "Ha! That sounds wonderfully British. I'll definitely give it a go!",
            "correct": true,
            "feedback": "✅ ユーモアを持ってイギリスの伝統を受け入れる態度が完璧です。'wonderfully British'という表現は相手の文化への敬意と親しみやすさを同時に示し、UKの自分たちの習慣を少し自嘲的に見る文化的スタイルに共鳴しています。",
            "feedbackEn": "Perfect! You embrace the tradition with humour and genuine interest. 'Wonderfully British' shows respect for local culture while matching the speaker's self-aware, slightly ironic tone about their own traditions.",
            "textJa": "é¢ç™½ã„ï¼ãªã‚“ã¦è‹±å›½ã‚‰ã—ã„ã‚“ã§ã—ã‚‡ã†ã€‚ãœã²ã‚„ã£ã¦ã¿ã¾ã™ï¼"
          },
          {
            "text": "What exactly is a cracker? I'd love to understand the tradition better.",
            "correct": false,
            "feedback": "✅ これも素晴らしい対応です。質問を通じて相手の文化への本当の興味を示しています。'I'd love to understand'というフレーズは礼儀正しく、イギリス人が相手の好奇心を高く評価する点を理解している表現です。",
            "feedbackEn": "Equally good! Asking genuine questions shows interest and respect. 'I'd love to understand the tradition' is polite and engages the speaker further, which British culture values highly in conversation.",
            "textJa": "ã‚¯ãƒ©ãƒƒã‚«ãƒ¼ã£ã¦ä½•ã§ã™ã‹ï¼Ÿä¼çµ±ã«ã¤ã„ã¦è©³ã—ãçŸ¥ã‚ŠãŸã„ã§ã™ã€‚"
          },
          {
            "text": "That does sound a bit unusual, but I'm keen to try it anyway!",
            "correct": false,
            "feedback": "✅ 良い対応です。'unusual'と認めながらも、参加する意欲を示しているバランスが取れています。イギリス文化では、変わったことを認めつつもポジティブに参加する態度が好まれます。",
            "feedbackEn": "Good approach! You acknowledge it's unusual (honest) while showing enthusiasm ('I'm keen to try'). This balance reflects British cultural values of honest reactions paired with good-natured participation.",
            "textJa": "å°‘ã—å¤‰ã‚ã£ã¦ã„ã‚‹ã‚ˆã†ã«èžã“ãˆã¾ã™ãŒã€è©¦ã—ã¦ã¿ãŸã„ã§ã™ï¼"
          }
        ],
        "textJa": "ç´ æ™´ã‚‰ã—ã„ï¼ã‚¯ãƒ©ãƒƒã‚«ãƒ¼ã‚’å¼•ã„ã¦ç´™ã®å¸½å­ã‚’ã‹ã¶ã‚‹ã“ã¨ã¯çµ¶å¯¾ã«ã‚„ã£ã¦ãã ã•ã„ã€‚é¦¬é¹¿ã’ã¦ã„ã‚‹ã‘ã©ã€ã¿ã‚“ãªã‚„ã‚‹ã‚“ã§ã™ï¼"
      },
      {
        "speaker": "colleague",
        "avatar": "🎄",
        "name": "Emma",
        "text": "We're having a team Secret Santa this week — did you get the email?",
        "options": [
          {
            "text": "Yes! I got Sarah — any ideas what she might like? I want to get something thoughtful.",
            "correct": true,
            "feedback": "✅「Yes!」で参加意思を明確に示し、「ideas」を求めることで相手との会話を広げます。英国職場文化では、Secret Santaは同僚との絆を深める重要な儀式。自分で考えるだけでなく同僚の意見を聞く姿勢が、協調性とhumble（謙虚さ）を示し、非常にイギリス的です。",
            "feedbackEn": "✅ Showing clear participation and asking for colleague input is perfect. In UK workplace culture, Secret Santa is a bonding ritual. Seeking others' opinions demonstrates both collaboration and the British value of being humble—you're not assuming you know best.",
            "textJa": "ã¯ã„ï¼ã‚µãƒ©ã‚’æ‹…å½“ã—ã¾ã—ãŸã€‚å½¼å¥³ãŒå–œã³ãã†ãªã‚‚ã®ã¯ä½•ã‹ã‚¢ã‚¤ãƒ‡ã‚¢ã‚ã‚Šã¾ã™ã‹ï¼Ÿå¿ƒã‚’è¾¼ã‚ãŸã‚‚ã®ã‚’è´ˆã‚ŠãŸã„ã§ã™ã€‚"
          },
          {
            "text": "Oh yes, I got someone! I'm thinking of getting them a nice mug or some chocolates.",
            "correct": false,
            "feedback": "✅「I got someone」で参加を肯定し、具体的な検討品を挙げることで積極的な姿勢が伝わります。Secret Santaはカジュアルな楽しみであり、このような素朴で誠実な返答は英国的です。新しい同僚や参加初心者の自然な応答としても最適です。",
            "feedbackEn": "✅ This shows genuine participation with a concrete, thoughtful approach. Secret Santa is meant to be fun and casual—mugs and chocolates are quintessentially British gift choices. This response feels honest and warm, especially good for newcomers or first-time participants.",
            "textJa": "ã‚ã‚ã€ã¯ã„ã€èª°ã‹ã‚’æ‹…å½“ã—ã¾ã—ãŸï¼ç´ æ•µãªãƒžã‚°ã‚«ãƒƒãƒ—ã‹ãƒãƒ§ã‚³ãƒ¬ãƒ¼ãƒˆã«ã—ã‚ˆã†ã‹ã¨æ€ã£ã¦ã„ã¾ã™ã€‚"
          },
          {
            "text": "I don't celebrate Secret Santa, but I'm happy to contribute to a group gift.",
            "correct": false,
            "feedback": "⚠️「celebrate」という個人的な選択は尊重されますが、「contribute to the office fund」という代替案を提示することで、チームスピリットに参加する姿勢が示されます。英国文化では個人の選択は尊重されますが、同時に全員で楽しむ方法を見つけることが大切です。このバランスが英国的です。",
            "feedbackEn": "⚠️ Personal choices around celebrations are respected in UK culture, but offering an alternative way to participate (fund contribution) shows team spirit. The British value both individual autonomy and collective fun—finding a way to join in, even differently, demonstrates good cultural awareness.",
            "textJa": "ã‚·ãƒ¼ã‚¯ãƒ¬ãƒƒãƒˆã‚µãƒ³ã‚¿ã¯ç¥ã„ã¾ã›ã‚“ãŒã€ã‚°ãƒ«ãƒ¼ãƒ—ã‚®ãƒ•ãƒˆã«ã¯å–œã‚“ã§è²¢çŒ®ã—ã¾ã™ã€‚"
          }
        ],
        "textJa": "ä»Šé€±ãƒãƒ¼ãƒ ã§ã‚·ãƒ¼ã‚¯ãƒ¬ãƒƒãƒˆã‚µãƒ³ã‚¿ã‚’ã‚„ã‚Šã¾ã™ã€‚ãƒ¡ãƒ¼ãƒ«è¦‹ã¾ã—ãŸã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: Christmas is huge in the UK. Key customs: crackers, paper hats, turkey dinner, Boxing Day (26th Dec), and Secret Santa at work.",
    "tipJa": "🇬🇧 イギリスTip: 英国のクリスマスは巨大な文化的行事です。クリスマスクラッカー、紙の帽子、七面鳥の夕食、ボクシングデー（12月26日）。"
  },
  "conv_culture_pub": {
    "id": "conv_culture_pub",
    "title": "Pub culture & the rounds system",
    "titleJa": "パブ文化・ラウンド制",
    "situation": "A UK colleague explains pub culture to you over your first work social.",
    "situationJa": "最初のワークソーシャルで英国の同僚がパブ文化を説明してくれています。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "🍺",
        "name": "Dave",
        "text": "So — have you done rounds before? I'll get the first one in.",
        "options": [
          {
            "text": "I haven't actually — how does it work? I'll definitely get the next round.",
            "correct": true,
            "feedback": "✅ ラウンドシステムの仕組みを率直に認め、次のラウンドを買うことをすぐに約束しています。イギリスのパブ文化では「順番に全員が1ラウンド分を奢る」という相互扶助の精神が最も大切で、この応答はそれを完璧に示しています。相手の親切さに感謝しながら、社交的な義務をしっかり理解していることが伝わります。",
            "feedbackEn": "Perfect UK pub etiquette. You're honest about being new, immediately show you understand the reciprocal obligation, and demonstrate you respect the social contract. This is exactly what British people expect and appreciate.",
            "textJa": "å®Ÿã¯ãªã„ã‚“ã§ã™ã€‚ã©ã†ã„ã†ã‚·ã‚¹ãƒ†ãƒ ã§ã™ã‹ï¼Ÿæ¬¡ã¯ç§ãŒå‡ºã—ã¾ã™ã€‚"
          },
          {
            "text": "I don't usually drink alcohol, but I'll take a soft drink instead.",
            "correct": false,
            "feedback": "✅ 飲酒しないことは全く問題ありません。重要なのは『ラウンドシステムに参加する意思』を示すことです。ソフトドリンクでも「ラウンドの一員」として扱われ、やがて自分のターンが来たときに他の人のドリンクを買うことになります。イギリス人はこの参加姿勢と包括性を高く評価します。",
            "feedbackEn": "Excellent. Your choice of drink doesn't matter — what matters is participating in the round system. You'll still take your turn buying for everyone, which shows you respect and understand the social ritual.",
            "textJa": "æ™®æ®µã‚¢ãƒ«ã‚³ãƒ¼ãƒ«ã¯é£²ã¾ãªã„ã®ã§ã™ãŒã€ã‚½ãƒ•ãƒˆãƒ‰ãƒªãƒ³ã‚¯ã‚’ã„ãŸã ãã¾ã™ã€‚"
          },
          {
            "text": "Thanks, but I'd rather just pay for my own drink separately.",
            "correct": false,
            "feedback": "⚠️ 親切な申し出ですが、イギリスのラウンドシステムの本質を理解していません。ラウンドは『個別払い』ではなく『相互扶助と社交の儀式』です。これを断ると「グループの一員になりたくない」と解釈される可能性があります。代わりに『ラウンドに参加するが、次は自分が全員分買う』と言う方が良いでしょう。",
            "feedbackEn": "This misses the social significance of rounds. It's not just transactional — it's a ritual of belonging and reciprocal generosity. Opting out can seem unfriendly. Better: accept the round and commit to buying everyone when it's your turn.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ãŒã€è‡ªåˆ†ã®åˆ†ã¯è‡ªåˆ†ã§æ‰•ã£ãŸæ–¹ãŒã„ã„ã§ã™ã€‚"
          }
        ],
        "textJa": "ã•ã¦ã€ãƒ©ã‚¦ãƒ³ãƒ‰ã¯ã‚„ã£ãŸã“ã¨ã‚ã‚Šã¾ã™ã‹ï¼Ÿæœ€åˆã®ä¸€æ¯ã¯ç§ãŒå‡ºã—ã¾ã™ã€‚"
      },
      {
        "speaker": "colleague",
        "avatar": "🍺",
        "name": "Dave",
        "text": "Basically, everyone takes turns buying for the whole group. It evens out over the night.",
        "options": [
          {
            "text": "That makes sense — I'll keep track of who's buying so I don't miss my turn.",
            "correct": true,
            "feedback": "✅ パブの「ラウンド」文化を正しく理解しています。順番を覚えて自分のターンに率先して買う姿勢は、グループの一員として信頼される行動です。英国では「自分の番を忘れない」ことが社交性と責任感の証になります。",
            "feedbackEn": "✅ You've grasped the round system perfectly. Remembering whose turn it is next and stepping up willingly shows you're reliable and part of the group. This is how Brits build camaraderie—through mutual trust and reciprocity.",
            "textJa": "ãªã‚‹ã»ã©ã€‚è‡ªåˆ†ã®ç•ªã‚’è¦‹é€ƒã•ãªã„ã‚ˆã†ã«è¦šãˆã¦ãŠãã¾ã™ã€‚"
          },
          {
            "text": "So over the whole evening, everyone ends up spending about the same?",
            "correct": false,
            "feedback": "✅ 「ラウンド」の本質を理解した質問です。英国人はお金の計算よりも「グループ全体で支え合う」という社交的価値を重視します。この質問はシステムへの信頼を示しており、文化的に適切です。",
            "feedbackEn": "✅ This shows you understand the spirit of rounds—it's not about precise accounting, but about fairness and group cohesion. Brits appreciate when newcomers grasp that the system works because everyone trusts it will balance out.",
            "textJa": "ã¤ã¾ã‚Šã€ä¸€å¤œã‚’é€šã˜ã¦å…¨å“¡ãŒã ã„ãŸã„åŒã˜é¡ã‚’ä½¿ã†ã¨ã„ã†ã“ã¨ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "What if I can't afford a full round for everyone tonight?",
            "correct": false,
            "feedback": "✅ 実用的で正直な質問として受け取られます。英国では無理に参加することより、正直に状況を話す方が歓迎されます。友人たちは代替案（少ない飲み物、後で返すなど）を提案するでしょう。個人の事情は「不正解」ではなく「相談すべき現実」です。",
            "feedbackEn": "✅ Honestly flagging financial constraints is respected in UK culture. Rather than struggling silently, Brits appreciate directness—your friends will likely suggest alternatives (buying soft drinks, settling up later, or sitting this round out). Honesty builds trust.",
            "textJa": "å…¨å“¡åˆ†æ‰•ãˆã‚‹ä½™è£•ãŒãªã„æ™‚ã¯ã©ã†ã™ã‚Œã°ã„ã„ã§ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "åŸºæœ¬çš„ã«å…¨å“¡ãŒäº¤äº’ã«ã‚°ãƒ«ãƒ¼ãƒ—å…¨ä½“ã®åˆ†ã‚’æ‰•ã†ã‚“ã§ã™ã€‚å¤œãŒçµ‚ã‚ã‚Œã°å¹³å‡ã—ã¦åŒã˜ã«ãªã‚Šã¾ã™ã€‚"
      },
      {
        "speaker": "colleague",
        "avatar": "🍺",
        "name": "Dave",
        "text": "Right — it's your round! What's everyone having?",
        "options": [
          {
            "text": "Of course! Let me get these in — what'll everyone have then?",
            "correct": true,
            "feedback": "✅ 「Of course!」で潔く受け入れ、「Let me get these in」という英国パブで最も典型的な表現を使っています。ラウンドシステムは相互扶助と信頼の文化であり、快く引き受けることが英国社会での評判を高めます。この返答は相手に対して「グループの一員として責任を果たす」という強いメッセージを送ります。",
            "feedbackEn": "'Of course!' demonstrates you embrace the round system gracefully. 'Let me get these in' is quintessentially British pub language showing responsibility and good social spirit. This response signals you're a reliable group member—essential in UK pub culture.",
            "textJa": "ã‚‚ã¡ã‚ã‚“ï¼è¡Œã£ã¦ãã¾ã™ã€‚çš†ã•ã‚“ã¯ä½•ã‚’é£²ã¿ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Right, brilliant! What is everyone drinking tonight then?",
            "correct": false,
            "feedback": "⚠️ ラウンドを受け入れる意思は伝わりますが、「brilliant」は少しカジュアルすぎて、相手の言葉に対する直接的な応答性が弱いです。「Let me get these in」や「Same again?」といった、より積極的にラウンドの責任を引き受ける表現があるとより英国的です。会話の流れとしては良いですが、相手への姿勢をもっとはっきり示すと◎",
            "feedbackEn": "Shows acceptance of the round, but 'brilliant' is a bit casual and lacks the direct responsibility-taking language. Phrases like 'Let me get these in' or 'Same again?' more clearly demonstrate you're taking charge. Good effort, but a bit more directness would be more typically British.",
            "textJa": "ã‚ˆã—ï¼çš†ã•ã‚“ã¯ä»Šå¤œä½•ã‚’é£²ã¿ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Actually, I'd rather not pay this round — can we take turns differently?",
            "correct": false,
            "feedback": "⚠️ 経済的な事情や個人の状況がある場合、正直に伝えることは全く問題ありません。英国文化では誠実さが重視されます。ただし、このシーンではすでにラウンドシステムが始まっており、相手が「your round」と明確に告げている状況です。その場で拒否するより、事前に相談したり代替案を提案する方が、より英国的で配慮のある対応になります。",
            "feedbackEn": "Being honest about your situation is fine in British culture—directness is valued. However, in this moment the round has already been called. Declining mid-way can seem awkward. Better to discuss financial arrangements beforehand or propose alternatives like 'Would you mind if I get a soft drink this time?' That shows more tact and cultural awareness.",
            "textJa": "å®Ÿã¯ä»Šå›žã¯æ‰•ã„ãŸããªã„ã‚“ã§ã™ãŒã€‚åˆ¥ã®é †ç•ªã§ã§ãã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ã•ã¦ã€æ¬¡ã¯ã‚ãªãŸã®ç•ªï¼çš†ã•ã‚“ä½•ã«ã—ã¾ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: The rounds system is sacred. Key rules: always buy a round if you've accepted drinks; don't skip out before your turn; include non-drinkers.",
    "tipJa": "🇬🇧 イギリスTip: ラウンド制は英国パブ文化の神聖なルール。飲み物を受け取ったら必ず自分のラウンドを買う。"
  },
  "conv_culture_royals": {
    "id": "conv_culture_royals",
    "title": "Talking about the Royal Family & politics",
    "titleJa": "王室・政治の話題",
    "situation": "A UK colleague brings up the Royal Family at lunch.",
    "situationJa": "昼食中に英国の同僚が王室の話を持ち出しました。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "👑",
        "name": "Colleague",
        "text": "Did you see the news about the King? What do you make of the Royal Family?",
        "options": [
          {
            "text": "Yes, I find it quite interesting. What's your own view on it all?",
            "correct": true,
            "feedback": "✅ 英国文化的にベスト。王室への関心を示しつつ、すぐに相手の意見を引き出す姿勢が重要です。英国では「controversial」な話題について、自分の強い主張よりも「相手の視点を理解したい」という姿勢を最初に示すことが、信頼関係を築く基本。この簡潔で開かれた対応が最も自然です。",
            "feedbackEn": "✅ This is culturally ideal. It expresses genuine interest while immediately deferring to the other person's perspective. British culture values listening before asserting opinions on sensitive topics like the monarchy. This open, balanced approach builds rapport and shows respect for their views.",
            "textJa": "ã¯ã„ã€ã¨ã¦ã‚‚èˆˆå‘³æ·±ã„ã§ã™ã€‚ã‚ãªãŸè‡ªèº«ã¯ã©ã†æ€ã„ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "They're absolutely wonderful and represent British values brilliantly.",
            "correct": false,
            "feedback": "⚠️ 惜しい点：「absolutely wonderful」という強い肯定は英国人にも様々な意見があるため、相手が共感しない場合は会話が冷え込みます。より良くは、「I can see why many people find them important to British tradition」など、複数の視点を認めた上で意見を述べる方が自然です。",
            "feedbackEn": "⚠️ Strong positive statements like 'absolutely wonderful' may not resonate with all British people, as views on the monarchy are diverse. A more nuanced approach—'I can see why many people find them important to British tradition'—would acknowledge different perspectives while still expressing interest.",
            "textJa": "ç´ æ™´ã‚‰ã—ã„ã§ã™ã—ã€è‹±å›½çš„ãªä¾¡å€¤è¦³ã‚’è¦‹äº‹ã«ä½“ç¾ã—ã¦ã„ã¾ã™ã€‚"
          },
          {
            "text": "It's quite a complex topic with different views — what do you think?",
            "correct": false,
            "feedback": "⚠️ 良い対応ですが、正解より少し回りくどいです。「It's quite complex」という前置きは多角性を認識する点で良いのですが、英国ではより直接的に「What do you think?」と相手に委ねるだけでも十分。余分な前置きを避け、もっとシンプルに尋ねる方が、より自然で親しみやすい印象になります。",
            "feedbackEn": "⚠️ Good response, but slightly more roundabout than ideal. While acknowledging complexity shows awareness, British conversation style often prefers directness. Simply asking 'What do you think?' is more natural and conversational—the preamble about complexity, though thoughtful, can feel a bit formal or hedging.",
            "textJa": "ã•ã¾ã–ã¾ãªæ„è¦‹ãŒã‚ã‚‹è¤‡é›‘ãªãƒ†ãƒ¼ãƒžã§ã™ã‚ˆã­ã€‚ã‚ãªãŸã¯ã©ã†æ€ã„ã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "å›½çŽ‹ã®ãƒ‹ãƒ¥ãƒ¼ã‚¹ã‚’è¦‹ã¾ã—ãŸã‹ï¼ŸçŽ‹å®¤ã«ã¤ã„ã¦ã©ã†æ€ã„ã¾ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "👑",
        "name": "Colleague",
        "text": "Honestly, I think the whole institution is outdated. But my mum loves them!",
        "options": [
          {
            "text": "Ha — that's very British! I can see both sides, to be honest.",
            "correct": true,
            "feedback": "✅ ユーモアで複雑性を認めながら、相手と異なる見方も尊重する「外交的な返し方」。イギリス文化では議論の最中に相手を否定するのではなく、異なる視点を認める姿勢が非常に重要です。この返答は相手の意見も母親の気持ちも両方価値があることを示し、会話を続けやすくします。",
            "feedbackEn": "Perfect diplomatic response using humour. British culture values acknowledging complexity and respecting different viewpoints without taking sides. This approach keeps the conversation open and shows emotional intelligence.",
            "textJa": "é¢ç™½ã„ï¼ã¾ã•ã«è‹±å›½ã‚‰ã—ã„ã§ã™ã­ã€‚ä¸¡æ–¹ã®ç«‹å ´ãŒç†è§£ã§ãã¾ã™ã€‚"
          },
          {
            "text": "I completely agree with your mum actually! The royals are quite important.",
            "correct": false,
            "feedback": "⚠️ 相手の個人的な見方を否定してしまい、会話が停止しやすくなります。イギリス人は自分の意見を述べることは歓迎していますが、相手の話をまず理解してから、自分の視点を「でも」ではなく「一方で」という形で加えるのが自然です。「Actually, I find the historical aspect fascinating」のように、別の角度を提案する方がより良いでしょう。",
            "feedbackEn": "Sounds dismissive of the other person's viewpoint. While stating your opinion is fine, British conversation style favours understanding first, then gently offering your perspective. Try: 'I see your point, though I quite like the historical significance myself.'",
            "textJa": "ãŠæ¯ã•ã‚“ã«å®Œå…¨ã«åŒæ„ã—ã¾ã™ï¼çŽ‹å®¤ã¯çµæ§‹é‡è¦ã ã¨æ€ã„ã¾ã™ã€‚"
          },
          {
            "text": "In Japan we have an Emperor too, so I understand that pull.",
            "correct": false,
            "feedback": "⚠️ 文化的な平行線は興味深いですが、このシーンでは「相手の母親の気持ちが理解できる」というスタンスになってしまい、相手自身（王制は時代遅れと思っている人）との共感が欠けます。「そうですね」で終わらず、相手の複雑な心情（家族との価値観の違い）に焦点を当てるなら、「That's a tricky position with family, isn't it?」の方がイギリス文化的に相手を理解しようとする姿勢が伝わります。",
            "feedbackEn": "Cultural parallel is interesting but misses the immediate point. You're validating the mother's view rather than acknowledging the speaker's own complex feelings about family differences. Try: 'That's quite a common split, I think—tricky with family, isn't it?'",
            "textJa": "æ—¥æœ¬ã«ã‚‚å¤©çš‡é™›ä¸‹ãŒã„ã‚‹ã®ã§ã€ãã®æ°—æŒã¡ã¯åˆ†ã‹ã‚Šã¾ã™ã€‚"
          }
        ],
        "textJa": "æ­£ç›´è¨€ã£ã¦ã€ã“ã®åˆ¶åº¦ã¯æ™‚ä»£é…ã‚Œã ã¨æ€ã„ã¾ã™ã€‚ã§ã‚‚æ¯ã¯å¤§å¥½ãã§ã™ã‚ˆï¼"
      },
      {
        "speaker": "colleague",
        "avatar": "👑",
        "name": "Colleague",
        "text": "What about politics back in Japan — is it very different from here?",
        "options": [
          {
            "text": "It's quite different — fewer dramatic debates in parliament! How do you find UK politics?",
            "correct": true,
            "feedback": "✅ イギリス文化的にベストな応答です。相手の質問に簡潔に答えつつ、相手に質問を返すことで会話を広げる姿勢は、イギリスの対話文化では「相手を尊重し、共通の話題を探る」という理想的なアプローチです。政治的な立場を明かさない点も英国では適切です。",
            "feedbackEn": "✅ This is the best approach in UK culture. You answer their question briefly while turning it back to them — showing genuine interest in their perspective. This balanced conversational style is highly valued in British dialogue, and it avoids personal political disclosure, which is culturally appropriate.",
            "textJa": "ã‹ãªã‚Šé•ã„ã¾ã™ã€‚å›½ä¼šã§ã®æ´¾æ‰‹ãªè¨Žè«–ãŒå°‘ãªã„ã§ã™ï¼è‹±å›½ã®æ”¿æ²»ã¯ã©ã†æ€ã„ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I'm still getting my head around the UK system — it's quite complex, isn't it?",
            "correct": false,
            "feedback": "⚠️ 好ましい応答です。自分の理解度を率直に認める謙虚さはイギリス人が好むアプローチで、相手が説明や意見を述べるきっかけを自然に作ります。ただし「How do you find...?」と相手に質問を返すと、さらに会話が深まり、より英国的な相互尊重の姿勢が引き出せます。",
            "feedbackEn": "⚠️ This is a good response. British people appreciate candour about what you're still learning, and it naturally invites them to share their perspective. Adding a reciprocal question like 'How do you find UK politics?' would deepen the conversation and show the mutual interest that's so valued in British dialogue.",
            "textJa": "è‹±å›½ã®ã‚·ã‚¹ãƒ†ãƒ ã¯ã¾ã ç†è§£ã—ã‚ˆã†ã¨ã—ã¦ã„ã¾ã™ã€‚ã‹ãªã‚Šè¤‡é›‘ã§ã™ã‚ˆã­ï¼Ÿ"
          },
          {
            "text": "I prefer not to discuss politics too much, but Japan's system works quite differently.",
            "correct": false,
            "feedback": "⚠️ 問題ありません。個人の政治的立場はイギリスでもプライベートなテーマです。「prefer not to discuss」は丁寧で英国らしい表現ですが、すぐに「but Japan's system...」と一方的に説明するより、相手の意見を先に引き出す方が、より英国文化的な相互対話の姿勢を示せます。",
            "feedbackEn": "⚠️ This is perfectly fine — UK culture respects political privacy and 'prefer not to discuss' is characteristically polite. However, immediately launching into explaining Japan's system can feel one-directional. Asking 'What do you think about how things work here?' invites dialogue rather than a lecture.",
            "textJa": "ã‚ã¾ã‚Šæ”¿æ²»ã«ã¤ã„ã¦è©±ã—ãŸãã¯ãªã„ã§ã™ãŒã€æ—¥æœ¬ã®ã‚·ã‚¹ãƒ†ãƒ ã¯ã‹ãªã‚Šç•°ãªã‚Šã¾ã™ã€‚"
          }
        ],
        "textJa": "æ—¥æœ¬ã®æ”¿æ²»ã¯ã©ã†ã§ã™ã‹ï¼Ÿã“ã¡ã‚‰ã¨ã¯ã‹ãªã‚Šé•ã„ã¾ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: The Royal Family is a genuinely divisive topic. On politics: never ask who someone voted for. Safe topics: weather, food, sport, TV.",
    "tipJa": "🇬🇧 イギリスTip: 王室は真に分裂した話題です。誰に投票したか絶対に聞かないこと。安全な話題：天気、食べ物、スポーツ、テレビ。"
  },
  "conv_culture_sport": {
    "id": "conv_culture_sport",
    "title": "Football & sport culture",
    "titleJa": "フットボールとスポーツ文化",
    "situation": "Your UK colleagues are discussing last night's football match in the office.",
    "situationJa": "英国の同僚たちが昨夜のサッカーの試合について話しています。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "⚽",
        "name": "Colleague",
        "text": "Did you see the Arsenal game last night? Absolute disaster.",
        "options": [
          {
            "text": "I missed it — what happened? I'm still learning about the Premier League!",
            "correct": true,
            "feedback": "✅ 正直で好奇心を示す最良の対応。イギリス人はフットボールに本当に興味を持つ人に説明することが大好きです。相手が詳しく話す機会を与え、自然な会話が続きます。",
            "feedbackEn": "✅ Honest and genuinely curious—Brits love explaining football to someone who's truly interested. This gives your conversation partner the floor naturally.",
            "textJa": "è¦‹é€ƒã—ã¾ã—ãŸï¼ä½•ãŒèµ·ããŸã‚“ã§ã™ã‹ï¼Ÿãƒ—ãƒ¬ãƒŸã‚¢ãƒªãƒ¼ã‚°ã‚’ã¾ã å‹‰å¼·ä¸­ãªã‚“ã§ã™ï¼"
          },
          {
            "text": "I don't follow football much, but I'd love to hear what went wrong!",
            "correct": false,
            "feedback": "✅ 個人の選択を尊重しながら、相手の情熱に寄り添う英国文化的に良い対応。フットボールの話題から完全に逃げず、相手との関係を保つバランスが取れています。",
            "feedbackEn": "✅ Respectful of your own interests while showing genuine engagement. Brit culture values people who listen enthusiastically to others' passions, even if they don't share them.",
            "textJa": "ã‚ã¾ã‚Šã‚µãƒƒã‚«ãƒ¼ã¯è¦‹ãªã„ã‚“ã§ã™ãŒã€ä½•ãŒæ‚ªã‹ã£ãŸã®ã‹èžã‹ã›ã¦ãã ã•ã„ï¼"
          },
          {
            "text": "Yeah, I caught most of it—frustrating performance from the defence!",
            "correct": false,
            "feedback": "⚠️ 実際に見ていないのにこう答えるのは避けた方が良いです。イギリス人はフットボールの詳細について突っ込んだ質問をする傾向があり、嘘がすぐにばれます。正直に『見逃した』と言う方が信用を失いません。",
            "feedbackEn": "⚠️ Don't claim you watched if you didn't—Brits will likely ask specific follow-up questions about the match, and dishonesty erodes trust. Honesty is valued more.",
            "textJa": "ãˆãˆã€å¤§éƒ¨åˆ†è¦‹ã¾ã—ãŸã€‚å®ˆå‚™ã®ãƒ‘ãƒ•ã‚©ãƒ¼ãƒžãƒ³ã‚¹ãŒæ®‹å¿µã§ã—ãŸã­ï¼"
          }
        ],
        "textJa": "æ˜¨å¤œã®ã‚¢ãƒ¼ã‚»ãƒŠãƒ«ã®è©¦åˆè¦‹ã¾ã—ãŸã‹ï¼Ÿå®Œå…¨ãªæƒ¨æ•—ã§ã—ãŸã‚ˆã€‚"
      },
      {
        "speaker": "colleague",
        "avatar": "⚽",
        "name": "Colleague",
        "text": "Do you have a team back in Japan? Or any team here?",
        "options": [
          {
            "text": "No team yet — who should I support? I live in East London so maybe West Ham?",
            "correct": true,
            "feedback": "✅ 地域に基づいた質問は英国文化的にベストです。ローカルチームへの親しみやすさと学ぶ姿勢を同時に示し、相手と自然な会話が続きます。",
            "feedbackEn": "Perfect! Asking for a recommendation based on your local area shows openness to UK culture and gives your friend a chance to share their passion. This is exactly how football fandom works in the UK.",
            "textJa": "ã¾ã ãªã„ã‚“ã§ã™ã€‚ã©ã“ã‚’å¿œæ´ã™ã‚Œã°ã„ã„ã§ã™ã‹ï¼Ÿã‚¤ãƒ¼ã‚¹ãƒˆãƒ­ãƒ³ãƒ‰ãƒ³ã«ä½ã‚“ã§ã„ã‚‹ã®ã§ã‚¦ã‚§ã‚¹ãƒˆãƒãƒ ã‹ãªï¼Ÿ"
          },
          {
            "text": "I support Manchester United back home. Are they popular here too?",
            "correct": false,
            "feedback": "✅ これも自然で良い返答です。日本での経験を共有しながら、英国での受け取られ方を確認する姿勢は相手に好印象を与えます。",
            "feedbackEn": "Also excellent! Sharing your existing connection while asking about UK perceptions shows genuine interest. Man Utd has global fans, and asking 'are they popular here?' opens dialogue about football culture differences.",
            "textJa": "æ—¥æœ¬ã§ã¯ãƒžãƒ³ãƒã‚§ã‚¹ã‚¿ãƒ¼ãƒ»ãƒ¦ãƒŠã‚¤ãƒ†ãƒƒãƒ‰ã‚’å¿œæ´ã—ã¦ã„ã¾ã™ã€‚ã“ã¡ã‚‰ã§ã‚‚äººæ°—ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I'm not really into football, but I'm curious about the culture around it here.",
            "correct": false,
            "feedback": "✅ スポーツファンでなくても、文化への興味を示すことは英国人に好まれます。押し付けられないニュアンスが大切で、相手も説明しやすくなります。",
            "feedbackEn": "Great approach! Being honest about not being a football fan while showing interest in UK sports culture is perfectly acceptable. This opens conversation about why football matters culturally without pretending.",
            "textJa": "ã‚ã¾ã‚Šã‚µãƒƒã‚«ãƒ¼ã«ã¯è©³ã—ããªã„ã§ã™ãŒã€ãã®å‘¨ã‚Šã®æ–‡åŒ–ã«èˆˆå‘³ãŒã‚ã‚Šã¾ã™ã€‚"
          }
        ],
        "textJa": "æ—¥æœ¬ã§ãƒãƒ¼ãƒ ã‚’å¿œæ´ã—ã¦ã„ã¾ã™ã‹ï¼Ÿãã‚Œã¨ã‚‚ã“ã¡ã‚‰ã§ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "⚽",
        "name": "Colleague",
        "text": "Some of us are going to watch the match at the pub on Saturday. Fancy joining?",
        "options": [
          {
            "text": "That sounds brilliant! I'd love to come and experience a proper match day at the pub.",
            "correct": true,
            "feedback": "✅「That sounds brilliant」はイギリス人が日常的に使う表現で、相手の誘いを温かく受け入れる姿勢を自然に示します。パブでの試合観戦は典型的なイギリス文化体験であり、グループ活動への参加意欲がコミュニティ形成に直結します。",
            "feedbackEn": "Perfect! 'That sounds brilliant' is authentic British enthusiasm. It expresses genuine interest in the group activity and shows openness to experiencing UK pub culture—exactly what Brits value when building friendships.",
            "textJa": "ç´ æ™´ã‚‰ã—ã„ï¼ãœã²å‚åŠ ã—ã¦æœ¬æ ¼çš„ãªè©¦åˆæ—¥ã‚’ãƒ‘ãƒ–ã§ä½“é¨“ã—ãŸã„ã§ã™ã€‚"
          },
          {
            "text": "I'm interested, but let me check my schedule and get back to you tomorrow.",
            "correct": false,
            "feedback": "⚠️「Let me check」という返答は丁寧ですが、この文脈では「明らかに行きたいけど確認が必要」と聞こえます。英国文化的には、すぐに返事できない場合でも「その場で前向きな態度を見せて後で連絡」がより自然です。例えば「I'll definitely let you know by Friday」と期限を示すとさらに良くなります。",
            "feedbackEn": "Polite, but a bit formal for a casual pub invite. Brits prefer you to show immediate enthusiasm even if you need to confirm details. Try: 'Sounds great—I'll confirm by Friday!' This shows you're genuinely interested while being honest about pending logistics.",
            "textJa": "èˆˆå‘³ã‚ã‚Šã¾ã™ã€‚ã‚¹ã‚±ã‚¸ãƒ¥ãƒ¼ãƒ«ã‚’ç¢ºèªã—ã¦æ˜Žæ—¥é€£çµ¡ã—ã¾ã™ã€‚"
          },
          {
            "text": "I'd like to come, but I should be honest—I'm not really a football fan.",
            "correct": false,
            "feedback": "✅ 正直さはイギリス文化で非常に尊重されます。興味がなくても「参加したい」という意欲があれば、イギリス人は心から歓迎します。この返答は誠実性を示しながら、社交的な参加姿勢を伝えており、英国のカジュアルなコミュニケーション文化にぴったりです。",
            "feedbackEn": "Excellent! British culture truly values honesty combined with willingness to participate. Admitting you're not a huge fan while showing eagerness to join demonstrates authenticity—Brits will welcome this directness and appreciate your genuine interest in the social experience.",
            "textJa": "å‚åŠ ã—ãŸã„ã§ã™ãŒã€æ­£ç›´ã«ã„ã†ã¨ã‚ã¾ã‚Šã‚µãƒƒã‚«ãƒ¼ãƒ•ã‚¡ãƒ³ã˜ã‚ƒãªã„ã‚“ã§ã™ã€‚"
          }
        ],
        "textJa": "åœŸæ›œæ—¥ã«ãƒ‘ãƒ–ã§è©¦åˆã‚’è¦‹ã‚‹äºˆå®šãŒã‚ã‚Šã¾ã™ã€‚ä¸€ç·’ã«æ¥ã¾ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: Football is the UK's national obsession. Choose a local team to follow — it's a great conversation starter.",
    "tipJa": "🇬🇧 イギリスTip: フットボールは英国の国民的執着です。地元チームを応援することで会話のきっかけになります。"
  },
  "conv_culture_bonfire": {
    "id": "conv_culture_bonfire",
    "title": "Bonfire Night & British traditions",
    "titleJa": "ボンファイアナイトと英国の伝統",
    "situation": "A colleague invites you to a Bonfire Night event in early November.",
    "situationJa": "11月初旬、同僚がボンファイアナイトのイベントに誘ってくれました。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "🎆",
        "name": "Colleague",
        "text": "Are you coming to the Bonfire Night fireworks on Saturday? It's brilliant!",
        "options": [
          {
            "text": "I'd love to! What's the story behind Bonfire Night? I'm curious about the tradition.",
            "correct": true,
            "feedback": "✅ 最高の応答です。招待に熱意を示しながら、イギリスの伝統への真摯な興味を表現しています。イギリス人は自分たちの文化について説明することを楽しむため、この質問は相手に好印象を与え、会話を自然に広げます。英国文化学習の姿勢も感じられます。",
            "feedbackEn": "Perfect response. You show genuine enthusiasm and authentic curiosity about British tradition. Brits love sharing their cultural heritage, and this approach builds rapport while demonstrating respect for their customs.",
            "textJa": "ãœã²ï¼ãƒœãƒ³ãƒ•ã‚¡ã‚¤ã‚¢ãƒŠã‚¤ãƒˆã®ç”±æ¥ã¯ä½•ã§ã™ã‹ï¼Ÿä¼çµ±ãŒæ°—ã«ãªã‚Šã¾ã™ã€‚"
          },
          {
            "text": "That sounds brilliant! What time should I arrive? Will there be food and drinks?",
            "correct": false,
            "feedback": "⚠️ 非常に実用的で自然な応答です。イベント詳細と社交的な側面への興味を示しており、イギリス人は practical questions を歓迎します。ただし、正解の選択肢よりも「実務的」で、文化への興味が薄く見えます。「What's it all about?」と軽く文化的背景を聞くと、より良くなります。",
            "feedbackEn": "Very practical and natural. You ask helpful logistics and show interest in the social experience. However, this focuses more on 'how to attend' than 'why it matters culturally.' Adding cultural curiosity alongside practical questions would be ideal.",
            "textJa": "ç´ æ™´ã‚‰ã—ãã†ã§ã™ã­ï¼ä½•æ™‚ã«è¡Œã‘ã°ã„ã„ã§ã™ã‹ï¼Ÿé£Ÿã¹ç‰©ã‚„é£²ã¿ç‰©ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I'd really like to, but I need to check my schedule first. Can I let you know soon?",
            "correct": false,
            "feedback": "⚠️ 完全に妥当で誠実な応答です。個人の予定を優先することはイギリス人にも理解されます。ただし、最初の返答では「後で確認する」より「興味を示してから確認する」の順が、相手に対してより親友らしく、相手の招待を大切にしている印象を与えます。",
            "feedbackEn": "Perfectly reasonable and honest. Brits understand scheduling conflicts. However, showing genuine interest first ('That sounds great!') before checking your schedule would demonstrate greater enthusiasm for their invitation and the friendship.",
            "textJa": "è¡ŒããŸã„ã‚“ã§ã™ãŒã€ã¾ãšã‚¹ã‚±ã‚¸ãƒ¥ãƒ¼ãƒ«ã‚’ç¢ºèªã™ã‚‹å¿…è¦ãŒã‚ã‚Šã¾ã™ã€‚ã™ãã«é€£çµ¡ã—ã¦ã‚‚ã„ã„ã§ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "åœŸæ›œæ—¥ã®ãƒœãƒ³ãƒ•ã‚¡ã‚¤ã‚¢ãƒŠã‚¤ãƒˆã®èŠ±ç«ã«æ¥ã¾ã™ã‹ï¼Ÿæœ€é«˜ã§ã™ã‚ˆï¼"
      },
      {
        "speaker": "colleague",
        "avatar": "🎆",
        "name": "Colleague",
        "text": "So in 1605, Guy Fawkes tried to blow up Parliament — we celebrate that he failed!",
        "options": [
          {
            "text": "That's fascinating! So the celebration is really about the failed plot rather than Guy Fawkes himself?",
            "correct": true,
            "feedback": "✅「That's fascinating」はイギリス人との歴史的会話で自然で親しみやすい反応です。相手の説明を確認する質問を添えることで、真摯に耳を傾け、文化的背景を正しく理解しようとする姿勢が伝わり、会話がより深まります。イギリス文化では「相手の話を理解しようとする努力」が高く評価されます。",
            "feedbackEn": "✅ 'That's fascinating' is a natural, warm opener for UK historical discussions. Your clarifying question shows genuine intellectual engagement and respect for the tradition—British conversational culture highly values active listening and demonstrating real interest in understanding cultural nuances.",
            "textJa": "é¢ç™½ã„ï¼ã¤ã¾ã‚ŠãŠç¥ã„ã¯ã‚¬ã‚¤ãƒ»ãƒ•ã‚©ãƒ¼ã‚¯ã‚¹è‡ªèº«ã§ã¯ãªãã€å¤±æ•—ã—ãŸé™°è¬€ã®ã“ã¨ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Interesting! How do you typically celebrate Bonfire Night? Do families gather together?",
            "correct": false,
            "feedback": "⚠️ これは良い質問で、相手の個人的な経験を引き出そうとしています。ただし、まず相手の説明をもっと深く理解してから個人的な経験を聞く方が、より自然な会話の流れです。相手が詳しく説明した後に「How do you celebrate it?」と続けると、より親密で自然な進展になります。",
            "feedbackEn": "⚠️ This is a friendly question, but it shifts topic before fully engaging with their explanation. In British conversation, it's often better to show deeper understanding of their point first, then naturally transition to personal experience. Try: 'That's fascinating—and how do people typically celebrate that today?' This acknowledges their point while inviting the personal angle.",
            "textJa": "èˆˆå‘³æ·±ã„ï¼ãƒœãƒ³ãƒ•ã‚¡ã‚¤ã‚¢ãƒŠã‚¤ãƒˆã¯ã©ã†ã‚„ã£ã¦ç¥ã„ã¾ã™ã‹ï¼Ÿå®¶æ—ã§é›†ã¾ã‚‹ã‚“ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I see. Is it similar to how other countries celebrate their historical victories?",
            "correct": false,
            "feedback": "⚠️ 他の国との比較は悪くありませんが、イギリス人は自分たちの文化がユニークだと考える傾向があります。この段階では、まずGuy Fawkes Nightそのものの詳細や意味をもっと理解することが大切です。相手が詳しく説明した後に、「Is this unique to the UK, or do other places have similar traditions?」と聞く方がより良いでしょう。",
            "feedbackEn": "⚠️ Comparing to other countries too early can feel dismissive of the UK's unique tradition. Brits often take pride in their distinct cultural practices. Better to deepen understanding of Bonfire Night itself first. After more discussion, you could ask: 'Is this tradition unique to the UK?' This shows you recognize its special significance.",
            "textJa": "ãªã‚‹ã»ã©ã€‚ä»–ã®å›½ãŒæ­´å²çš„å‹åˆ©ã‚’ç¥ã†ã®ã¨ä¼¼ã¦ã„ã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "1605å¹´ã«ã‚¬ã‚¤ãƒ»ãƒ•ã‚©ãƒ¼ã‚¯ã‚¹ãŒè­°ä¼šã‚’çˆ†ç ´ã—ã‚ˆã†ã¨ã—ã¦ã€å¤±æ•—ã—ãŸã“ã¨ã‚’ç¥ã†ã‚“ã§ã™ï¼"
      },
      {
        "speaker": "colleague",
        "avatar": "🎆",
        "name": "Colleague",
        "text": "We'll have hot dogs and toffee apples. Dress warm — it'll be freezing!",
        "options": [
          {
            "text": "Brilliant! I'll wrap up warm. Would you like me to bring anything along?",
            "correct": true,
            "feedback": "✅「Brilliant」はイギリス人が日常的に使う肯定的な反応で、温かみがあります。また、主催者に「何か持ってくることはあるか」と聞くのは英国の集まり文化では非常に丁寧で思慮深い行動です。親しみやすさと気配りのバランスが完璧です。",
            "feedbackEn": "✅ 'Brilliant' is an authentically British positive response that sounds warm and natural. Asking the host if you can contribute is considered thoughtful and considerate in British social culture—it shows genuine interest in the gathering's success.",
            "textJa": "ç´ æ™´ã‚‰ã—ã„ï¼æš–ã‹ãã—ã¾ã™ã€‚ä½•ã‹æŒå‚ã—ãŸæ–¹ãŒã„ã„ã‚‚ã®ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Sounds lovely! What exactly is a toffee apple? I'd like to know before I come!",
            "correct": false,
            "feedback": "⚠️「Sounds lovely」は招待を受け入れる英国的な言い方で良いですが、質問を続ける際に「『来る前に知りたい』という言い方は若干慎重に聞こえます。より自然には『Sounds lovely! Is a toffee apple something I should know about?』や『I've never had a toffee apple before—what should I expect?』と、前向きな好奇心として聞く方が英国文化的です。」",
            "feedbackEn": "⚠️ 'Sounds lovely' is perfectly British, and asking about traditions is great. However, phrasing it as 'I'd like to know before I come' sounds slightly hesitant. More naturally British would be: 'I've never had one before—what should I expect?' or 'Is it something I should know about?'—this frames it as enthusiastic curiosity rather than caution.",
            "textJa": "æ¥½ã—ãã†ã§ã™ã­ï¼ã‚¿ãƒ•ã‚£ãƒ¼ã‚¢ãƒƒãƒ—ãƒ«ã¨ã¯ä½•ã§ã™ã‹ï¼Ÿæ¥ã‚‹å‰ã«çŸ¥ã£ã¦ãŠããŸã„ã§ã™ï¼"
          },
          {
            "text": "Hot dogs aren't really my thing, but I'll definitely come along!",
            "correct": false,
            "feedback": "✅ 個人の食の好みは全く問題ありません。重要なのは「でも絶対に来る！」という前向きな姿勢です。英国文化では参加意欲を示すことが大切で、完璧に全てを食べることは期待されていません。正直さと熱意の両立は非常に好感度が高いです。",
            "feedbackEn": "✅ Personal food preferences are completely fine and show honesty. What matters in British culture is your enthusiasm to participate—saying 'I'll definitely come along' demonstrates genuine interest in the experience, which is highly valued. Brits appreciate authentic honesty combined with genuine enthusiasm.",
            "textJa": "ãƒ›ãƒƒãƒˆãƒ‰ãƒƒã‚°ã¯ã‚ã¾ã‚Šå¥½ãã˜ã‚ƒãªã„ã§ã™ãŒã€çµ¶å¯¾ã«è¡Œãã¾ã™ï¼"
          }
        ],
        "textJa": "ãƒ›ãƒƒãƒˆãƒ‰ãƒƒã‚°ã¨ã‚¿ãƒ•ã‚£ãƒ¼ã‚¢ãƒƒãƒ—ãƒ«ãŒã‚ã‚Šã¾ã™ã€‚æš–ã‹ãç€ã¦ãã¦ãã ã•ã„ã€‚å¯’ã„ã§ã™ã‚ˆï¼"
      }
    ],
    "tip": "🇬🇧 UK tip: Bonfire Night (5th November) commemorates the failed Gunpowder Plot of 1605. Key customs: bonfires, fireworks, sparklers, and autumn food.",
    "tipJa": "🇬🇧 イギリスTip: ボンファイアナイト（11月5日）は1605年の失敗した火薬陰謀事件を記念します。"
  },
  "conv_culture_weather": {
    "id": "conv_culture_weather",
    "title": "Talking about the weather",
    "titleJa": "天気の話題",
    "situation": "You arrive at the office on a typically grey London morning.",
    "situationJa": "典型的な曇りのロンドンの朝、オフィスに到着しました。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "🌧️",
        "name": "Colleague",
        "text": "Morning! Miserable out there, isn't it?",
        "options": [
          {
            "text": "Absolutely! The drizzle's relentless—I thought I'd be used to it by now, but it really gets to you.",
            "correct": true,
            "feedback": "✅ イギリス人の天気談義における最高の応答パターンです。相手の否定的な意見に同意（'Absolutely'）しながら、自分の具体的な観察（'drizzle's relentless'）を加えることで、単なる相槌ではなく「共感の共有」になります。'gets to you'という表現は、天気への感情的な反応を自然に表現する典型的なイギリス英語です。これにより相手との親密さが深まり、社交儀式としての天気談義が成立します。",
            "feedbackEn": "Perfect British small talk. You validate their complaint ('Absolutely'), add specific observation ('relentless'), and use natural emotional language ('gets to you'). This deepens rapport—not just exchanging weather facts, but bonding through shared experience.",
            "textJa": "ã¾ã£ãŸãã§ã™ï¼é›¨ãŒæ­¢ã¾ãªãã¦ã€æ…£ã‚Œã‚‹ã¨æ€ã£ã¦ã„ãŸã‚“ã§ã™ãŒã€æœ¬å½“ã«ã¤ã‚‰ã„ã§ã™ã‚ˆã­ã€‚"
          },
          {
            "text": "Dreadful, isn't it? Though I've heard it might clear up by the weekend, so there's hope!",
            "correct": false,
            "feedback": "⚠️ 非常に良い応答で、'dreadful'という共感的な語彙を使い、相手の気持ちを認めています。ただ「惜しい」点は、この応答がやや「情報提供」に傾いていることです。より英国文化的にベストにするには、相手の感情をもっと引き出すような問いかけを加えるほうが良いでしょう。例えば'Dreadful, isn't it? Have you been stuck indoors all morning?'のように、相手の経験を尋ねることで、会話がより双方向的になります。",
            "feedbackEn": "Good effort—'dreadful' shows sympathy and you add optimism. However, it leans toward 'giving information' rather than 'deepening connection.' Better to ask about their experience: 'Dreadful, isn't it? Have you been out in it much?' This invites them to share.",
            "textJa": "ã²ã©ã„ã§ã™ã‚ˆã­ã€‚ã§ã‚‚åˆå¾Œã«ã¯æ™´ã‚Œã‚‹ã‚‰ã—ã„ã§ã™ã€‚å¸Œæœ›ãŒã‚ã‚Šã¾ã™ã­ï¼"
          },
          {
            "text": "I do quite enjoy the rain actually, but I understand it's annoying for most people.",
            "correct": false,
            "feedback": "⚠️ 個人の好みとして「雨が好き」というのは完全に有効な立場です。しかし英国文化的には「惜しい」ポイントがあります。相手が'Miserable'と否定的に開いているのに、まず異なる意見を述べると、会話が一瞬途切れやすくなります。より自然にするなら、先に相手の気持ちを認めてから個人的な視点を加えましょう：'Fair point, though I rather like the smell of rain myself—keeps things fresh, doesn't it?'このように、相手の共感を得た上で、自分の見方を穏やかに提示するほうがイギリス文化的です。",
            "feedbackEn": "Your personal preference is completely valid, but opening with disagreement can interrupt conversational flow. Better approach: 'Fair point, though I quite like the smell of rain—keeps things fresh, doesn't it?' This validates their view first, then gently introduces your perspective.",
            "textJa": "å®Ÿã¯é›¨ã¯ã‘ã£ã“ã†å¥½ããªã‚“ã§ã™ãŒã€ã»ã¨ã‚“ã©ã®äººã«ã¯è¿·æƒ‘ã§ã™ã‚ˆã­ã€‚"
          }
        ],
        "textJa": "ãŠã¯ã‚ˆã†ã”ã–ã„ã¾ã™ï¼ã²ã©ã„å¤©æ°—ã§ã™ã­ï¼"
      },
      {
        "speaker": "colleague",
        "avatar": "🌧️",
        "name": "Colleague",
        "text": "Apparently it's going to clear up this afternoon. Famous last words!",
        "options": [
          {
            "text": "Ha — I'll believe it when I see it! The weather app has let me down far too many times.",
            "correct": true,
            "feedback": "✅ イギリス人特有の「天気予報への慈悲深い懐疑」を完璧に表現しています。'Famous last words'というユーモアに対して、同じトーンで軽くシニカルに返すのは英国文化のコミュニケーションの基本。自分の経験を加えることで親密感も生まれます。",
            "feedbackEn": "✅ Perfect! You've matched the speaker's gentle cynicism about weather forecasts with relatable self-deprecation. This weather grumbling + joking is quintessentially British and shows real cultural fluency.",
            "textJa": "ä¿¡ã˜ã‚‹ã®ã¯å®Ÿéš›ã«è¦‹ã¦ã‹ã‚‰ã«ã—ã¾ã™ï¼å¤©æ°—ã‚¢ãƒ—ãƒªã«ä½•åº¦ã‚‚è£åˆ‡ã‚‰ã‚Œã¾ã—ãŸã‹ã‚‰ã€‚"
          },
          {
            "text": "Let's hope so! I forgot my umbrella, so fingers crossed it actually stays dry today.",
            "correct": false,
            "feedback": "✅ これも非常に優れた応答です！自虐的なユーモア（傘を忘れた）と楽観的な願いが両立し、非常にイギリス的です。'Fingers crossed'は英国文化で自然な表現。ただし相手のシニカルなジョークのトーンに比べると、やや前向きすぎて「波長のズレ」が生まれています。",
            "feedbackEn": "⚠️ Great British humour (self-deprecating umbrella joke) + colloquial expression. Very natural! However, the speaker's joke was cynical about weather forecasts being unreliable. Your response is a bit too optimistic in tone. Try adding more scepticism: 'Fingers crossed, but we both know how this usually goes!'",
            "textJa": "ãã†ã§ã‚ã‚‹ã¨ã„ã„ã§ã™ã­ï¼å‚˜ã‚’å¿˜ã‚Œã¦ã—ã¾ã£ãŸã®ã§ã€ä»Šæ—¥ã¯æœ¬å½“ã«æ™´ã‚Œã¦ã»ã—ã„ã§ã™ã€‚"
          },
          {
            "text": "Exactly! Weather forecasts in this country are about as reliable as a chocolate teapot, aren't they?",
            "correct": false,
            "feedback": "⚠️ イディオム使いは素晴らしく、シニカルなトーンも完璧です。しかし「chocolate teapot」はやや古い表現で、現代の日常会話では少し「作りすぎた感」があります。もっとシンプルで自然なシニカルさ（例：weather app への個人的な不信）の方が、より自然に相手のジョークに乗れます。",
            "feedbackEn": "⚠️ Good cynicism and idiomatic! However, 'chocolate teapot' sounds a bit forced/dated for casual conversation. Stick to more personal, natural scepticism like 'I'll believe it when I see it.' It flows better with the speaker's conversational tone.",
            "textJa": "ã¾ã£ãŸãã§ã™ï¼ã“ã®å›½ã®å¤©æ°—äºˆå ±ã¯ãƒãƒ§ã‚³ãƒ¬ãƒ¼ãƒˆã®ãƒ†ã‚£ãƒ¼ãƒãƒƒãƒˆã¨åŒã˜ãã‚‰ã„ä¿¡é ¼ã§ãã¾ã›ã‚“ã­ï¼"
          }
        ],
        "textJa": "ä»Šæ—¥ã®åˆå¾Œã¯æ™´ã‚Œã‚‹ã‚‰ã—ã„ã§ã™ã€‚ã¾ã‚è¦‹ã¦ã¿ã¾ã—ã‚‡ã†ï¼"
      },
      {
        "speaker": "colleague",
        "avatar": "🌧️",
        "name": "Colleague",
        "text": "Well, at least it's not as bad as last week. Right — shall we get started?",
        "options": [
          {
            "text": "Ha, true — every cloud! Right, let's do it.",
            "correct": true,
            "feedback": "✅ 'Every cloud' (silver lining) is a classic British expression. Excellent.",
            "textJa": "ç¢ºã‹ã«ï¼ã¾ã‚ã„ã„ã‚„ã€‚ã‚ˆã—ã€ã‚„ã‚Šã¾ã—ã‚‡ã†ã€‚"
          },
          {
            "text": "Ha — yes, absolutely dreadful last week! Shall we crack on and get this out of the way then?",
            "correct": false,
            "feedback": "⚠️ Fine, but 'every cloud' or a similar quip would be more British.",
            "textJa": "ç¢ºã‹ã«ã€å…ˆé€±ã¯æœ¬å½“ã«ã²ã©ã‹ã£ãŸã§ã™ï¼ã•ã¦ã€å§‹ã‚ã¾ã—ã‚‡ã†ã‹ï¼Ÿ"
          },
          {
            "text": "The weather here is very different from Japan.",
            "correct": false,
            "feedback": "⚠️ This extends the small talk past its natural endpoint. They're ready to work!",
            "textJa": "ã“ã“ã®å¤©æ°—ã¯æ—¥æœ¬ã¨ãšã„ã¶ã‚“é•ã„ã¾ã™ã­ã€‚"
          }
        ],
        "textJa": "ã¾ã‚ã€å…ˆé€±ã‚ˆã‚Šã¯ã¾ã—ã§ã™ã­ã€‚ã•ã¦ã€å§‹ã‚ã¾ã—ã‚‡ã†ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: Weather small talk is a British social ritual. The key is to agree, add something relatable, and use gentle humour. Never say you 'don't mind' the rain!",
    "tipJa": "🇬🇧 イギリスTip: 天気の雑談は英国の社交的な儀式です。同意し、共感できることを加え、穏やかなユーモアを使うこと。"
  },
  "conv_life_boiler": {
    "id": "conv_life_boiler",
    "title": "Reporting a broken boiler or bath",
    "titleJa": "ボイラー・お風呂の故障報告",
    "situation": "It's winter and your boiler has stopped working. You have no heating or hot water. You're calling your letting agent.",
    "situationJa": "冬にボイラーが止まり、暖房もお湯も出なくなりました。不動産エージェントに電話しています。",
    "turns": [
      {
        "speaker": "agent",
        "avatar": "🏠",
        "name": "Letting Agent",
        "text": "Good morning, Greenfield Properties. How can I help?",
        "options": [
          {
            "text": "Good morning. I'm calling about a urgent repair at my property — my boiler stopped working last night. I have no heating or hot water.",
            "correct": true,
            "feedback": "✅ 緊急性・問題の内容・影響（暖房とお湯がない）を明確に伝えています。英国の賃貸では「urgent repair」という表現が法的に重要で、エージェントの対応義務を喚起します。冬のボイラー故障は緊急扱いになります。",
            "feedbackEn": "'Urgent repair' is legally significant in UK tenancy law—landlords must fix heating and hot water quickly, especially in winter. Stating the impact (no heating, no hot water) makes the urgency clear immediately.",
            "textJa": "ãŠã¯ã‚ˆã†ã”ã–ã„ã¾ã™ã€‚ç‰©ä»¶ã®ç·Šæ€¥ä¿®ç†ã«ã¤ã„ã¦é›»è©±ã—ã¦ã„ã¾ã™ã€‚æ˜¨å¤œãƒœã‚¤ãƒ©ãƒ¼ãŒæ­¢ã¾ã‚Šã¾ã—ãŸã€‚æš–æˆ¿ã‚‚ãŠæ¹¯ã‚‚å‡ºã¾ã›ã‚“ã€‚"
          },
          {
            "text": "Hello, I'm ringing because my boiler has completely stopped working — it cut out overnight and I've had no heating or hot water since then. I need this fixed as a matter of urgency.",
            "correct": false,
            "feedback": "✅ 問題は伝わりますが「urgent」という表現がないため、エージェントの緊急対応義務が喚起されにくいです。また「last night」から始まった問題であることや暖房・お湯がないという影響を伝えると、より迅速な対応につながります。",
            "feedbackEn": "The problem is clear, but lacking 'urgent' and the impact (no heating/hot water) means it may not be treated as a priority. UK landlords have a legal duty to fix heating quickly—make that urgency explicit.",
            "textJa": "ã“ã‚“ã«ã¡ã¯ã€‚ãƒœã‚¤ãƒ©ãƒ¼ãŒå®Œå…¨ã«æ­¢ã¾ã£ãŸã®ã§é›»è©±ã—ã¦ã„ã¾ã™ã€‚å¤œä¸­ã«æ­¢ã¾ã£ã¦ã€æš–æˆ¿ã‚‚ãŠæ¹¯ã‚‚å‡ºãªã„çŠ¶æ…‹ã§ã™ã€‚ç·Šæ€¥ã§ç›´ã—ã¦ã»ã—ã„ã§ã™ã€‚"
          },
          {
            "text": "Hello — there's a fairly urgent issue with my flat that I need to report. My heating system seems to have packed in entirely and I've had no hot water or warmth since yesterday evening.",
            "correct": false,
            "feedback": "⚠️ あいまいすぎます。受付が問題の内容を判断できず、適切な担当者につないでもらえない可能性があります。電話の最初から問題の内容を明確に伝えることが英国では期待されます。",
            "feedbackEn": "Too vague—the receptionist can't assess priority or route your call correctly. In the UK, stating the specific problem immediately (broken boiler, no heating) gets you to the right person faster.",
            "textJa": "ã“ã‚“ã«ã¡ã¯ã€ãƒ•ãƒ©ãƒƒãƒˆã®ç·Šæ€¥ã®å•é¡Œã‚’å ±å‘Šã—ãŸã„ã§ã™ã€‚æš–æˆ¿ã‚·ã‚¹ãƒ†ãƒ ãŒå®Œå…¨ã«æ­¢ã¾ã£ã¦ã—ã¾ã„ã€æ˜¨å¤œã‹ã‚‰æš–æˆ¿ã‚‚ãŠæ¹¯ã‚‚å‡ºãªã„çŠ¶æ…‹ã§ã™ã€‚"
          }
        ],
        "textJa": "ãŠã¯ã‚ˆã†ã”ã–ã„ã¾ã™ã€ã‚°ãƒªãƒ¼ãƒ³ãƒ•ã‚£ãƒ¼ãƒ«ãƒ‰ä¸å‹•ç”£ã§ã™ã€‚ä½•ã‹ã”ç”¨ä»¶ã§ã—ã‚‡ã†ã‹ï¼Ÿ"
      },
      {
        "speaker": "agent",
        "avatar": "🏠",
        "name": "Letting Agent",
        "text": "I'm sorry to hear that. We'll contact the landlord. It might take 24-48 hours to arrange a plumber.",
        "options": [
          {
            "text": "I understand, but it's December and I have a young child at home. Could you treat this as an emergency repair? Landlords have a duty to provide heating.",
            "correct": true,
            "feedback": "✅ 具体的な状況（冬・子ども）を伝え、法的な義務（heating duty）に言及しています。英国の賃貸法では暖房とお湯の修理は緊急義務とされており、この知識を穏やかに伝えることで迅速な対応を促せます。",
            "feedbackEn": "Citing your specific circumstances (winter, young child) and the landlord's legal duty is exactly right. Under UK law, heating and hot water must be repaired urgently. Knowing your rights and stating them calmly is effective.",
            "textJa": "åˆ†ã‹ã‚Šã¾ã™ãŒã€ä»Šã¯12æœˆã§ã€å°ã•ãªå­ä¾›ãŒã„ã¾ã™ã€‚ç·Šæ€¥ä¿®ç†ã¨ã—ã¦å¯¾å¿œã—ã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿå®¶ä¸»ã«ã¯æš–æˆ¿ã‚’æä¾›ã™ã‚‹ç¾©å‹™ãŒã‚ã‚Šã¾ã™ã€‚"
          },
          {
            "text": "OK, if that's the standard process then I'll wait — hopefully the landlord will get back to you quickly and this can all be sorted out within a day or so at the latest.",
            "correct": false,
            "feedback": "⚠️ 冬のボイラー故障は法的に緊急修理の対象です。「24-48時間」は一般的な修理には許容範囲ですが、暖房・お湯なしの場合は即日対応を求める権利があります。特に子どもや高齢者がいる場合は強く主張すべきです。",
            "feedbackEn": "Don't accept 24-48 hours without heating in winter—you have legal rights here. Landlords must provide heating and hot water urgently. Politely but clearly state your circumstances and ask for emergency treatment.",
            "textJa": "åˆ†ã‹ã‚Šã¾ã—ãŸã€ãã‚ŒãŒé€šå¸¸ã®æ‰‹é †ã§ã‚ã‚Œã°å¾…ã¡ã¾ã™ã€‚å®¶ä¸»ãŒæ—©ã‚ã«å¯¾å¿œã—ã¦ãã‚Œã‚‹ã“ã¨ã‚’é¡˜ã£ã¦ã„ã¾ã™ã€‚"
          },
          {
            "text": "Forty-eight hours is simply not acceptable in these conditions — I'm demanding a plumber within the hour, and if that doesn't happen I'll be withholding rent and contacting the council immediately.",
            "correct": false,
            "feedback": "⚠️ 感情的な反応は理解できますが、家賃の支払い停止は法的に複雑で逆効果になる場合があります。代わりに、緊急修理としての対応を穏やかに主張し、修理が遅れる場合の代替手段（一時宿泊費など）を交渉する方が建設的です。",
            "feedbackEn": "Withholding rent is legally complex and can backfire. Instead, calmly assert your right to emergency repair and ask about interim solutions (hotel costs, temporary heaters). Document everything in writing.",
            "textJa": "48æ™‚é–“ã¯ã“ã®çŠ¶æ³ã§ã¯å…¨ãå—ã‘å…¥ã‚Œã‚‰ã‚Œã¾ã›ã‚“ã€‚1æ™‚é–“ä»¥å†…ã«é…ç®¡å·¥ã‚’ã‚ˆã“ã—ã¦ãã ã•ã„ã€‚ãã†ã§ãªã‘ã‚Œã°å®¶è³ƒã‚’æ­¢ã‚ã¦å¸‚ã«é€£çµ¡ã—ã¾ã™ã€‚"
          }
        ],
        "textJa": "å¤§å¤‰ã§ã—ãŸã­ã€‚å®¶ä¸»ã«é€£çµ¡ã—ã¾ã™ã€‚é…ç®¡å·¥ã‚’æ‰‹é…ã™ã‚‹ã®ã«24ã€œ48æ™‚é–“ã‹ã‹ã‚‹ã‹ã‚‚ã—ã‚Œã¾ã›ã‚“ã€‚"
      },
      {
        "speaker": "agent",
        "avatar": "🏠",
        "name": "Letting Agent",
        "text": "I understand. I'll mark it as emergency and contact a plumber now. Can you confirm your address?",
        "options": [
          {
            "text": "Of course — it's 14 Maple Street, Islington, N1 2AB. Could you also confirm by email once a plumber is booked, so I have a record?",
            "correct": true,
            "feedback": "✅ 住所を明確に伝え、メールでの確認を求めています。英国の賃貸トラブルでは書面での記録が重要です。「so I have a record」という表現は権利主張のためではなく、記録管理の観点で自然に伝えています。",
            "feedbackEn": "Providing your address clearly and requesting written confirmation is smart UK tenancy practice. Having a paper trail protects you if repairs are delayed. Framing it as 'so I have a record' sounds reasonable rather than confrontational.",
            "textJa": "ã‚‚ã¡ã‚ã‚“ã§ã™ã€‚ã‚¤ã‚ºãƒªãƒ³ãƒˆãƒ³ã€ãƒ¡ãƒ¼ãƒ—ãƒ«ã‚¹ãƒˆãƒªãƒ¼ãƒˆ14ç•ªåœ°ã€N1 2ABã§ã™ã€‚é…ç®¡å·¥ã®äºˆç´„ãŒå–ã‚ŒãŸã‚‰ãƒ¡ãƒ¼ãƒ«ã§ç¢ºèªã—ã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Certainly — it's 14 Maple Street, N1. You can ring me back on this mobile if there are any issues getting access to the building or finding the property.",
            "correct": false,
            "feedback": "✅ 住所をテキストで送るのは実用的です。ただメールでの確認依頼も合わせて行うと、修理の記録が残り、後々のトラブル防止に役立ちます。英国賃貸では書面記録が非常に重要です。",
            "feedbackEn": "Texting is fine practically, but also request email confirmation of the booking. Written records are vital in UK tenancy law—if repairs are delayed or disputed, documentation protects your rights significantly.",
            "textJa": "ã‚‚ã¡ã‚ã‚“ã€ã‚¤ã‚ºãƒªãƒ³ãƒˆãƒ³ã€ãƒ¡ãƒ¼ãƒ—ãƒ«ã‚¹ãƒˆãƒªãƒ¼ãƒˆ14ç•ªåœ°ã€N1ã§ã™ã€‚å»ºç‰©ã¸ã®å…¥ã‚Šæ–¹ã§å•é¡ŒãŒã‚ã‚Œã°ã€ã“ã®æºå¸¯ã«é€£çµ¡ã—ã¦ãã ã•ã„ã€‚"
          },
          {
            "text": "It's 14 Maple Street, Islington — just buzz when you arrive. Actually, if it's going to be several hours I may need to arrange for a neighbour to let the engineer in.",
            "correct": false,
            "feedback": "✅ 時間確認は実用的です。ただし郵便番号を含む完全な住所を伝える方が、修理業者が確実に来訪できます。また書面での確認依頼も忘れずに。",
            "feedbackEn": "Asking about timing is practical, but give your full address including postcode to avoid any confusion. Also request written confirmation of the appointment—essential for UK tenancy records.",
            "textJa": "ã‚¤ã‚ºãƒªãƒ³ãƒˆãƒ³ã€ãƒ¡ãƒ¼ãƒ—ãƒ«ã‚¹ãƒˆãƒªãƒ¼ãƒˆ14ç•ªåœ°ã§ã™ã€‚ç€ã„ãŸã‚‰ãƒ–ã‚¶ãƒ¼ã‚’æŠ¼ã—ã¦ãã ã•ã„ã€‚ã‚‚ã—æ•°æ™‚é–“ã‹ã‹ã‚‹ã‚ˆã†ãªã‚‰ã€éš£äººã«å…¥ã‚Œã¦ã‚‚ã‚‰ã†æ‰‹é…ãŒå¿…è¦ã‹ã‚‚ã—ã‚Œã¾ã›ã‚“ã€‚"
          }
        ],
        "textJa": "åˆ†ã‹ã‚Šã¾ã—ãŸã€‚ç·Šæ€¥ã¨ã—ã¦ãƒžãƒ¼ã‚¯ã—ã¦ä»Šã™ãé…ç®¡å·¥ã«é€£çµ¡ã—ã¾ã™ã€‚ä½æ‰€ã‚’ç¢ºèªã•ã›ã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: Landlords are legally required to repair heating and hot water urgently under the Landlord and Tenant Act. Always request repairs in writing and keep records. If unresolved, contact your local council's Environmental Health team.",
    "tipJa": "🇬🇧 イギリスTip: 大家は法律上、暖房とお湯の修理を緊急で行う義務があります（Landlord and Tenant Act）。修理依頼は必ず書面で行い記録を保管しましょう。解決しない場合は地方議会のEnvironmental Healthに連絡を。"
  },
  "conv_life_transport": {
    "id": "conv_life_transport",
    "title": "Asking about buses & trains",
    "titleJa": "バス・電車の問い合わせ",
    "situation": "You're at a bus stop in London, unsure which bus to take to your destination.",
    "situationJa": "ロンドンのバス停で、目的地へのバスが分からず困っています。",
    "turns": [
      {
        "speaker": "stranger",
        "avatar": "🚌",
        "name": "Passenger",
        "text": "You all right? Waiting for the 73?",
        "options": [
          {
            "text": "Hi! Actually, I'm trying to get to Angel — do you know which bus I should take?",
            "correct": true,
            "feedback": "✅ 明確で丁寧な質問です。目的地を具体的に伝えることで、相手が的確なアドバイスをしやすくなります。英国では見知らぬ人への質問も自然で、バス停での会話は日常的です。",
            "feedbackEn": "Clear and direct. Stating your destination gives the other person what they need to help you. Asking strangers at bus stops is completely normal in UK culture.",
            "textJa": "ã“ã‚“ã«ã¡ã¯ï¼ã‚¨ãƒ³ã‚¸ã‚§ãƒ«ã«è¡ŒããŸã„ã‚“ã§ã™ãŒã€ã©ã®ãƒã‚¹ã«ä¹—ã‚Œã°ã„ã„ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I'm not sure. I need to go to Angel — is this the right stop?",
            "correct": false,
            "feedback": "✅ こちらも良い対応です。不確実さを正直に伝えつつ、目的地を明示しています。ただ「is this the right stop?」はYes/Noで終わりやすく、より詳しい情報を引き出しにくいです。",
            "feedbackEn": "Good approach—honest about uncertainty and states the destination. However, 'is this the right stop?' invites a yes/no answer. An open question like 'which bus should I take?' gets more useful information.",
            "textJa": "ã‚ˆãåˆ†ã‹ã‚Šã¾ã›ã‚“ã€‚ã‚¨ãƒ³ã‚¸ã‚§ãƒ«ã«è¡ŒããŸã„ã‚“ã§ã™ãŒã€ã“ã“ã§åˆã£ã¦ã„ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Yes, just waiting for the 73 actually — is this the right stop for heading towards Oxford Street?",
            "correct": false,
            "feedback": "⚠️ 実際に何を待っているか分からない状況でこう答えると、情報を得る機会を逃します。英国ではバス停での会話は自然なので、助けを求めるのがベストです。",
            "feedbackEn": "You're missing a chance to get help. In the UK, asking fellow passengers for directions is completely normal and expected. Don't be shy—people are generally happy to help.",
            "textJa": "ã¯ã„ã€73ç•ªã‚’å¾…ã£ã¦ã„ã¾ã™ã€‚ã‚ªãƒƒã‚¯ã‚¹ãƒ•ã‚©ãƒ¼ãƒ‰ã‚¹ãƒˆãƒªãƒ¼ãƒˆæ–¹å‘ã§ã“ã“ã§åˆã£ã¦ã„ã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "å¤§ä¸ˆå¤«ã§ã™ã‹ï¼Ÿ73ç•ªã‚’å¾…ã£ã¦ã„ã¾ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "stranger",
        "avatar": "🚌",
        "name": "Passenger",
        "text": "Angel? You want the 38 or the 56 from across the road — this side only goes north.",
        "options": [
          {
            "text": "Oh brilliant, thank you! So I need to cross over — the 38 or the 56?",
            "correct": true,
            "feedback": "✅ 情報を確認しながら、次のステップを明確にする対応。「brilliant」はイギリス人が喜ぶ反応で、会話をスムーズに続けます。重要な情報（2つのバス番号）を繰り返して確認する姿勢が英国では信頼されます。",
            "feedbackEn": "'Brilliant' is a warm British response. Repeating key information (38 or 56) confirms you've understood and keeps the conversation going naturally—very good communication style.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼æ¸¡ã£ãŸæ–¹ãŒã„ã„ã‚“ã§ã™ã­ã€‚38ç•ªã‹56ç•ªã§ã™ã­ï¼Ÿ"
          },
          {
            "text": "I see — thank you so much. I'll use Google Maps to check.",
            "correct": false,
            "feedback": "⚠️ 感謝の表現は良いですが、せっかく親切に教えてくれた相手に「Google Mapsで確認する」と言うと少し失礼に聞こえます。相手の情報を信頼し、「Which one is more frequent?」など追加質問をする方が自然です。",
            "feedbackEn": "Thanking is good, but mentioning Google Maps suggests you don't trust their advice, which can feel dismissive. Accept the information warmly and ask a follow-up like 'Which one comes more often?'",
            "textJa": "ãã†ã§ã™ã‹ã€ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ã‚°ãƒ¼ã‚°ãƒ«ãƒžãƒƒãƒ—ã§ç¢ºèªã—ã¾ã™ã€‚"
          },
          {
            "text": "Oh no — I've been waiting on the wrong side! How long do you think I'll have to wait?",
            "correct": false,
            "feedback": "⚠️ 状況を理解した反応としては自然ですが、「Oh no」という過度な反応は英国文化では少し大げさに映ります。また待ち時間を聞くより、まず「どちらのバスに乗るべきか」を確認する方が実用的です。",
            "feedbackEn": "Understanding you're on the wrong side is good, but 'Oh no' sounds a bit dramatic for British tastes. Focus on the practical next step: confirm which bus to take before asking about waiting times.",
            "textJa": "é•ã†å´ã§å¾…ã£ã¦ã„ãŸã‚“ã§ã™ã­ï¼ã©ã®ãã‚‰ã„å¾…ã¤ã¨æ€ã„ã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ã‚¨ãƒ³ã‚¸ã‚§ãƒ«ï¼Ÿå‘ã“ã†ã®é“ã®38ç•ªã‹56ç•ªã«ä¹—ã£ã¦ãã ã•ã„ã€‚ã“ã®å´ã¯åŒ—è¡Œãã—ã‹ã‚ã‚Šã¾ã›ã‚“ã€‚"
      },
      {
        "speaker": "stranger",
        "avatar": "🚌",
        "name": "Passenger",
        "text": "Either works — the 38's more frequent. You'll need to tap in with your Oyster.",
        "options": [
          {
            "text": "Perfect, thank you! I've got my Oyster card ready. Really appreciate the help.",
            "correct": true,
            "feedback": "✅ 相手の助けに自然に感謝し、準備ができていることを示しています。「Really appreciate」は英国で誠実さを伝える定番表現です。会話を温かく締めくくる最良の対応です。",
            "feedbackEn": "'Really appreciate' is a warm and genuine British sign-off. Confirming you have your Oyster card shows you're prepared—a reassuring note that wraps up the exchange naturally.",
            "textJa": "å®Œç’§ã§ã™ã€ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼ã‚ªã‚¤ã‚¹ã‚¿ãƒ¼ã‚«ãƒ¼ãƒ‰ã¯ç”¨æ„ã—ã¦ã„ã¾ã™ã€‚æœ¬å½“ã«åŠ©ã‹ã‚Šã¾ã—ãŸã€‚"
          },
          {
            "text": "Great — and do I need to tap out as well, or just tap in?",
            "correct": false,
            "feedback": "✅ 実用的な追加質問で、英国のバス乗車マナーへの関心を示しています。バスはtap inのみ（tap outは不要）という知識を確認しようとする姿勢は良いです。ただ、まず感謝を述べてから質問するとより自然です。",
            "feedbackEn": "Good practical question—on London buses you only tap in (no tap out needed). Showing interest in doing things correctly is appreciated. Just remember to thank them first before asking follow-ups.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼ã‚¿ãƒƒãƒã‚¢ã‚¦ãƒˆã‚‚å¿…è¦ã§ã™ã‹ã€ãã‚Œã¨ã‚‚ã‚¿ãƒƒãƒã‚¤ãƒ³ã ã‘ã§ã„ã„ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Thank you so much! I actually have a contactless bank card as well — will that work in the same way as an Oyster, or is it better to stick with this?",
            "correct": false,
            "feedback": "⚠️ 感謝は良いですが「Sorry for the trouble」は必要ありません。バス停での案内は相手も喜んでしていることで、謝罪は過剰です。英国では「謝りすぎる」のは逆に不自然に聞こえます。",
            "feedbackEn": "Thanking is fine, but 'Sorry for the trouble' is unnecessary—they were happy to help. Over-apologising can actually seem awkward in British culture. A simple 'Thank you, really helpful!' is perfect.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼ã‚³ãƒ³ã‚¿ã‚¯ãƒˆãƒ¬ã‚¹å¯¾å¿œã®éŠ€è¡Œã‚«ãƒ¼ãƒ‰ã‚‚ã‚ã‚‹ã‚“ã§ã™ãŒã€ã‚ªã‚¤ã‚¹ã‚¿ãƒ¼ã¨åŒã˜ã‚ˆã†ã«ä½¿ãˆã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ã©ã¡ã‚‰ã§ã‚‚å¤§ä¸ˆå¤«ã§ã™ã€‚38ç•ªã®æ–¹ãŒæœ¬æ•°ãŒå¤šã„ã§ã™ã€‚ã‚ªã‚¤ã‚¹ã‚¿ãƒ¼ã‚«ãƒ¼ãƒ‰ã‚’ã‚¿ãƒƒãƒã™ã‚‹å¿…è¦ãŒã‚ã‚Šã¾ã™ã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: London buses only require tapping in (not out) with Oyster or contactless. Always have your card ready before boarding to avoid holding up the queue.",
    "tipJa": "🇬🇧 イギリスTip: ロンドンのバスはOysterカードや非接触カードでのタップインのみ（タップアウト不要）。乗車前にカードを準備しておきましょう。"
  },
  "conv_life_money": {
    "id": "conv_life_money",
    "title": "Understanding your payslip & NI number",
    "titleJa": "給与明細・NI番号の確認",
    "situation": "You've just started a new job in the UK. You're asking your HR manager about your first payslip and National Insurance number.",
    "situationJa": "英国で新しい仕事を始めました。HRマネージャーに給与明細とNI番号について質問しています。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "💼",
        "name": "HR Manager",
        "text": "Hi! Just checking in — have you received your NI number yet? You'll need it for payroll.",
        "options": [
          {
            "text": "Not yet — I applied a few weeks ago. Should I chase HMRC, or can HR help with this?",
            "correct": true,
            "feedback": "✅ 状況を正直に伝えつつ、次のステップについて具体的に質問しています。英国では「chase」という表現は「フォローアップする」という意味で一般的です。HRと自分で何ができるかを確認する姿勢が効率的です。",
            "feedbackEn": "'Chase' is standard British business English for following up. Asking whether HR can help shows initiative and saves time. This is exactly the right approach for navigating UK bureaucracy.",
            "textJa": "ã¾ã ã§ã™ã€‚æ•°é€±é–“å‰ã«ç”³è«‹ã—ã¾ã—ãŸã€‚HMRCã«å‚¬ä¿ƒã™ã¹ãã§ã™ã‹ã€ãã‚Œã¨ã‚‚HRãŒåŠ©ã‘ã¦ãã‚Œã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I don't actually have it yet — is a National Insurance number something I need to apply for separately online, or does it arrive automatically once I've started working?",
            "correct": false,
            "feedback": "✅ NI番号を知らない場合、正直に聞くのは良いことです。英国ではNational Insurance（国民保険）番号は就労・税金・給付金に必須の番号です。ただ「already applied」という状況確認も加えると、HRが次のステップをアドバイスしやすくなります。",
            "feedbackEn": "Asking what an NI number is shows honesty, which is appreciated. However, also mentioning whether you've applied gives HR the context they need to help you more efficiently.",
            "textJa": "ã¾ã ãªã„ã‚“ã§ã™ã€‚å›½æ°‘ä¿é™ºç•ªå·ã¯åˆ¥é€”ã‚ªãƒ³ãƒ©ã‚¤ãƒ³ã§ç”³è«‹ã™ã‚‹å¿…è¦ãŒã‚ã‚Šã¾ã™ã‹ï¼Ÿãã‚Œã¨ã‚‚åƒãå§‹ã‚ã‚‹ã¨è‡ªå‹•çš„ã«å±Šãã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Yes, I've received it — I believe it was on a letter from HMRC or the government. Should I give it to you now, or does HR need to see the original letter for their records?",
            "correct": false,
            "feedback": "⚠️ NI番号を持っている場合は完全に正しい対応です。ただしまだ持っていないのにこう答えると問題になります。英国の給与計算では正確なNI番号が必須なので、正直に状況を伝えることが重要です。",
            "feedbackEn": "If you have it, offering it immediately is perfect. But if you don't have it yet, be honest—NI numbers are essential for UK payroll and tax. Honesty here saves complications later.",
            "textJa": "ã¯ã„ã€å—ã‘å–ã‚Šã¾ã—ãŸã€‚HMRCã‹æ”¿åºœã‹ã‚‰ã®æ‰‹ç´™ã«æ›¸ã„ã¦ã‚ã£ãŸã¨æ€ã„ã¾ã™ã€‚ä»ŠãŠä¼ãˆã™ã¹ãã§ã™ã‹ã€ãã‚Œã¨ã‚‚HRãŒåŽŸæœ¬ã‚’ç¢ºèªã™ã‚‹å¿…è¦ãŒã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ã“ã‚“ã«ã¡ã¯ï¼NIç•ªå·ã¯ã‚‚ã†å—ã‘å–ã‚Šã¾ã—ãŸã‹ï¼Ÿçµ¦ä¸Žè¨ˆç®—ã«å¿…è¦ã§ã™ã€‚"
      },
      {
        "speaker": "colleague",
        "avatar": "💼",
        "name": "HR Manager",
        "text": "We can still process your first payslip on an emergency tax code — you might pay slightly more initially, but it'll balance out. Does that work?",
        "options": [
          {
            "text": "That works, thanks. Could you explain what an emergency tax code means for my take-home pay?",
            "correct": true,
            "feedback": "✅ 提案を受け入れながら、自分への影響を具体的に確認しています。「take-home pay」は手取り給与を指す英国での一般的な表現です。財務的な影響を事前に把握しようとする姿勢は、英国のビジネス文化で評価されます。",
            "feedbackEn": "'Take-home pay' is standard British English for net pay. Asking about the practical impact shows financial awareness and is a perfectly reasonable question in a UK workplace.",
            "textJa": "å¤§ä¸ˆå¤«ã§ã™ã€ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ç·Šæ€¥ã®ç¨Žã‚³ãƒ¼ãƒ‰ãŒæ‰‹å–ã‚Šã«ã©ã†å½±éŸ¿ã™ã‚‹ã‹æ•™ãˆã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "OK, that's fine — an emergency tax code shouldn't affect the salary figure too drastically, so it's probably close enough for now and we can sort the details out later.",
            "correct": false,
            "feedback": "⚠️ 信頼の表現は良いですが、緊急税コードは給与から多めに引かれる可能性があるため、影響を確認することが重要です。英国のHRは詳細を説明することに慣れているので、遠慮なく質問してください。",
            "feedbackEn": "Trust is good, but emergency tax codes can mean higher deductions initially. It's smart to ask about the impact—HR staff expect and welcome these questions. Don't be shy about your finances.",
            "textJa": "å¤§ä¸ˆå¤«ã§ã™ã€‚ç·Šæ€¥ã®ç¨Žã‚³ãƒ¼ãƒ‰ã§çµ¦ä¸ŽãŒå¤§ããå¤‰ã‚ã‚‹ã‚ã‘ã§ã¯ãªã„ã®ã§ã€ã¨ã‚Šã‚ãˆãšã¯å¤§ä¸ˆå¤«ã§ã—ã‚‡ã†ã€‚å¾Œã§æ•´ç†ã—ã¾ã™ã€‚"
          },
          {
            "text": "Actually, can we delay my first payslip until I have my NI number?",
            "correct": false,
            "feedback": "⚠️ 実際には可能な場合もありますが、これはHRの業務に支障をきたす可能性があります。英国では緊急税コードで処理し、後で修正する方法が一般的です。HRの提案を受け入れ、詳細を確認する方が協力的です。",
            "feedbackEn": "This might cause administrative complications for HR. The emergency tax code approach is standard UK practice and can be corrected later. Accept the offer and ask questions rather than requesting delays.",
            "textJa": "NIç•ªå·ãŒå±Šãã¾ã§æœ€åˆã®çµ¦ä¸Žã‚’é…ã‚‰ã›ã‚‹ã“ã¨ã¯ã§ãã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ç·Šæ€¥ã®ç¨Žã‚³ãƒ¼ãƒ‰ã§æœ€åˆã®çµ¦ä¸Žæ˜Žç´°ã‚’å‡¦ç†ã™ã‚‹ã“ã¨ãŒã§ãã¾ã™ã€‚æœ€åˆã¯å°‘ã—å¤šãå¼•ã‹ã‚Œã‚‹ã‹ã‚‚ã—ã‚Œã¾ã›ã‚“ãŒã€å¾Œã§èª¿æ•´ã•ã‚Œã¾ã™ã€‚å¤§ä¸ˆå¤«ã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "💼",
        "name": "HR Manager",
        "text": "Of course. You'll see deductions for Income Tax, National Insurance, and your pension contribution. Anything else you'd like to know?",
        "options": [
          {
            "text": "Yes — could you point me to somewhere I can check my tax code is correct once my NI number comes through?",
            "correct": true,
            "feedback": "✅ 積極的で自立した姿勢が英国文化で高く評価されます。HMRC（英国税務当局）のオンラインアカウントで税コードを確認できます。自分で確認できるリソースを求めることで、HRの負担を減らしながら自己管理を示しています。",
            "feedbackEn": "Proactively asking where to check your own tax code shows initiative—very valued in UK workplaces. You can check via your HMRC Personal Tax Account online. This reduces HR's workload too.",
            "textJa": "ã¯ã„ã€NIç•ªå·ãŒå±Šã„ãŸã‚‰ç¨Žã‚³ãƒ¼ãƒ‰ãŒæ­£ã—ã„ã‹ç¢ºèªã™ã‚‹æ–¹æ³•ã‚’æ•™ãˆã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Thank you — that all makes sense. I'm sure it will sort itself out once I've been on payroll for a month or two and everything has had a chance to catch up through the system.",
            "correct": false,
            "feedback": "✅ 自主的に調べる姿勢は良いです。ただ「where can I check?」と具体的なリソースを聞く方が効率的です。英国ではHRに質問するのは全く普通のことで、自分で調べると言うことが必ずしも好印象とは限りません。",
            "feedbackEn": "Self-sufficiency is valued, but asking for specific resources is even better. HR staff are there to help with exactly these questions—take advantage of their knowledge rather than figuring it out alone.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ãã‚Œã§åˆ†ã‹ã‚Šã¾ã—ãŸã€‚1ã€œ2ãƒ¶æœˆçµ¦ä¸Žã‚’å—ã‘å–ã‚Œã°ã€ã™ã¹ã¦æ•´ã†ã¨æ€ã„ã¾ã™ã€‚"
          },
          {
            "text": "Will HMRC automatically contact me once my NI number comes through to confirm the correct code, or is there anything I actually need to do proactively at my end to get it updated?",
            "correct": false,
            "feedback": "⚠️ 雇用主は給与から源泉徴収する税額を把握していますが、個人の税務状況の詳細は知りません。この質問自体は有効ですが、より実用的なのは「どうすれば自分の税コードが正しいか確認できるか」を聞くことです。",
            "feedbackEn": "Employers know what tax they deduct, but not the full picture of your tax affairs. A more useful question is how to verify your own tax code is correct—that's within your control and HMRC's remit.",
            "textJa": "NIç•ªå·ãŒå±Šã„ãŸã‚‰HMRCã‹ã‚‰è‡ªå‹•çš„ã«æ­£ã—ã„ã‚³ãƒ¼ãƒ‰ãŒå±Šãã¾ã™ã‹ï¼Ÿãã‚Œã¨ã‚‚ä½•ã‹ç©æ¥µçš„ã«ã™ã‚‹å¿…è¦ãŒã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ã‚‚ã¡ã‚ã‚“ã§ã™ã€‚æ‰€å¾—ç¨Žã€å›½æ°‘ä¿é™ºã€å¹´é‡‘æ‹ å‡ºé‡‘ã®æŽ§é™¤ãŒã‚ã‚Šã¾ã™ã€‚ä»–ã«ä½•ã‹çŸ¥ã‚ŠãŸã„ã“ã¨ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: Your NI number is in the format AB123456C. Apply via GOV.UK if you don't have one. Set up a Personal Tax Account on HMRC's website to manage your tax code and check deductions.",
    "tipJa": "🇬🇧 イギリスTip: NI番号はAB123456C形式。持っていない場合はGOV.UKから申請を。HRMCのPersonal Tax Accountを設定すると税コードや控除を自分で確認できます。"
  },
  "conv_biz_remote": {
    "id": "conv_biz_remote",
    "title": "Facilitating a Teams/Zoom meeting",
    "titleJa": "Teams/Zoom会議のファシリテーション",
    "situation": "You're facilitating a hybrid team meeting on Microsoft Teams. Some colleagues are in the office, others are remote.",
    "situationJa": "Microsoft Teamsでハイブリッドチーム会議をファシリテートしています。一部の同僚はオフィスに、他はリモートで参加しています。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "💻",
        "name": "Remote colleague",
        "text": "Sorry, can you repeat that? There's a bit of an echo from the office side.",
        "options": [
          {
            "text": "Of course — apologies for the echo. Could those in the office mute when not speaking? Let me repeat...",
            "correct": true,
            "feedback": "✅ 問題に対して即座に対応し、全員への配慮を示しています。「Could those in the office mute...」というリクエストは指示ではなく依頼形で、英国のビジネス文化での丁寧なファシリテーションスタイルに合っています。",
            "feedbackEn": "Immediate action, an apology, and a polite request to mute—this is textbook UK meeting facilitation. Using 'could' rather than 'please mute' softens the request and keeps the tone collaborative.",
            "textJa": "ã‚‚ã¡ã‚ã‚“ã§ã™ã€‚ã‚¨ã‚³ãƒ¼ã«ã¤ã„ã¦ç”³ã—è¨³ã‚ã‚Šã¾ã›ã‚“ã€‚ã‚ªãƒ•ã‚£ã‚¹ã«ã„ã‚‹æ–¹ã€…ã¯è©±ã—ã¦ã„ãªã„æ™‚ã¯ãƒŸãƒ¥ãƒ¼ãƒˆã«ã—ã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿã‚‚ã†ä¸€åº¦ç¹°ã‚Šè¿”ã—ã¾ã™..."
          },
          {
            "text": "Apologies for the interruption — let me go back to the beginning and run through everything again from the start so there are no gaps for anyone on the call.",
            "correct": false,
            "feedback": "✅ 素早く対応する姿勢は良いです。ただエコーの原因（オフィス側のマイク）に対処しないと、問題が繰り返されます。より良いファシリテーションは原因に対処しながら繰り返すことです。",
            "feedbackEn": "Quick response is good, but not addressing the echo source means it'll happen again. Good facilitation means solving the underlying issue—ask the office side to mute—before repeating yourself.",
            "textJa": "ä¸­æ–­ã—ã¦ç”³ã—è¨³ã‚ã‚Šã¾ã›ã‚“ã€‚æœ€åˆã‹ã‚‰å…¨éƒ¨ã‚‚ã†ä¸€åº¦èª¬æ˜Žã—ã¾ã™ã€‚é€šè©±ã«å‚åŠ ã—ã¦ã„ã‚‹å…¨å“¡ã«æŠœã‘æ¼ã‚ŒãŒãªã„ã‚ˆã†ã«ã€‚"
          },
          {
            "text": "I'm not detecting any echo from my side of the call — could it be your microphone settings or laptop speakers that are causing the feedback for everyone else?",
            "correct": false,
            "feedback": "⚠️ 問題を相手のせいにするのは避けましょう。エコーはオフィス側のマイクが原因である可能性が高く、ファシリテーターとしては全員が快適に参加できる環境を作る責任があります。",
            "feedbackEn": "Deflecting to the other person's setup is poor facilitation. The echo likely comes from the office side. As facilitator, take ownership of the audio environment rather than shifting blame.",
            "textJa": "ç§ã®å´ã‹ã‚‰ã¯ã‚¨ã‚³ãƒ¼ã¯èžã“ãˆã¦ã„ã¾ã›ã‚“ã€‚ã‚ãªãŸã®ãƒžã‚¤ã‚¯è¨­å®šã‹ãƒ©ãƒƒãƒ—ãƒˆãƒƒãƒ—ã®ã‚¹ãƒ”ãƒ¼ã‚«ãƒ¼ãŒåŽŸå› ã‹ã‚‚ã—ã‚Œã¾ã›ã‚“ã€‚"
          }
        ],
        "textJa": "ã™ã¿ã¾ã›ã‚“ã€ã‚‚ã†ä¸€åº¦è¨€ã£ã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿã‚ªãƒ•ã‚£ã‚¹å´ã‹ã‚‰å°‘ã—ã‚¨ã‚³ãƒ¼ãŒã—ã¦ã„ã¾ã™ã€‚"
      },
      {
        "speaker": "colleague",
        "avatar": "💻",
        "name": "Remote colleague",
        "text": "Thanks. Also, I can't see the screen share — could you check it's working?",
        "options": [
          {
            "text": "Good point — let me stop and restart the share. Bear with me one moment.",
            "correct": true,
            "feedback": "✅ 「Good point」で相手の指摘を認め、「Bear with me」はイギリス人がよく使う「少々お待ちを」の表現です。技術的な問題に対して落ち着いて対処する姿勢が、英国のビジネス文化では信頼感を生みます。",
            "feedbackEn": "'Bear with me' is a very British way to ask for patience—natural and warm. Acknowledging the issue with 'good point' and taking action immediately shows confident, calm facilitation.",
            "textJa": "ãŠã£ã—ã‚ƒã‚‹é€šã‚Šã§ã™ã€‚å…±æœ‰ã‚’åœæ­¢ã—ã¦å†èµ·å‹•ã—ã¾ã™ã€‚å°‘ã€…ãŠå¾…ã¡ãã ã•ã„ã€‚"
          },
          {
            "text": "Is anyone else having trouble seeing the screen?",
            "correct": false,
            "feedback": "✅ 問題の範囲を確認するのは良いアプローチです。ただし、確認しながら同時に画面共有を再起動する方が時間の節約になります。英国のビジネス文化では効率性が重視されます。",
            "feedbackEn": "Checking if others have the same issue shows consideration, but do it while also fixing the share. UK meetings value efficiency—address the problem and verify simultaneously.",
            "textJa": "ä»–ã«ç”»é¢ãŒè¦‹ãˆãªã„æ–¹ã¯ã„ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I can see it on my screen, so it must be an issue on your end.",
            "correct": false,
            "feedback": "❌ ファシリテーターとして問題を参加者のせいにするのは不適切です。画面共有の設定を確認し、全員が見られるようにするのがファシリテーターの役割です。英国のビジネス文化では「ownership」（責任を持って対処する）が重視されます。",
            "feedbackEn": "As facilitator, never blame participants for technical issues. It's your responsibility to ensure everyone can see the content. Take ownership and fix it—this is fundamental to UK meeting facilitation.",
            "textJa": "ç§ã®ç”»é¢ã§ã¯è¦‹ãˆã¦ã„ã‚‹ã®ã§ã€ã‚ãªãŸã®å´ã®å•é¡Œã ã¨æ€ã„ã¾ã™ã€‚"
          }
        ],
        "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ç”»é¢å…±æœ‰ã‚‚è¦‹ãˆãªã„ã‚“ã§ã™ãŒã€ç¢ºèªã—ã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "👔",
        "name": "In-office colleague",
        "text": "Should we just crack on? We're running a bit behind.",
        "options": [
          {
            "text": "Good shout — let's pick up from the action points. Sarah, could you quickly summarise where we got to?",
            "correct": true,
            "feedback": "✅ 「Good shout」は英国ビジネスでよく使われる肯定表現。進行を取り戻しながら、特定の参加者に役割を与えることで会議を活性化させています。全員が状況を共有できるよう配慮したファシリテーションです。",
            "feedbackEn": "'Good shout' is natural British meeting language for 'good idea'. Delegating a summary to a named colleague keeps everyone aligned and shows confident facilitation—this is exactly right.",
            "textJa": "ãã†ã—ã¾ã—ã‚‡ã†ï¼ã‚¢ã‚¯ã‚·ãƒ§ãƒ³ãƒã‚¤ãƒ³ãƒˆã‹ã‚‰å†é–‹ã—ã¾ã—ã‚‡ã†ã€‚ã‚µãƒ©ã€ã©ã“ã¾ã§é€²ã‚“ã ã‹ç°¡å˜ã«ã¾ã¨ã‚ã¦ã‚‚ã‚‰ãˆã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Right — let me talk everyone through the full agenda from the beginning, just to make sure we're all properly aligned before we move on to the main items.",
            "correct": false,
            "feedback": "⚠️ 謝罪は良いですが、「check if everyone's ready」は更に時間がかかります。英国の会議では遅れた後は素早く本題に戻るのが期待されます。「Let's pick up from...」と直接次のポイントに移る方が効率的です。",
            "feedbackEn": "Apologising is fine, but checking if everyone's ready adds more delay. In UK meetings, after a disruption, dive straight back into content—'Let's pick up from...' gets things moving faster.",
            "textJa": "ãã†ã§ã™ã­ã€æœ€åˆã‹ã‚‰è­°é¡Œã‚’èª¬æ˜Žã—ã¦ã€å…¨å“¡ãŒä¸»è¦ãªè­°é¡Œã«é€²ã‚€å‰ã«ãã¡ã‚“ã¨æƒã£ã¦ã„ã‚‹ã‹ç¢ºèªã—ã¾ã™ã€‚"
          },
          {
            "text": "Absolutely — I'll just quickly finish explaining the technical issue first.",
            "correct": false,
            "feedback": "⚠️ 技術的な問題の説明は不要です。英国のビジネス文化では「action over explanation」が重視されます。問題を簡潔に認めて前に進む方が、プロフェッショナルな印象を与えます。",
            "feedbackEn": "Don't explain technical issues at length—UK meetings prefer action over explanation. Acknowledge briefly and move on. 'Right, let's crack on' is all you need.",
            "textJa": "åˆ†ã‹ã‚Šã¾ã—ãŸã€‚ã§ã‚‚å…ˆã«æŠ€è¡“çš„ãªå•é¡Œã®èª¬æ˜Žã‚’çµ‚ã‚ã‚‰ã›ã¾ã™ã€‚"
          }
        ],
        "textJa": "å°‘ã—é…ã‚Œã¦ã„ã‚‹ã®ã§ã€ç¶šã‘ã¾ã—ã‚‡ã†ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: In hybrid meetings, always ask remote participants first if they can hear and see clearly. 'Bear with me', 'good shout', and 'crack on' are common British meeting phrases worth knowing.",
    "tipJa": "🇬🇧 イギリスTip: ハイブリッド会議では、まずリモート参加者に音声・画面が問題ないか確認しましょう。「Bear with me」「good shout」「crack on」は英国の会議でよく使われる表現です。"
  },
  "conv_culture_queue": {
    "id": "conv_culture_queue",
    "title": "Queue culture & jumping the queue",
    "titleJa": "キュー文化・割り込みへの対応",
    "situation": "You're queuing at a busy London deli. Someone tries to jump the queue in front of you.",
    "situationJa": "ロンドンのデリで列に並んでいます。誰かがあなたの前に割り込もうとしています。",
    "turns": [
      {
        "speaker": "stranger",
        "avatar": "🧍",
        "name": "Queue jumper",
        "text": "Excuse me, I just need to grab one thing — won't be a sec.",
        "options": [
          {
            "text": "Sorry, I think there's a queue — the back's just there.",
            "correct": true,
            "feedback": "✅ これが英国人の典型的な対応です。「Sorry」で始めて相手を直接批判せず、列の存在を穏やかに指摘しています。「I think」という控えめな表現と「the back's just there」という事実の指摘が、英国文化の間接的コミュニケーションの完璧な例です。",
            "feedbackEn": "This is quintessentially British. Starting with 'Sorry' (even though you've done nothing wrong), using 'I think' to soften the observation, and pointing out the queue location rather than accusing—perfect passive-assertive British style.",
            "textJa": "ã™ã¿ã¾ã›ã‚“ã€é †ç•ªå¾…ã¡ãŒã‚ã‚Šã¾ã™ã€‚åˆ—ã®æœ€å¾Œå°¾ã¯ã‚ã¡ã‚‰ã§ã™ã€‚"
          },
          {
            "text": "Of course, not a problem — I'm sure no one in the queue will mind, and it only seems polite to let you through for just one thing.",
            "correct": false,
            "feedback": "⚠️ 親切ですが、列に並んでいる他の人への不公平につながります。英国では列は神聖なものです。「ノー問題」と言って割り込みを許すと、後ろの人たちに対して失礼になります。穏やかに指摘する方が英国文化的に正しい行動です。",
            "feedbackEn": "Very kind, but this is unfair to everyone else in the queue. In the UK, the queue is sacred. Letting someone jump affects everyone behind you. A gentle 'I think there's a queue' is the expected response.",
            "textJa": "ã‚‚ã¡ã‚ã‚“ã€ã©ã†ãžã€‚ä¸€ã¤ã ã‘ãªã‚‰åˆ—ã®æ–¹ã€…ã‚‚æ°—ã«ã—ãªã„ã§ã—ã‚‡ã†ã€‚"
          },
          {
            "text": "Actually, we've all been waiting. You need to join the back.",
            "correct": false,
            "feedback": "⚠️ 内容は正しいですが、やや直接的すぎます。英国文化ではこのような状況でも間接的な表現が好まれます。「Sorry, I think there's a queue」の方が摩擦を避けながら同じメッセージを伝えられます。",
            "feedbackEn": "Correct in content but too direct for British taste. Even when asserting your rights, British culture prefers indirection. 'Sorry, I think there's a queue' conveys the same message with far less friction.",
            "textJa": "å®Ÿã¯ã€ã¿ã‚“ãªå¾…ã£ã¦ã„ã¾ã™ã€‚å¾Œã‚ã«ä¸¦ã‚“ã§ãã ã•ã„ã€‚"
          }
        ],
        "textJa": "ã™ã¿ã¾ã›ã‚“ã€ä¸€ã¤ã ã‘å–ã‚‹ã®ã§ã€ã™ãçµ‚ã‚ã‚Šã¾ã™ã€‚"
      },
      {
        "speaker": "stranger",
        "avatar": "🧍",
        "name": "Queue jumper",
        "text": "Oh sorry, I didn't see the queue! How embarrassing.",
        "options": [
          {
            "text": "No worries — it happens! The end's just around the corner.",
            "correct": true,
            "feedback": "✅ 「No worries」で相手の謝罪を温かく受け入れ、正確な情報（列の最後尾の場所）を提供しています。相手の恥ずかしさを軽減しながらも、正しい行動（列に並ぶ）を促す英国的な完璧な対応です。",
            "feedbackEn": "'No worries' graciously accepts the apology while guiding them to the correct position. This resolves the awkwardness kindly—exactly what British social etiquette expects when someone makes an honest mistake.",
            "textJa": "å¤§ä¸ˆå¤«ã§ã™ã‚ˆï¼èª°ã§ã‚‚ã‚ã‚‹ã“ã¨ã§ã™ã€‚æœ€å¾Œå°¾ã¯ã‚ã¡ã‚‰ã®è§’ã§ã™ã€‚"
          },
          {
            "text": "That's completely fine — honestly it really isn't a big deal at all. Please don't worry, it could happen to absolutely anyone. After you!",
            "correct": false,
            "feedback": "✅ 温かく受け入れる表現として問題ありません。ただ「The end's just around the corner」という具体的な案内がないため、相手がどこへ行けばいいか分からない可能性があります。",
            "feedbackEn": "Kind and gracious, but missing the practical guidance on where the back of the queue is. British etiquette combines forgiveness with helpfulness—add the queue location for the complete response.",
            "textJa": "å…¨ç„¶å¤§ä¸ˆå¤«ã§ã™ã‚ˆã€‚èª°ã§ã‚‚ã‚ã‚‹ã“ã¨ã§ã™ã‹ã‚‰ã€‚ã©ã†ãžã€ãŠå…ˆã«ï¼"
          },
          {
            "text": "That's okay. But next time, please check for a queue.",
            "correct": false,
            "feedback": "⚠️ 前半は良いですが「next time, please check」は少し説教的に聞こえます。相手はすでに謝罪しており、英国文化ではその後に説教を加えるのは過剰です。許すなら完全に許すのが英国流です。",
            "feedbackEn": "The first part is fine, but adding 'next time, please check' is lecturing someone who's already apologised. In British culture, if you forgive, forgive completely—moralising after the fact is considered poor form.",
            "textJa": "å¤§ä¸ˆå¤«ã§ã™ã‚ˆã€‚ã§ã‚‚æ¬¡å›žã¯åˆ—ãŒã‚ã‚‹ã‹ç¢ºèªã—ã¦ãã ã•ã„ã€‚"
          }
        ],
        "textJa": "ã”ã‚ã‚“ãªã•ã„ã€åˆ—ã«æ°—ã¥ãã¾ã›ã‚“ã§ã—ãŸï¼æ¥ãšã‹ã—ã„ã§ã™ã­ã€‚"
      },
      {
        "speaker": "stranger",
        "avatar": "👔",
        "name": "Shopkeeper",
        "text": "Who's next, please?",
        "options": [
          {
            "text": "I think I'm next — a chicken sandwich and a coffee, please.",
            "correct": true,
            "feedback": "✅ 「I think I'm next」は確信があっても使う英国的な控えめ表現です。直接「I'm next」と言うより柔らかく、でも明確に自分の順番を主張しています。注文もスムーズに続けており、効率的で礼儀正しい対応です。",
            "feedbackEn": "'I think I'm next' is classic British understatement—even when certain, it sounds less aggressive than 'I'm next.' It asserts your place politely. Following immediately with your order keeps things efficient.",
            "textJa": "ç§ã§ã™ï¼ãƒã‚­ãƒ³ã‚µãƒ³ãƒ‰ã‚¤ãƒƒãƒã¨ã‚³ãƒ¼ãƒ’ãƒ¼ã‚’ãŠé¡˜ã„ã—ã¾ã™ã€‚"
          },
          {
            "text": "Me please! I'd like a chicken sandwich and a black coffee.",
            "correct": false,
            "feedback": "✅ 元気で自然な表現です。「Me please!」は親しみやすく、英国のカジュアルな場面では全く問題ありません。ただ「I think I'm next」の方がより典型的な英国の控えめさを示します。",
            "feedbackEn": "Friendly and natural—'Me please!' is perfectly acceptable in a casual UK deli. Slightly less understated than the ideal response, but completely appropriate and very British in its warmth.",
            "textJa": "ã¯ã„ï¼ãƒã‚­ãƒ³ã‚µãƒ³ãƒ‰ã‚¤ãƒƒãƒã¨ãƒ–ãƒ©ãƒƒã‚¯ã‚³ãƒ¼ãƒ’ãƒ¼ã‚’ãŠé¡˜ã„ã—ã¾ã™ã€‚"
          },
          {
            "text": "After you actually — I haven't quite decided what I want yet anyway, so please do go ahead and order first, I don't mind waiting at all.",
            "correct": false,
            "feedback": "⚠️ 過度な礼儀正しさです。列に並んでいたのに自分の番を譲る必要はありません。英国では列のルールは全員が守るものです。自分の番を堂々と主張することが期待されます。",
            "feedbackEn": "Overly self-sacrificing—you've been waiting in the queue, so it's your turn. British queue culture expects everyone to follow the order. Confidently stating your order when called is correct and expected.",
            "textJa": "å®Ÿã¯ã€ã¾ã æ±ºã¾ã£ã¦ã„ãªã„ã®ã§å…ˆã«ã©ã†ãžã€‚æ€¥ã„ã§ã„ãªã„ã®ã§å¤§ä¸ˆå¤«ã§ã™ã€‚"
          }
        ],
        "textJa": "æ¬¡ã®æ–¹ã€ã©ã†ãžï¼"
      }
    ],
    "tip": "🇬🇧 UK tip: The queue is almost sacred in British culture. Never jump one, and if someone does, a gentle 'Sorry, I think there's a queue' is the perfect British response—assertive but never aggressive.",
    "tipJa": "🇬🇧 イギリスTip: 英国ではキュー（列）はほぼ神聖なものです。「Sorry, I think there's a queue」は割り込みに対する英国的な完璧な対応です。主張しながらも攻撃的にならないバランスが大切。"
  },
  "conv_life_doctor_emergency": {
    "id": "conv_life_doctor_emergency",
    "title": "Calling 111 & using A&E",
    "titleJa": "111番電話・A&E（救急外来）の利用",
    "situation": "It's late evening and your child has a high fever and a rash. You're unsure whether to call 111, go to A&E, or wait until morning.",
    "situationJa": "夕方遅くに、お子さんが高熱と発疹が出ています。111番に電話すべきか、A&E（救急外来）に行くべきか、朝まで待つべきか分からない状況です。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "📞",
        "name": "111 Operator",
        "text": "You're through to NHS 111. What's the problem today?",
        "options": [
          {
            "text": "My son is 4 years old and has had a high fever of 39.5 degrees for six hours. He's also developed a rash on his chest in the last hour. I'm worried about meningitis.",
            "correct": true,
            "feedback": "✅ 完璧な111への報告です。患者の年齢・症状・発症時間・懸念事項を明確に伝えています。「meningitis」という具体的な懸念を述べることで、オペレーターが適切なトリアージを行えます。111への電話では具体的で冷静な情報提供が重要です。",
            "feedbackEn": "Perfect 111 call: age, specific temperature, duration, new symptom, and your specific concern all given clearly. Mentioning meningitis directly helps the operator triage appropriately. Calm and detailed is exactly right.",
            "textJa": "æ¯å­ã¯4æ­³ã§ã€39.5åº¦ã®é«˜ç†±ãŒ6æ™‚é–“ç¶šã„ã¦ã„ã¾ã™ã€‚ã¾ãŸã€1æ™‚é–“å‰ã‹ã‚‰èƒ¸ã«ç™ºç–¹ãŒå‡ºã¦ã„ã¾ã™ã€‚é«„è†œç‚ŽãŒå¿ƒé…ã§ã™ã€‚"
          },
          {
            "text": "My child has been very unwell all day with a high temperature, and we're really not sure whether we should go to A&E, see a GP, or just stay at home and keep a close eye on things.",
            "correct": false,
            "feedback": "⚠️ 心配な気持ちは理解できますが、111のオペレーターは具体的な情報が必要です。年齢・体温・症状・発症時間を伝えることで、より適切なアドバイスが得られます。",
            "feedbackEn": "This gives the operator too little to work with. 111 needs specifics: age, temperature, symptoms, and duration. The more precise you are, the faster and more accurate the advice. Prepare these details before calling.",
            "textJa": "å­ä¾›ãŒä¸€æ—¥ä¸­é«˜ç†±ã§éžå¸¸ã«å…·åˆãŒæ‚ªã„ã§ã™ã€‚æ•‘æ€¥ã€GPã¸ã®ç›¸è«‡ã€ãã‚Œã¨ã‚‚å®¶ã§æ§˜å­ã‚’è¦‹ã‚‹ã¹ãã‹åˆ¤æ–­ã§ãã¾ã›ã‚“ã€‚"
          },
          {
            "text": "My son has had a high fever all day and feels very hot and unwell — we don't know whether to drive to A&E right now or give it until morning to see if he improves with some Calpol.",
            "correct": false,
            "feedback": "⚠️ これはオペレーターへの質問ではなく、オペレーターが判断するための情報を提供する場面です。111では最初に症状の詳細を伝え、オペレーターの判断に委ねます。",
            "feedbackEn": "Don't lead with a question—that's for the operator to answer after assessing the situation. Start with the facts: your child's age, symptoms, temperature, and how long they've been unwell.",
            "textJa": "æ¯å­ãŒä¸€æ—¥ä¸­é«˜ç†±ã§éžå¸¸ã«è‹¦ã—ãã†ã§ã™ã€‚ä»Šã™ãA&Eã«è¡Œãã¹ãã‹ã€ã‚«ãƒ«ãƒãƒ¼ãƒ«ã§æ§˜å­ã‚’è¦‹ã¦æœã¾ã§å¾…ã¤ã¹ãã‹è¿·ã£ã¦ã„ã¾ã™ã€‚"
          }
        ],
        "textJa": "NHS 111ã«ãŠé›»è©±ã„ãŸã ãã¾ã—ãŸã€‚ä»Šæ—¥ã®ã”ç”¨ä»¶ã¯ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "📞",
        "name": "111 Operator",
        "text": "Given the rash and fever together, I'm going to recommend you go to A&E as a precaution. Can you get there within the hour?",
        "options": [
          {
            "text": "Yes, we can get there. Should I call ahead, or just go straight to A&E?",
            "correct": true,
            "feedback": "✅ 素早く確認し、到着前の手順を確認する実用的な質問です。英国のA&Eは通常事前連絡不要ですが、111から指示を受けた旨をA&Eに伝えると優先対応される場合があります。",
            "feedbackEn": "Quick confirmation and a practical follow-up question. A&E doesn't usually require pre-calling, but informing them you were advised by 111 can help with triage. Good thinking.",
            "textJa": "ã¯ã„ã€è¡Œã‘ã¾ã™ã€‚äº‹å‰ã«é›»è©±ã™ã¹ãã§ã™ã‹ã€ãã‚Œã¨ã‚‚ãã®ã¾ã¾A&Eã«è¡Œãã¹ãã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Can't it wait until morning? He seems to be sleeping now.",
            "correct": false,
            "feedback": "⚠️ 眠っているように見えても、髄膜炎の症状（発熱＋発疹）は緊急対応が必要です。111のオペレーターが「precaution（予防）」としてA&Eを勧めた場合、必ず従ってください。英国のNHSでは111の指示に従うことが重要です。",
            "feedbackEn": "When 111 recommends A&E, always follow that advice—especially with fever and rash, which can indicate meningitis. Children can appear to be sleeping while seriously unwell. Don't wait.",
            "textJa": "æœã¾ã§å¾…ã¦ã¾ã›ã‚“ã‹ï¼Ÿä»Šã¯çœ ã£ã¦ã„ã‚‹ã‚ˆã†ã§ã™ã€‚"
          },
          {
            "text": "Right, understood — should we drive there ourselves, or would calling an ambulance actually be faster given how unwell he is?",
            "correct": false,
            "feedback": "✅ 実用的な質問です。Red Book（子どもの健康記録）、保険証（NHSカードまたはビザ）、症状のメモを持参すると良いでしょう。ただしまず「行けます」という確認を先にする方が自然です。",
            "feedbackEn": "Practical question. Bring the Red Book (child health record), any medication records, and ID. But confirm you're going first—the operator needs to know you're following the advice before providing packing tips.",
            "textJa": "åˆ†ã‹ã‚Šã¾ã—ãŸã€‚è‡ªåˆ†ã§é‹è»¢ã—ã¦è¡Œãã¹ãã§ã™ã‹ã€ãã‚Œã¨ã‚‚çŠ¶æ…‹ã‚’è€ƒãˆã‚‹ã¨æ•‘æ€¥è»Šã‚’å‘¼ã‚“ã æ–¹ãŒæ—©ã„ã§ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ç™ºç–¹ã¨ç™ºç†±ãŒåŒæ™‚ã«ã‚ã‚‹å ´åˆã€å¿µã®ãŸã‚A&Eã«è¡Œãã“ã¨ã‚’ãŠå‹§ã‚ã—ã¾ã™ã€‚1æ™‚é–“ä»¥å†…ã«è¡Œã‘ã¾ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "🏥",
        "name": "A&E Receptionist",
        "text": "Hello, what's the problem today?",
        "options": [
          {
            "text": "My son is 4. He has a high fever of 39.5 and developed a new rash on his chest an hour ago. NHS 111 advised us to come in.",
            "correct": true,
            "feedback": "✅ A&Eでの完璧な最初の説明です。症状の概要と「111から指示を受けた」という点を明確に伝えることで、トリアージナースが適切な優先度を設定できます。英国のA&Eでは具体的かつ簡潔な情報提供が重要です。",
            "feedbackEn": "Mentioning '111 advised us to come in' is key—it signals this has already been triaged and helps A&E staff prioritise appropriately. Brief, clear, and includes the critical details. Exactly right.",
            "textJa": "æ¯å­ã¯4æ­³ã§ã€39.5åº¦ã®é«˜ç†±ãŒã‚ã‚Šã€1æ™‚é–“å‰ã‹ã‚‰èƒ¸ã«ç™ºç–¹ãŒå‡ºã¦ã„ã¾ã™ã€‚NHS 111ã‹ã‚‰A&Eã«æ¥ã‚‹ã‚ˆã†æŒ‡ç¤ºã•ã‚Œã¾ã—ãŸã€‚"
          },
          {
            "text": "My child has had a very high temperature all day and there's now some kind of rash appearing — we were very worried and weren't sure where else to go at this time of night.",
            "correct": false,
            "feedback": "⚠️ 情報が不十分です。A&Eのトリアージでは具体的な数値（体温）・症状・発症時間・年齢が必要です。また111の指示で来たことを伝えると、より迅速に対応してもらえる可能性があります。",
            "feedbackEn": "Too vague for A&E triage. Staff need: age, temperature, specific symptoms, duration, and whether 111 sent you. More detail means faster, more appropriate care for your child.",
            "textJa": "å­ä¾›ãŒä¸€æ—¥ä¸­éžå¸¸ã«é«˜ã„ç†±ãŒã‚ã‚Šã€ä½•ã‚‰ã‹ã®ç™ºç–¹ãŒå‡ºã¦ã„ã¾ã™ã€‚å¿ƒé…ã§ã€ã“ã®æ™‚é–“å¸¯ã«ä»–ã«è¡Œãå ´æ‰€ãŒåˆ†ã‹ã‚Šã¾ã›ã‚“ã§ã—ãŸã€‚"
          },
          {
            "text": "111 directed us to come to A&E, but we waited for a callback that never came — so in the end we decided it was better to just drive here ourselves rather than wait any longer.",
            "correct": false,
            "feedback": "✅ 111の指示で来たことは重要な情報です。ただ「sick」だけでは具体的な症状が分かりません。体温（39.5度）と発疹という具体的な症状を加えると、トリアージがより迅速になります。",
            "feedbackEn": "Good that you mention 111 sent you—this matters for triage. But 'sick' is too vague. Add the specific symptoms (high fever of 39.5, new rash) for faster and more accurate assessment.",
            "textJa": "111ã«è¨€ã‚ã‚Œã¦A&Eã«æ¥ã¾ã—ãŸãŒã€æŠ˜ã‚Šè¿”ã—ã®é›»è©±ãŒãªã‹ã£ãŸã®ã§ã€ã‚‚ã†ã“ã‚Œä»¥ä¸Šå¾…ã¦ãšã«è‡ªåˆ†ã§æ¥ã¾ã—ãŸã€‚"
          }
        ],
        "textJa": "ä»Šæ—¥ã¯ã©ã®ã‚ˆã†ãªã”ç”¨ä»¶ã§ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: Call 111 for urgent but non-emergency medical advice (available 24/7). Go to A&E for life-threatening emergencies only, or call 999. Always mention if 111 advised you to attend A&E—it helps with triage.",
    "tipJa": "🇬🇧 イギリスTip: 緊急だが命に関わらない医療相談は111番（24時間）へ。生命に関わる緊急時はA&Eか999番へ。A&Eに行く際は「111から指示された」と必ず伝えましょう。"
  },
  "conv_culture_americanenglish": {
    "id": "conv_culture_americanenglish",
    "title": "British vs American English",
    "titleJa": "イギリス英語とアメリカ英語の違い",
    "situation": "You're having lunch with a British colleague. You use an American English expression and it causes a brief moment of confusion.",
    "situationJa": "イギリス人の同僚とランチ中、アメリカ英語の表現を使ったら一瞬戸惑われてしまいました。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "🍽️",
        "name": "Colleague",
        "text": "Sorry — did you say you'll 'table' the proposal? In the UK that means we should discuss it now, not postpone it!",
        "options": [
          {
            "text": "Oh! I meant it the American way — put it aside for now. Sorry for the confusion! Good to know.",
            "correct": true,
            "feedback": "✅ 誤解を素直に認め、アメリカ英語での意味を説明し、英国英語の違いを学ぶ姿勢を示しています。「Good to know」はイギリス人が喜ぶ前向きな反応です。英米間の言語差は英国人も楽しみながら話す話題です。",
            "feedbackEn": "'Good to know' shows you're learning, not embarrassed. British people enjoy explaining these differences—it's a great bonding moment. Clarifying 'American way' vs UK meaning shows cultural awareness.",
            "textJa": "ã‚ï¼ã‚¢ãƒ¡ãƒªã‚«å¼ã§è¨€ã„ã¾ã—ãŸã€‚ä»Šã¯ä¿ç•™ã¨ã„ã†æ„å‘³ã§ã—ãŸã€‚ç´›ã‚‰ã‚ã—ãã¦ã™ã¿ã¾ã›ã‚“ï¼å‚è€ƒã«ãªã‚Šã¾ã—ãŸã€‚"
          },
          {
            "text": "I did say 'table' it — where I come from that has always meant to postpone or defer, so I genuinely don't understand why that would cause any confusion in this context.",
            "correct": false,
            "feedback": "⚠️ 誤解が生じたことに気づかず、相手を困らせます。「table」は英米で正反対の意味を持つ典型的な例です。英国では「議題に乗せる（今すぐ議論する）」、アメリカでは「棚上げにする（後回し）」という意味になります。",
            "feedbackEn": "'Table' is a classic false friend—it means 'discuss now' in British English but 'postpone' in American English. This is genuinely confusing even for native speakers. Acknowledge the miscommunication graciously.",
            "textJa": "ã€Œãƒ†ãƒ¼ãƒ–ãƒ«ã«ä¸Šã’ã‚‹ã€ã¨è¨€ã„ã¾ã—ãŸã€‚ç§ã®ã¨ã“ã‚ã§ã¯ãšã£ã¨å»¶æœŸã™ã‚‹ã¨ã„ã†æ„å‘³ãªã®ã§ã€ãªãœæ··ä¹±ã™ã‚‹ã®ã‹æ­£ç›´ç†è§£ã§ãã¾ã›ã‚“ã€‚"
          },
          {
            "text": "You're right, I should use more British English. I'll try harder.",
            "correct": false,
            "feedback": "⚠️ 謙虚さは良いですが、過度に謝る必要はありません。英国人は一般的にアメリカ英語の違いを面白いと感じており、責めているわけではありません。「Good to know」と軽く受け流す方が自然です。",
            "feedbackEn": "No need to over-apologise—British people find these differences amusing, not offensive. A light touch ('Good to know!') is more natural than excessive self-criticism. These moments are conversation starters, not failures.",
            "textJa": "ãŠã£ã—ã‚ƒã‚‹é€šã‚Šã§ã™ã€‚ã‚‚ã£ã¨è‹±å›½è‹±èªžã‚’ä½¿ã†ã‚ˆã†ã«ã—ã¾ã™ã€‚åŠªåŠ›ã—ã¾ã™ã€‚"
          }
        ],
        "textJa": "ã™ã¿ã¾ã›ã‚“ã€ææ¡ˆã‚’ã€Œãƒ†ãƒ¼ãƒ–ãƒ«ã«ä¸Šã’ã‚‹ã€ã¨ãŠã£ã—ã‚ƒã„ã¾ã—ãŸã‹ï¼Ÿè‹±å›½ã§ã¯ä»Šã™ãè­°è«–ã™ã‚‹ã¨ã„ã†æ„å‘³ã§ã™ãŒã€å»¶æœŸã§ã¯ãªã„ã§ã™ã‚ˆï¼"
      },
      {
        "speaker": "colleague",
        "avatar": "🍽️",
        "name": "Colleague",
        "text": "Ha! Yes — 'chips' is another classic. What would you call these?",
        "options": [
          {
            "text": "In American English these would be 'fries' — or 'French fries'. And what I'd call 'chips' in America are your 'crisps'!",
            "correct": true,
            "feedback": "✅ 完璧な回答です。chips/fries/crispsの英米差を正確に説明しています。このような知識を持っていることを示すと、英国人との会話が弾みます。英語の違いについての会話は英国人が大好きなトピックです。",
            "feedbackEn": "Nailing the chips/fries/crisps triangle shows real cultural knowledge. British people love this topic—sharing these differences enthusiastically is a great way to bond. You've turned a confusion into a fun cultural moment.",
            "textJa": "ã‚¢ãƒ¡ãƒªã‚«è‹±èªžã§ã¯ã€Œãƒ•ãƒ©ã‚¤ã‚ºã€ã¾ãŸã¯ã€Œãƒ•ãƒ¬ãƒ³ãƒãƒ•ãƒ©ã‚¤ã‚ºã€ã§ã™ã€‚ã‚¢ãƒ¡ãƒªã‚«ã§ã€Œãƒãƒƒãƒ—ã‚¹ã€ã¨è¨€ãˆã°è‹±å›½ã®ã€Œã‚¯ãƒªã‚¹ãƒ—ã‚¹ã€ã«ç›¸å½“ã—ã¾ã™ï¼"
          },
          {
            "text": "In Japan we'd also call these 'fries' or 'fried potatoes' — so calling them 'chips' feels quite strange to me. Are British chips always this thick and chunky, or do you get thin ones too?",
            "correct": false,
            "feedback": "⚠️ 日本での呼び方の共有は面白いですが、英米差の説明が抜けています。「chips in the UK = fries in the US、crisps in the UK = chips in the US」という全体像を共有すると会話がより豊かになります。",
            "feedbackEn": "Sharing the Japanese perspective adds a fun dimension, but explaining the full British/American vocabulary swap (chips=fries, crisps=chips) would make this a richer cultural exchange.",
            "textJa": "æ—¥æœ¬ã§ã‚‚ã“ã‚Œã‚’ã€Œãƒ•ãƒ©ã‚¤ã‚ºã€ã‚„ã€Œãƒ•ãƒ©ã‚¤ãƒ‰ãƒãƒ†ãƒˆã€ã¨å‘¼ã¶ã®ã§ã€ã€Œãƒãƒƒãƒ—ã‚¹ã€ã¨å‘¼ã¶ã®ã¯ã¨ã¦ã‚‚ä¸æ€è­°ãªæ„Ÿã˜ãŒã—ã¾ã™ã€‚è‹±å›½ã®ãƒãƒƒãƒ—ã‚¹ã¯ã„ã¤ã‚‚ã“ã‚“ãªã«å¤ªã„ã‚“ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Hmm, I've always thought of 'chips' as the thin, crispy, bagged snack you get from the shop — like Walkers crisps. These look much more like fried potatoes to me, not chips at all.",
            "correct": false,
            "feedback": "⚠️ これはアメリカ英語の理解をそのまま使っています。英国では「chips」は温かいポテトフライで、「crisps」がアメリカの「chips（スナック菓子）」に相当します。この混乱は英国人には典型的なアメリカ英語の誤用として知られています。",
            "feedbackEn": "You're using American English definitions. In British English: chips = hot potato fries, crisps = what Americans call chips (the snack). This swap trips up many people—knowing it shows cultural fluency.",
            "textJa": "ã€Œãƒãƒƒãƒ—ã‚¹ã€ã¯ãŠåº—ã§å£²ã£ã¦ã„ã‚‹è–„ãã¦ãƒ‘ãƒªãƒ‘ãƒªã®è¢‹å…¥ã‚Šã‚¹ãƒŠãƒƒã‚¯ã ã¨æ€ã£ã¦ã„ã¾ã—ãŸã€‚ã“ã‚Œã¯ãƒ•ãƒ©ã‚¤ãƒ‰ãƒãƒ†ãƒˆã®ã‚ˆã†ã«è¦‹ãˆã¦ã€ãƒãƒƒãƒ—ã‚¹ã˜ã‚ƒãªã„ã¨æ€ã„ã¾ã™ã€‚"
          }
        ],
        "textJa": "ãã†ãªã‚“ã§ã™ï¼ã€Œãƒãƒƒãƒ—ã‚¹ã€ã‚‚å…¸åž‹çš„ãªä¾‹ã§ã™ã‚ˆã­ã€‚ã“ã‚Œã¯ä½•ã¨å‘¼ã³ã¾ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "🍽️",
        "name": "Colleague",
        "text": "What other differences have caught you out since you moved here?",
        "options": [
          {
            "text": "Quite a few! 'Pants' was a shock — I said I liked someone's pants and meant their trousers, but in the UK it means underwear!",
            "correct": true,
            "feedback": "✅ 「pants」の英米差は最も有名な誤解の一つです。この種の個人的な経験談を共有することで、会話が盛り上がります。英国人はこのような文化的エピソードを大変楽しみます。自分の経験を笑いながら話せる姿勢が好印象です。",
            "feedbackEn": "The 'pants' story is a classic British-American confusion—and sharing it with humour shows cultural confidence. British people love these anecdotes. Self-deprecating humour about language mix-ups is very endearing in UK culture.",
            "textJa": "ãŸãã•ã‚“ã‚ã‚Šã¾ã™ï¼ã€Œãƒ‘ãƒ³ãƒ„ã€ã¯è¡æ’ƒçš„ã§ã—ãŸã€‚èª°ã‹ã®ãƒ‘ãƒ³ãƒ„ãŒå¥½ãã¨è¨€ã£ãŸã‚‰ã€ãƒˆãƒ©ã‚¦ã‚¶ãƒ¼ã‚ºã®ã¤ã‚‚ã‚Šã ã£ãŸã®ã«ã€è‹±å›½ã§ã¯ã‚¢ãƒ³ãƒ€ãƒ¼ã‚¦ã‚§ã‚¢ã®æ„å‘³ãªã‚“ã§ã™ã‚ˆï¼"
          },
          {
            "text": "I've found it mostly straightforward so far — English is English after all, and years of American TV means a lot of British vocabulary and idioms already feel naturally familiar.",
            "correct": false,
            "feedback": "⚠️ 正直な返答ですが、アクセントの話は別のトピックです。相手は英米英語の違いについて聞いているので、具体的な語彙の違い（例：lift/elevator、autumn/fall、flat/apartment）を共有する方が会話が続きます。",
            "feedbackEn": "Honest but changes the subject. The colleague is asking about vocabulary differences—share a specific example (lift/elevator, flat/apartment, autumn/fall) to keep the conversation flowing naturally.",
            "textJa": "ã»ã¨ã‚“ã©å•é¡Œã‚ã‚Šã¾ã›ã‚“ã§ã—ãŸã€‚ã‚¢ãƒ¡ãƒªã‚«ã®ãƒ†ãƒ¬ãƒ“ã‚’é•·å¹´è¦‹ã¦ã„ãŸã®ã§ã€å¤šãã®è‹±å›½ã®èªžå½™ã‚„ã‚¤ãƒ‡ã‚£ã‚ªãƒ ã¯ã‚‚ã†è‡ªç„¶ã«é¦´æŸ“ã‚“ã§ã„ã¾ã—ãŸã€‚"
          },
          {
            "text": "Not really, no — I watched a lot of American TV before moving here, so most British words and phrases already felt quite familiar and natural from pretty much my very first week.",
            "correct": false,
            "feedback": "⚠️ 英米英語には数百の語彙・文法・発音の違いがあります。この発言は相手の質問を軽視しているように聞こえます。実際に違いで困った経験を共有する方が、会話が豊かになり相手も楽しめます。",
            "feedbackEn": "There are hundreds of British/American differences—vocabulary, spelling, grammar, and pronunciation. This dismissive response misses a great bonding opportunity. British people enjoy discussing these nuances.",
            "textJa": "ã‚ã¾ã‚Šãªã„ã§ã™ã­ã€‚è‹±å›½ã«æ¥ã‚‹å‰ã«ã‚¢ãƒ¡ãƒªã‚«ã®ãƒ†ãƒ¬ãƒ“ã‚’ãŸãã•ã‚“è¦‹ã¦ã„ãŸã®ã§ã€è‹±å›½ã®è¨€è‘‰ã‚„è¡¨ç¾ã¯ã»ã¨ã‚“ã©æœ€åˆã‹ã‚‰è‡ªç„¶ã«æ„Ÿã˜ã¾ã—ãŸã€‚"
          }
        ],
        "textJa": "è‹±å›½ã«æ¥ã¦ã‹ã‚‰ä½•ã‹æˆ¸æƒ‘ã£ãŸã“ã¨ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: Key British vs American differences: chips/fries, crisps/chips, pants/trousers, lift/elevator, flat/apartment, autumn/fall, 'table' a proposal (UK=discuss now, US=postpone). When in doubt, ask!",
    "tipJa": "🇬🇧 イギリスTip: 主な英米差：chips(英)=fries(米)、crisps(英)=chips(米)、pants(英)=下着、lift(英)=elevator(米)、flat(英)=apartment(米)、autumn(英)=fall(米)。「table a proposal」は英国では「今すぐ議論する」、米国では「棚上げにする」の真逆の意味。"
  },
  "conv_travel_tube": {
    "id": "conv_travel_tube",
    "title": "Navigating the Tube & Overground",
    "titleJa": "チューブ・オーバーグラウンドの乗り方",
    "situation": "You're at King's Cross station trying to get to Brixton. You're unsure which line to take and ask a fellow passenger.",
    "situationJa": "キングスクロス駅からブリクストンへ行こうとしています。どの路線に乗るか分からず、他の乗客に聞いています。",
    "turns": [
      {
        "speaker": "stranger",
        "avatar": "🚇",
        "name": "Commuter",
        "text": "You all right? You look a bit lost.",
        "options": [
          {
            "text": "Yes, a bit! I'm trying to get to Brixton — is it easy from here?",
            "correct": true,
            "feedback": "✅ 「Yes, a bit!」はイギリス的なユーモアを交えた自然な返答です。目的地を明確に伝え、相手が助けやすい質問をしています。ロンドンの通勤者は一般的に助けを求める人に親切で、道案内を喜びます。",
            "feedbackEn": "'Yes, a bit!' shows good humour and self-awareness—very British. Stating your destination clearly lets the stranger help efficiently. London commuters are generally happy to assist with directions.",
            "textJa": "ã¯ã„ã€å°‘ã—ï¼ãƒ–ãƒªã‚¯ã‚¹ãƒˆãƒ³ã«è¡ŒããŸã„ã‚“ã§ã™ãŒã€ã“ã“ã‹ã‚‰ç°¡å˜ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I need to get to Brixton. Which line do I take?",
            "correct": false,
            "feedback": "✅ 実用的で直接的な質問です。ただ「I need」という表現はやや強く聞こえます。「Could you help me get to Brixton?」のように依頼形にすると、より英国的で丁寧な印象になります。",
            "feedbackEn": "Direct and clear, but 'I need' can sound demanding. 'Could you help me get to Brixton?' is softer and more British in tone. Small changes in phrasing make a significant difference in UK communication style.",
            "textJa": "ãƒ–ãƒªã‚¯ã‚¹ãƒˆãƒ³ã«è¡ŒããŸã„ã®ã§ã™ãŒã€ã©ã®è·¯ç·šã«ä¹—ã‚Œã°ã„ã„ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I'm fine actually, just getting my bearings — I think I know roughly where I'm going, but thank you for asking.",
            "correct": false,
            "feedback": "⚠️ 助けを申し出てくれた人を断ってしまいます。ロンドンでは見知らぬ人が道案内を申し出ることは珍しいので、この機会を活かしましょう。",
            "feedbackEn": "You're turning down a genuine offer of help—rare in London! When a stranger offers assistance, accept it gratefully. This is a great opportunity to get local knowledge.",
            "textJa": "å¤§ä¸ˆå¤«ã§ã™ã€‚ã ã„ãŸã„ã©ã“ã¸è¡Œãã‹åˆ†ã‹ã£ã¦ã„ã¾ã™ã€‚ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚"
          }
        ],
        "textJa": "å¤§ä¸ˆå¤«ã§ã™ã‹ï¼Ÿå°‘ã—è¿·ã£ã¦ã„ã‚‹ã‚ˆã†ã«è¦‹ãˆã¾ã™ã€‚"
      },
      {
        "speaker": "stranger",
        "avatar": "🚇",
        "name": "Commuter",
        "text": "Brixton? Easy — you want the Victoria line southbound. Change here at King's Cross, hop on the Victoria. About 20 minutes.",
        "options": [
          {
            "text": "Perfect, thank you! Is this platform the right one, or do I need to follow signs for the Victoria line?",
            "correct": true,
            "feedback": "✅ 情報を確認しながら、次の具体的なステップを確認しています。ロンドンの地下鉄では乗換案内の看板を使うことが基本ですが、「どちらのプラットフォームか」という具体的な確認は迷わないために重要です。",
            "feedbackEn": "Confirming the next practical step (which platform) shows you've understood and are taking action. Following Victoria line signs is standard—this clarifying question helps you navigate independently.",
            "textJa": "å®Œç’§ã€ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼ã“ã®ãƒ›ãƒ¼ãƒ ã§åˆã£ã¦ã„ã¾ã™ã‹ï¼Ÿãã‚Œã¨ã‚‚ãƒ“ã‚¯ãƒˆãƒªã‚¢ç·šã®è¡¨ç¤ºã«å¾“ã†ã¹ãã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Thank you so much — that's brilliant! I think I'll manage perfectly well from here; London's public transport really isn't as complicated as I'd feared it might be.",
            "correct": false,
            "feedback": "✅ 感謝は良いですが、実用的な確認（どのプラットフォームか、乗り換え方法）を追加すると、実際に迷わずに済みます。英国では感謝と実用的な質問を組み合わせるのが自然です。",
            "feedbackEn": "Grateful and warm, but missing a practical follow-up. In a busy London station, confirming 'which direction/platform' saves you wandering around. Combine thanks with one clarifying question.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼ã“ã“ã‹ã‚‰å¤§ä¸ˆå¤«ã ã¨æ€ã„ã¾ã™ã€‚ãƒ­ãƒ³ãƒ‰ãƒ³ã®äº¤é€šã¯æ€ã£ãŸã»ã©è¤‡é›‘ã˜ã‚ƒãªã„ã§ã™ã­ã€‚"
          },
          {
            "text": "Wait — I was quite certain that Brixton was on the Northern line. Are you absolutely sure it's the Victoria line and not the Jubilee or something else?",
            "correct": false,
            "feedback": "⚠️ 実はBrixtonはVictoria lineのみです（Northern lineではありません）。地下鉄路線の確認は大切ですが、親切に教えてくれた相手に疑問を呈する前に、TfLのアプリや駅の路線図で確認する方が確実です。",
            "feedbackEn": "Brixton is actually only on the Victoria line, not the Northern line. If you're unsure, check the Tube map rather than questioning the stranger—they're likely right. TfL's app shows live journey options.",
            "textJa": "å¾…ã£ã¦ã€ãƒ–ãƒªã‚¯ã‚¹ãƒˆãƒ³ã¯ãƒŽãƒ¼ã‚¶ãƒ³ç·šã ã¨æ€ã£ã¦ã„ã¾ã—ãŸã€‚æœ¬å½“ã«ãƒ“ã‚¯ãƒˆãƒªã‚¢ç·šã§ã™ã‹ï¼Ÿã‚¸ãƒ¥ãƒ“ãƒªãƒ¼ç·šã¨ã‹ã˜ã‚ƒãªã„ã§ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ãƒ–ãƒªã‚¯ã‚¹ãƒˆãƒ³ï¼Ÿç°¡å˜ã§ã™ã‚ˆã€‚å—è¡Œãã®ãƒ“ã‚¯ãƒˆãƒªã‚¢ç·šã«ä¹—ã£ã¦ãã ã•ã„ã€‚ã‚­ãƒ³ã‚°ã‚ºã‚¯ãƒ­ã‚¹ã§ä¹—ã‚Šæ›ãˆã¦ãƒ“ã‚¯ãƒˆãƒªã‚¢ç·šã«ã€‚ç´„20åˆ†ã§ã™ã€‚"
      },
      {
        "speaker": "stranger",
        "avatar": "🚇",
        "name": "Commuter",
        "text": "Just follow the Victoria line signs — it's well signposted. One tip: you're in Zone 1 here, Brixton's Zone 2, so make sure you've got enough on your Oyster.",
        "options": [
          {
            "text": "Good tip — I'll check my balance at the machine before I go through. Thanks again!",
            "correct": true,
            "feedback": "✅ 実用的なアドバイスを素直に受け入れ、具体的な行動（残高確認）を示しています。ゾーン制度はロンドンの運賃に直結するため、この知識は重要です。Zone 1-2の移動は単一ゾーンより運賃が高くなります。",
            "feedbackEn": "Checking your Oyster balance before travelling is smart—crossing zone boundaries increases the fare. Acting on the tip immediately ('I'll check at the machine') shows you've understood and will follow through.",
            "textJa": "ã„ã„ã‚¢ãƒ‰ãƒã‚¤ã‚¹ã§ã™ï¼ä¹—ã‚‹å‰ã«æ©Ÿæ¢°ã§æ®‹é«˜ã‚’ç¢ºèªã—ã¾ã™ã€‚ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼"
          },
          {
            "text": "I had no idea London's tube was divided into zones — does that mean my ticket is limited to Zone 1 only, or does a standard Oyster card automatically cover all zones?",
            "correct": false,
            "feedback": "✅ 知らなければ聞くのは良いことです。ロンドンはZone 1-9に分かれており、乗る距離が長いほど運賃が高くなります。Oysterカードの残高が不足すると改札を出られなくなるため、ゾーンの理解は重要です。",
            "feedbackEn": "Asking is good if you genuinely don't know—London's zone system (1-9) affects fares significantly. But act on the advice to check your balance regardless, as running out of credit means you can't exit the barriers.",
            "textJa": "ãƒ­ãƒ³ãƒ‰ãƒ³ã®åœ°ä¸‹é‰„ãŒã‚¾ãƒ¼ãƒ³åˆ†ã‘ã•ã‚Œã¦ã„ã‚‹ã¨ã¯çŸ¥ã‚Šã¾ã›ã‚“ã§ã—ãŸã€‚ãƒã‚±ãƒƒãƒˆã¯ã‚¾ãƒ¼ãƒ³1ã ã‘æœ‰åŠ¹ã§ã™ã‹ï¼Ÿãã‚Œã¨ã‚‚æ™®é€šã®ã‚ªã‚¤ã‚¹ã‚¿ãƒ¼ã‚«ãƒ¼ãƒ‰ã¯å…¨ã‚¾ãƒ¼ãƒ³ã«ä½¿ãˆã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I'll use my contactless bank card — it works the same as an Oyster, doesn't it? I'm pretty sure zones don't make much of a difference when you're using contactless payment.",
            "correct": false,
            "feedback": "⚠️ 非接触カードでも同じゾーン運賃が適用されます。残高が不足する（デビットカードで支払い拒否される）と改札を出られなくなります。アドバイスを受け入れ、出発前に残高・限度額を確認することをお勧めします。",
            "feedbackEn": "Contactless cards use the same zone-based fares and can also be declined if you hit limits. Don't dismiss the advice—check your card balance before travelling, especially for longer journeys across zones.",
            "textJa": "ã‚³ãƒ³ã‚¿ã‚¯ãƒˆãƒ¬ã‚¹å¯¾å¿œã®éŠ€è¡Œã‚«ãƒ¼ãƒ‰ã‚’ä½¿ã„ã¾ã™ã€‚ã‚ªã‚¤ã‚¹ã‚¿ãƒ¼ã¨åŒã˜ã‚ˆã†ã«ä½¿ãˆã¾ã™ã‚ˆã­ï¼Ÿã‚³ãƒ³ã‚¿ã‚¯ãƒˆãƒ¬ã‚¹ã§ä½¿ã£ã¦ã‚‚ã‚¾ãƒ¼ãƒ³ã¯ã‚ã¾ã‚Šé–¢ä¿‚ãªã„ã¨æ€ã„ã¾ã™ã€‚"
          }
        ],
        "textJa": "ãƒ“ã‚¯ãƒˆãƒªã‚¢ç·šã®è¡¨ç¤ºã«å¾“ãˆã°åˆ†ã‹ã‚Šã‚„ã™ã„ã§ã™ã€‚ä¸€ã¤ã‚¢ãƒ‰ãƒã‚¤ã‚¹ï¼šã“ã“ã¯ã‚¾ãƒ¼ãƒ³1ã§ã€ãƒ–ãƒªã‚¯ã‚¹ãƒˆãƒ³ã¯ã‚¾ãƒ¼ãƒ³2ãªã®ã§ã€ã‚ªã‚¤ã‚¹ã‚¿ãƒ¼ã‚«ãƒ¼ãƒ‰ã«ååˆ†ãªæ®‹é«˜ãŒã‚ã‚‹ã‹ç¢ºèªã—ã¦ãã ã•ã„ã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: London is divided into 9 fare zones. Zone 1 covers central London; most tourist attractions are in Zones 1-2. Always check your Oyster balance before longer journeys. The TfL app shows live Tube status and journey planning.",
    "tipJa": "🇬🇧 イギリスTip: ロンドンは9つのゾーンに分かれており、ゾーンをまたぐと運賃が上がります。Zone 1が中心部で、主要観光地はZone 1-2が多いです。長距離移動前はOysterの残高確認を。TfLアプリで路線状況やルート検索ができます。"
  },
  "conv_life_nhsprivate": {
    "id": "conv_life_nhsprivate",
    "title": "Choosing between NHS, A&E & private healthcare",
    "titleJa": "NHS・A&E・私立医療の使い分け",
    "situation": "A colleague is new to the UK and asks you for advice about how the healthcare system works after they mention feeling unwell.",
    "situationJa": "英国に来たばかりの同僚が体調不良を訴え、英国の医療制度についてアドバイスを求めてきました。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "🤒",
        "name": "New Colleague",
        "text": "I've had a bad cough for two weeks. Should I just go to A&E?",
        "options": [
          {
            "text": "For a cough that's been going on two weeks, I'd call your GP or use the NHS app first — A&E is really for emergencies. Have you registered with a GP near you?",
            "correct": true,
            "feedback": "✅ 正確な医療アドバイスです。2週間続く咳はGPの診察が適切で、A&Eは緊急時（生命の危険、重傷など）のためのものです。NHSアプリの提案も現代的で実用的です。「Have you registered?」という確認も親切です。",
            "feedbackEn": "Correct and helpful advice. A 2-week cough warrants a GP appointment, not A&E. A&E is for emergencies—using it unnecessarily increases waiting times for everyone. Mentioning the NHS app is modern and practical.",
            "textJa": "2é€±é–“ç¶šãå’³ãªã‚‰ã€ã¾ãšGPã«é›»è©±ã™ã‚‹ã‹NHSã‚¢ãƒ—ãƒªã‚’ä½¿ã†ã“ã¨ã‚’ãŠå‹§ã‚ã—ã¾ã™ã€‚A&Eã¯æœ¬å½“ã®ç·Šæ€¥äº‹æ…‹ç”¨ã§ã™ã€‚è¿‘ãã®GPã«ç™»éŒ²ã—ã¾ã—ãŸã‹ï¼Ÿ"
          },
          {
            "text": "A&E is probably the best option since it's completely free and open around the clock — you don't need any kind of appointment and they're set up to deal with all sorts of problems, not just genuine emergencies.",
            "correct": false,
            "feedback": "⚠️ A&Eは確かに予約なしで行けますが、2週間続く咳には不適切です。A&Eは緊急・命に関わる症状のためのもので、非緊急での利用は数時間待ちになることが多く、本当に緊急な患者への迷惑になります。",
            "feedbackEn": "While A&E accepts walk-ins, it's wrong for a 2-week cough. Non-emergency visits mean hours of waiting and divert resources from genuine emergencies. GP or NHS 111 is the right first step.",
            "textJa": "A&EãŒæœ€å–„ã®é¸æŠžè‚¢ã ã¨æ€ã„ã¾ã™ã€‚å®Œå…¨ã«ç„¡æ–™ã§24æ™‚é–“å¯¾å¿œã—ã¦ãŠã‚Šã€äºˆç´„ä¸è¦ã§ã€ç·Šæ€¥äº‹æ…‹ã ã‘ã§ãªãã„ã‚ã„ã‚ãªå•é¡Œã«å¯¾å¿œã—ã¦ã„ã¾ã™ã€‚"
          },
          {
            "text": "Just pop into Boots or Superdrug and pick up some cough syrup — pharmacists are brilliant for this sort of thing, and honestly a two-week cough is probably just a stubborn cold that needs time and rest to clear up.",
            "correct": false,
            "feedback": "⚠️ 2週間続く咳は医師に相談すべきです。短期の咳なら市販薬でも良いですが、2週間以上続く場合は肺炎・喘息・その他の症状の可能性があり、GPでの診察が推奨されます。",
            "feedbackEn": "Two weeks is too long to self-medicate without advice. Persistent coughs can indicate pneumonia, asthma, or other conditions. A GP appointment or NHS 111 call is the right first step—not dismissing it.",
            "textJa": "ãƒ–ãƒ¼ãƒ„ã‚„ã‚¹ãƒ¼ãƒ‘ãƒ¼ãƒ‰ãƒ©ãƒƒã‚°ã«è¡Œã£ã¦å’³ã‚·ãƒ­ãƒƒãƒ—ã‚’è²·ãˆã°ã„ã„ã§ã™ã‚ˆã€‚è–¬å‰¤å¸«ãŒã“ã†ã„ã†å ´åˆã«å½¹ç«‹ã¡ã¾ã™ã€‚2é€±é–“ã®å’³ã¯ãŸã ã®é¢¨é‚ªã ã¨æ€ã„ã¾ã™ã€‚"
          }
        ],
        "textJa": "2é€±é–“ã‚‚ã²ã©ã„å’³ãŒç¶šã„ã¦ã„ã¾ã™ã€‚A&Eã«è¡Œãã¹ãã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "🤒",
        "name": "New Colleague",
        "text": "I haven't registered with a GP yet. What's the difference between NHS and going private?",
        "options": [
          {
            "text": "NHS is free at the point of use but you might wait longer for appointments. Private is faster but costs money — for most things, NHS is absolutely fine. First priority: register with a local GP on NHS.uk.",
            "correct": true,
            "feedback": "✅ 公平で正確な比較です。NHSと私立医療の主な違い（費用vs速度）を簡潔に説明し、最も重要なアクション（GP登録）を明確に示しています。英国に来たばかりの人への実用的なアドバイスとして完璧です。",
            "feedbackEn": "Accurate, balanced comparison and a clear action point. For most conditions, NHS is excellent—private healthcare's main advantage is speed. Directing them to register on NHS.uk is the single most important first step.",
            "textJa": "NHSã¯åˆ©ç”¨æ™‚ã«ç„¡æ–™ã§ã™ãŒã€äºˆç´„ã«æ™‚é–“ãŒã‹ã‹ã‚‹ã“ã¨ãŒã‚ã‚Šã¾ã™ã€‚æ°‘é–“ã¯æ—©ã„ã§ã™ãŒãŠé‡‘ãŒã‹ã‹ã‚Šã¾ã™ã€‚ã»ã¨ã‚“ã©ã®ã“ã¨ã«ã¯NHSã§ååˆ†ã§ã™ã€‚ã¾ãšå„ªå…ˆã™ã‚‹ã“ã¨ï¼šNHS.ukã§åœ°å…ƒã®GPã«ç™»éŒ²ã—ã¦ãã ã•ã„ã€‚"
          },
          {
            "text": "Honestly, I'd go private from the start — NHS waiting lists can stretch to many months for anything non-urgent, and for a few hundred pounds you'll be seen within days. Most expats here tend to use private healthcare as a matter of course.",
            "correct": false,
            "feedback": "⚠️ 私立医療は確かに速いですが、一般的な問題にはNHSで十分です。また私立医療は高額（GP受診で£80-200程度）で、保険なしでは費用がかさみます。まずGPに登録することが最優先です。",
            "feedbackEn": "Private healthcare is faster but expensive (£80-200+ per GP visit without insurance). For most conditions, NHS quality is excellent. Recommending private immediately without knowing their insurance situation isn't helpful.",
            "textJa": "æœ€åˆã‹ã‚‰æ°‘é–“åŒ»ç™‚ãŒã„ã„ã¨æ€ã„ã¾ã™ã€‚NHSã®å¾…æ©Ÿãƒªã‚¹ãƒˆã¯æ€¥ãŽã§ãªã„ã“ã¨ã«ã¯æ•°ãƒ¶æœˆã‹ã‹ã‚‹ã“ã¨ãŒã‚ã‚Šã¾ã™ã€‚æ•°ç™¾ãƒãƒ³ãƒ‰ã§æ•°æ—¥ä»¥å†…ã«è¨ºã¦ã‚‚ã‚‰ãˆã¾ã™ã€‚"
          },
          {
            "text": "NHS is always the right choice without question — private healthcare is essentially just paying for a faster queue and isn't necessarily better care. As a UK resident you're fully entitled to NHS treatment, so there's really no reason to spend money on going private.",
            "correct": false,
            "feedback": "⚠️ 私立医療が悪いわけではありません。速さ・専門医への直接アクセス・より長い診察時間など利点もあります。状況によって使い分けるのが現実的で、選択肢として否定するのは適切ではありません。",
            "feedbackEn": "Private healthcare has genuine advantages: speed, direct specialist access, longer appointments. It's not 'bad'—it's a complement to NHS, especially for faster specialist referrals. Present it as an option, not something to avoid.",
            "textJa": "NHSãŒçµ¶å¯¾ã«æ­£ã—ã„é¸æŠžã§ã™ã€‚æ°‘é–“åŒ»ç™‚ã¯æœ¬è³ªçš„ã«é€Ÿã„é †ç•ªã‚’è²·ã†ã ã‘ã§ã€ã‚±ã‚¢ã®è³ªãŒè‰¯ã„ã¨ã¯é™ã‚Šã¾ã›ã‚“ã€‚è‹±å›½å±…ä½è€…ã¨ã—ã¦NHSæ²»ç™‚ã‚’å—ã‘ã‚‹æ¨©åˆ©ãŒã‚ã‚Šã¾ã™ã€‚"
          }
        ],
        "textJa": "ã¾ã GPã«ç™»éŒ²ã—ã¦ã„ã¾ã›ã‚“ã€‚NHSã¨æ°‘é–“åŒ»ç™‚ã®é•ã„ã¯ä½•ã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "🤒",
        "name": "New Colleague",
        "text": "What if it's an emergency in the middle of the night? Can I call my GP?",
        "options": [
          {
            "text": "For genuine emergencies, call 999. For urgent advice at night, call 111 — they'll assess you and tell you whether to go to A&E, see an out-of-hours GP, or wait until morning.",
            "correct": true,
            "feedback": "✅ 完璧な英国の緊急医療システムの説明です。999（緊急）・111（緊急ではないが今すぐ相談が必要）・GPの役割分担を明確に伝えています。特に111の「out-of-hours GP」への案内機能は知られていないことが多く、有用な情報です。",
            "feedbackEn": "Perfect explanation of the UK emergency system: 999 for life-threatening emergencies, 111 for urgent but non-emergency advice. 111's ability to direct you to an out-of-hours GP is underused but very helpful.",
            "textJa": "æœ¬å½“ã®ç·Šæ€¥äº‹æ…‹ã¯999ã«é›»è©±ã—ã¦ãã ã•ã„ã€‚å¤œé–“ã®ç·Šæ€¥ã‚¢ãƒ‰ãƒã‚¤ã‚¹ã¯111ã«é›»è©±ã—ã¦ãã ã•ã„ã€‚A&Eã«è¡Œãã¹ãã‹ã€å¤œé–“GPã‚’å—è¨ºã™ã¹ãã‹ã€æœã¾ã§å¾…ã¤ã¹ãã‹ã‚’åˆ¤æ–­ã—ã¦ãã‚Œã¾ã™ã€‚"
          },
          {
            "text": "Since GPs are only available during standard working hours, the sensible thing to do if something feels urgent in the night is to head straight to your nearest A&E — they're open 24 hours and equipped to assess anything that simply cannot wait until morning.",
            "correct": false,
            "feedback": "⚠️ GPが夜間対応しないのは正しいですが、夜間に「straight to A&E」を勧めるのは正確ではありません。111番に電話すれば、A&Eに行くべきか、out-of-hours GPに行くべきか、または翌朝まで待てるかをトリアージしてくれます。",
            "feedbackEn": "GPs not being available at night is correct, but 111 should be the first call for non-life-threatening issues—they triage and may direct you to an out-of-hours GP rather than A&E, saving time and resources.",
            "textJa": "GPã¯é€šå¸¸ã®æ¥­å‹™æ™‚é–“ã—ã‹å¯¾å¿œã—ã¦ã„ãªã„ã®ã§ã€å¤œé–“ã«ç·Šæ€¥ã¨æ€ã‚ã‚Œã‚‹ã“ã¨ãŒèµ·ããŸã‚‰æœ€å¯„ã‚Šã®A&Eã«ç›´æŽ¥è¡Œãã¹ãã§ã™ã€‚24æ™‚é–“å¯¾å¿œã§ã€æœã¾ã§å¾…ã¦ãªã„ã“ã¨ãªã‚‰ä½•ã§ã‚‚è¨ºã¦ãã‚Œã¾ã™ã€‚"
          },
          {
            "text": "Most modern GP surgeries have an online triage form or email submission system these days, so you can describe your symptoms overnight and someone on duty will review the message and get back to you first thing the next morning.",
            "correct": false,
            "feedback": "⚠️ 緊急時にGPへのメールは適切ではありません。メールは翌営業日に確認されるものです。夜間の緊急状況では111番または999番が正しい対応です。",
            "feedbackEn": "Emailing a GP is for non-urgent matters during business hours. In a night-time emergency, this is dangerous advice. 111 (urgent, non-life-threatening) or 999 (life-threatening) are the correct options.",
            "textJa": "å¤šãã®GPè¨ºç™‚æ‰€ã«ã¯ç¾åœ¨ã‚ªãƒ³ãƒ©ã‚¤ãƒ³ã®ãƒˆãƒªã‚¢ãƒ¼ã‚¸ãƒ•ã‚©ãƒ¼ãƒ ã‚„ãƒ¡ãƒ¼ãƒ«æŠ•ç¨¿ã‚·ã‚¹ãƒ†ãƒ ãŒã‚ã‚‹ã®ã§ã€å¤œé–“ã«ç—‡çŠ¶ã‚’èª¬æ˜Žã™ã‚Œã°æ‹…å½“è€…ãŒç¢ºèªã—ã¦ç¿Œæœæœ€åˆã«ã”é€£çµ¡ã„ãŸã ã‘ã¾ã™ã€‚"
          }
        ],
        "textJa": "æ·±å¤œã«ç·Šæ€¥äº‹æ…‹ãŒèµ·ããŸå ´åˆã€GPã«é›»è©±ã§ãã¾ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: 999 = life-threatening emergencies. 111 = urgent medical advice (24/7, non-emergency). GP = routine and ongoing health issues. A&E = serious injuries and emergencies. Register with a local GP as soon as you arrive in the UK via NHS.uk.",
    "tipJa": "🇬🇧 イギリスTip: 999=生命に関わる緊急時。111=緊急だが命に関わらない医療相談（24時間）。GP=日常的な健康問題。A&E=重傷・緊急時。英国到着後はすぐにNHS.ukでGP登録を。"
  },
  "conv_culture_rugby_cricket": {
    "id": "conv_culture_rugby_cricket",
    "title": "Rugby & cricket culture",
    "titleJa": "ラグビー・クリケット文化",
    "situation": "A British colleague invites you to watch a rugby match at the pub. You're curious but unfamiliar with the sport.",
    "situationJa": "イギリス人の同僚にパブでのラグビー観戦に誘われました。興味はあるけどラグビーはよく分かりません。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "🏉",
        "name": "Colleague",
        "text": "England vs France Six Nations on Saturday — fancy coming to the pub to watch?",
        "options": [
          {
            "text": "I'd love to! I have to be honest — I don't really know rugby, but I'd love to learn. What should I know before I come?",
            "correct": true,
            "feedback": "✅ 参加意欲と正直さを組み合わせた英国文化的に理想的な応答です。ラグビーを知らないことを素直に認め、事前に学ぼうとする姿勢が好印象です。Six Nationsはイングランド・スコットランド・ウェールズ・アイルランド・フランス・イタリアの6カ国トーナメントで、英国では非常に重要な大会です。",
            "feedbackEn": "Enthusiasm plus honesty is the perfect combo. British people love explaining rugby to newcomers—you've given your colleague an invitation to share their passion. Six Nations is huge in the UK; showing interest will endear you to them.",
            "textJa": "ãœã²ï¼æ­£ç›´ã€ãƒ©ã‚°ãƒ“ãƒ¼ã¯ã‚ˆãçŸ¥ã‚‰ãªã„ã‚“ã§ã™ãŒã€å­¦ã³ãŸã„ã¨æ€ã£ã¦ã„ã¾ã™ã€‚æ¥ã‚‹å‰ã«ä½•ã‚’çŸ¥ã£ã¦ãŠãã¹ãã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Rugby isn't something I really follow to be honest — football is much more my kind of sport. That said, if there's a group heading to the pub, maybe I'll tag along and cheer for England anyway.",
            "correct": false,
            "feedback": "⚠️ 正直さは良いですが、誘いを断る方向になってしまいます。ラグビーを知らなくても「観て学ぶ」という姿勢を示す方が、英国の社交文化では歓迎されます。スポーツ観戦は仲間との絆を深める重要な機会です。",
            "feedbackEn": "Honest but deflects the invitation. In British social culture, being willing to try new sports (even just for the pub atmosphere) builds strong relationships. You don't need to love rugby—just enjoy the occasion.",
            "textJa": "ãƒ©ã‚°ãƒ“ãƒ¼ã¯ã‚ã¾ã‚Šè¿½ã£ã¦ã„ãªã„ã‚“ã§ã™ãŒã€ã‚µãƒƒã‚«ãƒ¼ã®æ–¹ãŒå¥½ãã§ã™ã€‚ã§ã‚‚çš†ã•ã‚“ãŒãƒ‘ãƒ–ã«è¡Œããªã‚‰ã€ä¸€ç·’ã«ã‚¤ãƒ³ã‚°ãƒ©ãƒ³ãƒ‰ã‚’å¿œæ´ã™ã‚‹ã‹ã‚‚ã—ã‚Œã¾ã›ã‚“ã€‚"
          },
          {
            "text": "Six Nations — is that the same competition as the Rugby World Cup? I always get the tournaments mixed up; there seem to be so many different rugby competitions running throughout the season.",
            "correct": false,
            "feedback": "⚠️ Six NationsはWorld Cupとは別の大会です。Six Nationsはヨーロッパ6カ国の年次トーナメント（2月-3月）、Rugby World Cupは4年ごとの世界大会です。知らないのは問題ありませんが、確認してから言う方が印象が良いです。",
            "feedbackEn": "Six Nations is a separate annual European tournament (6 nations competing each Feb-March), not the World Cup (held every 4 years globally). It's fine not to know—but asking 'Is that the big tournament?' is better than guessing.",
            "textJa": "ã‚·ãƒƒã‚¯ã‚¹ãƒãƒ¼ã‚·ãƒ§ãƒ³ã‚ºã¯ãƒ©ã‚°ãƒ“ãƒ¼ãƒ¯ãƒ¼ãƒ«ãƒ‰ã‚«ãƒƒãƒ—ã¨åŒã˜å¤§ä¼šã§ã™ã‹ï¼Ÿã„ã¤ã‚‚æ··ä¹±ã—ã¦ã—ã¾ã„ã¾ã™ã€‚ãŸãã•ã‚“ã®ãƒ©ã‚°ãƒ“ãƒ¼å¤§ä¼šãŒã‚ã‚‹ã‚ˆã†ã§ã€‚"
          }
        ],
        "textJa": "åœŸæ›œæ—¥ã«ã‚·ãƒƒã‚¯ã‚¹ãƒãƒ¼ã‚·ãƒ§ãƒ³ã‚ºã®ã‚¤ãƒ³ã‚°ãƒ©ãƒ³ãƒ‰å¯¾ãƒ•ãƒ©ãƒ³ã‚¹æˆ¦ãŒã‚ã‚Šã¾ã™ã€‚ãƒ‘ãƒ–ã§ä¸€ç·’ã«è¦‹ã¾ã›ã‚“ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "🏉",
        "name": "Colleague",
        "text": "Ha! Basically: carry the ball forward but pass it backwards. Tackle, scrum, lineout. Don't worry — you'll pick it up. What about cricket — have you ever watched that?",
        "options": [
          {
            "text": "I've seen a bit but found it quite confusing! Is it true a match can last five days?",
            "correct": true,
            "feedback": "✅ クリケットへの正直な感想（confusing）と有名な特徴（5日間）への言及が会話を広げます。テストクリケットは確かに最大5日間続く場合があり、これを面白いと感じるのは英国人の誇りです。この質問は会話を自然に続けます。",
            "feedbackEn": "Mentioning the 5-day match shows you know something about cricket—and it's a great conversation starter. Test cricket lasting 5 days is genuinely unique and something British people enjoy explaining. Good cultural curiosity.",
            "textJa": "å°‘ã—è¦‹ã¾ã—ãŸãŒã€ã‹ãªã‚Šæ··ä¹±ã—ã¾ã—ãŸï¼è©¦åˆãŒ5æ—¥é–“ç¶šãã“ã¨ãŒã‚ã‚‹ã¨èžãã¾ã—ãŸãŒã€æœ¬å½“ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I don't understand cricket at all. It seems very complicated.",
            "correct": false,
            "feedback": "✅ 正直な感想です。クリケットは確かに複雑ですが、英国人にとって重要な文化です。「I've seen a bit but found it confusing — could you explain the basics?」と一歩進めると、相手が喜んで説明してくれます。",
            "feedbackEn": "Honest and fair—cricket is complex! But adding 'could you explain the basics?' turns this into an invitation for your colleague to share their passion. British people love explaining cricket to curious newcomers.",
            "textJa": "ã‚¯ãƒªã‚±ãƒƒãƒˆã¯å…¨ãåˆ†ã‹ã‚Šã¾ã›ã‚“ã€‚éžå¸¸ã«è¤‡é›‘ã«è¦‹ãˆã¾ã™ã€‚"
          },
          {
            "text": "Cricket moves quite slowly for me and I genuinely can't follow what's happening on the field or even work out which side is winning at any given moment.",
            "correct": false,
            "feedback": "⚠️ クリケットへの否定的な意見は英国文化では慎重に。クリケットはイングランドで非常に重要な文化・スポーツであり、特に年配の方や郊外出身の方には深く愛されています。「I haven't really got into it yet」のように控えめに表現する方が無難です。",
            "feedbackEn": "Criticising cricket can be sensitive in English culture—it's deeply embedded in national identity. Even if you find it slow, 'I haven't really got into it yet' is more diplomatic than 'boring.' Save the critique until you know them better.",
            "textJa": "ã‚¯ãƒªã‚±ãƒƒãƒˆã¯å‹•ããŒé…ãã¦ã€ä½•ãŒèµ·ãã¦ã„ã‚‹ã®ã‹åˆ†ã‹ã‚‰ãªã„ã—ã€ã©ã¡ã‚‰ãŒå‹ã£ã¦ã„ã‚‹ã®ã‹ã‚‚å…¨ãåˆ†ã‹ã‚Šã¾ã›ã‚“ã€‚"
          }
        ],
        "textJa": "åŸºæœ¬çš„ã«ã¯ï¼šãƒœãƒ¼ãƒ«ã‚’å‰ã«æŒã£ã¦èµ°ã‚‹ãŒã€ãƒ‘ã‚¹ã¯å¾Œã‚ã«ã™ã‚‹ã€‚ã‚¿ãƒƒã‚¯ãƒ«ã€ã‚¹ã‚¯ãƒ©ãƒ ã€ãƒ©ã‚¤ãƒ³ã‚¢ã‚¦ãƒˆã€‚å¤§ä¸ˆå¤«ã€æ…£ã‚Œã¾ã™ã€‚ã‚¯ãƒªã‚±ãƒƒãƒˆã¯è¦‹ãŸã“ã¨ãŒã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "🏉",
        "name": "Colleague",
        "text": "Ha — yes! Test cricket. Five days and it can still end in a draw. Very British. Anyway, Saturday, The Crown pub, 2pm — you in?",
        "options": [
          {
            "text": "Definitely! Should I get there early, or is 2pm fine to grab a seat?",
            "correct": true,
            "feedback": "✅ 参加を確約しながら実用的な質問をしています。人気の試合はパブが混むため、早めに行く必要がある場合があります。この質問は参加意欲と準備の良さを示します。Six Nationsのイングランド戦はパブが非常に混雑します。",
            "feedbackEn": "Confirming attendance and asking a practical question shows enthusiasm and preparation. Six Nations England matches pack pubs out—arriving early is usually wise. This question signals you're genuinely planning to attend.",
            "textJa": "ãœã²ï¼æ—©ã‚ã«è¡Œã£ãŸæ–¹ãŒã„ã„ã§ã™ã‹ï¼Ÿåˆå¾Œ2æ™‚ã§ã„ã„ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I'll try to make it. I'll let you know by Friday.",
            "correct": false,
            "feedback": "⚠️ 「try to make it」は英国文化では「あまり行く気がない」というサインに聞こえます。特に誘ってくれた相手には直接的に返事をする方が誠実です。予定が不確かなら「I'd love to come — I just need to check one thing. Can I confirm by Thursday?」の方が自然です。",
            "feedbackEn": "'I'll try' is British code for 'probably not.' If you want to go, say so clearly. If genuinely unsure, 'I'd love to—can I confirm by Thursday?' is honest and keeps the door open without seeming uncommitted.",
            "textJa": "è¡Œã‘ã‚‹ã‚ˆã†ã«ã—ã¾ã™ã€‚é‡‘æ›œæ—¥ã¾ã§ã«é€£çµ¡ã—ã¾ã™ã€‚"
          },
          {
            "text": "Actually, I might watch it at home — I prefer peace and quiet.",
            "correct": false,
            "feedback": "⚠️ 個人の好みは理解できますが、同僚から誘われた社交の場を断ることは、英国の職場文化ではやや距離を置く印象を与えます。パブでのスポーツ観戦は英国の重要な社交行事です。少なくとも一度は参加してみることをお勧めします。",
            "feedbackEn": "Personal preference is valid, but turning down a colleague's pub invitation affects workplace relationships. Pub sports watching is central to British social bonding. Try it once—you might enjoy the atmosphere even if not the sport.",
            "textJa": "å®Ÿã¯å®¶ã§è¦‹ã‚‹ã‹ã‚‚ã—ã‚Œã¾ã›ã‚“ã€‚é™ã‹ãªæ–¹ãŒå¥½ããªã®ã§ã€‚"
          }
        ],
        "textJa": "ãã†ã§ã™ï¼ãƒ†ã‚¹ãƒˆã‚¯ãƒªã‚±ãƒƒãƒˆã€‚5æ—¥é–“ã§å¼•ãåˆ†ã‘ã«ãªã‚‹ã“ã¨ã‚‚ã‚ã‚Šã¾ã™ã€‚ã¾ã•ã«è‹±å›½ã‚‰ã—ã„ã€‚ã¨ã‚‚ã‹ãã€åœŸæ›œæ—¥ã€The Crownã€åˆå¾Œ2æ™‚ã€æ¥ã¾ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: Six Nations (rugby) runs Feb-March; Ashes (cricket vs Australia) is a major summer event. You don't need to understand every rule—enthusiasm and turning up to watch with colleagues matters more than expertise.",
    "tipJa": "🇬🇧 イギリスTip: Six Nations（ラグビー）は2-3月、The Ashes（イングランドvsオーストラリアのクリケット）は夏の大イベントです。ルールを全て分からなくても大丈夫。同僚と一緒に観戦する姿勢が大切です。"
  },
  "conv_biz_presentation": {
    "id": "conv_biz_presentation",
    "title": "Presenting in a UK meeting",
    "titleJa": "英国式プレゼンテーション",
    "situation": "You're presenting a project proposal to a British team in London.",
    "situationJa": "ロンドンの英国チームにプロジェクト提案をプレゼンします。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "💼",
        "name": "Emma",
        "text": "Before you start — do feel free to interrupt if anything's unclear. We prefer a conversation over a one-way presentation here.",
        "options": [
          {
            "text": "Absolutely — any questions as we go are very welcome. I'd rather we discuss than I just talk at you.",
            "correct": true,
            "feedback": "✅ 完璧な返答です。英国のプレゼンスタイルは対話型が基本で、スライドを一方的に読み上げるのは好まれません。質問を歓迎する姿勢を最初に示すことで、チームはリラックスして関与しやすくなります。",
            "feedbackEn": "Perfect. UK presentation culture values conversation over lecture. Inviting questions throughout signals confidence and builds engagement. Brits find one-way presentations with 'hold questions till the end' rules quite formal and off-putting.",
            "textJa": "ã‚‚ã¡ã‚ã‚“ã§ã™ï¼é€²è¡Œä¸­ã®è³ªå•ã¯å¤§æ­“è¿Žã§ã™ã€‚ä¸€æ–¹çš„ã«è©±ã™ã‚ˆã‚Šä¸€ç·’ã«è­°è«–ã—ãŸã„ã§ã™ã€‚"
          },
          {
            "text": "Thank you — I'll take questions at the end to keep things on track.",
            "correct": false,
            "feedback": "⚠️ 効率重視の姿勢は理解できますが、英国では「質問は最後に」というルールは堅苦しく感じられます。途中での発言を歓迎した方がチームが参加しやすくなります。",
            "feedbackEn": "This works, but 'hold questions till the end' feels more American than British. UK teams prefer to jump in with queries mid-flow. Trying to control this can create distance rather than engagement.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚è³ªå•ã¯ãƒˆãƒ©ãƒƒã‚¯ã«ä¹—ã›ã‚‹ãŸã‚ã«æœ€å¾Œã«å—ã‘ä»˜ã‘ã¾ã™ã€‚"
          },
          {
            "text": "I appreciate that — though I'd probably prefer to save questions until the very end, as I find it easier to keep my train of thought if I can run through all the slides without any interruptions along the way.",
            "correct": false,
            "feedback": "❌ 英国のビジネス文化では、この指示は非常に堅苦しく受け取られます。英国人は型にはまったプレゼンよりも率直で対話的なスタイルを好みます。質問を封じると、むしろ信頼感が失われます。",
            "feedbackEn": "This is too controlling for UK business culture. Brits value informality and two-way dialogue; shutting down questions until the end can come across as defensive or overly corporate. It often kills room energy.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ãŸã ã€ã‚¹ãƒ©ã‚¤ãƒ‰ã‚’å…¨éƒ¨çµ‚ãˆã¦ã‹ã‚‰è³ªå•ã‚’å—ã‘ãŸæ–¹ãŒè©±ã®æµã‚ŒãŒé€”åˆ‡ã‚Œãªã„ã®ã§ã€ã§ãã‚Œã°æœ€å¾Œã¾ã§å¾…ã£ã¦ã„ãŸã ããŸã„ã§ã™ã€‚"
          }
        ],
        "textJa": "å§‹ã‚ã‚‹å‰ã«ã€ä¸æ˜Žãªç‚¹ãŒã‚ã‚Œã°è‡ªç”±ã«å‰²ã‚Šè¾¼ã‚“ã§ãã ã•ã„ã€‚ã“ã¡ã‚‰ã§ã¯ä¸€æ–¹çš„ãªãƒ—ãƒ¬ã‚¼ãƒ³ã‚ˆã‚Šã‚‚ä¼šè©±å½¢å¼ã‚’å¥½ã¿ã¾ã™ã€‚"
      },
      {
        "speaker": "colleague",
        "avatar": "💼",
        "name": "Oliver",
        "text": "Interesting figures. How confident are you in these projections?",
        "options": [
          {
            "text": "Reasonably confident — based on last quarter's data. There are some assumptions worth testing, which I've flagged on slide four.",
            "correct": true,
            "feedback": "✅ 英国のビジネス文化では「控えめに言って期待を上回る」のが美徳です。'Reasonably confident'という表現はリスクを認識しつつも根拠を示す、英国らしい誠実な答え方です。",
            "feedbackEn": "Ideal. 'Reasonably confident' plus acknowledging assumptions is quintessentially British—honest, measured, and it invites scrutiny rather than overselling. Brits are deeply suspicious of anyone who claims to be 'absolutely certain' in projections.",
            "textJa": "ã¾ã‚ã¾ã‚è‡ªä¿¡ãŒã‚ã‚Šã¾ã™ã€‚å…ˆå››åŠæœŸã®ãƒ‡ãƒ¼ã‚¿ã«åŸºã¥ã„ã¦ã„ã¾ã™ã€‚ã‚¹ãƒ©ã‚¤ãƒ‰4ã«ãƒ•ãƒ©ã‚°ã‚’ç«‹ã¦ãŸã„ãã¤ã‹ã®å‰æãŒã‚ã‚Šã¾ã™ã€‚"
          },
          {
            "text": "Very confident indeed — we ran these numbers through several different models and they all converged on essentially the same result, so I'm satisfied this is as accurate a forecast as we could possibly produce.",
            "correct": false,
            "feedback": "⚠️ 自信を示すのは良いですが、英国のビジネス文化では過度な自信は疑われます。「Very confident」は根拠が薄く聞こえることがあります。リスクや前提条件を添えた方が信頼感が増します。",
            "feedbackEn": "Confident is good, but overclaiming in a UK boardroom invites scepticism. British professionals are trained to probe assumptions—saying 'most accurate' without caveats will prompt harder pushback.",
            "textJa": "éžå¸¸ã«è‡ªä¿¡ãŒã‚ã‚Šã¾ã™ã€‚ã„ãã¤ã‹ã®ç•°ãªã‚‹ãƒ¢ãƒ‡ãƒ«ã§æ•°å­—ã‚’æ¤œè¨¼ã—ã€ã™ã¹ã¦åŒã˜çµæžœã«ãªã‚Šã¾ã—ãŸã€‚"
          },
          {
            "text": "Completely confident — these projections are built on solid, verified data and I'm entirely happy to put my name to every figure on the slide. There are genuinely no caveats worth mentioning at this stage.",
            "correct": false,
            "feedback": "❌ ビジネスで数字を「保証する」と言うのは英国では赤信号です。予測は必ず不確実性を伴います。このような発言は信頼性を下げ、後で問題になります。",
            "feedbackEn": "Never say 'guaranteed' about projections in a UK business context. It immediately undermines your credibility—experienced colleagues will know it's impossible and question your judgement.",
            "textJa": "å®Œå…¨ã«è‡ªä¿¡ãŒã‚ã‚Šã¾ã™ã€‚ã“ã®äºˆæ¸¬ã¯æ¤œè¨¼æ¸ˆã¿ã®ãƒ‡ãƒ¼ã‚¿ã«åŸºã¥ã„ã¦ãŠã‚Šã€ã™ã¹ã¦ã®æ•°å­—ã«è²¬ä»»ã‚’æŒã¦ã¾ã™ã€‚ç•™æ„ç‚¹ã¯ç‰¹ã«ã‚ã‚Šã¾ã›ã‚“ã€‚"
          }
        ],
        "textJa": "èˆˆå‘³æ·±ã„æ•°å­—ã§ã™ã­ã€‚ã“ã®äºˆæ¸¬ã«ã©ã®ãã‚‰ã„è‡ªä¿¡ãŒã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "💼",
        "name": "Charlotte",
        "text": "A whiteboard sketch might help us visualise the flow. Shall we ditch the slides for a moment?",
        "options": [
          {
            "text": "Great idea — let me grab a marker. Drawing it out will make the dependencies much clearer.",
            "correct": true,
            "feedback": "✅ 英国のプレゼン文化ではスライドへの固執は避けられます。ホワイトボードへの柔軟な移行は、内容を深く理解しているサインです。スライドなしで説明できる人は信頼されます。",
            "feedbackEn": "Excellent flexibility. UK business culture values substance over polish—being able to sketch ideas on a whiteboard shows you genuinely understand your content, not just your slides. Brits respect presenters who can think on their feet.",
            "textJa": "è‰¯ã„ã‚¢ã‚¤ãƒ‡ã‚¢ã§ã™ï¼ãƒžãƒ¼ã‚«ãƒ¼ã‚’å–ã£ã¦ãã¾ã™ã€‚æã„ã¦èª¬æ˜Žã—ãŸæ–¹ãŒä¾å­˜é–¢ä¿‚ãŒæ˜Žç¢ºã«ãªã‚Šã¾ã™ã€‚"
          },
          {
            "text": "I have additional slides that cover the flow — shall I move on to those instead?",
            "correct": false,
            "feedback": "⚠️ 追加スライドを提示するのは準備が良い証拠ですが、ホワイトボードの提案を断ることで、スライドに頼りすぎという印象を与える可能性があります。相手の提案に乗る柔軟性も大切です。",
            "feedbackEn": "Prepared, but prioritising your own slides over a colleague's suggestion can seem rigid. In UK culture, adapting to the room is valued—if someone proposes a whiteboard, try it.",
            "textJa": "ãƒ•ãƒ­ãƒ¼ã‚’ã‚«ãƒãƒ¼ã™ã‚‹è¿½åŠ ã®ã‚¹ãƒ©ã‚¤ãƒ‰ãŒã‚ã‚Šã¾ã™ã€‚ãã¡ã‚‰ã«ç§»ã‚Šã¾ã—ã‚‡ã†ã‹ï¼Ÿ"
          },
          {
            "text": "I'd rather stick to the slides — everything is already on there.",
            "correct": false,
            "feedback": "❌ スライドへの固執は英国の会議では良い印象を与えません。英国人は「スライドを読む」プレゼンターより、自分の言葉で語れる人を信頼します。提案を柔軟に受け入れる姿勢が重要です。",
            "feedbackEn": "Refusing the whiteboard suggestion makes you appear inflexible. UK audiences distrust presenters who seem glued to their slides. If you can't explain it without the deck, they'll wonder if you truly understand it.",
            "textJa": "ã‚¹ãƒ©ã‚¤ãƒ‰ã®æ–¹ãŒã„ã„ã§ã™ã€‚ã™ã§ã«ã™ã¹ã¦è¼‰ã£ã¦ã„ã¾ã™ã€‚"
          }
        ],
        "textJa": "ãƒ•ãƒ­ãƒ¼ã®è¦–è¦šåŒ–ã«ãƒ›ãƒ¯ã‚¤ãƒˆãƒœãƒ¼ãƒ‰ã®ã‚¹ã‚±ãƒƒãƒãŒå½¹ç«‹ã¤ã‹ã‚‚ã—ã‚Œã¾ã›ã‚“ã€‚ä¸€æ™‚çš„ã«ã‚¹ãƒ©ã‚¤ãƒ‰ã‚’ã‚„ã‚ã¾ã—ã‚‡ã†ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: British presentations favour conversation over polish. 'Any questions as we go?' is welcomed, understatement in claims builds credibility, and being able to ditch the slides for a whiteboard is a sign of real expertise.",
    "tipJa": "🇬🇧 イギリスTip: 英国式プレゼンは対話型が基本。「途中で質問どうぞ」が歓迎され、控えめな表現が信頼を生みます。スライドを捨ててホワイトボードに切り替えられる柔軟さが本物の専門家の証です。"
  },
  "conv_biz_references": {
    "id": "conv_biz_references",
    "title": "Providing UK job references",
    "titleJa": "英国の推薦状・リファレンス",
    "situation": "You're applying for a UK job and the recruiter asks about your referees.",
    "situationJa": "英国の採用担当者から推薦人（referee）について聞かれました。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "📋",
        "name": "James",
        "text": "Can you provide two referees — ideally your current or most recent line managers?",
        "options": [
          {
            "text": "Of course. I'll reach out to both first to confirm they're happy to act as my referees before sharing their details.",
            "correct": true,
            "feedback": "✅ 英国では推薦人に事前確認するのがマナーです。許可なく連絡先を共有するのは失礼とされます。また「referee」は英国英語で、「reference」は書類自体を指す場合が多いです。",
            "feedbackEn": "Always ask before naming someone as a referee in the UK—contacting them without warning is considered rude. This response shows professional courtesy. Note: 'referee' is the UK term; 'reference' refers to the document or process itself.",
            "textJa": "ã‚‚ã¡ã‚ã‚“ã§ã™ã€‚è©³ç´°ã‚’å…±æœ‰ã™ã‚‹å‰ã«ã€ä¸¡åã«æŽ¨è–¦è€…ã¨ã—ã¦å¿«è«¾ã—ã¦ã„ãŸã ã‘ã‚‹ã‹äº‹å‰ã«ç¢ºèªã—ã¾ã™ã€‚"
          },
          {
            "text": "Yes, I have two colleagues who said they'd give me a good word — I'll send their details now.",
            "correct": false,
            "feedback": "⚠️ 同僚が口頭で応援すると言っていても、正式なリファレンスとして連絡先を共有する前に書面で確認するのが英国の慣行です。採用担当者が突然連絡して推薦人が戸惑うケースがあります。",
            "feedbackEn": "Colleagues may be happy to help, but in UK practice you should formally confirm they're willing to act as a referee before sharing contact details. Recruiters calling unwarned referees can create awkward situations.",
            "textJa": "ã¯ã„ã€è‰¯ã„ã“ã¨ã‚’è¨€ã£ã¦ãã‚Œã‚‹ã¨è¨€ã£ãŸåŒåƒšãŒ2äººã„ã¾ã™ã€‚ä»Šã™ãè©³ç´°ã‚’é€ã‚Šã¾ã™ã€‚"
          },
          {
            "text": "My current manager isn't yet aware that I'm looking to move on — could I use a couple of trusted former colleagues from a previous role as referees rather than my current employer?",
            "correct": false,
            "feedback": "❌ 英国では友人のリファレンスは通常受け付けられません。前職の上司や信頼できる職業上の連絡先が必要です。現職の上司に知られたくない場合は、前職の上司を使うのが一般的です。",
            "feedbackEn": "Personal friends are not accepted as professional references in UK recruitment. Use a previous line manager if your current boss doesn't know you're looking—this is common and understood by UK recruiters.",
            "textJa": "ç¾åœ¨ã®ä¸Šå¸ã¯ã¾ã è»¢è·ã‚’è€ƒãˆã¦ã„ã‚‹ã“ã¨ã‚’çŸ¥ã‚Šã¾ã›ã‚“ã€‚å‰è·ã®ä¿¡é ¼ã§ãã‚‹å…ƒåŒåƒšã‚’æŽ¨è–¦è€…ã¨ã—ã¦ä½¿ãˆã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "æŽ¨è–¦è€…ã‚’2åã€ã§ãã‚Œã°ç¾åœ¨ã¾ãŸã¯ç›´è¿‘ã®ä¸Šå¸ã‚’æ•™ãˆã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "📋",
        "name": "James",
        "text": "Just so you know — UK law limits what referees can share due to GDPR. A standard reference confirms job title, dates, and whether they'd re-employ.",
        "options": [
          {
            "text": "That's useful to know. Should I let my referees know what they're permitted to say under GDPR?",
            "correct": true,
            "feedback": "✅ GDPRを理解し、推薦人へのサポートを申し出るのは非常に良い姿勢です。英国では雇用主は詳細な評価を共有することに慎重で、事実確認のみの簡潔なリファレンスが一般的です。",
            "feedbackEn": "Showing GDPR awareness and offering to brief your referees is excellent. UK employers are very cautious about sharing opinions due to legal liability—factual confirmations are standard. Knowing this prevents disappointment if referees seem 'bland'.",
            "textJa": "å½¹ç«‹ã¤æƒ…å ±ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚GDPRã®ä¸‹ã§ä½•ã‚’è¨€ãˆã‚‹ã‹ã‚’æŽ¨è–¦è€…ã«ä¼ãˆãŸæ–¹ãŒã„ã„ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "That surprises me — in Japan employers often share much more detail. Good to know.",
            "correct": false,
            "feedback": "⚠️ 文化的な比較は良いですが、GDPRに関する具体的なフォローアップがありません。英国のリファレンスの実態を理解しつつ、次のステップを確認する方が積極的な印象を与えます。",
            "feedbackEn": "Noting the cultural difference is fine, but this is a missed opportunity to engage further. Following up with a practical question about the process would show more initiative.",
            "textJa": "é©šãã¾ã—ãŸã€‚æ—¥æœ¬ã§ã¯é›‡ç”¨ä¸»ãŒã‚‚ã£ã¨è©³ç´°ã‚’å…±æœ‰ã™ã‚‹ã“ã¨ãŒå¤šã„ã§ã™ã€‚å‚è€ƒã«ãªã‚Šã¾ã—ãŸã€‚"
          },
          {
            "text": "In that case, what's the point of a reference if they can't say anything useful?",
            "correct": false,
            "feedback": "❌ 採用担当者にこう言うのは失礼に聞こえます。英国のGDPR制限は現実であり、リファレンス文化を批判する姿勢は印象を悪くします。制度に適応する姿勢を見せる方が賢明です。",
            "feedbackEn": "Questioning the value of a UK legal process in front of a recruiter is unprofessional. GDPR limits are a reality of UK employment law—adapt to the system rather than challenging it.",
            "textJa": "ã§ã¯ã€ä½•ã‚‚å½¹ç«‹ã¤ã“ã¨ã‚’è¨€ãˆãªã„ãªã‚‰ã€æŽ¨è–¦çŠ¶ã®æ„å‘³ã¯ä½•ã§ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "çŸ¥ã£ã¦ãŠã„ã¦ã„ãŸã ããŸã„ã®ã§ã™ãŒã€è‹±å›½æ³•ã§ã¯GDPRã«ã‚ˆã‚ŠæŽ¨è–¦è€…ãŒå…±æœ‰ã§ãã‚‹æƒ…å ±ãŒåˆ¶é™ã•ã‚Œã¦ã„ã¾ã™ã€‚æ¨™æº–çš„ãªæŽ¨è–¦çŠ¶ã§ã¯å½¹è·ã€åœ¨ç±æœŸé–“ã€å†æŽ¡ç”¨ã®æ„å‘ã‚’ç¢ºèªã—ã¾ã™ã€‚"
      },
      {
        "speaker": "colleague",
        "avatar": "📋",
        "name": "James",
        "text": "One of your referees hasn't responded yet. Is it okay if we chase them?",
        "options": [
          {
            "text": "Please do — and I'll send them a reminder as well so they know to expect your email.",
            "correct": true,
            "feedback": "✅ 採用担当者と協力してプロセスを前進させる積極的な姿勢が好印象です。推薦人への事前連絡済みであることも伝わります。採用プロセスの円滑化に貢献する姿勢は評価されます。",
            "feedbackEn": "Proactively coordinating with both the recruiter and your referee shows initiative and professionalism. UK recruiters appreciate candidates who keep the process moving without needing to be chased themselves.",
            "textJa": "ãœã²ã€‚ç§ã‚‚å½¼ã‚‰ã«ãƒ¡ãƒ¼ãƒ«ã‚’é€ã£ã¦ã€ã‚ãªãŸã‹ã‚‰ã®é€£çµ¡ã‚’æœŸå¾…ã™ã‚‹ã‚ˆã†ä¼ãˆã¾ã™ã€‚"
          },
          {
            "text": "I'll follow up with them directly — they've been rather tied up with a project lately, but I'll make sure they know it's urgent. A few more days should definitely be enough.",
            "correct": false,
            "feedback": "⚠️ 自分でフォローする意欲は良いですが、採用担当者の時間軸に配慮が必要です。採用担当者と推薦人の両方に同時にアプローチする方が効率的です。",
            "feedbackEn": "Taking ownership is good, but asking for 'a couple more days' can slow down the hiring process unnecessarily. Offering to coordinate both sides simultaneously is more efficient.",
            "textJa": "ç›´æŽ¥é€£çµ¡ã—ã¾ã™ã€‚æœ€è¿‘ãƒ—ãƒ­ã‚¸ã‚§ã‚¯ãƒˆã§å¿™ã—ãã—ã¦ã„ã¾ã™ãŒã€ç·Šæ€¥ã ã¨ä¼ãˆã¾ã™ã€‚æ•°æ—¥ã‚ã‚Œã°ååˆ†ã§ã™ã€‚"
          },
          {
            "text": "If they don't reply, can you just skip the reference check?",
            "correct": false,
            "feedback": "❌ 英国の採用プロセスでは通常2名のリファレンス確認が必須です。省略を求めることは採用担当者に悪印象を与え、選考通過の可能性を下げます。",
            "feedbackEn": "References are usually non-negotiable in UK hiring. Asking to skip them can raise red flags—it suggests the candidate may have something to hide or that their professional relationships are weak.",
            "textJa": "è¿”äº‹ãŒãªã‘ã‚Œã°ã€æŽ¨è–¦è€…ãƒã‚§ãƒƒã‚¯ã‚’ã‚¹ã‚­ãƒƒãƒ—ã§ãã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "æŽ¨è–¦è€…ã®ä¸€äººãŒã¾ã è¿”äº‹ã‚’ã—ã¦ã„ã¾ã›ã‚“ã€‚è¿½ã„ã‹ã‘ã¦ã‚ˆã„ã§ã™ã‹ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: Always ask before naming someone as a referee — contacting them without warning is rude. UK references are limited by GDPR to facts only (job title, dates, 're-employ' flag). Two professional referees is standard.",
    "tipJa": "🇬🇧 イギリスTip: 推薦人（referee）には必ず事前に確認を。英国ではGDPRにより、リファレンスは事実のみ（役職・在籍期間・再雇用の可否）に限定されます。専門的な推薦人2名が標準です。"
  },
  "conv_life_council": {
    "id": "conv_life_council",
    "title": "Registering for council tax",
    "titleJa": "カウンシルタックス登録",
    "situation": "You've just moved into a flat in London and visit the local council office to register for council tax.",
    "situationJa": "ロンドンのフラットに引っ越し、カウンシルタックスの登録のために区役所を訪れました。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "🏛️",
        "name": "Council Officer",
        "text": "Good morning. Are you here to register for council tax or to query an existing bill?",
        "options": [
          {
            "text": "I've just moved in and need to register. I'm also wondering if I qualify for the single person discount — I live alone.",
            "correct": true,
            "feedback": "✅ 登録と同時に単身者割引（25%）を確認するのは非常に賢明です。英国のカウンシルタックスはA〜Hの8バンドで評価額が決まり、一人暮らしの場合は25%割引が受けられます。積極的に確認する姿勢が良い印象を与えます。",
            "feedbackEn": "Excellent. The single person discount (25%) is automatic once proven but must be claimed—it's not applied by default. Asking upfront shows you've done your research and will save you money from the start.",
            "textJa": "å¼•ã£è¶Šã—ãŸã°ã‹ã‚Šã§ç™»éŒ²ã—ãŸã„ã®ã§ã™ãŒã€‚1äººæš®ã‚‰ã—ãªã®ã§ä¸€äººå‰²å¼•ã®å¯¾è±¡ã‹ã©ã†ã‹ã‚‚ç¢ºèªã—ãŸã„ã§ã™ã€‚"
          },
          {
            "text": "I need to register as I've just moved into a new flat — could you also tell me what council tax band the property falls into and roughly how much I'll be expected to pay each month?",
            "correct": false,
            "feedback": "⚠️ バンドについて質問するのは良いですが、単身者割引の確認を忘れないようにしましょう。バンドはA〜Hで物件の評価額に基づき決まり、変更することはできません。",
            "feedbackEn": "Asking about the band is fine, but missing the single person discount question could cost you 25% of your annual bill. Always claim it proactively if you live alone.",
            "textJa": "æ–°ã—ã„ãƒ•ãƒ©ãƒƒãƒˆã«å¼•ã£è¶Šã—ãŸã®ã§ç™»éŒ²ã—ãŸã„ã§ã™ã€‚ã“ã®ç‰©ä»¶ã®ã‚«ã‚¦ãƒ³ã‚·ãƒ«ã‚¿ãƒƒã‚¯ã‚¹ã®ãƒãƒ³ãƒ‰ã¨æ¯Žæœˆã®æ”¯æ‰•ã„é¡ã‚’æ•™ãˆã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I'm not sure I need to pay — I'm from Japan. Do foreigners have to pay council tax?",
            "correct": false,
            "feedback": "❌ カウンシルタックスは国籍に関係なく、英国に居住する全員に課税されます。外国人であることは免除の理由にはなりません。ただし学生は免除申請が可能です。",
            "feedbackEn": "Council tax applies to all UK residents regardless of nationality. Claiming exemption based on being foreign will not work and may create a negative impression. Students can claim exemption, but workers cannot.",
            "textJa": "æ”¯æ‰•ã„ãŒå¿…è¦ã‹ã©ã†ã‹åˆ†ã‹ã‚Šã¾ã›ã‚“ã€‚æ—¥æœ¬ã‹ã‚‰æ¥ã¾ã—ãŸã€‚å¤–å›½äººã‚‚ã‚«ã‚¦ãƒ³ã‚·ãƒ«ã‚¿ãƒƒã‚¯ã‚¹ã‚’æ”¯æ‰•ã†å¿…è¦ãŒã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ãŠã¯ã‚ˆã†ã”ã–ã„ã¾ã™ã€‚ã‚«ã‚¦ãƒ³ã‚·ãƒ«ã‚¿ãƒƒã‚¯ã‚¹ã®ç™»éŒ²ã§ã„ã‚‰ã£ã—ã‚ƒã„ã¾ã™ã‹ã€ãã‚Œã¨ã‚‚æ—¢å­˜ã®è«‹æ±‚æ›¸ã«é–¢ã™ã‚‹ãŠå•ã„åˆã‚ã›ã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "🏛️",
        "name": "Council Officer",
        "text": "You'll qualify for a 25% single person discount. Your property is Band C — about £111 a month after the discount. Are you a student?",
        "options": [
          {
            "text": "No, I'm working. The 25% discount is helpful — can I set up a direct debit to pay monthly?",
            "correct": true,
            "feedback": "✅ ダイレクトデビット（口座自動引き落とし）で月払いを設定するのは英国で最も一般的な支払い方法です。年10回払い（4月〜1月）が標準で、2月・3月は支払いなしになります。",
            "feedbackEn": "Setting up a direct debit is the standard UK approach—most councils bill over 10 months (April to January) with February and March free. It's efficient and avoids missed payments.",
            "textJa": "ã„ã„ãˆã€åƒã„ã¦ã„ã¾ã™ã€‚25%ã®å‰²å¼•ã¯åŠ©ã‹ã‚Šã¾ã™ã€‚æ¯Žæœˆã®ç›´æŽ¥å¼•ãè½ã¨ã—ã‚’è¨­å®šã§ãã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "No, I'm working. Can I pay in one lump sum to get a discount?",
            "correct": false,
            "feedback": "⚠️ 一括払いは通常可能ですが、割引は一般的に提供されません。月払いと一括払いで金額は同じです。一括払いを希望する場合は窓口で確認しましょう。",
            "feedbackEn": "Lump sum payment is usually possible but rarely discounted. There's no financial incentive to pay all at once—monthly direct debit is just as cost-effective and simpler to manage.",
            "textJa": "ã„ã„ãˆã€åƒã„ã¦ã„ã¾ã™ã€‚ä¸€æ‹¬æ‰•ã„ã§å‰²å¼•ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "That seems expensive. Can I opt out if I don't use local services?",
            "correct": false,
            "feedback": "❌ カウンシルタックスはオプトアウトできません。ゴミ収集、道路、図書館、地方サービスなどに使われる税金で、居住者全員が支払う義務があります。",
            "feedbackEn": "Council tax is mandatory for all UK residents—you cannot opt out based on personal use of services. It funds rubbish collection, local roads, libraries, and other shared services.",
            "textJa": "é«˜ã„ã§ã™ã­ã€‚åœ°åŸŸã‚µãƒ¼ãƒ“ã‚¹ã‚’åˆ©ç”¨ã—ãªã‘ã‚Œã°å…é™¤ã•ã‚Œã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "25%ã®å˜ç‹¬å æœ‰è€…å‰²å¼•ã®å¯¾è±¡ã«ãªã‚Šã¾ã™ã€‚ç‰©ä»¶ã¯ãƒãƒ³ãƒ‰Cã§ã€å‰²å¼•å¾Œã¯æœˆç´„111ãƒãƒ³ãƒ‰ã§ã™ã€‚å­¦ç”Ÿã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "🏛️",
        "name": "Council Officer",
        "text": "To apply for the single person discount, fill in this form and provide proof of single occupancy. Your move-in date is important for back-dating.",
        "options": [
          {
            "text": "Understood. I'll complete the form today and include my tenancy agreement to confirm the move-in date.",
            "correct": true,
            "feedback": "✅ 入居日の証拠として賃貸契約書を提出するのは最適です。割引は申請日ではなく入居日に遡って適用されるため、早めに手続きするほど有利です。",
            "feedbackEn": "Providing the tenancy agreement is exactly right—it proves your move-in date for back-dating. Acting promptly ensures you claim the discount from day one of occupancy, not just from when you applied.",
            "textJa": "åˆ†ã‹ã‚Šã¾ã—ãŸã€‚ä»Šæ—¥ãƒ•ã‚©ãƒ¼ãƒ ã‚’è¨˜å…¥ã—ã¦ã€å…¥å±…æ—¥ã®ç¢ºèªã®ãŸã‚ã«è³ƒè²¸å€Ÿå¥‘ç´„æ›¸ã‚’æ·»ä»˜ã—ã¾ã™ã€‚"
          },
          {
            "text": "Is there an online version of this available? I'd much rather complete it digitally — it's quicker to fill in and easier to keep a copy for my own records afterwards.",
            "correct": false,
            "feedback": "⚠️ 多くの区では申請をオンラインでも受け付けていますが、窓口に来ている段階で紙で提出するのが最も確実で速い方法です。柔軟性はありますが、今日中に完了することを優先すべきです。",
            "feedbackEn": "Many councils do offer online applications, but since you're already at the office, completing the paper form is the quickest way to get it processed. Online is fine if offered—just don't delay.",
            "textJa": "ã‚ªãƒ³ãƒ©ã‚¤ãƒ³ç‰ˆã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿç´™ã‚ˆã‚Šãƒ‡ã‚¸ã‚¿ãƒ«ã®æ–¹ãŒæ—©ã„ã—ã€å¾Œã§ã‚³ãƒ”ãƒ¼ã‚’ä¿å­˜ã—ã‚„ã™ã„ã§ã™ã€‚"
          },
          {
            "text": "Is it really necessary for me to provide the tenancy agreement? I'd have thought the council would already have records of who's currently registered as living at the property.",
            "correct": false,
            "feedback": "❌ 単身者割引の申請には証拠提出が必要です。不正申請を防ぐための制度であり、プライバシー侵害ではありません。賃貸契約書や選挙登録簿の照合が一般的な確認方法です。",
            "feedbackEn": "Proof is required to prevent fraudulent discount claims—it's standard procedure, not an invasion of privacy. Councils cross-reference electoral rolls and tenancy agreements. Providing it promptly is in your own interest.",
            "textJa": "è³ƒè²¸å€Ÿå¥‘ç´„æ›¸ã¯æœ¬å½“ã«å¿…è¦ã§ã™ã‹ï¼Ÿå¸‚å½¹æ‰€ã¯ç‰©ä»¶ã«èª°ãŒç™»éŒ²ã—ã¦ã„ã‚‹ã‹ã®è¨˜éŒ²ã‚’æŒã£ã¦ã„ã‚‹ã¯ãšã§ã¯ï¼Ÿ"
          }
        ],
        "textJa": "å˜ç‹¬å æœ‰è€…å‰²å¼•ã‚’ç”³è«‹ã™ã‚‹ã«ã¯ã€ã“ã®ãƒ•ã‚©ãƒ¼ãƒ ã«è¨˜å…¥ã—ã¦å˜ç‹¬å æœ‰ã®è¨¼æ˜Žã‚’æå‡ºã—ã¦ãã ã•ã„ã€‚å…¥å±…æ—¥ã¯é¡åŠã®ãŸã‚ã«é‡è¦ã§ã™ã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: Council tax is charged in bands A–H based on property value. If you live alone, always claim the 25% single person discount — it's not automatic. Full-time students are fully exempt.",
    "tipJa": "🇬🇧 イギリスTip: カウンシルタックスはA〜Hのバンドで決まります。一人暮らしなら必ず25%の単身者割引を申請しましょう（自動適用ではありません）。フルタイム学生は全額免除です。"
  },
  "conv_life_driving": {
    "id": "conv_life_driving",
    "title": "Driving in the UK",
    "titleJa": "英国での運転・免許",
    "situation": "You want to drive in the UK and visit the DVLA to sort out your licence.",
    "situationJa": "英国で運転したいと思い、DVLAの窓口を訪れました。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "🚗",
        "name": "DVLA Officer",
        "text": "Are you exchanging a foreign licence or applying for a provisional UK licence?",
        "options": [
          {
            "text": "I have a Japanese licence. I understand I can drive on it for up to 12 months — after that I need to exchange it or take the UK test?",
            "correct": true,
            "feedback": "✅ 正確な理解です。日本の免許は英国の承認リストに含まれているため、筆記・実技テストなしで英国免許に切り替えることができます。ただし12ヶ月以内に手続きが必要で、それ以降は日本の免許では運転できません。",
            "feedbackEn": "Correct. Japan is on the DVLA's approved exchange list, meaning you can swap your licence without retaking tests. The 12-month window is real—after that you'd need a full UK test if you haven't exchanged. Knowing this shows good preparation.",
            "textJa": "æ—¥æœ¬ã®å…è¨±è¨¼ã‚’æŒã£ã¦ã„ã¾ã™ã€‚12ãƒ¶æœˆã¾ã§ä½¿ç”¨ã§ãã‚‹ã¨ç†è§£ã—ã¦ã„ã¾ã™ãŒã€ãã®å¾Œã¯äº¤æ›ã‹è‹±å›½ã§ã®ãƒ†ã‚¹ãƒˆãŒå¿…è¦ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I have an international driving permit from Japan — I was told that covers you to drive legally in any country worldwide, so I assumed I wouldn't need to do anything else here in the UK.",
            "correct": false,
            "feedback": "⚠️ 国際運転免許証は英国でも有効ですが、元の国内免許証と合わせて携帯する必要があります。また1年しか有効でなく、英国在住者は切り替えを推奨されています。",
            "feedbackEn": "An IDP is valid in the UK but must be carried with your domestic licence. For UK residents, it's only a temporary solution—exchanging to a full UK licence is strongly recommended after 12 months.",
            "textJa": "æ—¥æœ¬ã‹ã‚‰ã®å›½éš›é‹è»¢å…è¨±è¨¼ã‚’æŒã£ã¦ã„ã¾ã™ã€‚ä¸–ç•Œä¸­ã©ã“ã§ã‚‚åˆæ³•çš„ã«é‹è»¢ã§ãã‚‹ã¨è¨€ã‚ã‚ŒãŸã®ã§ã€è‹±å›½ã§ã¯ç‰¹ã«ä½•ã‚‚å¿…è¦ãªã„ã¨æ€ã£ã¦ã„ã¾ã—ãŸã€‚"
          },
          {
            "text": "My Japanese licence is a full driving licence, not a provisional — surely it should be accepted internationally without any additional conversion process, in the same way that an EU licence would be.",
            "correct": false,
            "feedback": "❌ 日本の免許は英国で最初の12ヶ月間のみ有効です。12ヶ月を超えて英国居住者が日本の免許で運転することは違法です。早めにDVLAで切り替え手続きをすることが重要です。",
            "feedbackEn": "Japanese licences are only valid for the first 12 months in the UK. Driving on a foreign licence beyond that as a UK resident is illegal. Always check—licences from some countries require a full UK test regardless of exchange lists.",
            "textJa": "ç§ã®æ—¥æœ¬ã®å…è¨±è¨¼ã¯ä»®å…è¨±ã§ã¯ãªãæ­£å¼ãªé‹è»¢å…è¨±è¨¼ã§ã™ã€‚EUã®å…è¨±è¨¼ã¨åŒæ§˜ã«ã€è¿½åŠ ã®å¤‰æ›æ‰‹ç¶šããªã—ã«å›½éš›çš„ã«é€šç”¨ã™ã‚‹ã¯ãšã§ã™ã€‚"
          }
        ],
        "textJa": "å¤–å›½ã®å…è¨±è¨¼ã‚’äº¤æ›ã—ã¾ã™ã‹ï¼Ÿãã‚Œã¨ã‚‚UKã®ä»®å…è¨±ã‚’ç”³è«‹ã—ã¾ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "🚗",
        "name": "DVLA Officer",
        "text": "Good news — Japan is on our approved exchange list, so no test needed. You'll need your Japanese licence, passport, proof of address, and the D1 form.",
        "options": [
          {
            "text": "Perfect. I have all of those with me. Will my Japanese licence be returned, or do you keep it?",
            "correct": true,
            "feedback": "✅ 必要書類を全て準備して持参しているのは非常に良い準備です。英国では免許交換時に元の免許を没収するのが一般的ですが、DVLAが返却ポリシーを説明してくれます。",
            "feedbackEn": "Coming prepared with all documents is ideal. Asking about the Japanese licence shows practical thinking—the DVLA typically retains the foreign licence when issuing a UK one, but it's worth confirming.",
            "textJa": "å®Œç’§ã§ã™ã€‚ã™ã¹ã¦æŒã£ã¦ã„ã¾ã™ã€‚æ—¥æœ¬ã®å…è¨±è¨¼ã¯è¿”å´ã•ã‚Œã¾ã™ã‹ã€ãã‚Œã¨ã‚‚é ã‹ã£ãŸã¾ã¾ã«ãªã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Great — I have everything here with me. Will this be processed and returned today, or does it take several weeks for the new UK licence to come through?",
            "correct": false,
            "feedback": "⚠️ DVLAは通常、交換時に元の外国免許を保管します。両方を保持することは認められていません。日本の免許が必要な場合は日本の機関に問い合わせてください。",
            "feedbackEn": "The DVLA typically retains the foreign licence on exchange—you can't legally hold both. If you need to drive in Japan in future, you'd apply separately to the Japanese authority.",
            "textJa": "ç´ æ™´ã‚‰ã—ã„ã§ã™ã€‚å…¨éƒ¨ã‚ã‚Šã¾ã™ã€‚ä»Šæ—¥å‡¦ç†ã—ã¦è¿”å´ã•ã‚Œã¾ã™ã‹ã€ãã‚Œã¨ã‚‚æ–°ã—ã„è‹±å›½ã®å…è¨±è¨¼ãŒå±Šãã¾ã§æ•°é€±é–“ã‹ã‹ã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Then I'll just keep driving on my Japanese licence for now and deal with it later.",
            "correct": false,
            "feedback": "❌ 12ヶ月の期限を過ぎると英国居住者として日本の免許での運転は違法になります。「後で対処する」という姿勢はリスクが高く、罰金や保険無効の原因になります。",
            "feedbackEn": "Procrastinating risks driving illegally after 12 months—which can invalidate insurance and result in prosecution. The exchange process is straightforward; doing it promptly is far safer.",
            "textJa": "ã§ã¯ä»Šã¯æ—¥æœ¬ã®å…è¨±è¨¼ã§é‹è»¢ã‚’ç¶šã‘ã¦ã€å¾Œã§æ‰‹ç¶šãã—ã¾ã™ã€‚"
          }
        ],
        "textJa": "è‰¯ã„ãƒ‹ãƒ¥ãƒ¼ã‚¹ã§ã™ã€‚æ—¥æœ¬ã¯æ‰¿èªæ¸ˆã¿äº¤æ›ãƒªã‚¹ãƒˆã«ã‚ã‚‹ã®ã§ã€ãƒ†ã‚¹ãƒˆã¯ä¸è¦ã§ã™ã€‚æ—¥æœ¬ã®å…è¨±è¨¼ã€ãƒ‘ã‚¹ãƒãƒ¼ãƒˆã€ä½æ‰€è¨¼æ˜Žã€D1ãƒ•ã‚©ãƒ¼ãƒ ãŒå¿…è¦ã§ã™ã€‚"
      },
      {
        "speaker": "colleague",
        "avatar": "🚗",
        "name": "DVLA Officer",
        "text": "Also — cars over three years old need an annual MOT test. And if you drive into central London, there's a congestion charge on weekdays.",
        "options": [
          {
            "text": "Good to know. I'll check when the MOT is due and set up a TfL account for the congestion charge before I drive into the zone.",
            "correct": true,
            "feedback": "✅ MOTと渋滞税の両方について具体的なアクションを示しているのは素晴らしいです。ロンドンの渋滞税（Congestion Charge）は月〜金の午前7時〜午後6時に適用され、1日£15です。TfLのAuto Pay登録で割引が受けられます。",
            "feedbackEn": "Proactive on both counts. The MOT (annual roadworthiness test) is mandatory from year 3—failing to have one invalidates insurance. The congestion charge is £15/day in central London; TfL Auto Pay gives a small discount.",
            "textJa": "å‚è€ƒã«ãªã‚Šã¾ã—ãŸã€‚MOTã®æœŸæ—¥ã‚’ç¢ºèªã—ã¦ã€æ¸‹æ»žèª²é‡‘ã‚¾ãƒ¼ãƒ³ã«å…¥ã‚‹å‰ã«TfLã®ã‚¢ã‚«ã‚¦ãƒ³ãƒˆã‚’è¨­å®šã—ã¾ã™ã€‚"
          },
          {
            "text": "Is the MOT something I need to arrange myself through a garage, or does it happen automatically? And is the congestion charge the same kind of thing as a parking permit for the zone?",
            "correct": false,
            "feedback": "⚠️ MOTを忘れると車検証が無効になり、保険も無効になる可能性があります。自動的に罰金が来るわけではありませんが、車検証が切れた車での運転は違法です。期限を車のダッシュボードやスマホに記録しておきましょう。",
            "feedbackEn": "Missing an MOT doesn't trigger an automatic fine, but driving without a valid MOT is illegal and voids your insurance. Renewal reminders are not sent officially—you must track the date yourself.",
            "textJa": "MOTã¯è‡ªåˆ†ã§ã‚¬ãƒ¬ãƒ¼ã‚¸ã‚’æ‰‹é…ã™ã‚‹å¿…è¦ãŒã‚ã‚Šã¾ã™ã‹ï¼Ÿãã‚Œã¨ã‚‚è‡ªå‹•çš„ã«è¡Œã‚ã‚Œã¾ã™ã‹ï¼Ÿæ¸‹æ»žèª²é‡‘ã¯é§è»Šè¨±å¯è¨¼ã®ã‚ˆã†ãªã‚‚ã®ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "The congestion charge sounds complicated. I'll just avoid driving in London altogether.",
            "correct": false,
            "feedback": "⚠️ ロンドン中心部への運転を避けることは合理的な選択です。ただし、渋滞税は仕組みを理解すれば簡単です。TfLのウェブサイトで対象エリアを確認し、必要な時だけ支払う選択肢も覚えておくと便利です。",
            "feedbackEn": "Avoiding central London driving is actually sensible—public transport is excellent. But understanding the congestion charge is useful: it only applies within the designated zone, and you pay via TfL online or phone.",
            "textJa": "æ¸‹æ»žèª²é‡‘ã¯è¤‡é›‘ãã†ã§ã™ã­ã€‚ãƒ­ãƒ³ãƒ‰ãƒ³ã§ã®é‹è»¢ã¯é¿ã‘ã¾ã™ã€‚"
          }
        ],
        "textJa": "ã¾ãŸã€3å¹´ä»¥ä¸ŠçµŒéŽã—ãŸè»Šã«ã¯æ¯Žå¹´MOTæ¤œæŸ»ãŒå¿…è¦ã§ã™ã€‚å¹³æ—¥ã«ä¸­å¤®ãƒ­ãƒ³ãƒ‰ãƒ³ã«å…¥ã‚‹å ´åˆã¯æ¸‹æ»žèª²é‡‘ãŒã‚ã‚Šã¾ã™ã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: Drive on the left in right-hand drive cars. Japanese licences can be exchanged for a UK licence without a test (DVLA D1 form). Annual MOT test required for cars 3+ years old. London congestion charge: £15/day weekdays.",
    "tipJa": "🇬🇧 イギリスTip: 英国は左側通行・右ハンドルです。日本の免許はテスト不要でDVLA（D1フォーム）に申請して切り替えられます。3年以上の車は年1回のMOT検査が必要。ロンドン市内は平日£15の渋滞税があります。"
  },
  "conv_life_gp": {
    "id": "conv_life_gp",
    "title": "Registering with an NHS GP",
    "titleJa": "NHS GPへの登録",
    "situation": "You want to register at an NHS GP surgery near your new flat.",
    "situationJa": "新しいフラットの近くのNHS GP（かかりつけ医）に登録しに行きました。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "🏥",
        "name": "Receptionist",
        "text": "Good morning. Are you looking to register as a new patient?",
        "options": [
          {
            "text": "Yes please. I've just moved to the area. I have my passport and a recent utility bill as proof of address.",
            "correct": true,
            "feedback": "✅ GPに登録する際は身分証明書（パスポート）と住所確認書類（公共料金の請求書・銀行明細書など）を持参するのが英国の標準です。準備が整っていることを示すのは非常に良い印象です。",
            "feedbackEn": "Bringing a passport and proof of address is exactly right for NHS registration. Being prepared speeds up the process and shows you've researched UK healthcare. NHS GP registration is free and open to all UK residents.",
            "textJa": "ã¯ã„ã€ãŠé¡˜ã„ã—ã¾ã™ã€‚ã“ã®åœ°åŸŸã«æ¥ãŸã°ã‹ã‚Šã§ã™ã€‚ãƒ‘ã‚¹ãƒãƒ¼ãƒˆã¨æœ€è¿‘ã®å…¬å…±æ–™é‡‘ã®æ˜Žç´°æ›¸ã‚’ä½æ‰€è¨¼æ˜Žã¨ã—ã¦æŒã£ã¦ã„ã¾ã™ã€‚"
          },
          {
            "text": "Yes. I need to see a doctor soon — can I book an appointment at the same time as registering?",
            "correct": false,
            "feedback": "⚠️ 登録自体は可能ですが、新規患者は通常2週間程度待ってから予約を取れます。緊急の場合はNHS 111（非緊急緊急相談）かA&E（救急）を利用してください。",
            "feedbackEn": "Registration is fine, but same-day appointments as a new patient are rarely possible. For urgent needs, NHS 111 (non-emergency urgent line) is the correct route. For life-threatening emergencies, call 999 or go to A&E.",
            "textJa": "ã¯ã„ã€‚ã™ãã«åŒ»å¸«ã«è¨ºã¦ã‚‚ã‚‰ã„ãŸã„ã®ã§ã™ãŒã€ç™»éŒ²ã¨åŒæ™‚ã«äºˆç´„ã§ãã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Yes. I don't have a UK address yet — can I still register using my Japanese address?",
            "correct": false,
            "feedback": "❌ NHS GPは通常、その診療所のキャッチメントエリア（担当地域）内に居住していることが登録条件です。英国の住所がない段階では、まず住所を確保してから登録してください。ホームレス支援団体を通じた特例登録もあります。",
            "feedbackEn": "NHS GP surgeries require a local address within their catchment area. You'll need a UK address to register. In exceptional circumstances (homelessness), there are pathways, but for new arrivals, securing accommodation first is essential.",
            "textJa": "ã¯ã„ã€‚ã¾ã è‹±å›½ã®ä½æ‰€ãŒã‚ã‚Šã¾ã›ã‚“ã€‚æ—¥æœ¬ã®ä½æ‰€ã§ç™»éŒ²ã§ãã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ãŠã¯ã‚ˆã†ã”ã–ã„ã¾ã™ã€‚æ–°æ‚£ã¨ã—ã¦ç™»éŒ²ã•ã‚Œã¾ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "🏥",
        "name": "Receptionist",
        "text": "We have a two-week wait for routine appointments once you're registered. For urgent non-emergency issues, please call 111.",
        "options": [
          {
            "text": "Understood. Is 111 for things that need attention within 24 hours but aren't life-threatening?",
            "correct": true,
            "feedback": "✅ NHS 111の役割を正確に理解しています。111は24時間対応の医療相談窓口で、A&Eに行くべきか、GPを待つべきか、薬局で対処できるかをガイドしてくれます。生命の危機の場合は999へ。",
            "feedbackEn": "Correct understanding of NHS 111. It's the 24/7 triage service for urgent but non-life-threatening situations—it tells you whether you need A&E, an urgent GP, a pharmacist, or just home care. For emergencies, always call 999.",
            "textJa": "åˆ†ã‹ã‚Šã¾ã—ãŸã€‚111ã¯24æ™‚é–“ä»¥å†…ã«å¯¾å¿œãŒå¿…è¦ã ãŒå‘½ã«é–¢ã‚ã‚‰ãªã„ã‚‚ã®ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Two weeks feels quite long. Can I just go to A&E if I need to see someone sooner?",
            "correct": false,
            "feedback": "⚠️ A&E（救急外来）は本当の緊急症例のための場所です。軽症でA&Eを受診すると何時間も待つことになり、重症患者の妨げにもなります。NHS 111に電話して適切なルートを確認しましょう。",
            "feedbackEn": "A&E (Accident and Emergency) is for genuine emergencies only. Using it for non-urgent issues means very long waits and burdens the NHS. NHS 111 will direct you to the appropriate level of care far more efficiently.",
            "textJa": "2é€±é–“ã¯é•·ã„ã§ã™ã­ã€‚æ—©ã‚ã«è¨ºã¦ã‚‚ã‚‰ã„ãŸã„å ´åˆã¯A&Eã«è¡Œã‘ã°ã„ã„ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I'll just go to a private GP — NHS seems too slow for everyday things.",
            "correct": false,
            "feedback": "⚠️ 私立GPは確かに速いですが、1回の診察で£100〜£200程度かかります。NHSは無料で利用できるため、ほとんどの日常的な医療ニーズには十分対応できます。まずNHSに登録し、必要に応じて私立を補完的に使うことをお勧めします。",
            "feedbackEn": "Private GPs are faster but typically cost £100–200 per appointment. The NHS is free and works well for most routine needs. Register with NHS first; consider private only for speed-critical situations.",
            "textJa": "æ°‘é–“ã®GPã«è¡Œãã¾ã™ã€‚NHSã¯æ—¥å¸¸çš„ãªã“ã¨ã«ã¯é…ã™ãŽã¾ã™ã€‚"
          }
        ],
        "textJa": "ç™»éŒ²å¾Œã€é€šå¸¸ã®äºˆç´„ã¯2é€±é–“å¾…ã¡ã«ãªã‚Šã¾ã™ã€‚ç·Šæ€¥æ€§ã¯ã‚ã‚‹ãŒå‘½ã«é–¢ã‚ã‚‰ãªã„å•é¡Œã¯111ã«é›»è©±ã—ã¦ãã ã•ã„ã€‚"
      },
      {
        "speaker": "colleague",
        "avatar": "🏥",
        "name": "Receptionist",
        "text": "Here's the registration form. The GP may invite you for a brief new patient health check.",
        "options": [
          {
            "text": "Perfect. Should I mention any existing conditions or medications I'm currently taking on the form?",
            "correct": true,
            "feedback": "✅ 既往症や現在服用中の薬を登録フォームに記載することは非常に重要です。GPが適切なケアを提供するために必要な情報です。日本からの薬の処方箋を持参すると、英国での処方に切り替えやすくなります。",
            "feedbackEn": "Always declare existing conditions and medications on the registration form—it ensures safe, appropriate care from day one. If you take regular medication from Japan, bring a recent prescription so the UK GP can issue an equivalent.",
            "textJa": "å®Œç’§ã§ã™ã€‚ãƒ•ã‚©ãƒ¼ãƒ ã«æ—¢å¾€ç—‡ã‚„ç¾åœ¨æœç”¨ä¸­ã®è–¬ã‚’è¨˜è¼‰ã™ã¹ãã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Is there an online version I can fill in instead? I'd much prefer to do it digitally and send it back via the NHS app rather than completing a paper form.",
            "correct": false,
            "feedback": "⚠️ 一部のGPはオンライン登録フォームを提供していますが、窓口で直接提出する方がより迅速に処理されることが多いです。今日中に登録を完了することが最優先です。",
            "feedbackEn": "Some surgeries do offer online registration, but completing it in person usually gets processed faster. The priority is completing registration promptly—method matters less than doing it today.",
            "textJa": "ã‚ªãƒ³ãƒ©ã‚¤ãƒ³ã§è¨˜å…¥ã§ãã¾ã™ã‹ï¼Ÿç´™ã‚ˆã‚Šã‚‚NHSã‚¢ãƒ—ãƒªã§é€ã‚Šè¿”ã™æ–¹ãŒã„ã„ã§ã™ã€‚"
          },
          {
            "text": "Do I have to attend the health check? I prefer not to share medical information unless necessary.",
            "correct": false,
            "feedback": "⚠️ 新患健診は任意ですが、参加することで基礎データ（血圧・体重など）が記録され、将来の診察に役立ちます。プライバシーは守られており、英国の医療は患者の守秘義務を非常に重視しています。",
            "feedbackEn": "The new patient health check is usually optional, but it establishes a baseline record—useful for all future appointments. UK patient data is protected by strict confidentiality laws; sharing it with your GP is safe and beneficial.",
            "textJa": "å¥åº·ãƒã‚§ãƒƒã‚¯ã¯å¿…ãšå—ã‘ãªã‘ã‚Œã°ãªã‚Šã¾ã›ã‚“ã‹ï¼Ÿå¿…è¦ã§ãªã„é™ã‚ŠåŒ»ç™‚æƒ…å ±ã¯å…±æœ‰ã—ãŸããªã„ã§ã™ã€‚"
          }
        ],
        "textJa": "ã“ã¡ã‚‰ãŒç™»éŒ²ãƒ•ã‚©ãƒ¼ãƒ ã§ã™ã€‚GPã‹ã‚‰ç°¡å˜ãªæ–°æ‚£å¥åº·ãƒã‚§ãƒƒã‚¯ã«æ‹›å¾…ã•ã‚Œã‚‹ã‹ã‚‚ã—ã‚Œã¾ã›ã‚“ã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: Register with an NHS GP surgery immediately on arrival — bring ID and proof of address. Routine appointments may take 2 weeks; for urgent non-emergencies call 111; for life-threatening situations call 999 or go to A&E.",
    "tipJa": "🇬🇧 イギリスTip: 英国に着いたらすぐにNHS GPに登録しましょう（パスポート＋住所証明が必要）。通常の予約は2週間待ちが一般的。急ぎの非緊急相談は111へ、緊急の場合は999かA&Eへ。"
  },
  "conv_culture_tea": {
    "id": "conv_culture_tea",
    "title": "British tea culture",
    "titleJa": "英国のお茶文化",
    "situation": "You've just arrived at a British colleague's home for a working meeting. She puts the kettle on.",
    "situationJa": "英国人の同僚の自宅に打ち合わせで訪問しました。彼女がやかんを火にかけています。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "☕",
        "name": "Charlotte",
        "text": "Right, shall I be mother? Milk in first or after — very important question!",
        "options": [
          {
            "text": "Ha! I'll let you decide — I'm still learning the great British debate. Milk after, I think?",
            "correct": true,
            "feedback": "✅ 「Shall I be mother?」は英国の慣用句で「お茶を注ぎましょうか？」という意味です。ミルク論争に明るく乗っかる姿勢は英国文化への関心を示し、会話を楽しくします。ミルクを後に入れるのが「正式」という説が有力です。",
            "feedbackEn": "Perfect. 'Shall I be mother?' is a classic British idiom meaning 'shall I pour?' Joining the milk debate playfully shows cultural awareness. The 'milk after' camp considers themselves more refined—though the argument is largely affectionate.",
            "textJa": "é¢ç™½ã„ï¼ã‚ãªãŸã«æ±ºã‚ã¦ã„ãŸã ãã¾ã™ã€‚è‹±å›½ã®å¤§è«–äº‰ã‚’å‹‰å¼·ä¸­ã§ã™ã€‚ãƒŸãƒ«ã‚¯ã¯å¾Œã§ã€‚"
          },
          {
            "text": "I'll have mine black please, no milk — I drink it the Japanese way.",
            "correct": false,
            "feedback": "⚠️ ミルクなしの要望自体は問題ありませんが、「日本式」と比較するのは会話の雰囲気を少し止めてしまいます。英国では客にお茶を提供する文化が非常に根強く、楽しく参加する方が歓迎されます。",
            "feedbackEn": "Perfectly fine to request black tea, but referencing 'the Japanese way' as a contrast can slightly deflect the cultural moment. In British homes, the tea ritual is social—engaging with it warmly matters as much as the tea itself.",
            "textJa": "ç§ã¯ã‚¹ãƒˆãƒ¬ãƒ¼ãƒˆã§ãŠé¡˜ã„ã—ã¾ã™ã€‚ãƒŸãƒ«ã‚¯ãªã—ã§ã€‚æ—¥æœ¬å¼ã§é£²ã‚“ã§ã„ã¾ã™ã€‚"
          },
          {
            "text": "Milk first, definitely — that's the logical approach. You add the milk to the cold cup and then pour the hot tea in on top, which makes much more sense to me scientifically.",
            "correct": false,
            "feedback": "⚠️ コーヒーを頼むのは問題ありませんが、英国では「お茶を断る」ことはやや意外に受け取られます。特に初めて訪問する相手の家では、一口だけでも試してみる姿勢が歓迎されます。英国人にとってお茶の提供は親切心の表現です。",
            "feedbackEn": "Turning down tea in a British home is mildly surprising—offering tea is an act of hospitality and warmth. If you genuinely dislike it, asking politely for coffee is fine, but accepting tea (even if not your favourite) builds rapport.",
            "textJa": "çµ¶å¯¾ã«ãƒŸãƒ«ã‚¯ãŒå…ˆã§ã™ï¼ãã‚ŒãŒè«–ç†çš„ã§ã™ã€‚å†·ãŸã„ã‚«ãƒƒãƒ—ã«ãƒŸãƒ«ã‚¯ã‚’å…ˆã«æ³¨ã„ã§ã‹ã‚‰ç†±ã„ãŠèŒ¶ã‚’æ³¨ãæ–¹ãŒç§‘å­¦çš„ã«ç†ã«ã‹ãªã£ã¦ã„ã¾ã™ã€‚"
          }
        ],
        "textJa": "ã§ã¯ã€ç§ãŒãŠèŒ¶ã‚’å…¥ã‚Œã¾ã—ã‚‡ã†ã‹ï¼ŸãƒŸãƒ«ã‚¯ã¯å…ˆã‹å¾Œã‹ã€ã¨ã¦ã‚‚é‡è¦ãªè³ªå•ã§ã™ã‚ˆï¼"
      },
      {
        "speaker": "colleague",
        "avatar": "☕",
        "name": "Charlotte",
        "text": "Milk after is technically correct, apparently. Now — shall I put a biscuit out? You can dunk it if you dare!",
        "options": [
          {
            "text": "Go on then — I'll attempt a dunk. What's the technique? I don't want it to fall in!",
            "correct": true,
            "feedback": "✅ ビスケットのダンキング（お茶に浸す）は英国の定番文化で、ユーモラスに参加する姿勢が最高です。ダンクしすぎるとビスケットが崩れてカップに沈む「ビスケット事故」は英国でよく笑い話になります。McVitie'sのDigestive（消化ビスケット）が最もダンキングに向いているとされます。",
            "feedbackEn": "Excellent! Biscuit dunking is a quintessential British pastime—and joking about the technique shows you're engaging with the culture fully. The 'soggy biscuit' disaster (breaking off in the tea) is a genuine hazard and always good for a laugh.",
            "textJa": "ã˜ã‚ƒã‚è©¦ã—ã¦ã¿ã¾ã™ï¼ãƒ€ãƒ³ã‚¯ã®ã‚³ãƒ„ã¯ä½•ã§ã™ã‹ï¼Ÿè½ã¨ã—ãŸããªã„ã®ã§ï¼"
          },
          {
            "text": "A biscuit would be lovely — but I don't think I'll risk the dunk.",
            "correct": false,
            "feedback": "✅ ビスケットを受け取るのは良いですが、ダンクを「リスク」として避けるのはユーモアの機会を逃します。英国人はお茶文化のユーモアを楽しんでいます。軽く挑戦してみると場が和みます。",
            "feedbackEn": "Accepting the biscuit is good, but declining the dunk with 'risk' misses a fun cultural moment. British tea and biscuit culture is self-deprecating and playful—lean in rather than play it safe.",
            "textJa": "ãƒ“ã‚¹ã‚±ãƒƒãƒˆã¯ã„ãŸã ãã¾ã™ã€‚ãƒ€ãƒ³ã‚¯ã¯æ€–ã„ã®ã§ã‚„ã‚ã¦ãŠãã¾ã™ã€‚"
          },
          {
            "text": "Dunking biscuits in tea seems a bit unhygienic, doesn't it?",
            "correct": false,
            "feedback": "❌ ダンキングを「不衛生」と批判するのは英国の伝統文化を否定するようで、その場の空気を壊してしまいます。ユーモアを持って参加するか、静かに遠慮するのが無難です。",
            "feedbackEn": "Calling dunking 'unhygienic' is likely to land badly—it criticises a beloved British tradition in the host's home. Even if it's not for you, a comment like this dampens the mood. Better to laugh along or quietly decline.",
            "textJa": "ãŠèŒ¶ã«ãƒ“ã‚¹ã‚±ãƒƒãƒˆã‚’ãƒ€ãƒ³ã‚¯ã™ã‚‹ã®ã¯å°‘ã—ä¸è¡›ç”Ÿã˜ã‚ƒãªã„ã§ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ãƒŸãƒ«ã‚¯ã‚’å¾Œã«å…¥ã‚Œã‚‹æ–¹ãŒæ­£ã—ã„ã‚‰ã—ã„ã§ã™ã­ã€‚ã•ã¦ã€ãƒ“ã‚¹ã‚±ãƒƒãƒˆã‚’å‡ºã—ã¾ã—ã‚‡ã†ã‹ï¼Ÿå‹‡æ°—ãŒã‚ã‚Œã°ãƒ€ãƒ³ã‚¯ã—ã¦ã¿ã¦ãã ã•ã„ï¼"
      },
      {
        "speaker": "colleague",
        "avatar": "☕",
        "name": "Charlotte",
        "text": "Terrible thing when it happens! Right — before we start, the kettle's always on here. Any time you want a cuppa, just say.",
        "options": [
          {
            "text": "That's very kind — thank you. I'm starting to understand why British people say a cup of tea solves everything!",
            "correct": true,
            "feedback": "✅ 英国のお茶文化への温かい参加を示す返答です。英国ではお茶はただの飲み物ではなく、心地よさ、歓迎、危機管理（「put the kettle on」＝困ったときはお茶を淹れる）の象徴です。",
            "feedbackEn": "This warmly engages with the cultural significance of tea in Britain. The phrase 'put the kettle on' is deeply embedded in British culture—it's an instinctive response to any stressful or uncertain situation, from minor disputes to national crises.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚è‹±å›½äººãŒãŠèŒ¶ã¯ã™ã¹ã¦ã‚’è§£æ±ºã™ã‚‹ã¨è¨€ã†ç†ç”±ãŒåˆ†ã‹ã‚Šå§‹ã‚ã¾ã—ãŸï¼"
          },
          {
            "text": "Thank you. Is it okay to ask for green tea instead? I have some in my bag.",
            "correct": false,
            "feedback": "⚠️ 緑茶を持参して頼むのは問題ありませんが、すぐに代替を求めると、せっかくのお茶の文化交流を少し遠ざけてしまいます。最初の一杯は英国式の紅茶を試してから、後で相談する方が自然です。",
            "feedbackEn": "Asking for your own green tea immediately is perfectly polite, but it slightly sidesteps the cultural exchange. Trying the British tea first and then mentioning you have green tea later feels more socially natural.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ä»£ã‚ã‚Šã«ç·‘èŒ¶ã‚’ãŠé¡˜ã„ã§ãã¾ã™ã‹ï¼Ÿãƒãƒƒã‚°ã«æŒã£ã¦ã„ã¾ã™ã€‚"
          },
          {
            "text": "I'll stick to water if that's OK — I'm not used to drinking black tea with milk and sugar. In Japan we usually drink green tea quite differently, so I've never quite got used to it.",
            "correct": false,
            "feedback": "⚠️ 水を選ぶのは自由ですが、英国の家庭訪問でお茶を繰り返し断ることは、相手の歓迎を遠ざける印象を与えることがあります。一度は試してみる姿勢が、文化への敬意として伝わります。",
            "feedbackEn": "Consistently refusing tea in a British home can come across as standoffish. Water is always an option, but at least trying a cup shows appreciation for the host's hospitality and cultural generosity.",
            "textJa": "æ°´ã§ã„ã„ã§ã™ã€‚ãƒŸãƒ«ã‚¯ã¨ç ‚ç³–ã‚’å…¥ã‚ŒãŸç´…èŒ¶ã¯æ…£ã‚Œã¦ã„ãªã„ã®ã§ã€‚æ—¥æœ¬ã§ã¯ç·‘èŒ¶ã‚’é£²ã‚€ã®ã§ã€‚"
          }
        ],
        "textJa": "ãã†ãªã£ã¡ã‚ƒã†ã¨æœ€æ‚ªã§ã™ã­ï¼ã•ã¦ã€å§‹ã‚ã‚‹å‰ã«ã€ã„ã¤ã§ã‚‚ãŠèŒ¶ãŒé£²ã¿ãŸããªã£ãŸã‚‰é æ…®ãªãè¨€ã£ã¦ãã ã•ã„ã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: Offering tea to any guest is a British reflex — it signals welcome and care. 'Shall I be mother?' means 'shall I pour?' The milk-in-first vs milk-after debate is eternal. Biscuit dunking is a beloved ritual.",
    "tipJa": "🇬🇧 イギリスTip: 客が来たら真っ先にお茶を勧めるのが英国の礼儀。「Shall I be mother?」は「注ぎましょうか？」の意味。ミルクを先に入れるか後かは永遠の論争。ビスケットをお茶に浸す「ダンキング」は定番の楽しみです。"
  },
  "conv_culture_banter": {
    "id": "conv_culture_banter",
    "title": "British banter & sarcasm",
    "titleJa": "英国式バンター・皮肉",
    "situation": "You've been with your British team for a few weeks and they're starting to include you in their banter.",
    "situationJa": "英国チームに加わって数週間。同僚たちのバンター（軽口）に巻き込まれてきました。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "😄",
        "name": "Oliver",
        "text": "Alright, the new person finally made a decent cup of tea — cheers, mate!",
        "options": [
          {
            "text": "Cheers! Coming from this lot, I'll take that as high praise.",
            "correct": true,
            "feedback": "✅ 「Cheers」は英国英語で「ありがとう」の意味で最も使われます（乾杯だけではありません）。「This lot（この人たち）」という表現を使いながら軽口を返す姿勢は、バンター文化への参加を示しています。英国のチームに受け入れられるサインです。",
            "feedbackEn": "Perfect banter participation. 'Cheers' is used constantly in British English to mean 'thanks.' Returning the light-hearted jab with 'this lot' (meaning 'you lot') shows you're picking up the banter rhythm—a sign you're being accepted into the team.",
            "textJa": "ã©ã†ã‚‚ï¼ã“ã®äººãŸã¡ã‹ã‚‰è¨€ã‚ã‚Œã‚‹ãªã‚‰ã€æœ€é«˜ã®è¤’ã‚è¨€è‘‰ã¨ã—ã¦å—ã‘å–ã‚Šã¾ã™ã€‚"
          },
          {
            "text": "Thank you — I've been practising! I was nervous it would be too weak.",
            "correct": false,
            "feedback": "⚠️ 誠実な返答ですが、バンターの流れに乗っていません。英国のバンターは「真剣に受け取らず、軽く返す」のがポイントです。too weakなどの自己批判は場の空気を少し重くします。",
            "feedbackEn": "Sincere, but this misses the banter rhythm. British banter doesn't expect earnest replies—it expects a light, self-deprecating or witty comeback. Thanking them seriously breaks the playful momentum.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼ç·´ç¿’ã—ã¾ã—ãŸã€‚å¼±ã™ãŽã‚‹ã‹å¿ƒé…ã§ã—ãŸã‚ˆã€‚"
          },
          {
            "text": "You're welcome. I wasn't sure if it was good enough — should I make another pot?",
            "correct": false,
            "feedback": "❌ 過度な謙遜と実務的な質問はバンターの場に合いません。英国のバンター文化では、相手の冗談に乗っかるか、軽く言い返すかが期待されます。真剣に取り組みすぎると「ノリが悪い」と思われます。",
            "feedbackEn": "Over-serious and practical—this kills the banter completely. Brits will feel their joke has fallen flat. When someone banters, the expected response is a witty comeback or playful acceptance, not a sincere work query.",
            "textJa": "ã©ã†ã„ãŸã—ã¾ã—ã¦ã€‚ååˆ†ã ã£ãŸã‹ä¸å®‰ã§ã—ãŸãŒã€ã‚‚ã†ä¸€æ¯å…¥ã‚Œã¾ã—ã‚‡ã†ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ã‚„ã‚ï¼æ–°äººã•ã‚“ãŒã‚„ã£ã¨ã¾ã¨ã‚‚ãªãŠèŒ¶ã‚’å…¥ã‚Œã¦ãã‚ŒãŸã€‚ã‚ã‚ŠãŒã¨ã†ï¼"
      },
      {
        "speaker": "colleague",
        "avatar": "😄",
        "name": "James",
        "text": "That report you sent was... not bad. High praise from me, that is.",
        "options": [
          {
            "text": "Ha! 'Not bad' from James — I'll put that on my CV. Thanks, I think!",
            "correct": true,
            "feedback": "✅ 「Not bad」は英国の典型的な控えめ表現で、実際は「かなり良い」を意味することが多いです。その文化的な皮肉を理解し、ユーモアで返す応答は完璧です。「Thanks, I think!」という「曖昧な感謝」も英国スタイルに合っています。",
            "feedbackEn": "Spot on. 'Not bad' in British English often means 'genuinely good'—understatement is a core feature of British communication. Recognising this and returning it with humour ('I think') shows cultural fluency. Brits love when this is understood.",
            "textJa": "ã€Œæ‚ªããªã‹ã£ãŸã€ã‚¸ã‚§ãƒ¼ãƒ ã‚ºã‹ã‚‰ï¼å±¥æ­´æ›¸ã«æ›¸ã„ã¦ãŠãã¾ã™ã€‚ã‚ã‚ŠãŒã¨ã†ã€ãŸã¶ã‚“ï¼"
          },
          {
            "text": "Thank you very much — I worked hard on it. Is there anything I should change?",
            "correct": false,
            "feedback": "⚠️ 誠実な姿勢は良いですが、「Not bad」を字義通りに受け取って真剣に改善点を聞くのは、英国の控えめ文化を理解していないサインです。「Not bad」の真意を読み取ることが大切です。",
            "feedbackEn": "Taking 'not bad' literally and asking for revisions misreads the British understatement. In UK culture, 'not bad' is often genuine praise wrapped in modesty. Responding earnestly to what was a compliment can seem slightly awkward.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ï¼é ‘å¼µã‚Šã¾ã—ãŸã€‚ä½•ã‹å¤‰ãˆã‚‹ã¹ãã¨ã“ã‚ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Not bad? Was there a problem with it? I thought it was quite thorough.",
            "correct": false,
            "feedback": "❌ 防衛的な反応は英国のバンターに最も合いません。「Not bad」を批判として受け取り反論するのは、英国の控えめ文化への誤解を示しています。相手の意図（実は褒めている）を読み取ることが重要です。",
            "feedbackEn": "Interpreting 'not bad' as criticism and pushing back is a cultural misread. British understatement means the opposite of what it sounds like. Responding defensively to a genuine compliment makes interactions awkward.",
            "textJa": "æ‚ªããªã‹ã£ãŸï¼Ÿä½•ã‹å•é¡ŒãŒã‚ã‚Šã¾ã—ãŸã‹ï¼Ÿã‹ãªã‚Šå¾¹åº•çš„ã ã¨æ€ã£ã¦ã„ã¾ã—ãŸãŒã€‚"
          }
        ],
        "textJa": "é€ã£ã¦ãã‚ŒãŸãƒ¬ãƒãƒ¼ãƒˆã¯...æ‚ªããªã‹ã£ãŸã‚ˆã€‚ç§ã‹ã‚‰è¨€ãˆã°ã€ã“ã‚Œã¯æœ€å¤§ã®è¤’ã‚è¨€è‘‰ã ã‚ˆã€‚"
      },
      {
        "speaker": "colleague",
        "avatar": "😄",
        "name": "Sarah",
        "text": "Careful — James said the same thing about Emma's project and it won a company award.",
        "options": [
          {
            "text": "Then I'm very flattered! I'll take the backhanded compliment with a smile.",
            "correct": true,
            "feedback": "✅ 「Backhanded compliment（遠回しの褒め言葉）」という英国の概念を使いながら、ユーモアと自信を持って返しています。このような返答は英国のバンター文化に完全に適応していることを示します。チームの一員として自然に機能しています。",
            "feedbackEn": "Excellent cultural fluency. Using the term 'backhanded compliment' shows you understand British indirect praise perfectly. Smiling and accepting it graciously—rather than deflecting or over-thanking—is exactly the right British response.",
            "textJa": "ãã‚Œã¯å¤§å¤‰å…‰æ „ã§ã™ã­ï¼çš®è‚‰ãªè¤’ã‚è¨€è‘‰ã‚’ç¬‘é¡”ã§å—ã‘å–ã‚Šã¾ã™ã€‚"
          },
          {
            "text": "Oh really? So 'not bad' actually means good here — I'll remember that!",
            "correct": false,
            "feedback": "⚠️ 学びを示す良い返答ですが、もう少し会話の流れに乗ると自然です。「I'll remember that」は少し他人行儀で、バンターの楽しい空気から外れます。余裕を持った返答の方が英国文化に合います。",
            "feedbackEn": "This shows self-awareness about British understatement, which is good. But saying 'I'll remember that' in a note-taking way breaks the playful flow. A more relaxed, in-the-moment response fits better.",
            "textJa": "ãã†ãªã‚“ã§ã™ã‹ï¼Ÿã€Œæ‚ªããªã‹ã£ãŸã€ã¯å®Ÿã¯è‰¯ã„ã¨ã„ã†æ„å‘³ãªã‚“ã§ã™ã­ã€‚è¦šãˆã¦ãŠãã¾ã™ï¼"
          },
          {
            "text": "I'm still not sure if that's a compliment or a criticism. Could someone explain?",
            "correct": false,
            "feedback": "⚠️ 理解を求めるのは自然ですが、バンターの真っ最中に「誰か説明してください」と言うと、空気を読めないと思われる可能性があります。バンターは後でゆっくり理解すれば良く、その場では笑顔で乗っていく方が賢明です。",
            "feedbackEn": "Asking for an explanation mid-banter can feel like you've over-analysed a moment meant to be light and fun. Better to smile along now and ask a trusted colleague to explain British sarcasm privately later.",
            "textJa": "ãã‚ŒãŒè¤’ã‚è¨€è‘‰ãªã®ã‹æ‰¹åˆ¤ãªã®ã‹ã¾ã åˆ†ã‹ã‚Šã¾ã›ã‚“ã€‚èª°ã‹èª¬æ˜Žã—ã¦ã‚‚ã‚‰ãˆã¾ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "æ°—ã‚’ã¤ã‘ã¦ãã ã•ã„ã€‚ã‚¸ã‚§ãƒ¼ãƒ ã‚ºã¯ã‚¨ãƒžã®ãƒ—ãƒ­ã‚¸ã‚§ã‚¯ãƒˆã«ã‚‚åŒã˜ã“ã¨ã‚’è¨€ã£ã¦ã€ä¼šç¤¾ã®è³žã‚’å—è³žã—ã¾ã—ãŸã‹ã‚‰ã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: British banter is a sign of acceptance, not unkindness. 'Not bad' often means 'genuinely good'. 'Cheers' means thanks (not just a toast). Sarcasm is affection in disguise — don't take it literally.",
    "tipJa": "🇬🇧 イギリスTip: バンターは受け入れられているサインです。「Not bad」はしばしば「かなり良い」の意味。「Cheers」はありがとうのことがほとんど。皮肉は親愛の裏返し——字義通りに受け取らないことが大切です。"
  },
  "conv_travel_train": {
    "id": "conv_travel_train",
    "title": "Booking a National Rail ticket",
    "titleJa": "ナショナルレールの切符購入",
    "situation": "You're at a station trying to book a train ticket to Edinburgh and a staff member offers help.",
    "situationJa": "駅でエジンバラ行きの切符を買おうとしたところ、駅員さんに声をかけられました。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "🚂",
        "name": "Emma",
        "text": "Can I help? The machines can be a bit confusing for longer journeys.",
        "options": [
          {
            "text": "Yes please — I want to go to Edinburgh next Friday. Is it cheaper to book in advance, and is there an off-peak option?",
            "correct": true,
            "feedback": "✅ 英国の鉄道は事前購入と時間帯で価格が大きく異なります。アドバンス切符は特定の列車のみ有効ですが、最大80%安くなることがあります。オフピークは平日9:30以降・16時前が目安です。積極的に情報を集める姿勢が良い印象を与えます。",
            "feedbackEn": "Smart question. UK rail fares are complex—advance tickets can be 80% cheaper but are train-specific. Off-peak avoids morning rush (after 9:30am weekdays). Asking both at once shows you've already thought through the key variables.",
            "textJa": "ã¯ã„ã€ãŠé¡˜ã„ã—ã¾ã™ï¼æ¥é€±é‡‘æ›œæ—¥ã«ã‚¨ãƒ‡ã‚£ãƒ³ãƒãƒ©ã«è¡ŒããŸã„ã®ã§ã™ãŒã€‚äº‹å‰äºˆç´„ã®æ–¹ãŒå®‰ã„ã§ã™ã‹ï¼Ÿã‚ªãƒ•ãƒ”ãƒ¼ã‚¯ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Yes, I'd like a ticket to Edinburgh for next Friday — is there a standard return fare I can just buy, or does the price vary quite a lot depending on the time of the train?",
            "correct": false,
            "feedback": "⚠️ 必要最低限の情報は得られますが、英国の鉄道は同じ区間でも価格が大きく異なります。アドバンスか当日か、ピーク時間かオフピークかを確認すると、大幅に節約できる可能性があります。",
            "feedbackEn": "This gets a price but misses the opportunity to find the cheapest fare. UK rail pricing is dynamic—the same journey can vary from £40 to £200+ depending on when you book and which train. Always ask about advance and off-peak options.",
            "textJa": "ã¯ã„ã€æ¥é€±é‡‘æ›œæ—¥ã®ã‚¨ãƒ‡ã‚£ãƒ³ãƒãƒ©è¡Œãã®ãƒã‚±ãƒƒãƒˆãŒã»ã—ã„ã§ã™ã€‚æ¨™æº–çš„ãªå¾€å¾©ãƒã‚±ãƒƒãƒˆã‚’è³¼å…¥ã§ãã¾ã™ã‹ï¼Ÿåˆ—è»Šã®æ™‚é–“ã«ã‚ˆã£ã¦ä¾¡æ ¼ãŒå¤‰ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I can manage the machine myself — I just want the cheapest single to Edinburgh for anytime next Friday. Which button do I press to get started with that sort of booking?",
            "correct": false,
            "feedback": "⚠️ 自立心は良いですが、英国の鉄道券売機は複雑で、最安値を見つけるには経験が必要です。駅員の助けを借りることで時間と費用を大幅に節約できます。申し出を断るのは少しもったいないです。",
            "feedbackEn": "UK ticket machines are genuinely confusing, especially for finding the cheapest advance fares across multiple train options. Refusing help here can cost you significantly more—accepting assistance is sensible, not a weakness.",
            "textJa": "æ©Ÿæ¢°ã¯å¤§ä¸ˆå¤«ã§ã™ã€‚æ¥é€±é‡‘æ›œæ—¥ã®ã‚¨ãƒ‡ã‚£ãƒ³ãƒãƒ©è¡Œãã®æœ€å®‰ã®ç‰‡é“ãƒã‚±ãƒƒãƒˆãŒã»ã—ã„ã ã‘ã§ã™ã€‚ã©ã®ãƒœã‚¿ãƒ³ã‚’æŠ¼ã›ã°ã„ã„ã§ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ãŠæ‰‹ä¼ã„ã—ã¾ã—ã‚‡ã†ã‹ï¼Ÿé•·è·é›¢ã®å ´åˆã€æ©Ÿæ¢°ã¯å°‘ã—åˆ†ã‹ã‚Šã«ãã„ã“ã¨ãŒã‚ã‚Šã¾ã™ã‚ˆã€‚"
      },
      {
        "speaker": "colleague",
        "avatar": "🚂",
        "name": "Emma",
        "text": "Advance tickets can be up to 80% cheaper — but they're tied to a specific train. Off-peak is anything after 9:30 and before 4pm on weekdays. Do you have a railcard?",
        "options": [
          {
            "text": "I don't have one yet — does a 16-25 Railcard work for this route? And can I buy one here today?",
            "correct": true,
            "feedback": "✅ レイルカード（Railcard）は英国の鉄道割引カードで、16-25歳向けは年£30で多くの切符が1/3割引になります。Two Together（2人旅割引）など他の種類もあります。駅窓口でも購入できます。長期滞在者には非常に有益です。",
            "feedbackEn": "Excellent initiative. The 16-25 Railcard costs £30/year and saves a third on most fares—it pays for itself in two journeys to Edinburgh. Other railcards exist too: Senior, Two Together, Network, Family. Check eligibility before buying.",
            "textJa": "ã¾ã ãªã„ã‚“ã§ã™ãŒã€‚ã“ã®ãƒ«ãƒ¼ãƒˆã«16-25ãƒ¬ãƒ¼ãƒ«ã‚«ãƒ¼ãƒ‰ã¯ä½¿ãˆã¾ã™ã‹ï¼Ÿä»Šæ—¥ã“ã“ã§è²·ãˆã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I'll just get a standard anytime ticket — I don't like being tied to a specific train.",
            "correct": false,
            "feedback": "⚠️ 柔軟性は理解できますが、英国の「Anytime（いつでも）」切符はアドバンス切符の数倍の値段になります。エジンバラへの場合、差額が£100以上になることもあります。計画的な旅行なら、アドバンス切符の方が圧倒的にお得です。",
            "feedbackEn": "Flexibility is understandable, but anytime tickets can cost 3-5x more than advance fares on long routes like London to Edinburgh (£200+ vs £40-60). If you know your travel date, advance booking almost always wins.",
            "textJa": "æ¨™æº–ã®é€šå¸¸ãƒã‚±ãƒƒãƒˆã«ã—ã¾ã™ã€‚ç‰¹å®šã®åˆ—è»Šã«ç¸›ã‚‰ã‚ŒãŸããªã„ã®ã§ã€‚"
          },
          {
            "text": "What's a railcard? Is it like an Oyster card for the whole country?",
            "correct": false,
            "feedback": "⚠️ 混乱は自然ですが、レイルカードとオイスターカードは全く別物です。オイスターはロンドンのTfLネットワーク専用。レイルカードはナショナルレール用の割引カードです。確認する姿勢は良いですが、事前に調べておくとよりスムーズです。",
            "feedbackEn": "A railcard and Oyster card are completely different. Oyster is for TfL (London's transport network only); a railcard is a discount card for National Rail routes across the UK. It's worth researching these before travelling.",
            "textJa": "ãƒ¬ãƒ¼ãƒ«ã‚«ãƒ¼ãƒ‰ã¨ã¯ä½•ã§ã™ã‹ï¼Ÿå›½å…¨ä½“ã§ä½¿ãˆã‚‹ã‚ªã‚¤ã‚¹ã‚¿ãƒ¼ã‚«ãƒ¼ãƒ‰ã®ã‚ˆã†ãªã‚‚ã®ã§ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "äº‹å‰äºˆç´„ãƒã‚±ãƒƒãƒˆã¯æœ€å¤§80%å®‰ããªã‚Šã¾ã™ãŒã€ç‰¹å®šã®åˆ—è»Šã«ç¸›ã‚‰ã‚Œã¾ã™ã€‚ã‚ªãƒ•ãƒ”ãƒ¼ã‚¯ã¯å¹³æ—¥ã®9æ™‚åŠä»¥é™ã¨åˆå¾Œ4æ™‚å‰ã§ã™ã€‚ãƒ¬ãƒ¼ãƒ«ã‚«ãƒ¼ãƒ‰ã¯ãŠæŒã¡ã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "🚂",
        "name": "Emma",
        "text": "The 16-25 Railcard saves a third on most fares — well worth it. The advance Edinburgh ticket today would be £45 with the railcard.",
        "options": [
          {
            "text": "That's excellent value. I'll get the railcard first and then the Edinburgh advance — can I do both here?",
            "correct": true,
            "feedback": "✅ レイルカードを先に購入してから切符を買うのが正しい順序です。レイルカードは即時発行され、その場で使えます。£45という価格はロンドン〜エジンバラ間としては非常に良い価格です（通常£100〜£200以上）。",
            "feedbackEn": "Correct sequence—buy the railcard first, then apply it to the advance ticket. The railcard is issued instantly at most stations. £45 for London–Edinburgh is excellent value; without the railcard it might be £65+ for the same advance train.",
            "textJa": "ãã‚Œã¯ãŠå¾—ã§ã™ã­ï¼ã¾ãšãƒ¬ãƒ¼ãƒ«ã‚«ãƒ¼ãƒ‰ã‚’è³¼å…¥ã—ã¦ã‹ã‚‰ã‚¨ãƒ‡ã‚£ãƒ³ãƒãƒ©ã®äº‹å‰äºˆç´„ãƒã‚±ãƒƒãƒˆã‚’ã€‚ã“ã“ã§ä¸¡æ–¹ã§ãã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "£45 sounds very reasonable — does the railcard start working straight away, or do I need to activate it online first before I can use it to buy the advance ticket?",
            "correct": false,
            "feedback": "⚠️ 座席指定は英国の長距離列車では通常無料で可能ですが、先にレイルカードの購入を確定させるのが優先です。座席については確認する価値があります。窓側か通路側、前向きか後ろ向きかも選べることが多いです。",
            "feedbackEn": "Seat reservations are often free on long-distance UK trains—definitely worth asking. But prioritise confirming the railcard purchase first to lock in the £45 fare before asking about seats.",
            "textJa": "45ãƒãƒ³ãƒ‰ã¯ã‹ãªã‚Šãƒªãƒ¼ã‚ºãƒŠãƒ–ãƒ«ã§ã™ã­ã€‚ãƒ¬ãƒ¼ãƒ«ã‚«ãƒ¼ãƒ‰ã¯ã™ãã«ä½¿ãˆã¾ã™ã‹ï¼Ÿå…ˆã«ã‚ªãƒ³ãƒ©ã‚¤ãƒ³ã§æœ‰åŠ¹åŒ–ã™ã‚‹å¿…è¦ãŒã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I'll think about the railcard — just give me the cheapest Edinburgh ticket available now.",
            "correct": false,
            "feedback": "⚠️ レイルカードなしで購入すると、同じ切符でも割引が受けられません。年30ポンドの投資がすぐに元が取れることを考えると、今購入してから切符を買う方が賢明です。後で後悔しないためにも今が決断のタイミングです。",
            "feedbackEn": "Hesitating on the railcard means buying the Edinburgh ticket at the higher non-railcard price—you'd immediately lose more than the £30 railcard costs. Commit now and save on this very journey.",
            "textJa": "ãƒ¬ãƒ¼ãƒ«ã‚«ãƒ¼ãƒ‰ã¯è€ƒãˆã¾ã™ã€‚ã¨ã‚Šã‚ãˆãšä»Šä½¿ãˆã‚‹ã‚¨ãƒ‡ã‚£ãƒ³ãƒãƒ©è¡Œãã®æœ€å®‰ãƒã‚±ãƒƒãƒˆã‚’ãŠé¡˜ã„ã—ã¾ã™ã€‚"
          }
        ],
        "textJa": "16-25ãƒ¬ãƒ¼ãƒ«ã‚«ãƒ¼ãƒ‰ã¯ã»ã¨ã‚“ã©ã®é‹è³ƒãŒ3åˆ†ã®1å¼•ãã«ãªã‚Šã¾ã™ã€‚ãƒ¬ãƒ¼ãƒ«ã‚«ãƒ¼ãƒ‰ä½¿ç”¨ã§ã‚¨ãƒ‡ã‚£ãƒ³ãƒãƒ©ã®äº‹å‰äºˆç´„ãƒã‚±ãƒƒãƒˆã¯45ãƒãƒ³ãƒ‰ã§ã™ã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: National Rail advance tickets can be 80% cheaper than walk-up fares but are fixed to a specific train. Railcards (16-25, Two Together, Senior) save a third on most fares. Book via Trainline, National Rail, or station ticket offices.",
    "tipJa": "🇬🇧 イギリスTip: ナショナルレールのアドバンス切符は当日購入より最大80%安いですが、特定の列車専用です。レイルカード（16-25歳・2人一緒・シニアなど）で多くの切符が1/3割引。Trainlineやナショナルレール公式サイトで予約できます。"
  },
  "conv_culture_class": {
    "id": "conv_culture_class",
    "title": "UK class & social awareness",
    "titleJa": "英国の階級意識",
    "situation": "You're at a dinner party with British colleagues and conversation touches on social backgrounds.",
    "situationJa": "英国人の同僚たちとのディナーパーティーで、出身や学校の話題になりました。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "🎭",
        "name": "Charlotte",
        "text": "Where did you go to school, James? Was it state or private?",
        "options": [
          {
            "text": "I notice there's a lot of awareness about school types here. Is that something that comes up a lot in British culture?",
            "correct": true,
            "feedback": "✅ 会話に参加しつつ、観察者として文化的な質問を返すのは非常にスマートです。英国の学校制度（国立校vs私立校）は階級意識と深く結びついており、デリケートなトピックです。直接的に意見を述べず、好奇心を示すのが最も安全で知的な姿勢です。",
            "feedbackEn": "Smart move. Observing rather than weighing in directly avoids getting tangled in a sensitive topic. UK school type (state vs private) is loaded with class associations—asking a curious question shows cultural awareness without taking sides.",
            "textJa": "ã“ã¡ã‚‰ã§ã¯å­¦æ ¡ã®ã‚¿ã‚¤ãƒ—ã«ã¤ã„ã¦ã®æ„è­˜ãŒé«˜ã„ã§ã™ã­ã€‚è‹±å›½ã®æ–‡åŒ–ã§ã‚ˆãè©±é¡Œã«ä¸ŠãŒã‚‹ã“ã¨ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "In Japan the main distinction is really about which university you attended rather than your school — is private school here more similar to that kind of academic prestige marker?",
            "correct": false,
            "feedback": "⚠️ 文化的比較は興味深いですが、「日本にはない」と言うことで会話の焦点をずらしてしまいます。英国での学校制度の重要性を率直に尋ねる方が会話を深められます。",
            "feedbackEn": "Cultural comparison is interesting but slightly deflects. The second part—'is it important here?'—is the good question. Lead with curiosity about the UK context rather than using Japan as a contrast point.",
            "textJa": "æ—¥æœ¬ã§ã¯ä¸»ã«å¤§å­¦ãŒã©ã“ã‹ãŒé‡è¦ã§ã€å­¦æ ¡ã¯ãã‚Œã»ã©é‡è¦–ã•ã‚Œã¾ã›ã‚“ã€‚ã“ã¡ã‚‰ã®ç§ç«‹å­¦æ ¡ã¯å­¦è¡“çš„ãªã‚¹ãƒ†ãƒ¼ã‚¿ã‚¹ã®æ„å‘³ã§ã‚ˆã‚Šä¼¼ã¦ã„ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Why does it matter which school someone went to? Surely your work speaks for itself.",
            "correct": false,
            "feedback": "❌ 英国の根深い階級意識に正面から異議を唱えるのは、特にディナーパーティーでは場の空気を壊します。どの国にも複雑な社会構造があります。批判よりも理解しようとする姿勢の方が賢明です。",
            "feedbackEn": "Challenging the class system directly at a British dinner party is likely to cause awkwardness or defensiveness. Every society has its own social stratifications—showing curiosity rather than judgement is more socially effective.",
            "textJa": "èª°ãŒã©ã®å­¦æ ¡ã«é€šã£ãŸã‹ãŒé–¢ä¿‚ã‚ã‚‹ã‚“ã§ã™ã‹ï¼Ÿå®Ÿç¸¾ã“ããŒé‡è¦ã§ã¯ï¼Ÿ"
          }
        ],
        "textJa": "ã‚¸ã‚§ãƒ¼ãƒ ã‚ºã•ã‚“ã€ã©ã“ã§å­¦æ ¡ã«é€šã‚ã‚Œã¾ã—ãŸã‹ï¼Ÿå…¬ç«‹ã§ã™ã‹ç§ç«‹ã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "🎭",
        "name": "James",
        "text": "It's a bit of a minefield, honestly. Accent, school, university — Brits are quite aware of it all, even if they don't admit it.",
        "options": [
          {
            "text": "That's fascinating — and quite subtle. I've noticed different reactions to accents too. It seems polite not to bring it up directly yourself?",
            "correct": true,
            "feedback": "✅ 英国のアクセントと階級意識の関係は非常に深く、外国人が観察しやすいポイントです。「直接触れないのが礼儀？」という質問は鋭く、英国人が内心で意識していることを言語化しています。相手も安心して話せます。",
            "feedbackEn": "Perceptive. British accents carry significant class signalling—RP (Received Pronunciation) vs regional accents vs 'posh' vs 'working class' variations are all noted, consciously or not. Asking about the etiquette shows genuine cultural intelligence.",
            "textJa": "é¢ç™½ã„ã§ã™ã­ã€‚ã‹ãªã‚Šå¾®å¦™ãªã‚“ã§ã™ã­ã€‚ã‚¢ã‚¯ã‚»ãƒ³ãƒˆã¸ã®åå¿œã®é•ã„ã‚‚æ°—ã¥ã„ã¦ã„ã¾ã™ã€‚è‡ªåˆ†ã‹ã‚‰è©±é¡Œã«å‡ºã•ãªã„æ–¹ãŒç¤¼å„€æ­£ã—ã„ã‚ˆã†ã§ã™ã­ï¼Ÿ"
          },
          {
            "text": "It sounds like something you should just address head-on when it comes up — surely being open and direct about class differences is far less awkward than carefully dancing around the topic in conversation.",
            "correct": false,
            "feedback": "⚠️ 懸念は理解できますが、この質問は自分の心配を中心にしており、会話の共感から外れています。「どういう仕組みで機能しているのか」への関心を示す方が自然な対話になります。",
            "feedbackEn": "This turns the focus onto your own anxiety rather than engaging with what James is saying. Showing genuine curiosity about how the system works (rather than how to avoid mistakes) makes for better conversation.",
            "textJa": "ãã‚Œã¯çœŸã£å‘ã‹ã‚‰å–ã‚Šä¸Šã’ã‚‹ã¹ãå•é¡Œã®ã‚ˆã†ã«æ€ãˆã¾ã™ã€‚éšŽç´šã®é•ã„ã«ã¤ã„ã¦ã‚ªãƒ¼ãƒ—ãƒ³ã§æ­£ç›´ãªæ–¹ãŒã€è©±é¡Œã‚’é¿ã‘ã‚‹ã‚ˆã‚Šãšã£ã¨æ°—ã¾ãšããªã„ã¯ãšã§ã™ã€‚"
          },
          {
            "text": "That's quite different from Japan and I have to say, it sounds rather outdated as a way of judging people. Surely professional qualifications and actual results should matter far more than accent or which school you attended.",
            "correct": false,
            "feedback": "⚠️ 比較は興味深いですが、「unfair」という評価は英国の文化を批判しているように聞こえます。英国人自身がしばしば自国の階級制度を批判しますが、外国人がそれを言うと防衛的になることがあります。",
            "feedbackEn": "British people often criticise their own class system, but hearing it from an outsider can provoke defensiveness. Cultural critique is more welcome when invited—engaging with curiosity first tends to open more honest conversations.",
            "textJa": "æ—¥æœ¬ã¨ã¯ã‹ãªã‚Šé•ã„ã¾ã™ã—ã€äººã‚’åˆ¤æ–­ã™ã‚‹ãŸã‚ã®æ–¹æ³•ã¨ã—ã¦ã¯ã‹ãªã‚Šæ™‚ä»£é…ã‚Œã«èžã“ãˆã¾ã™ã€‚è³‡æ ¼ã‚„å®Ÿéš›ã®çµæžœã®æ–¹ãŒã‚¢ã‚¯ã‚»ãƒ³ãƒˆã‚„å­¦æ ¡æ­´ã‚ˆã‚Šã¯ã‚‹ã‹ã«é‡è¦ãªã¯ãšã§ã™ã€‚"
          }
        ],
        "textJa": "å®Ÿã¯ã‹ãªã‚Šè¤‡é›‘ãªå•é¡Œãªã‚“ã§ã™ã€‚ã‚¢ã‚¯ã‚»ãƒ³ãƒˆã€å­¦æ ¡ã€å¤§å­¦ã€è‹±å›½äººã¯ã“ã‚Œã‚‰ã‚’éžå¸¸ã«æ°—ã«ã—ã¦ã„ã¾ã™ã€‚è¡¨ç«‹ã£ã¦ã¯èªã‚ã¾ã›ã‚“ãŒã€‚"
      },
      {
        "speaker": "colleague",
        "avatar": "🎭",
        "name": "Charlotte",
        "text": "So {name}, what do you do back in Japan? Well — I mean, what brings you to London?",
        "options": [
          {
            "text": "I'm a project manager — over on a secondment for about a year. What do you do, Charlotte?",
            "correct": true,
            "feedback": "✅ 簡潔に答えて質問を相手に返すのは英国のディナーパーティーで最もスムーズなやり取りです。英国では初対面で「お仕事は？」という質問を早々に聞くのはやや直接的とされますが、聞かれたら答えて返す流れは自然です。",
            "feedbackEn": "Perfect. Answer concisely and return the question—the hallmark of good British dinner party conversation. Note that Charlotte initially hesitated before asking ('well — I mean') because 'what do you do?' is considered slightly forward in UK culture.",
            "textJa": "ãƒ—ãƒ­ã‚¸ã‚§ã‚¯ãƒˆãƒžãƒãƒ¼ã‚¸ãƒ£ãƒ¼ã§ã™ã€‚1å¹´ã®å‡ºå‘ã§ã“ã¡ã‚‰ã«æ¥ã¦ã„ã¾ã™ã€‚ã‚·ãƒ£ãƒ¼ãƒ­ãƒƒãƒˆã•ã‚“ã¯ï¼Ÿ"
          },
          {
            "text": "I'm in finance — sent over from the Tokyo office on assignment for about six months. This is actually my first time living abroad long-term, so it's all quite new and different still.",
            "correct": false,
            "feedback": "⚠️ 答えは問題ありませんが、「Finance」は非常に広い言葉です。もう少し具体的に言うと会話が深まります。また、英国では自分の仕事の「重要性」を強調するのはあまり好まれません。",
            "feedbackEn": "Fine but vague. 'Finance' covers a huge range of roles in UK culture and doesn't give much to work with conversationally. A brief, modest description of your actual role is more engaging and more British.",
            "textJa": "é‡‘èžé–¢ä¿‚ã§ã™ã€‚æ±äº¬ã®äº‹å‹™æ‰€ã‹ã‚‰ç´„6ãƒ¶æœˆã®å‡ºå¼µã§æ¥ã¦ã„ã¾ã™ã€‚æµ·å¤–ã«é•·æœŸæ»žåœ¨ã™ã‚‹ã®ã¯åˆã‚ã¦ã§ã€ã¾ã æ–°é®®ãªæ„Ÿã˜ãŒã—ã¾ã™ã€‚"
          },
          {
            "text": "I'm quite senior actually — I manage a team of fifteen back home.",
            "correct": false,
            "feedback": "❌ 英国の社交の場で自分の地位を強調するのは「ポッシュ（気取っている）」とみなされます。英国のディナーパーティーの文化では、控えめさが美徳です。特に初対面の相手に肩書きや部下の数を持ち出すのは避けた方が賢明です。",
            "feedbackEn": "Emphasising seniority at a British dinner party comes across as boastful—a social faux pas. British culture strongly values modesty in social settings. Save professional status for the workplace; at dinner parties, be a person first.",
            "textJa": "å®Ÿã¯ã‹ãªã‚Šä¸Šä½ã®ç«‹å ´ã§ã™ã€‚æ—¥æœ¬ã§ã¯15åã®ãƒãƒ¼ãƒ ã‚’ç®¡ç†ã—ã¦ã„ã¾ã™ã€‚"
          }
        ],
        "textJa": "{name}ã•ã‚“ã€æ—¥æœ¬ã§ã¯ä½•ã‚’ã•ã‚Œã¦ã„ã‚‹ã‚“ã§ã™ã‹ï¼Ÿã¤ã¾ã‚Šã€ãƒ­ãƒ³ãƒ‰ãƒ³ã«æ¥ãŸç†ç”±ã¯ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: The UK class system is subtle but ever-present — accents, schools and postcodes all carry social meaning. Avoid asking 'what do you do?' too early; it can feel transactional. Modesty is always the safer register.",
    "tipJa": "🇬🇧 イギリスTip: 英国の階級意識はアクセント・学歴・郵便番号に至るまで根付いています。初対面で「お仕事は？」を早々に聞くのはやや無粋とされることも。控えめさが社交の場での美徳です。"
  },
  "conv_life_broadband": {
    "id": "conv_life_broadband",
    "title": "Setting up UK broadband",
    "titleJa": "英国でのブロードバンド開設",
    "situation": "An Openreach engineer arrives to install your fibre broadband line.",
    "situationJa": "Openreachのエンジニアがファイバーブロードバンドの回線工事に来ました。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "🔧",
        "name": "Oliver",
        "text": "Morning! Openreach here — I'm installing your fibre line. Is this a good time?",
        "options": [
          {
            "text": "Yes, perfect timing. Quick question — will you be setting up the router today, or does that come separately from my provider?",
            "correct": true,
            "feedback": "✅ 英国ではOpenreachは物理的な回線工事のみ担当し、ルーターはプロバイダー（BT、Sky、Virgin等）から別途郵送されます。この区別を理解して確認するのは非常に良い準備です。工事後にルーターが届くまで数日かかることが一般的です。",
            "feedbackEn": "Smart question. In the UK, Openreach (the infrastructure company) installs the physical line; your ISP (BT, Sky, Virgin etc.) sends the router separately by post. Understanding this structure prevents confusion about next steps.",
            "textJa": "ã¯ã„ã€å®Œç’§ãªã‚¿ã‚¤ãƒŸãƒ³ã‚°ã§ã™ã€‚ä»Šæ—¥ãƒ«ãƒ¼ã‚¿ãƒ¼ã‚‚è¨­ç½®ã—ã¦ã„ãŸã ã‘ã¾ã™ã‹ï¼Ÿãã‚Œã¨ã‚‚å¾Œã§ãƒ—ãƒ­ãƒã‚¤ãƒ€ãƒ¼ã‹ã‚‰åˆ¥é€”å±Šãã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Yes, do come in — I'm expecting a delivery and have a work call at eleven, so I'm really hoping this won't take much more than an hour or so in total.",
            "correct": false,
            "feedback": "⚠️ 時間の確認は理解できますが、工事の流れについて確認することで、ルーターの到着まで接続できないことを事前に把握できます。実務的な確認を優先しましょう。",
            "feedbackEn": "Asking about timing is reasonable, but missing the router question means you might expect broadband to work immediately after the engineer leaves—which it won't. The router question is more important.",
            "textJa": "ã¯ã„ã€ã©ã†ãžã€‚è·ç‰©ã®é…é”ã‚’å¾…ã£ã¦ã„ã¦ã€11æ™‚ã«ä»•äº‹ã®é›»è©±ã‚‚ã‚ã‚‹ã®ã§ã€1æ™‚é–“ä»¥å†…ã«ã¯çµ‚ã‚ã‚‹ã“ã¨ã‚’é¡˜ã£ã¦ã„ã¾ã™ã€‚"
          },
          {
            "text": "Actually, I think there might be some confusion — I signed up with Sky broadband, not BT, so I'm not sure Openreach would be the right company to be doing my installation today.",
            "correct": false,
            "feedback": "⚠️ Openreachはほぼ全てのブロードバンドプロバイダー（BT、Sky、TalkTalk等）に対応する共有インフラです。Sky、BT、TalkTalkのいずれを選んでも、実際の回線工事はOpenreachが行います。混乱は自然ですが、工事自体は正しいです。",
            "feedbackEn": "Openreach is the shared infrastructure provider that installs lines for virtually all UK broadband providers—BT, Sky, TalkTalk, Plusnet, and many others. The engineer is correct regardless of which ISP you chose.",
            "textJa": "æ··ä¹±ãŒã‚ã‚‹ã‹ã‚‚ã—ã‚Œã¾ã›ã‚“ã€‚ã‚¹ã‚«ã‚¤ãƒ–ãƒ­ãƒ¼ãƒ‰ãƒãƒ³ãƒ‰ã‚’ç”³ã—è¾¼ã¿ã¾ã—ãŸãŒã€BTã§ã¯ãªã„ã®ã§ã€ã‚ªãƒ¼ãƒ—ãƒ³ãƒªãƒ¼ãƒãŒè¨­ç½®ã«æ¥ã‚‹ã®ã¯æ­£ã—ããªã„ã¨æ€ã„ã¾ã™ã€‚"
          }
        ],
        "textJa": "ãŠã¯ã‚ˆã†ã”ã–ã„ã¾ã™ï¼ã‚ªãƒ¼ãƒ—ãƒ³ãƒªãƒ¼ãƒã§ã™ã€‚å…‰ãƒ•ã‚¡ã‚¤ãƒãƒ¼å›žç·šã‚’è¨­ç½®ã—ã«æ¥ã¾ã—ãŸã€‚ä»Šã€è‰¯ã„æ™‚é–“å¸¯ã§ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "🔧",
        "name": "Oliver",
        "text": "Right — Openreach installs the physical line. Your router comes from your provider by post, usually a few days after this.",
        "options": [
          {
            "text": "Got it. So once the hub arrives, I just plug it in and follow the setup guide? And if there are issues, I call my provider, not Openreach?",
            "correct": true,
            "feedback": "✅ 完全に正しい理解です。回線の問題はOpenreach、ルーターや接続設定の問題はプロバイダー（BT、Sky等）に連絡します。この区別を把握しておくと、トラブル時に正しい窓口にすぐ連絡できます。",
            "feedbackEn": "Exactly right. Physical line issues go to Openreach (via your ISP); router, activation, and account issues go to your provider. Knowing this avoids being bounced between departments when something goes wrong.",
            "textJa": "åˆ†ã‹ã‚Šã¾ã—ãŸã€‚ãƒãƒ–ãŒå±Šã„ãŸã‚‰å·®ã—è¾¼ã‚“ã§ã‚»ãƒƒãƒˆã‚¢ãƒƒãƒ—ã‚¬ã‚¤ãƒ‰ã«å¾“ãˆã°ã„ã„ã§ã™ã‹ï¼Ÿå•é¡ŒãŒã‚ã£ãŸã‚‰ã‚ªãƒ¼ãƒ—ãƒ³ãƒªãƒ¼ãƒã§ã¯ãªããƒ—ãƒ­ãƒã‚¤ãƒ€ãƒ¼ã«é›»è©±ã™ã‚Œã°ã„ã„ã§ã™ã­ï¼Ÿ"
          },
          {
            "text": "How long will the full activation take once the hub arrives — and can I use my mobile data as a hotspot in the meantime, or is there another way to get a temporary internet connection while I wait?",
            "correct": false,
            "feedback": "⚠️ 有用な質問ですが、プロバイダーとOpenreachの役割分担を確認することがより重要です。アクティベーション時間はプロバイダーによって異なり（通常24時間以内）、Openreachエンジニアより自社プロバイダーに聞く方が正確な情報が得られます。",
            "feedbackEn": "Good practical question, but the engineer may not know your provider's activation timeline. Activation typically happens within 24 hours of the engineer's visit. Ask your ISP directly for the precise timeline.",
            "textJa": "ãƒãƒ–ãŒå±Šã„ã¦ã‹ã‚‰å®Œå…¨ã«æœ‰åŠ¹ã«ãªã‚‹ã¾ã§ã©ã®ãã‚‰ã„ã‹ã‹ã‚Šã¾ã™ã‹ï¼Ÿå¾…æ©Ÿä¸­ã¯æºå¸¯ã®ãƒ¢ãƒã‚¤ãƒ«ãƒ‡ãƒ¼ã‚¿ã‚’ãƒ›ãƒƒãƒˆã‚¹ãƒãƒƒãƒˆã¨ã—ã¦ä½¿ãˆã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "That seems unnecessarily complicated — surely one company should handle everything from the physical line installation right through to the router setup. Is this really the standard process for all broadband in the UK?",
            "correct": false,
            "feedback": "⚠️ 比較は理解できますが、英国の仕組みを批判しても状況は変わりません。Openreachと各プロバイダーを分離したモデルは競争促進のためですが、確かに手続きが増えます。現実に適応する方が建設的です。",
            "feedbackEn": "Cultural comparison is understandable, but it doesn't change the UK setup process. The Openreach/ISP separation model exists to enable competition—it has trade-offs. Adapting pragmatically is more productive than comparing.",
            "textJa": "ç‰©ç†çš„ãªå›žç·šã®è¨­ç½®ã‹ã‚‰ãƒ«ãƒ¼ã‚¿ãƒ¼è¨­å®šã¾ã§ä¸€ç¤¾ã§å¯¾å¿œã—ã¦ãã‚ŒãŸæ–¹ãŒç°¡å˜ãªã®ã«ã€‚ã“ã‚ŒãŒè‹±å›½ã®ãƒ–ãƒ­ãƒ¼ãƒ‰ãƒãƒ³ãƒ‰ã®æ¨™æº–çš„ãªãƒ—ãƒ­ã‚»ã‚¹ã§ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ã‚ªãƒ¼ãƒ—ãƒ³ãƒªãƒ¼ãƒã¯ç‰©ç†çš„ãªå›žç·šã‚’è¨­ç½®ã—ã¾ã™ã€‚ãƒ«ãƒ¼ã‚¿ãƒ¼ã¯ãƒ—ãƒ­ãƒã‚¤ãƒ€ãƒ¼ã‹ã‚‰æ•°æ—¥å¾Œã«éƒµä¾¿ã§å±Šãã¾ã™ã€‚"
      },
      {
        "speaker": "colleague",
        "avatar": "🔧",
        "name": "Oliver",
        "text": "Exactly. One more thing — your contract is 18 months. Early exit fees apply if you cancel before then.",
        "options": [
          {
            "text": "Thanks for flagging that. I'll note the contract end date. Is there anything I should know about speed drops during peak hours?",
            "correct": true,
            "feedback": "✅ 英国のブロードバンド契約は18ヶ月が一般的です。ピーク時間帯（夕方6〜10時頃）に速度が低下することは英国でよくあります。プロバイダーの広告速度（Mbps表示）は「最大」速度であり、実際の速度は異なる場合があります。",
            "feedbackEn": "Smart question. UK broadband speeds are advertised as 'up to' figures—actual speeds vary by area, peak times, and line quality. Evening slowdowns are common. Knowing this sets realistic expectations.",
            "textJa": "æ•™ãˆã¦ã„ãŸã ãã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚å¥‘ç´„çµ‚äº†æ—¥ã‚’æŽ§ãˆã¾ã™ã€‚ãƒ”ãƒ¼ã‚¯æ™‚é–“å¸¯ã®é€Ÿåº¦ä½Žä¸‹ã«ã¤ã„ã¦ä½•ã‹çŸ¥ã£ã¦ãŠãã“ã¨ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Eighteen months feels like quite a long commitment — if I need to move flat during the contract period, could the agreement be transferred to a new address, or would that automatically trigger the early exit fee?",
            "correct": false,
            "feedback": "⚠️ 転居時の対応は重要な質問です。多くのプロバイダーは転居先にサービスを移転できますが、提供エリア外の場合は解約料が発生することがあります。これはOpenreachエンジニアよりプロバイダーに直接確認しましょう。",
            "feedbackEn": "A valid concern—most UK ISPs allow you to transfer the contract to a new address within their service area. If you move outside coverage, early exit fees may apply. Ask your ISP directly about their moving policy.",
            "textJa": "18ãƒ¶æœˆã¯ã‹ãªã‚Šé•·ã„ç¸›ã‚Šã§ã™ã­ã€‚å¥‘ç´„æœŸé–“ä¸­ã«å¼•è¶Šã—ã™ã‚‹å ´åˆã€å¥‘ç´„ã‚’æ–°ã—ã„ä½æ‰€ã«ç§»ã™ã“ã¨ã¯ã§ãã¾ã™ã‹ï¼Ÿãã‚Œã¨ã‚‚æ—©æœŸè§£ç´„æ‰‹æ•°æ–™ãŒç™ºç”Ÿã—ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Eighteen months is honestly too long a commitment for me — I'd rather just use my mobile phone as a personal hotspot and avoid taking on a fixed broadband contract altogether.",
            "correct": false,
            "feedback": "⚠️ モバイルデータのみでの生活は可能ですが、英国のモバイルデータプランは高く、在宅勤務や動画ストリーミングには不十分なことが多いです。ブロードバンドは長期的にははるかにコスト効率が良いです。",
            "feedbackEn": "Using only mobile data in the UK gets expensive quickly, especially for remote work or streaming. Broadband contracts, while long, offer much better value per GB. The 18-month commitment is standard across all major UK ISPs.",
            "textJa": "18ãƒ¶æœˆã¯é•·ã™ãŽã¾ã™ã€‚æºå¸¯ã®ãƒ›ãƒƒãƒˆã‚¹ãƒãƒƒãƒˆã‚’ä½¿ã£ã¦ãƒ–ãƒ­ãƒ¼ãƒ‰ãƒãƒ³ãƒ‰å¥‘ç´„ã‚’é¿ã‘ã¾ã™ã€‚"
          }
        ],
        "textJa": "ãã†ã§ã™ã­ã€‚ã‚‚ã†ä¸€ã¤ã€å¥‘ç´„ã¯18ãƒ¶æœˆã§ã™ã€‚ãã‚Œä»¥å‰ã«ã‚­ãƒ£ãƒ³ã‚»ãƒ«ã™ã‚‹ã¨æ—©æœŸè§£ç´„æ‰‹æ•°æ–™ãŒã‹ã‹ã‚Šã¾ã™ã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: Openreach installs the physical broadband line for almost all UK providers. Your router comes separately from your ISP (BT, Sky, Virgin, etc.). Contracts are typically 18 months. Advertised speeds are 'up to' figures.",
    "tipJa": "🇬🇧 イギリスTip: Openreachはほぼ全プロバイダーの回線工事を担当。ルーターはBT・Sky・Virgin等のISPから別途郵送されます。契約は通常18ヶ月。広告の速度表示は「最大」値です。"
  },
  "conv_culture_pubs_etiquette": {
    "id": "conv_culture_pubs_etiquette",
    "title": "Pub etiquette & quiz night",
    "titleJa": "パブのマナーとクイズナイト",
    "situation": "It's pub quiz night and you've joined your British colleagues' team at a traditional pub.",
    "situationJa": "パブのクイズナイトに参加。英国人の同僚チームに加わりました。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "🍺",
        "name": "Emma",
        "text": "Right — it's a traditional pub, so no table service. You order at the bar. Shall we get a first round in?",
        "options": [
          {
            "text": "Got it — no table service in traditional pubs. What does everyone want? I'll head up.",
            "correct": true,
            "feedback": "✅ 伝統的な英国のパブではテーブルサービスはなく、バーカウンターで注文するのが基本です。ファーストラウンドを申し出るのは英国のパブ文化の「ラウンド制」への参加を示す積極的な姿勢です。好印象を与えます。",
            "feedbackEn": "Perfect. Ordering at the bar is standard in traditional UK pubs—table service (if available at all) is a modern addition and not expected. Volunteering for the first round shows you understand the British pub round system.",
            "textJa": "åˆ†ã‹ã‚Šã¾ã—ãŸã€‚ä¼çµ±çš„ãªãƒ‘ãƒ–ã§ã¯ãƒ†ãƒ¼ãƒ–ãƒ«ã‚µãƒ¼ãƒ“ã‚¹ãªã—ã€‚çš†ã•ã‚“ã¯ä½•ã‚’é£²ã¿ã¾ã™ã‹ï¼Ÿç§ãŒè¡Œã£ã¦ãã¾ã™ã€‚"
          },
          {
            "text": "I'll wait until someone else goes — I'm not sure what to order yet.",
            "correct": false,
            "feedback": "⚠️ 消極的な姿勢はラウンド文化に参加していないように映ります。英国のパブでは順番に全員分の飲み物を買うのが慣習です。まず一緒にバーに行って注文を見ながら学ぶのが自然です。",
            "feedbackEn": "Hanging back misses the social cue. In British pub culture, joining the round—even if you're unsure what to order—is expected. Go to the bar, look at what's on tap, and ask for a recommendation if needed.",
            "textJa": "èª°ã‹ä»–ã®äººãŒè¡Œãã¾ã§å¾…ã¡ã¾ã™ã€‚ã¾ã ä½•ã‚’æ³¨æ–‡ã™ã‚‹ã‹æ±ºã‚ã¦ã„ãªã„ã®ã§ã€‚"
          },
          {
            "text": "Can't we just wait for someone to come and take our order?",
            "correct": false,
            "feedback": "❌ 伝統的な英国のパブではテーブルサービスはありません。カウンターで注文するのが絶対的な基本です。テーブルサービスを待つと、何も届かないまま時間が経ってしまいます。",
            "feedbackEn": "In a traditional UK pub, no one will come to take your order—this isn't a restaurant. Waiting at the table means waiting forever. Always go to the bar.",
            "textJa": "èª°ã‹ãŒæ¥ã¦æ³¨æ–‡ã‚’å–ã£ã¦ãã‚Œã‚‹ã¾ã§å¾…ã¦ã¾ã›ã‚“ã‹ï¼Ÿ"
          }
        ],
        "textJa": "ã“ã“ã¯ä¼çµ±çš„ãªãƒ‘ãƒ–ãªã®ã§ã€ãƒ†ãƒ¼ãƒ–ãƒ«ã‚µãƒ¼ãƒ“ã‚¹ã¯ã‚ã‚Šã¾ã›ã‚“ã€‚ã‚«ã‚¦ãƒ³ã‚¿ãƒ¼ã§æ³¨æ–‡ã—ã¾ã™ã€‚æœ€åˆã®ä¸€æ¯ã‚’æ³¨æ–‡ã—ã¾ã—ã‚‡ã†ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "🍺",
        "name": "James",
        "text": "Quiz starts at eight. The host is very dry — very British sense of humour. Don't take wrong answers personally!",
        "options": [
          {
            "text": "Ha — noted. Is it teams of four? And what topics usually come up? I want to be useful!",
            "correct": true,
            "feedback": "✅ クイズへの積極的な参加意欲を示しつつ、実用的な情報を集めています。英国のパブクイズは通常、一般知識・英国の歴史・スポーツ・音楽・地理などのラウンドがあります。チームへの貢献意欲を示すのは好印象です。",
            "feedbackEn": "Great attitude. Pub quizzes in the UK typically cover general knowledge, British history, sport, music, geography, and a picture round. Showing enthusiasm and asking practical questions signals you're a team player.",
            "textJa": "äº†è§£ã§ã™ï¼4äººãƒãƒ¼ãƒ ã§ã™ã‹ï¼Ÿã©ã‚“ãªãƒˆãƒ”ãƒƒã‚¯ãŒå‡ºã¾ã™ã‹ï¼Ÿå½¹ã«ç«‹ã¡ãŸã„ã§ã™ï¼"
          },
          {
            "text": "I'll do my best — I should warn you, I might not know many British culture questions.",
            "correct": false,
            "feedback": "⚠️ 謙遜は良いですが、事前に自分の限界を宣言することでチームの期待を下げてしまいます。参加して実際に試してみる方が、英国文化では「スポーツマンシップ」として評価されます。",
            "feedbackEn": "Modest, but pre-emptively declaring your limitations can dampen team energy. British quiz culture values having a go—even wrong answers are part of the fun. Dive in enthusiastically rather than hedging.",
            "textJa": "é ‘å¼µã‚Šã¾ã™ï¼è‹±å›½ã®æ–‡åŒ–ã«ã¤ã„ã¦ã®è³ªå•ã¯ã‚ã¾ã‚ŠçŸ¥ã‚‰ãªã„ã‹ã‚‚ã—ã‚Œã¾ã›ã‚“ã€‚"
          },
          {
            "text": "What do we actually win if we come first? I'm quite competitive by nature — it genuinely helps to have something concrete to aim for rather than just playing for fun.",
            "correct": false,
            "feedback": "⚠️ 競争心を最初に前面に出すのは英国のパブクイズの雰囲気に合いません。パブクイズは勝利よりも社交・ユーモア・チームワークを楽しむ場です。賞品（バウチャーや無料ビールのことが多い）よりも場の楽しみが優先されます。",
            "feedbackEn": "Leading with competitiveness is slightly off-tone for British pub quizzes—the culture is more about fun, camaraderie, and witty team names than winning. Prizes are often a free round or small voucher. The joy is in the playing.",
            "textJa": "1ä½ã«ãªã£ãŸã‚‰ä½•ãŒã‚‚ã‚‰ãˆã¾ã™ã‹ï¼Ÿç«¶äº‰å¿ƒãŒå¼·ã„ã®ã§ã€æ¥½ã—ã¿ä»¥å¤–ã«å…·ä½“çš„ãªç›®æ¨™ãŒã‚ã£ãŸæ–¹ãŒã„ã„ã§ã™ã€‚"
          }
        ],
        "textJa": "ã‚¯ã‚¤ã‚ºã¯8æ™‚ã‹ã‚‰å§‹ã¾ã‚Šã¾ã™ã€‚å¸ä¼šã®äººã¯ã¨ã¦ã‚‚çš®è‚‰å±‹ã§ã€è‹±å›½çš„ãªãƒ¦ãƒ¼ãƒ¢ã‚¢ã§ã™ã€‚é–“é•ãˆã¦ã‚‚æ°—ã«ã—ãªã„ã§ï¼"
      },
      {
        "speaker": "colleague",
        "avatar": "🍺",
        "name": "Sarah",
        "text": "Second place — not bad for a new team member! Same time next week?",
        "options": [
          {
            "text": "Definitely! That was brilliant fun — I even got the cricket question right. Same time next week, absolutely.",
            "correct": true,
            "feedback": "✅ 「Brilliant」は英国英語でとても自然な褒め表現です。特定の質問（クリケット）への言及でチームへの貢献を具体的に示し、次回への明確なコミットメントを示しています。英国の社交文化での理想的な締め方です。",
            "feedbackEn": "'Brilliant' is very British-sounding—well done for using it naturally. Mentioning the specific cricket question shows you were engaged and contributed. Committing clearly to next week (not 'I'll try') is the right social signal.",
            "textJa": "ã‚‚ã¡ã‚ã‚“ï¼ã™ã”ãæ¥½ã—ã‹ã£ãŸã§ã™ã€‚ã‚¯ãƒªã‚±ãƒƒãƒˆã®è³ªå•ã‚‚æ­£è§£ã—ã¾ã—ãŸã€‚æ¥é€±ã‚‚åŒã˜æ™‚é–“ã«ï¼"
          },
          {
            "text": "It was good fun! Though I'll need to brush up on my British history for next time.",
            "correct": false,
            "feedback": "⚠️ 楽しんだことは伝わりますが、弱点への言及が少し後ろ向きです。英国のパブクイズでは「楽しかった！来週も来るよ！」という前向きな締めが場の雰囲気に合います。",
            "feedbackEn": "Mentioning what you need to improve is fine, but it slightly deflates the celebratory moment. Focus on the positives—second place is a respectable result and the fun you had matters more than the gaps in knowledge.",
            "textJa": "æ¥½ã—ã‹ã£ãŸã§ã™ï¼ã§ã‚‚æ¬¡å›žã¯è‹±å›½ã®æ­´å²ã«ã¤ã„ã¦ã‚‚ã£ã¨å‹‰å¼·ã—ã¦ãŠãã¾ã™ã€‚"
          },
          {
            "text": "We were absolutely robbed this evening — question seven was completely ambiguous and the quiz master marked it wrong. I'm genuinely tempted to have a quiet word with him about it.",
            "correct": false,
            "feedback": "❌ クイズマスターの判定に異議を唱えるのは英国のパブクイズでは非常に不評です。たとえ本当に間違いがあっても、その場の雰囲気を壊すことになります。楽しい社交の場では勝敗より参加を楽しむ姿勢が大切です。",
            "feedbackEn": "Challenging the quiz master is a significant social faux pas in British pub culture. Even if they were wrong, causing a scene over it spoils the evening for everyone. Accept the result with good humour—that's the British way.",
            "textJa": "ä»Šå¤œã¯å®Œå…¨ã«ä¸å½“ãªçµæžœã§ã—ãŸã€‚è³ªå•7ã¯æ›–æ˜§ã§ã€ã‚¯ã‚¤ã‚ºãƒžã‚¹ã‚¿ãƒ¼ã®æŽ¡ç‚¹ãŒé–“é•ã£ã¦ã„ã¾ã™ã€‚ä¸€è¨€è¨€ã„ãŸã„ã§ã™ã€‚"
          }
        ],
        "textJa": "2ä½ã§ã™ï¼æ–°ãƒãƒ¼ãƒ ãƒ¡ãƒ³ãƒãƒ¼ã¨ã—ã¦ã¯æ‚ªããªã„ã§ã™ã‚ˆï¼æ¥é€±ã‚‚åŒã˜æ™‚é–“ã«ï¼Ÿ"
      }
    ],
    "tip": "🇬🇧 UK tip: In traditional pubs, always order at the bar — no table service. Pub quizzes run most Tuesday or Wednesday nights and are more about fun and banter than winning. The round system (everyone takes turns buying) is sacred.",
    "tipJa": "🇬🇧 イギリスTip: 伝統的なパブでは必ずバーカウンターで注文します（テーブルサービスなし）。パブクイズは火曜か水曜夜が多く、勝敗より楽しさが主役。全員が交代で全員分を買う「ラウンド制」は英国パブの重要な慣習です。"
  },
  "conv_biz_leaveholiday": {
    "id": "conv_biz_leaveholiday",
    "title": "Annual leave in the UK",
    "titleJa": "英国の年次有給休暇",
    "situation": "Your UK line manager explains the annual leave system on your first week.",
    "situationJa": "英国のラインマネージャーが入社初週に有給休暇の仕組みを説明してくれました。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "📅",
        "name": "Sarah",
        "text": "Just a reminder — use the HR system to book leave. You have 28 days statutory entitlement this year, including bank holidays.",
        "options": [
          {
            "text": "Thanks — just to clarify, is that 28 working days, and are bank holidays already counted within the 28?",
            "correct": true,
            "feedback": "✅ 英国の法定有給休暇は28日（バンクホリデーを含む）が最低ラインです。つまり実際に自由に使える日数は20日（＝28日 − 8日のバンクホリデー）です。この点を最初に確認するのは非常に賢明です。",
            "feedbackEn": "Exactly the right question. UK statutory entitlement is 28 working days including 8 bank holidays—so 20 bookable days in practice. Many employers offer more (25+ days), but 28 is the legal minimum. Clarifying upfront avoids confusion later.",
            "textJa": "ã‚ã‚ŠãŒã¨ã†ã”ã–ã„ã¾ã™ã€‚ç¢ºèªã§ã™ãŒã€28æ—¥ã¯å°±æ¥­æ—¥ã§ã€éŠ€è¡Œä¼‘æ—¥ã¯ãã®28æ—¥ã®ä¸­ã«å«ã¾ã‚Œã¦ã„ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "28 days? That includes bank holidays? In Japan we don't usually count bank holidays as leave.",
            "correct": false,
            "feedback": "⚠️ 文化的な驚きは理解できますが、英国の制度を批判するトーンになっています。日本では祝日は別枠が一般的ですが、英国では法定最低28日（バンクホリデー含む）がスタンダードです。比較より確認の姿勢が職場では好印象です。",
            "feedbackEn": "Cultural difference noted, but framing it as a complaint about the UK system is not ideal in a first-week conversation with your manager. Accept the system first; you can compare notes with colleagues later informally.",
            "textJa": "28æ—¥ï¼ŸéŠ€è¡Œä¼‘æ—¥ã‚’å«ã‚ã¦ï¼Ÿæ—¥æœ¬ã§ã¯éŠ€è¡Œä¼‘æ—¥ã¯é€šå¸¸ä¼‘æš‡ã¨ã—ã¦æ•°ãˆã¾ã›ã‚“ã€‚"
          },
          {
            "text": "28 days seems low — my contract says 25 days. There must be a mistake.",
            "correct": false,
            "feedback": "❌ 25日はバンクホリデーを除いた日数で、28日はバンクホリデー込みの法定最低日数です。25日＋バンクホリデー8日＝33日相当となり、28日より実質的に多い場合があります。混乱が起きやすい点ですが、マネージャーへの指摘は慎重に。",
            "feedbackEn": "A contract offering 25 days PLUS bank holidays is actually more generous than the 28-day statutory minimum (which includes bank holidays). Check your contract carefully before suggesting there's an error—it may be in your favour.",
            "textJa": "28æ—¥ã¯å°‘ãªã„æ°—ãŒã—ã¾ã™ã€‚å¥‘ç´„ã§ã¯25æ—¥ã¨æ›¸ã„ã¦ã‚ã‚Šã¾ã™ãŒã€é–“é•ã„ãŒã‚ã‚‹ã¯ãšã§ã™ã€‚"
          }
        ],
        "textJa": "ãƒªãƒžã‚¤ãƒ³ãƒ€ãƒ¼ã§ã™ãŒã€ä¼‘æš‡ç”³è«‹ã¯HRã‚·ã‚¹ãƒ†ãƒ ã‚’ä½¿ã£ã¦ãã ã•ã„ã€‚ä»Šå¹´ã¯éŠ€è¡Œä¼‘æ—¥ã‚’å«ã‚ã¦28æ—¥ã®æ³•å®šä¼‘æš‡ãŒã‚ã‚Šã¾ã™ã€‚"
      },
      {
        "speaker": "colleague",
        "avatar": "📅",
        "name": "Sarah",
        "text": "Right — 28 total including bank holidays, so 20 bookable days. Most people take a chunk at Christmas and spread the rest.",
        "options": [
          {
            "text": "That makes sense. Are there any blackout periods I should know about? And what's the carry-over policy at year end?",
            "correct": true,
            "feedback": "✅ ブラックアウト期間（繁忙期の取得制限）とキャリーオーバー（翌年持越し）の確認は非常に実務的で重要な質問です。英国では多くの企業がキャリーオーバーを制限しており（「use it or lose it」）、年度末に駆け込みで取得する慣行があります。",
            "feedbackEn": "Both questions are essential. Blackout periods (e.g. financial year-end, busy seasons) are common in UK workplaces. Carry-over is often strictly limited—many employers allow only 5 days to roll over, with the rest forfeited. Ask early.",
            "textJa": "ãªã‚‹ã»ã©ã€‚çŸ¥ã£ã¦ãŠãã¹ããƒ–ãƒ©ãƒƒã‚¯ã‚¢ã‚¦ãƒˆæœŸé–“ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿå¹´åº¦æœ«ã®ç¹°ã‚Šè¶Šã—ãƒãƒªã‚·ãƒ¼ã¯ã©ã†ãªã£ã¦ã„ã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Can I take all twenty days together in August? I'd like to go back to Japan for a full month — would that kind of request typically be approved, or is there usually a maximum limit on consecutive days?",
            "correct": false,
            "feedback": "⚠️ 一度に全休暇を取ることは多くの職場で難しく、特に繁忙期には承認されないことがあります。英国では休暇はチームの需要とのバランスを取ることが暗黙のルールです。長期休暇を取る場合は早めに相談し、チームへの影響を配慮することが大切です。",
            "feedbackEn": "Taking all 20 days at once in August may clash with team coverage needs. UK workplaces expect leave to be distributed through the year and coordinated with colleagues. Plan early and check team capacity before booking a month.",
            "textJa": "8æœˆã«å…¨20æ—¥ã¾ã¨ã‚ã¦å–ã‚Œã¾ã™ã‹ï¼Ÿæ—¥æœ¬ã«1ãƒ¶æœˆå¸°ã‚ŠãŸã„ã®ã§ã™ãŒã€ãã®ã‚ˆã†ãªãƒªã‚¯ã‚¨ã‚¹ãƒˆã¯é€šå¸¸æ‰¿èªã•ã‚Œã¾ã™ã‹ï¼Ÿé€£ç¶šã—ã¦å–ã‚Œã‚‹æœ€å¤§æ—¥æ•°ã®åˆ¶é™ã¯ã‚ã‚Šã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Is it possible to receive a payment for any unused annual leave at the end of the year? I tend not to take many holidays and would honestly prefer the extra money in my salary if that's an option.",
            "correct": false,
            "feedback": "❌ 英国では法定有給休暇の買い取り（cash out）は原則として禁止されています。雇用法上、労働者は実際に休暇を取ることが義務付けられています（健康と福祉のため）。未使用休暇は取るか、許可されていれば翌年繰り越すしかありません。",
            "feedbackEn": "Cashing out statutory leave is illegal in the UK—employment law requires workers to actually take rest. Some employers allow buyout of leave above statutory minimums, but never the basic 28 days. You must take it.",
            "textJa": "å¹´åº¦æœ«ã«ä½¿ã„æ®‹ã—ãŸä¼‘æš‡ã‚’æ”¯æ‰•ã„ã«å¤‰ãˆã‚‹ã“ã¨ã¯ã§ãã¾ã™ã‹ï¼Ÿä¼‘æš‡ã‚’ã‚ã¾ã‚Šå–ã‚‰ãªã„ã®ã§ã€çµ¦æ–™ã«ä¸Šä¹—ã›ã—ã¦ã‚‚ã‚‰ãˆã‚‹ãªã‚‰å¬‰ã—ã„ã§ã™ã€‚"
          }
        ],
        "textJa": "ã¤ã¾ã‚Šã€éŠ€è¡Œä¼‘æ—¥ã‚’å«ã‚ã¦28æ—¥ã§ã€äºˆç´„å¯èƒ½ãªæ—¥æ•°ã¯20æ—¥ã§ã™ã€‚ã»ã¨ã‚“ã©ã®äººã¯ã‚¯ãƒªã‚¹ãƒžã‚¹ã«ã¾ã¨ã‚ã¦å–ã‚Šã€æ®‹ã‚Šã‚’åˆ†æ•£ã•ã›ã¾ã™ã€‚"
      },
      {
        "speaker": "colleague",
        "avatar": "📅",
        "name": "Sarah",
        "text": "Carry-over is limited — use it or lose it by March. And just culturally — if someone always takes every Monday off, people do start to notice.",
        "options": [
          {
            "text": "Ha — good to know. I'll spread my leave reasonably and book it through the system with good notice.",
            "correct": true,
            "feedback": "✅ 「Use it or lose it」の現実を理解し、休暇の計画的な使用とシステム経由での申請を約束するのは模範的な姿勢です。英国の職場では「いつも月曜休む人」への目線は確かにあり、マネージャーがさりげなく警告しているのを理解できています。",
            "feedbackEn": "Ideal response. Acknowledging the cultural note ('people notice') and committing to spread leave reasonably shows professional maturity. Booking early through the system also shows respect for team planning—always give as much notice as possible.",
            "textJa": "å‚è€ƒã«ãªã‚Šã¾ã—ãŸã€‚ä¼‘æš‡ã‚’åˆç†çš„ã«åˆ†æ•£ã•ã›ã¦ã€ä½™è£•ã‚’æŒã£ã¦ã‚·ã‚¹ãƒ†ãƒ ã§ç”³è«‹ã—ã¾ã™ã€‚"
          },
          {
            "text": "That seems unfair — why should it matter which day someone takes leave if it's approved?",
            "correct": false,
            "feedback": "⚠️ 法的には正当な意見ですが、マネージャーからのさりげない文化的アドバイスに反論するのは得策ではありません。英国の職場には書かれていないルールがあり、それを理解する姿勢が長期的なキャリアに有益です。",
            "feedbackEn": "Legally you may have a point, but pushing back on a manager's cultural guidance in week one is risky. British workplaces have unwritten norms—understanding and respecting them matters for long-term career success, even if rules are technically followed.",
            "textJa": "ãã‚Œã¯ä¸å…¬å¹³ã«æ€ãˆã¾ã™ã€‚ç”³è«‹ãŒæ‰¿èªã•ã‚Œã¦ã„ã‚‹ãªã‚‰ã€ã©ã®æ›œæ—¥ã«å–ã‚‹ã‹ãŒå•é¡Œãªã‚“ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "Noted. I'll just make sure I book it in the system so it's official.",
            "correct": false,
            "feedback": "⚠️ システムに入力することは必要ですが、マネージャーの暗黙のアドバイス（月曜連続休暇への目線）を聞き流しています。「分かりました、バランスよく取ります」という明示的な応答の方が、理解していることをマネージャーに伝えられます。",
            "feedbackEn": "Booking through the system is correct, but this response ignores the cultural advice about Mondays. A better response acknowledges the subtext—that spreading leave across the week and year is the expected norm, not just booking it officially.",
            "textJa": "æ‰¿çŸ¥ã—ã¾ã—ãŸã€‚æ­£å¼ã«ã™ã‚‹ãŸã‚ã«ã‚·ã‚¹ãƒ†ãƒ ã§ç”³è«‹ã—ã¾ã™ã€‚"
          }
        ],
        "textJa": "ç¹°ã‚Šè¶Šã—ã¯åˆ¶é™ãŒã‚ã‚Šã¾ã™ã€‚3æœˆã¾ã§ã«ä½¿ã„åˆ‡ã‚‰ãªã„ã¨å¤±åŠ¹ã—ã¾ã™ã€‚æ–‡åŒ–çš„ãªã“ã¨ã§ã™ãŒã€æ¯Žé€±æœˆæ›œæ—¥ã«ä¼‘æš‡ã‚’å–ã‚‹äººã¯å‘¨å›²ãŒæ°—ã¥ãå§‹ã‚ã¾ã™ã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: UK statutory leave is 28 days including 8 bank holidays — so 20 bookable days. Carry-over is usually limited (use it or lose it). Book leave early and spread it through the year. Always use the HR system.",
    "tipJa": "🇬🇧 イギリスTip: 英国の法定有給は28日（バンクホリデー8日含む）、実質20日が自由に使えます。年度末の繰越は通常制限（使わないと消滅）。早めに計画し、年間を通して分散して取るのが英国職場の慣習です。"
  },
  "conv_culture_tvlicence": {
    "id": "conv_culture_tvlicence",
    "title": "TV Licence",
    "titleJa": "TV受信許可証",
    "situation": "You have just moved into a shared flat in the UK. Your flatmate Sam raises the topic of the TV Licence.",
    "situationJa": "英国のシェアフラットに引越したばかり。フラットメイトのサムがTV受信許可証の話を切り出しました。",
    "turns": [
      {
        "speaker": "colleague",
        "avatar": "📺",
        "name": "Sam",
        "text": "Have you sorted your TV licence yet? Those letters from TV Licensing are real — they can visit.",
        "options": [
          {
            "text": "Not yet — how do I pay for it? Can I do it monthly?",
            "correct": true,
            "feedback": "✅ 正解です。TV受信許可証は法的義務で£169.50/年（2024年）。月払いのダイレクトデビットも利用可能です。すぐに確認しようとする姿勢が適切です。",
            "feedbackEn": "✅ Correct. The TV Licence is a legal requirement at £169.50/year (2024). Monthly payment by Direct Debit is available via tv.licensing.co.uk. Acting immediately avoids any risk of enforcement.",
            "textJa": "ã¾ã ã§ã™ã€‚ã©ã†ã‚„ã£ã¦æ”¯æ‰•ã„ã¾ã™ã‹ï¼Ÿæ¯Žæœˆæ‰•ãˆã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I'm not sure — I don't have a TV, so I probably don't need one.",
            "correct": false,
            "feedback": "⚠️ テレビがなくてもBBCiPlayerをノートPCやスマートフォンで使う場合は許可証が必要です。またライブTVの視聴も対象です。本当に不要な場合は公式サイトで申告が必要です。",
            "feedbackEn": "⚠️ No TV does not mean no licence needed. If you use BBC iPlayer on any device — laptop, phone, tablet — or watch live TV via any service, a licence is required. Only if you genuinely do neither can you declare exemption online.",
            "textJa": "ã‚ˆãåˆ†ã‹ã‚Šã¾ã›ã‚“ã€‚ãƒ†ãƒ¬ãƒ“ãŒãªã„ã®ã§ã€ãŠãã‚‰ãå¿…è¦ãªã„ã¨æ€ã„ã¾ã™ã€‚"
          },
          {
            "text": "I've been throwing those letters away — they look like junk mail.",
            "correct": false,
            "feedback": "❌ TV Licensingからの手紙は無視してはいけません。これらは本物の公式通知で、未払いには最大£1,000の罰金が科せられます。執行官が自宅を訪問することもあります。",
            "feedbackEn": "❌ TV Licensing letters are genuine enforcement notices — not junk mail. Ignoring them risks a fine of up to £1,000 and a visit from an enforcement officer. Many new arrivals make this costly mistake.",
            "textJa": "ãã‚Œã‚‰ã®æ‰‹ç´™ã‚’æ¨ã¦ã¦ã„ã¾ã—ãŸã€‚ã‚¸ãƒ£ãƒ³ã‚¯ãƒ¡ãƒ¼ãƒ«ã®ã‚ˆã†ã«è¦‹ãˆãŸã®ã§ã€‚"
          }
        ],
        "textJa": "ãƒ†ãƒ¬ãƒ“ãƒ©ã‚¤ã‚»ãƒ³ã‚¹ã®æ‰‹ç¶šãã¯ã—ã¾ã—ãŸã‹ï¼Ÿãƒ†ãƒ¬ãƒ“ãƒ©ã‚¤ã‚»ãƒ³ã‚·ãƒ³ã‚°ã‹ã‚‰ã®æ‰‹ç´™ã¯æœ¬ç‰©ã§ã™ã€‚æ¥ã‚‹ã“ã¨ãŒã‚ã‚Šã¾ã™ã‚ˆã€‚"
      },
      {
        "speaker": "colleague",
        "avatar": "📺",
        "name": "Sam",
        "text": "It covers BBC iPlayer too — even on a laptop. Do you use BBC iPlayer at all?",
        "options": [
          {
            "text": "Yes I do — so I definitely need to pay. £169.50 a year, and I can spread it monthly?",
            "correct": true,
            "feedback": "✅ 正解です。BBCiPlayerをどのデバイスでも使う場合は許可証が必要です。年£169.50を月払いにすることで毎月約£14.12の支払いになります。",
            "feedbackEn": "✅ Correct. BBC iPlayer use on any device triggers the licence requirement. Paying monthly (≈£14.12/month) spreads the cost — set up Direct Debit via tv.licensing.co.uk.",
            "textJa": "ã¯ã„ã€ä½¿ã£ã¦ã„ã¾ã™ã€‚çµ¶å¯¾ã«æ”¯æ‰•ã†å¿…è¦ãŒã‚ã‚Šã¾ã™ã­ã€‚169.50ãƒãƒ³ãƒ‰ã§æ¯Žæœˆåˆ†å‰²ã§ãã¾ã™ã‹ï¼Ÿ"
          },
          {
            "text": "I only use it occasionally for catch-up viewing — surely the licence is really just for people who watch live broadcast television on a regular basis, isn't it?",
            "correct": false,
            "feedback": "⚠️ 「たまに使うだけ」でも許可証は必要です。使用頻度は関係なく、BBCiPlayerへのアクセス自体が要件を生じさせます。",
            "feedbackEn": "⚠️ Any use of BBC iPlayer requires a licence — there is no frequency threshold. Occasional viewing is not an exemption. The only exemption is if you genuinely never watch live TV and never use iPlayer at all.",
            "textJa": "ãŸã¾ã«ã‚­ãƒ£ãƒƒãƒã‚¢ãƒƒãƒ—è¦–è´ã«ä½¿ã†ç¨‹åº¦ã§ã™ã€‚ãƒ©ã‚¤ã‚»ãƒ³ã‚¹ã¯å®šæœŸçš„ã«ç”Ÿæ”¾é€ã‚’è¦‹ã‚‹äººã®ãŸã‚ã®ã‚‚ã®ã§ã¯ãªã„ã§ã™ã‹ï¼Ÿ"
          },
          {
            "text": "BBC iPlayer is free to access — so surely I don't need a licence?",
            "correct": false,
            "feedback": "❌ 「無料アクセス」はライセンス不要を意味しません。BBCiPlayerはTV受信許可証料によって資金調達されており、許可証なしの使用は法律違反です。",
            "feedbackEn": "❌ 'Free to access' is not the same as 'no licence required'. BBC iPlayer is publicly funded through TV Licence revenue. Accessing it without a valid licence is a legal offence regardless of having no paywall to bypass.",
            "textJa": "BBC iPlayerã¯ç„¡æ–™ã§ã‚¢ã‚¯ã‚»ã‚¹ã§ãã¾ã™ã€‚ãªãœãƒ©ã‚¤ã‚»ãƒ³ã‚¹ãŒå¿…è¦ãªã‚“ã§ã™ã‹ï¼Ÿ"
          }
        ],
        "textJa": "BBC iPlayerã‚‚å¯¾è±¡ã§ã™ã€‚ãƒŽãƒ¼ãƒˆãƒ‘ã‚½ã‚³ãƒ³ã§ã‚‚ã€‚BBC iPlayerã¯ä½¿ã„ã¾ã™ã‹ï¼Ÿ"
      },
      {
        "speaker": "colleague",
        "avatar": "📺",
        "name": "Sam",
        "text": "You can declare online that you don't need one if you never use live TV or iPlayer — then the letters stop.",
        "options": [
          {
            "text": "I use iPlayer so I'll pay — but good to know I can declare online if that ever changes.",
            "correct": true,
            "feedback": "✅ 完璧な理解です。iPlayerを使う限りは許可証が必要です。本当に不要になった場合はTV Licensing公式サイトで申告すれば督促状が止まります（2年ごとに更新）。",
            "feedbackEn": "✅ Perfect. Since you use iPlayer you need the licence now. If you ever genuinely stop watching live TV and using iPlayer, declare this at tv.licensing.co.uk — the letters then stop for two years before requiring renewal.",
            "textJa": "iPlayerã‚’ä½¿ã£ã¦ã„ã‚‹ã®ã§æ”¯æ‰•ã„ã¾ã™ã€‚çŠ¶æ³ãŒå¤‰ã‚ã£ãŸå ´åˆã«ã‚ªãƒ³ãƒ©ã‚¤ãƒ³ã§å±Šã‘å‡ºã§ãã‚‹ã“ã¨ã¯çŸ¥ã£ã¦ãŠãã¾ã™ã€‚"
          },
          {
            "text": "I'll ask my landlord first — it might be covered in the rent.",
            "correct": false,
            "feedback": "⚠️ TV受信許可証は個人の法的責任です。家主が家賃に含めることはほぼありません（特殊な学生寮を除く）。直接自分でTV Licensing公式サイトから手続きできます。",
            "feedbackEn": "⚠️ The TV Licence is your personal legal responsibility — landlords almost never include it in rent. There is no need to ask; you can apply or declare directly at tv.licensing.co.uk without involving your landlord.",
            "textJa": "å…ˆã«å®¶ä¸»ã«ç¢ºèªã—ã¾ã™ã€‚å®¶è³ƒã«å«ã¾ã‚Œã¦ã„ã‚‹ã‹ã‚‚ã—ã‚Œãªã„ã®ã§ã€‚"
          },
          {
            "text": "I'll just skip the licence for now — I really doubt anyone will actively check, and enforcement fines seem quite rare in practice from what I've heard from other people.",
            "correct": false,
            "feedback": "❌ TV Licensing執行官は特殊な検知機器を使用してBBCiPlayerやライブTVの使用を確認できます。無視による罰金は最大£1,000で、年間料金£169.50をはるかに超えます。",
            "feedbackEn": "❌ TV Licensing officers use detection equipment to identify iPlayer and live TV use. The assumption that evasion cannot be proved is wrong and costly — fines reach £1,000, far exceeding the £169.50 annual fee.",
            "textJa": "ä»Šã¯ãƒ©ã‚¤ã‚»ãƒ³ã‚¹ã‚’å–å¾—ã—ã¾ã›ã‚“ã€‚å®Ÿéš›ã«åŸ·è¡Œã•ã‚Œã‚‹ã“ã¨ã¯ã»ã¨ã‚“ã©ãªã„ã¨èžã„ã¦ã„ã¾ã™ã®ã§ã€‚"
          }
        ],
        "textJa": "ç”Ÿæ”¾é€ã‚‚iPlayerã‚‚ä½¿ã‚ãªã„å ´åˆã€ã‚ªãƒ³ãƒ©ã‚¤ãƒ³ã§å±Šã‘å‡ºã‚’å‡ºã›ã°æ‰‹ç´™ãŒæ¥ãªããªã‚Šã¾ã™ã€‚"
      }
    ],
    "tip": "🇬🇧 UK tip: TV Licensing letters look official — because they are. The licence (£169.50/year, 2024) covers BBC iPlayer on any device, not just a physical TV. Genuinely exempt? Declare online at tv.licensing.co.uk to stop the letters. Enforcement officers can visit and fines reach £1,000.",
    "tipJa": "🇬🇧 イギリスTip: TV Licensingからの手紙は本物の公式通知です。許可証（£169.50/年・2024年）はBBCiPlayerを含むすべてのデバイスに適用。本当に不要なら公式サイト（tv.licensing.co.uk）で申告することで督促を止められます。執行官の訪問・最大£1,000の罰金があります。"
  }
};
